
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fImWv", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $da002f83cf061f88$export$d0aef4d352cf8b14 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ctj29",
    name: "AnalyticsByLine",
    loader: async ()=>(await (parcelRequire("fTz11"))).AnalyticsByLine
});
module.exports["AnalyticsByLine"] = $da002f83cf061f88$export$d0aef4d352cf8b14;

});

parcelRegister("fTz11", function(module, exports) {

let $b9272768621092be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b9272768621092be$var$load("6wr18"),
    $b9272768621092be$var$load("4RHRd"),
    $b9272768621092be$var$load("6XCf4"),
    $b9272768621092be$var$load("ebvEF"),
    $b9272768621092be$var$load("ffEVr"),
    $b9272768621092be$var$load("7EorR"),
    $b9272768621092be$var$load("aEiTV"),
    $b9272768621092be$var$load("1qlDN"),
    $b9272768621092be$var$load("1yVM6"),
    $b9272768621092be$var$load("6c9wI")
]).then(()=>parcelRequire('ffp8s'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("kaFRI", function(module, exports) {
/**
 * @generated SignedSource<<64af480c914c91db1b510fce34177ff2>>
 * @relayHash 90308ee3f23c965d3be02cc175a44ffc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4ce5797d5f0008be560a06960fc2d934a6caa4c0b65b5dabd656144a79eb196
const $ee0ab3671dea2507$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPrivacyModeGateEnabled"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isPrivacyModeGateEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "privacyMode",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "ConfluencePrivacyMode",
                    "kind": "LinkedField",
                    "name": "confluence_isPrivacyModeEnabled",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isPrivacyModeEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AnalyticsDialogAnalyticsContentQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AnalyticsDialogAnalyticsContentQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "90308ee3f23c965d3be02cc175a44ffc",
            "id": "c4ce5797d5f0008be560a06960fc2d934a6caa4c0b65b5dabd656144a79eb196",
            "metadata": {},
            "name": "AnalyticsDialogAnalyticsContentQuery",
            "operationKind": "query",
            "text": "query AnalyticsDialogAnalyticsContentQuery($contentId:ID!,$cloudId:ID!,$isPrivacyModeGateEnabled:Boolean!){singleContent(id:$contentId){id,type,subType,title,metadata{createdDate}},privacyMode:confluence_isPrivacyModeEnabled(cloudId:$cloudId)@include(if:$isPrivacyModeGateEnabled){isPrivacyModeEnabled}}"
        }
    };
}();
$ee0ab3671dea2507$var$node.hash = "fe1ea5ee176ed78040ab6497bb6eafa9";
var $ee0ab3671dea2507$export$2e2bcd8739ae039 = $ee0ab3671dea2507$var$node;
module.exports["default"] = $ee0ab3671dea2507$export$2e2bcd8739ae039;

});

parcelRegister("a9SX7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $db22052f45cd3c08$export$aeb07f2d59756a1b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VfqBC",
    name: "ListenByline",
    loader: async ()=>(await (parcelRequire("j0sKX"))).ListenByline
});
module.exports["ListenByline"] = $db22052f45cd3c08$export$aeb07f2d59756a1b;

});

parcelRegister("j0sKX", function(module, exports) {

let $dd6452d0374466c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dd6452d0374466c1$var$load("ahEIC"),
    $dd6452d0374466c1$var$load("bb3WM"),
    $dd6452d0374466c1$var$load("5lo9L")
]).then(()=>parcelRequire('lFyOr'));

});

parcelRegister("l2a4I", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ew8wg = parcelRequire("ew8wg");


var $3plmx = parcelRequire("3plmx");


var $5vi32 = parcelRequire("5vi32");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $hvS6g = parcelRequire("hvS6g");





var $lsxnT = parcelRequire("lsxnT");

/* BylineConnectionsTrigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");





var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $aZ9If = parcelRequire("aZ9If");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $hTfX9 = parcelRequire("hTfX9");

const $55dbae87bfebb50e$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "byline-connections.label",
        defaultMessage: "Context"
    }
});
const $55dbae87bfebb50e$var$styles = {
    wrapper: "_2sNsIg7NXe _3iDTPbccYA _0hPCNLDIqT _2xTnZx1Y8M _0jFU0VoWWg _1ANEUSzUZr _1UtDYzZpcK",
    trigger: "_2sNsIg7NXe _0bjKvDKxmn _4FKVYE1Y8M _3iDTPbccYA _0hPCNLDIqT _17lj8p1Y8M _0KLXrujOvk _1ANEUSLRg7 _0wOv4Q7zJH _1UtDYzZpcK _1eOmH6o126 _3gzVzLN4oS",
    triggerExpanded: "_0KLXruo126"
};
const $55dbae87bfebb50e$export$8b56d9356350e1f6 = ({ children: children, ...htmlAttributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...htmlAttributes,
        className: (0, $hekY6.default)([
            $55dbae87bfebb50e$var$styles.wrapper
        ])
    }, children);
const $55dbae87bfebb50e$export$a5631cafd5b67535 = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { additionalIcons: additionalIcons, appearance: appearance, incomingLinks: incomingLinks, links: links, minIcons: minIcons } = props;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-subtle, #505258)",
        testId: "byline-connections-teamwork-graph-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        size: "small",
        color: "color.text.subtle"
    }, formatMessage($55dbae87bfebb50e$var$i18n.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTfX9.BylineConnectionIconStack), {
        links: links,
        incomingLinks: incomingLinks,
        additionalIcons: additionalIcons,
        appearance: appearance === 'placeholder' ? 'placeholder' : 'default',
        minIcons: minIcons,
        spacing: "none"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...props.buttonProps,
        testId: "byline-connections-trigger",
        xcss: (0, $w6R6I.cx)($55dbae87bfebb50e$var$styles.trigger, props.buttonProps['aria-expanded'] && $55dbae87bfebb50e$var$styles.triggerExpanded)
    }, content);
};





/* ConnectionsByLineMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $ad7Ou = parcelRequire("ad7Ou");


var $aRvnq = parcelRequire("aRvnq");





var $6IL1T = parcelRequire("6IL1T");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");





var $lfoFx = parcelRequire("lfoFx");








var $huzJY = parcelRequire("huzJY");


var $8FgJC = parcelRequire("8FgJC");


var $e9QBI = parcelRequire("e9QBI");

const $c0311709cd7c6fed$var$i18n = (0, $kSwu1.defineMessages)({
    syncedWith: {
        id: "dev-docs.byline-connection.menu.section.synced-with.ai-non-final",
        defaultMessage: "Synced with ({count, number})"
    }
});
const $c0311709cd7c6fed$export$23d9bfb525ce3655 = ({ connection: connection, onNavigate: onNavigate })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huzJY.default), null, formatMessage($c0311709cd7c6fed$var$i18n.syncedWith, {
        count: 1
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e9QBI.DevDocsConnectionRow), {
        connection: connection,
        onNavigate: onNavigate
    }));
};





/* ConnectionsByLineExpandableLinkSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 


















var $6F7l4 = parcelRequire("6F7l4");

const $92feead83550977e$var$styles = {
    expandButton: "_2Y7lL48HPE _46hvQmgVvo _0xmtko8HPE"
};
// links. Renders nothing when there are no links to show.
const $92feead83550977e$var$ConnectionsByLineLinkSection = ({ heading: heading, links: links, compact: compact, refreshLinkUrl: refreshLinkUrl, linkDirection: linkDirection, onNavigate: onNavigate, analyticsSource: analyticsSource })=>{
    if (links.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huzJY.default), null, heading), links.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6F7l4.ConnectionsByLineMenuItem), {
            key: `${item.url}-${item.occurrenceIndex}`,
            item: item,
            refreshLinkUrl: refreshLinkUrl,
            linkDirection: linkDirection,
            onNavigate: onNavigate,
            compact: compact,
            analyticsSource: analyticsSource,
            // them is a plain static list: no Connect, no row actions, no hover card.
            // The preview panel keeps the hover affordances. (CCINT-9250)
            disableHover: true
        }))));
};
const $92feead83550977e$export$825be6248d440e90 = ({ heading: heading, links: links, shouldShowExpandButton: shouldShowExpandButton = false, expandButtonLabel: expandButtonLabel, onExpand: onExpand, refreshLinkUrl: refreshLinkUrl, linkDirection: linkDirection, onNavigate: onNavigate, compact: compact, analyticsSource: analyticsSource })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92feead83550977e$var$ConnectionsByLineLinkSection, {
        heading: heading,
        links: links,
        compact: compact,
        refreshLinkUrl: refreshLinkUrl,
        linkDirection: linkDirection,
        onNavigate: onNavigate,
        analyticsSource: analyticsSource
    }), shouldShowExpandButton && expandButtonLabel && onExpand ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $92feead83550977e$var$styles.expandButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        shouldFitContainer: true,
        onClick: onExpand
    }, expandButtonLabel)) : null);









var $cS4kb = parcelRequire("cS4kb");


var $1UApO = parcelRequire("1UApO");


var $8dynS = parcelRequire("8dynS");





var $kOUwv = parcelRequire("kOUwv");

function $8ab372ddb9ea7e6c$export$284907af4a465a72(traitName, parse, { skip: skip } = {}) {
    const { data: data, loading: loading, error: error } = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: !!skip
    });
    const parseRef = (0, $cozmU.useRef)(parse);
    parseRef.current = parse;
    const value = (0, $cozmU.useMemo)(()=>{
        if (skip || !data?.attributes) return undefined;
        const raw = data.attributes.find(({ name: name })=>name === traitName)?.value;
        return parseRef.current(raw);
    }, [
        skip,
        data,
        traitName
    ]);
    return {
        value: value,
        loading: loading,
        error: error
    };
}


const $11c55f3cb3c29119$export$3d6612235992a7fe = 'google-drive';
function $11c55f3cb3c29119$export$2bffffe5ac9dc808(raw) {
    if (raw === undefined || raw.trim() === '') return undefined;
    const counts = raw.split(',').reduce((acc, segment)=>{
        const colonIdx = segment.indexOf(':');
        if (colonIdx === -1) return acc;
        const provider = segment.slice(0, colonIdx).trim();
        const countRaw = segment.slice(colonIdx + 1).trim();
        if (!provider || countRaw === '') return acc;
        const count = Number(countRaw);
        if (!Number.isInteger(count) || count < 0) return acc;
        acc[provider] = count;
        return acc;
    }, {});
    return Object.keys(counts).length > 0 ? counts : undefined;
}
function $11c55f3cb3c29119$export$2bd9a43397bfe114({ skip: skip } = {}) {
    return (0, $8ab372ddb9ea7e6c$export$284907af4a465a72)((0, $8dynS.SMARTLINK_CONNECTION_LINK_COUNT_TRAIT), $11c55f3cb3c29119$export$2bffffe5ac9dc808, {
        skip: skip
    });
}


/* GdriveConnectorPromoBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");











var $9NPFC = parcelRequire("9NPFC");


var $9Jc29 = parcelRequire("9Jc29");


var $jmjWc = parcelRequire("jmjWc");


const $aa7ff97a50d7e018$var$UnconnectedConnectorHoverCardLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "R6X72",
    name: "UnconnectedConnectorHoverCardLoadable",
    loader: async ()=>(await (parcelRequire("7su1d"))).UnconnectedConnectorHoverCard
});
const $aa7ff97a50d7e018$var$i18n = (0, $kSwu1.defineMessages)({
    message: {
        id: "byline-connections.menu.footer.connect-placeholder",
        defaultMessage: "Connect Google drive to see rich previews across Confluence"
    },
    connectAction: {
        id: "byline-connections.menu.footer.connect-action",
        defaultMessage: "Connect"
    },
    connectingAction: {
        id: "byline-connections.menu.footer.connecting-action",
        defaultMessage: "Connecting..."
    },
    dismissAction: {
        id: "byline-connections.menu.footer.dismiss-action",
        defaultMessage: "Dismiss"
    },
    googleDriveIconAlt: {
        id: "byline-connections.menu.footer.google-drive-icon.alt",
        defaultMessage: "Google Drive"
    }
});
const $aa7ff97a50d7e018$var$styles = {
    footer: "_4c065U8HPE _2Y7lL45zaO _0KLXrunmFW _0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67",
    message: "_2sNsIg7NXe _1UtDYzy7kJ",
    connect: "_2sNsIgmnOE _4FKVYEPgdg _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3hxITiYbGa _1UtDYzM7Tp _0KLXrujOvk _0wOv4Q7zJH _3YEZNOdnbC _253ZDm98eZ _2r76lK0Rl6 _4umoPx6wH8 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
    connecting: "_2sNsIgmnOE _4FKVYEPgdg _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3hxITiYbGa _1UtDYzot27 _0KLXrujOvk _0wOv4Q18ZR _3YEZNOdnbC"
};
const $aa7ff97a50d7e018$export$e7e7ab663009ba26 = ({ onConnect: onConnect, onDismiss: onDismiss, isConnecting: isConnecting })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isBannerHovered, setIsBannerHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aa7ff97a50d7e018$var$UnconnectedConnectorHoverCardLoadable, {
        providerKey: "gdrive",
        isOpen: isBannerHovered
    }, ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: ref,
            ...triggerProps,
            xcss: $aa7ff97a50d7e018$var$styles.footer,
            onMouseEnter: ()=>setIsBannerHovered(true),
            onMouseLeave: ()=>setIsBannerHovered(false),
            onFocus: ()=>setIsBannerHovered(true),
            onBlur: ()=>setIsBannerHovered(false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: formatMessage($aa7ff97a50d7e018$var$i18n.googleDriveIconAlt),
            size: "small",
            backgroundColor: "color.background.neutral",
            isInset: false,
            hasBorder: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Jc29.GoogleDriveAppSelectorIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $aa7ff97a50d7e018$var$styles.message
        }, formatMessage($aa7ff97a50d7e018$var$i18n.message))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: isConnecting ? $aa7ff97a50d7e018$var$styles.connecting : $aa7ff97a50d7e018$var$styles.connect,
            onClick: onConnect,
            isDisabled: isConnecting,
            "aria-busy": isConnecting
        }, formatMessage(isConnecting ? $aa7ff97a50d7e018$var$i18n.connectingAction : $aa7ff97a50d7e018$var$i18n.connectAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: formatMessage($aa7ff97a50d7e018$var$i18n.dismissAction),
            onClick: onDismiss
        })))));
};



var $I7TEB = parcelRequire("I7TEB");

const $4aa630edd4fe23e7$export$b1294d95ffe11792 = 'connectionsBylinePromoBanner';
const $4aa630edd4fe23e7$export$450e9e5e468adef1 = 'google';
const $4aa630edd4fe23e7$export$57e0ff4c2905037a = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'viewed',
            actionSubject: 'banner',
            actionSubjectId: $4aa630edd4fe23e7$export$b1294d95ffe11792,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: attributes
        }
    });
const $4aa630edd4fe23e7$export$c308d47e70cf3cab = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'dismissed',
            actionSubject: 'banner',
            actionSubjectId: $4aa630edd4fe23e7$export$b1294d95ffe11792,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: attributes
        }
    });
const $4aa630edd4fe23e7$export$3155a85848c110b5 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'notShown',
            actionSubject: 'banner',
            actionSubjectId: $4aa630edd4fe23e7$export$b1294d95ffe11792,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: attributes
        }
    });
const $4aa630edd4fe23e7$export$aa60f051027ec020 = 'connectionsBylineGdrivePromoConnect';
const $4aa630edd4fe23e7$export$89e0f005fead14a3 = 'connectionsBylineGdrivePromoAuth';
const $4aa630edd4fe23e7$export$53f4484811034e3e = ()=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $4aa630edd4fe23e7$export$aa60f051027ec020,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: {
                bannerType: 'gdrivePromo',
                connector: $4aa630edd4fe23e7$export$450e9e5e468adef1
            }
        }
    });
const $4aa630edd4fe23e7$export$a58cc560aa8bc031 = ()=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: 'auth',
            actionSubjectId: $4aa630edd4fe23e7$export$89e0f005fead14a3,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: {
                bannerType: 'gdrivePromo',
                connector: $4aa630edd4fe23e7$export$450e9e5e468adef1,
                status: 'success'
            }
        }
    });
const $4aa630edd4fe23e7$export$8d43fd709df6585d = (reason)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: 'auth',
            actionSubjectId: $4aa630edd4fe23e7$export$89e0f005fead14a3,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: {
                bannerType: 'gdrivePromo',
                connector: $4aa630edd4fe23e7$export$450e9e5e468adef1,
                status: 'failed',
                reason: reason
            }
        }
    });






var $17wUi = parcelRequire("17wUi");

const $aa04272ccb3d246a$var$readPages = (storageKey)=>{
    const value = (0, $17wUi.confluenceLocalStorageInstance).getItem(storageKey);
    return Array.isArray(value) ? value : [];
};
const $aa04272ccb3d246a$var$isPageDismissed = (storageKey, contentId)=>{
    if (!contentId) return false;
    return $aa04272ccb3d246a$var$readPages(storageKey).includes(contentId);
};
const $aa04272ccb3d246a$var$markPageDismissed = (storageKey, contentId)=>{
    const previous = $aa04272ccb3d246a$var$readPages(storageKey);
    const updated = [
        contentId,
        ...previous.filter((id)=>id !== contentId)
    ];
    (0, $17wUi.confluenceLocalStorageInstance).setItem(storageKey, updated);
};
const $aa04272ccb3d246a$export$6542d147ca3e4064 = (storageKey, contentId)=>{
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(()=>$aa04272ccb3d246a$var$isPageDismissed(storageKey, contentId));
    const dismiss = (0, $cozmU.useCallback)(()=>{
        if (contentId) $aa04272ccb3d246a$var$markPageDismissed(storageKey, contentId);
        setIsDismissed(true);
    }, [
        storageKey,
        contentId
    ]);
    return {
        isDismissed: isDismissed,
        dismiss: dismiss
    };
};






var $eEPSE = parcelRequire("eEPSE");


var $7zxJs = parcelRequire("7zxJs");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $8gF2o = parcelRequire("8gF2o");

const $ef409225f8f5ce6a$export$bf91246c5b17e0bf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { aaId: aaId, productKey: productKey } = t0;
    const [payload, setPayload] = (0, $cozmU.useState)(null);
    const [env, setEnv] = (0, $cozmU.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [optimisticAuthed, setOptimisticAuthed] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== aaId) {
        t1 = ()=>{
            setOptimisticAuthed(false);
            let cancelled = false;
            setIsLoading(true);
            (0, $8gF2o.fetchOutboundAuthAccounts)(aaId).then((fetched)=>{
                if (cancelled) return;
                setPayload(fetched);
                setEnv((0, $8gF2o.detectEnvFromPayload)(fetched) ?? undefined);
                setIsLoading(false);
            }).catch(()=>{
                if (cancelled) return;
                setPayload(null);
                setEnv(undefined);
                setIsLoading(false);
            });
            return ()=>{
                cancelled = true;
            };
        };
        $[0] = aaId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== aaId || $[3] !== productKey) {
        t2 = [
            aaId,
            productKey
        ];
        $[2] = aaId;
        $[3] = productKey;
        $[4] = t2;
    } else t2 = $[4];
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[5] !== optimisticAuthed || $[6] !== payload) {
        t3 = ()=>{
            if (payload && optimisticAuthed) setOptimisticAuthed(false);
        };
        t4 = [
            payload,
            optimisticAuthed
        ];
        $[5] = optimisticAuthed;
        $[6] = payload;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== aaId) {
        t5 = ()=>{
            if (!aaId) return;
            setOptimisticAuthed(true);
            (0, $8gF2o.fetchOutboundAuthAccounts)(aaId, {
                forceRefresh: true
            }).then((fresh)=>{
                if (fresh) {
                    setPayload(fresh);
                    setEnv((0, $8gF2o.detectEnvFromPayload)(fresh) ?? undefined);
                }
            });
        };
        $[9] = aaId;
        $[10] = t5;
    } else t5 = $[10];
    const onConnected = t5;
    let t6;
    if ($[11] !== env || $[12] !== productKey) {
        t6 = (0, $8gF2o.hasSmartLinkContainerMapping)(productKey, env) ? (0, $8gF2o.buildSmartLinkAuthUrl)(productKey, env) ?? undefined : undefined;
        $[11] = env;
        $[12] = productKey;
        $[13] = t6;
    } else t6 = $[13];
    const authUrl = t6;
    let t7;
    if ($[14] !== env || $[15] !== optimisticAuthed || $[16] !== payload || $[17] !== productKey) {
        t7 = optimisticAuthed || (0, $8gF2o.isAuthenticatedForProduct)(payload, productKey, env);
        $[14] = env;
        $[15] = optimisticAuthed;
        $[16] = payload;
        $[17] = productKey;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== authUrl || $[20] !== isLoading || $[21] !== onConnected || $[22] !== t7) {
        t8 = {
            authUrl: authUrl,
            isAuthenticated: t7,
            isLoading: isLoading,
            onConnected: onConnected
        };
        $[19] = authUrl;
        $[20] = isLoading;
        $[21] = onConnected;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ aaId: aaId, productKey: productKey })=>{
    const [payload, setPayload] = (0, $cozmU.useState)(null);
    const [env, setEnv] = (0, $cozmU.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [optimisticAuthed, setOptimisticAuthed] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setOptimisticAuthed(false);
        let cancelled = false;
        setIsLoading(true);
        (0, $8gF2o.fetchOutboundAuthAccounts)(aaId).then((fetched)=>{
            if (cancelled) return;
            setPayload(fetched);
            setEnv((0, $8gF2o.detectEnvFromPayload)(fetched) ?? undefined);
            setIsLoading(false);
        }).catch(()=>{
            if (cancelled) return;
            setPayload(null);
            setEnv(undefined);
            setIsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        aaId,
        productKey
    ]);
    // Auto-heal optimistic flip once ground truth arrives: clears stale
    // optimism even if the OAuth popup closed without granting scopes.
    (0, $cozmU.useEffect)(()=>{
        if (payload && optimisticAuthed) setOptimisticAuthed(false);
    }, [
        payload,
        optimisticAuthed
    ]);
    const onConnected = (0, $cozmU.useCallback)(()=>{
        if (!aaId) return;
        setOptimisticAuthed(true);
        // Bypass the 30-min cache so a later re-mount sees the fresh grant
        // instead of the stale pre-OAuth payload.
        (0, $8gF2o.fetchOutboundAuthAccounts)(aaId, {
            forceRefresh: true
        }).then((fresh)=>{
            if (fresh) {
                setPayload(fresh);
                setEnv((0, $8gF2o.detectEnvFromPayload)(fresh) ?? undefined);
            }
        });
    }, [
        aaId
    ]);
    const authUrl = (0, $8gF2o.hasSmartLinkContainerMapping)(productKey, env) ? (0, $8gF2o.buildSmartLinkAuthUrl)(productKey, env) ?? undefined : undefined;
    return {
        authUrl: authUrl,
        isAuthenticated: optimisticAuthed || (0, $8gF2o.isAuthenticatedForProduct)(payload, productKey, env),
        isLoading: isLoading,
        onConnected: onConnected
    };
};



var $fR63l = parcelRequire("fR63l");


var $bQm3c = parcelRequire("bQm3c");



var $bEvUu = parcelRequire("bEvUu");

const $ce8c0a0fac7ee6d6$export$f4c25aea7c19a132 = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [isConnecting, setIsConnecting] = (0, $cozmU.useState)(false);
    const { authUrl: authUrl, isAuthenticated: isAuthenticated, isLoading: isLoading, onConnected: onConnected } = (0, $ef409225f8f5ce6a$export$bf91246c5b17e0bf)({
        aaId: userId ?? undefined,
        productKey: (0, $fR63l.ProductKeys3P).GoogleDrive
    });
    const connect = (0, $cozmU.useCallback)(async ()=>{
        if (!authUrl || isConnecting) return;
        createAnalyticsEvent((0, $4aa630edd4fe23e7$export$53f4484811034e3e)()).fire();
        setIsConnecting(true);
        try {
            await (0, $eEPSE.auth)(authUrl);
            createAnalyticsEvent((0, $4aa630edd4fe23e7$export$a58cc560aa8bc031)()).fire();
            // Optimistically flip + force-refresh the shared outbound-auth cache
            // so the banner self-hides on the next render without a page reload.
            onConnected();
        } catch (err) {
            // Swallow (incl. user-cancelled AuthError) so the banner stays put and the
            // fire-and-forget onClick caller never sees an unhandled rejection.
            const reason = err instanceof (0, $7zxJs.AuthError) ? err.type ?? null : null;
            createAnalyticsEvent((0, $4aa630edd4fe23e7$export$8d43fd709df6585d)(reason)).fire();
        } finally{
            setIsConnecting(false);
        }
    }, [
        authUrl,
        isConnecting,
        onConnected,
        createAnalyticsEvent
    ]);
    return {
        authUrl: authUrl,
        isAuthenticated: isAuthenticated,
        isLoading: isLoading,
        isConnecting: isConnecting,
        connect: connect
    };
};





const $df045363bf2d3f3b$var$SHOWN_ATTRIBUTES = {
    bannerType: 'gdrivePromo',
    connector: (0, $4aa630edd4fe23e7$export$450e9e5e468adef1)
};
const $df045363bf2d3f3b$export$e5db6c134b99f42d = ({ links: links, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const isPageFirstPartyOnly = links.length > 0 && links.every((l)=>(0, $cS4kb.isFirstPartyLink)(l.url));
    const { value: linkCounts, loading: isLinkCountLoading } = (0, $11c55f3cb3c29119$export$2bd9a43397bfe114)({
        skip: !isPageFirstPartyOnly
    });
    const hasSiteWideDriveLinks = (linkCounts?.[0, $11c55f3cb3c29119$export$3d6612235992a7fe] ?? 0) >= 1;
    const { authUrl: authUrl, isAuthenticated: isAuthenticated, isLoading: isAuthLoading, isConnecting: isConnecting, connect: connect } = (0, $ce8c0a0fac7ee6d6$export$f4c25aea7c19a132)();
    const { isDismissed: isDismissed, dismiss: dismiss } = (0, $aa04272ccb3d246a$export$6542d147ca3e4064)((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_BYLINE_CONNECTIONS_GDRIVE_BANNER_DISMISSED_PAGES, contentId);
    const isLoading = isLinkCountLoading || isAuthLoading;
    // First terminal failure in check order; loading yields `undefined` (not reported).
    let ineligibleReason;
    if (!isPageFirstPartyOnly) ineligibleReason = 'notFirstPartyOnly';
    else if (isLoading) ineligibleReason = undefined;
    else if (!hasSiteWideDriveLinks) ineligibleReason = 'noSiteWideDriveLinks';
    else if (isAuthenticated) ineligibleReason = 'alreadyAuthenticated';
    else if (isDismissed) ineligibleReason = 'dismissed';
    else if (!authUrl) ineligibleReason = 'noAuthUrl';
    const shouldShow = !isLoading && ineligibleReason === undefined;
    const hasFiredShownRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldShow || hasFiredShownRef.current) return;
        hasFiredShownRef.current = true;
        createAnalyticsEvent((0, $4aa630edd4fe23e7$export$57e0ff4c2905037a)($df045363bf2d3f3b$var$SHOWN_ATTRIBUTES)).fire();
    }, [
        shouldShow,
        createAnalyticsEvent
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent((0, $4aa630edd4fe23e7$export$c308d47e70cf3cab)($df045363bf2d3f3b$var$SHOWN_ATTRIBUTES)).fire();
        dismiss();
    }, [
        createAnalyticsEvent,
        dismiss
    ]);
    if (!shouldShow) return {
        element: null,
        ineligibleReason: ineligibleReason
    };
    return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aa7ff97a50d7e018$export$e7e7ab663009ba26), {
            onConnect: connect,
            onDismiss: handleDismiss,
            isConnecting: isConnecting
        }),
        ineligibleReason: undefined
    };
};









const $f1588a16e52e7972$export$6472f9a534a66ffb = 'confluence_smartlink_connector_adoption_by_app';
function $f1588a16e52e7972$export$983a3bcefb295c3f(raw) {
    if (raw === undefined || raw.trim() === '') return undefined;
    const rates = raw.split(',').reduce((acc, segment)=>{
        const colonIdx = segment.indexOf(':');
        if (colonIdx === -1) return acc;
        const provider = segment.slice(0, colonIdx).trim();
        const percentRaw = segment.slice(colonIdx + 1).trim();
        if (!provider || percentRaw === '') return acc;
        const percent = Number(percentRaw);
        if (Number.isNaN(percent)) return acc;
        acc[provider] = percent;
        return acc;
    }, {});
    return Object.keys(rates).length > 0 ? rates : undefined;
}
function $f1588a16e52e7972$export$5d94aa936f525952({ skip: skip } = {}) {
    return (0, $8ab372ddb9ea7e6c$export$284907af4a465a72)($f1588a16e52e7972$export$6472f9a534a66ffb, $f1588a16e52e7972$export$983a3bcefb295c3f, {
        skip: skip
    });
}



var $5b9Ab = parcelRequire("5b9Ab");




const $e34182895af441bd$export$76cb2c3a079a73ad = (link)=>!(0, $cS4kb.isFirstPartyLink)(link.url) && link.access === 'unauthorized' && (link.authProviders?.length ?? 0) > 0;
const $e34182895af441bd$export$2422c4837d41b3e1 = (key)=>key?.replace(/-object-provider$/, '');
const $e34182895af441bd$export$41c181e9c9608a62 = (rates, unconnectedTraitKeys)=>{
    if (!rates) return undefined;
    let best;
    for (const [traitKey, percent] of Object.entries(rates)){
        if (!unconnectedTraitKeys.has(traitKey)) continue;
        if (!best || percent > best.percent) best = {
            traitKey: traitKey,
            percent: percent
        };
    }
    return best;
};
const $e34182895af441bd$export$8a9749363d54b4fa = (links)=>{
    const traitKeys = new Set();
    for (const link of links){
        const traitKey = $e34182895af441bd$export$2422c4837d41b3e1(link.key);
        if (traitKey) traitKeys.add(traitKey);
    }
    return traitKeys;
};


/* OrgConnectedAppsPromoBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 





















var $38aC9 = parcelRequire("38aC9");

const $056e9a986d0dc712$export$5237495f42936402 = 30;
const $056e9a986d0dc712$var$i18n = (0, $kSwu1.defineMessages)({
    highAdoptionMessageTeamworkGraph: {
        id: "byline-connections.menu.footer.org-connected-apps.high-adoption.teamwork-graph",
        defaultMessage: "{percent}% of your org uses connected apps to see how their pages connect to their team's work"
    },
    lowAdoptionMessage: {
        id: "byline-connections.menu.footer.org-connected-apps.low-adoption",
        defaultMessage: "Top teams use connected apps to get richer previews instantly"
    },
    dismissAction: {
        id: "byline-connections.menu.footer.org-connected-apps.dismiss-action",
        defaultMessage: "Dismiss"
    }
});
const $056e9a986d0dc712$var$styles = {
    footer: "_4c065U8HPE _2Y7lL45zaO _0KLXrunmFW _0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67",
    message: "_2sNsIg7NXe _1UtDYzy7kJ"
};
const $056e9a986d0dc712$export$ef9e86b15c3c921f = ({ icon: icon, productLabel: productLabel, topAppPercent: topAppPercent, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isHighAdoption = topAppPercent !== undefined && topAppPercent >= $056e9a986d0dc712$export$5237495f42936402;
    const message = isHighAdoption ? formatMessage($056e9a986d0dc712$var$i18n.highAdoptionMessageTeamworkGraph, {
        percent: topAppPercent
    }) : formatMessage($056e9a986d0dc712$var$i18n.lowAdoptionMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $056e9a986d0dc712$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: productLabel,
        size: "small",
        backgroundColor: "color.background.neutral",
        hasBorder: true
    }, icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
        icon: icon,
        size: "menu"
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $056e9a986d0dc712$var$styles.message
    }, message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($056e9a986d0dc712$var$i18n.dismissAction),
        onClick: onDismiss
    })));
};







const $68b45a19d32ba347$export$ac27ad92182d0edf = ({ links: links, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const unconnectedThirdPartyLinks = links.filter((0, $e34182895af441bd$export$76cb2c3a079a73ad));
    const hasUnconnectedThirdParty = unconnectedThirdPartyLinks.length > 0;
    const { value: orgRates, loading: isRatesLoading } = (0, $f1588a16e52e7972$export$5d94aa936f525952)({
        skip: !hasUnconnectedThirdParty
    });
    const unconnectedTraitKeys = new Set();
    for (const l of unconnectedThirdPartyLinks){
        const traitKey = (0, $e34182895af441bd$export$2422c4837d41b3e1)(l.key);
        if (traitKey) unconnectedTraitKeys.add(traitKey);
    }
    const topApp = (0, $e34182895af441bd$export$41c181e9c9608a62)(orgRates, unconnectedTraitKeys);
    const { isDismissed: isDismissed, dismiss: dismiss } = (0, $aa04272ccb3d246a$export$6542d147ca3e4064)((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_BYLINE_CONNECTIONS_ORG_CONNECTED_APPS_BANNER_DISMISSED_PAGES, contentId);
    // First terminal failure in check order; loading yields `undefined` (not reported).
    let ineligibleReason;
    if (!hasUnconnectedThirdParty) ineligibleReason = 'noUnconnectedThirdParty';
    else if (isRatesLoading) ineligibleReason = undefined;
    else if (!topApp) ineligibleReason = 'noTopApp';
    else if (isDismissed) ineligibleReason = 'dismissed';
    const shouldShow = !isRatesLoading && ineligibleReason === undefined && !!topApp;
    const shownAttributes = (0, $cozmU.useMemo)(()=>topApp ? {
            bannerType: 'orgConnectedApps',
            connector: topApp.traitKey,
            variant: topApp.percent >= (0, $056e9a986d0dc712$export$5237495f42936402) ? 'highAdoption' : 'lowAdoption',
            topAppPercent: topApp.percent
        } : undefined, [
        topApp
    ]);
    const hasFiredShownRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldShow || !shownAttributes || hasFiredShownRef.current) return;
        hasFiredShownRef.current = true;
        createAnalyticsEvent((0, $4aa630edd4fe23e7$export$57e0ff4c2905037a)(shownAttributes)).fire();
    }, [
        shouldShow,
        shownAttributes,
        createAnalyticsEvent
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        if (shownAttributes) createAnalyticsEvent((0, $4aa630edd4fe23e7$export$c308d47e70cf3cab)(shownAttributes)).fire();
        dismiss();
    }, [
        createAnalyticsEvent,
        shownAttributes,
        dismiss
    ]);
    if (!shouldShow || !topApp) return {
        element: null,
        ineligibleReason: ineligibleReason
    };
    const matchingLink = unconnectedThirdPartyLinks.find((l)=>(0, $e34182895af441bd$export$2422c4837d41b3e1)(l.key) === topApp.traitKey);
    const productLabel = matchingLink?.product ?? matchingLink?.authProviders[0]?.displayName ?? '';
    const icon = matchingLink ? (0, $5b9Ab.getSmartLinkIcon)(matchingLink) : undefined;
    return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $056e9a986d0dc712$export$ef9e86b15c3c921f), {
            icon: icon,
            productLabel: productLabel,
            topAppPercent: topApp.percent,
            onDismiss: handleDismiss
        }),
        ineligibleReason: undefined
    };
};






const $bdf06e0777a6f6ad$export$5a9fbaf775882c40 = ({ links: links, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const gdrive = (0, $df045363bf2d3f3b$export$e5db6c134b99f42d)({
        links: links,
        contentId: contentId
    });
    const orgConnectedApps = (0, $68b45a19d32ba347$export$ac27ad92182d0edf)({
        links: links,
        contentId: contentId
    });
    const element = gdrive.element ?? orgConnectedApps.element ?? null;
    // Settled = rendered or has a terminal reason; both null/undefined = still loading.
    const gdriveSettled = gdrive.element !== null || gdrive.ineligibleReason !== undefined;
    const orgConnectedAppsSettled = orgConnectedApps.element !== null || orgConnectedApps.ineligibleReason !== undefined;
    // A shown-then-dismissed banner is covered by the dismissed event, not notShown.
    const hasShownBannerRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (element !== null) hasShownBannerRef.current = true;
    }, [
        element
    ]);
    // Wait for both to settle so an early-settling banner can't drop the other's reason.
    const hasFiredNotShownRef = (0, $cozmU.useRef)(false);
    const isSettledNotShown = element === null && gdriveSettled && orgConnectedAppsSettled;
    (0, $cozmU.useEffect)(()=>{
        if (!isSettledNotShown || hasFiredNotShownRef.current || hasShownBannerRef.current) return;
        hasFiredNotShownRef.current = true;
        createAnalyticsEvent((0, $4aa630edd4fe23e7$export$3155a85848c110b5)({
            gdriveIneligibleReason: gdrive.ineligibleReason,
            orgConnectedAppsIneligibleReason: orgConnectedApps.ineligibleReason
        })).fire();
    }, [
        element,
        isSettledNotShown,
        gdrive.ineligibleReason,
        orgConnectedApps.ineligibleReason,
        createAnalyticsEvent
    ]);
    return element;
};



var $eyzEJ = parcelRequire("eyzEJ");

const $7d8abc6089406daa$var$OTHER_PRODUCT_KEY = 'Others';
const $7d8abc6089406daa$export$d5a13f0f4d135b4b = (link)=>// Atlas links collapse under a single "Goals" group; provider casing (e.g.
    // GitHub, OneDrive) is preserved; everything else is Title-Cased. Product-less
    // links fall into the catch-all "Others" bucket.
    (0, $eyzEJ.formatProduct)(link.product) ?? $7d8abc6089406daa$var$OTHER_PRODUCT_KEY;
const $7d8abc6089406daa$var$getProductKey = (link)=>{
    if (link.access === 'unauthorized') {
        const authKey = link.authProviders[0]?.key;
        if (authKey) return authKey;
    }
    return link.product || $7d8abc6089406daa$var$OTHER_PRODUCT_KEY;
};
const $7d8abc6089406daa$var$isUnconnected = (link)=>link.access === 'unauthorized';
// Group ordering tier: unconnected-only groups float to the top, fully connected
// groups sink to the bottom, and mixed groups sit in between. Lower rank = higher up.
const $7d8abc6089406daa$var$UNCONNECTED_ONLY = 0;
const $7d8abc6089406daa$var$MIXED = 1;
const $7d8abc6089406daa$var$CONNECTED_ONLY = 2;
const $7d8abc6089406daa$var$getGroupRank = (bucket)=>{
    if (bucket.unconnectedLinks.length === 0) return $7d8abc6089406daa$var$CONNECTED_ONLY;
    if (bucket.connectedLinks.length === 0) return $7d8abc6089406daa$var$UNCONNECTED_ONLY;
    return $7d8abc6089406daa$var$MIXED;
};
// The catch-all "Others" bucket (product-less links) is always pinned to the very
// bottom of the menu, below every named-product bucket, regardless of its tier.
const $7d8abc6089406daa$var$isOtherBucket = (bucket)=>bucket.product === $7d8abc6089406daa$var$OTHER_PRODUCT_KEY;
function $7d8abc6089406daa$export$e6dd401ecbdb01d(links) {
    const buckets = new Map();
    for (const link of links){
        const label = $7d8abc6089406daa$export$d5a13f0f4d135b4b(link);
        let bucket = buckets.get(label);
        if (!bucket) {
            bucket = {
                product: label,
                productKey: $7d8abc6089406daa$var$getProductKey(link),
                unconnectedLinks: [],
                connectedLinks: []
            };
            buckets.set(label, bucket);
        }
        ($7d8abc6089406daa$var$isUnconnected(link) ? bucket.unconnectedLinks : bucket.connectedLinks).push(link);
    }
    const allBuckets = Array.from(buckets.values());
    const productBuckets = allBuckets.filter((bucket)=>!$7d8abc6089406daa$var$isOtherBucket(bucket));
    const otherBucket = allBuckets.find($7d8abc6089406daa$var$isOtherBucket);
    // Stable sort keeps groups of equal rank in first-appearance order. "Others"
    // is held out of the sort and appended last so it always sits at the bottom.
    const orderedBuckets = productBuckets.sort((a, b)=>$7d8abc6089406daa$var$getGroupRank(a) - $7d8abc6089406daa$var$getGroupRank(b));
    if (otherBucket) orderedBuckets.push(otherBucket);
    return orderedBuckets.map(({ product: product, productKey: productKey, unconnectedLinks: unconnectedLinks, connectedLinks: connectedLinks })=>({
            product: product,
            productKey: productKey,
            items: [
                ...unconnectedLinks,
                ...connectedLinks
            ]
        }));
}



var $86sr7 = parcelRequire("86sr7");

const $f18dee4c2180353b$export$7ca6ed2e32ded1fd = 3;
const $f18dee4c2180353b$export$6b0d42ce6f300e4e = 5;
const $f18dee4c2180353b$export$2fb5469733250ea6 = ({ relatedContentLinks: relatedContentLinks = [], incomingLinks: incomingLinks = [], outgoingLinks: outgoingLinks = [] }, limit = $f18dee4c2180353b$export$6b0d42ce6f300e4e)=>{
    const relatedContent = relatedContentLinks.slice(0, limit);
    const appearsIn = incomingLinks.slice(0, limit - relatedContent.length);
    const linksTo = (0, $86sr7.getTopConnectionLinks)([
        ...outgoingLinks
    ], limit - relatedContent.length - appearsIn.length);
    return {
        relatedContent: relatedContent,
        appearsIn: appearsIn,
        linksTo: linksTo,
        total: relatedContent.length + appearsIn.length + linksTo.length
    };
};
const $f18dee4c2180353b$export$4184afff02de6fec = (sources)=>$f18dee4c2180353b$export$2fb5469733250ea6(sources).total >= $f18dee4c2180353b$export$7ca6ed2e32ded1fd;





const $70835a6aefe6c403$var$MENU_WIDTH = '320px';
const $70835a6aefe6c403$var$TWG_MENU_BODY_MAX_HEIGHT = '600px';
const $70835a6aefe6c403$var$i18n = (0, $kSwu1.defineMessages)({
    connectionsTwg: {
        id: "byline-connections.menu.header.title-teamwork-graph-twg.do-not-translate",
        defaultMessage: "Teamwork Graph"
    },
    viewMoreContext: {
        id: "byline-connections.menu.view-more-context",
        defaultMessage: "View more context"
    },
    relatedContent: {
        id: "byline-connections.menu.section.related-content",
        defaultMessage: "Related content ({count}{isTruncated, select, true {+} other {}})"
    },
    appearsIn: {
        id: "byline-connections.menu.section.appears-in",
        defaultMessage: "Appears in ({count}{isTruncated, select, true {+} other {}})"
    },
    linksTo: {
        id: "byline-connections.menu.section.links-to",
        defaultMessage: "Links to ({count}{isTruncated, select, true {+} other {}})"
    }
});
const $70835a6aefe6c403$export$80311957bc63d8ad = $70835a6aefe6c403$var$i18n.relatedContent; /**
                                                                                     * Values for a section heading that lists `visibleCount` of `totalCount` rows. The heading counts
                                                                                     * the listed rows and appends "+" when the section is cut off, since the popup caps its rows and
                                                                                     * the preview panel shows the rest (CCINT-9385).
                                                                                     */ 
const $70835a6aefe6c403$export$24b96fcc263af8cb = (visibleCount, totalCount, // The source knows more rows exist than it has loaded (e.g. the graph's `hasNextPage`).
hasMore = false)=>({
        count: visibleCount,
        isTruncated: hasMore || totalCount > visibleCount ? 'true' : 'false'
    });
const $70835a6aefe6c403$var$styles = {
    menu: "_0bjKvDKTcp _39xV02sz7G _0KLXruoI2d",
    twgContent: "_0xmtkoFQfX _0NUa3rpNyl _2WAcuGIZbP",
    viewMoreContext: "_2Y7lL42ADO _4c065U8HPE",
    loading: "_4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _37wbyuDIqT"
};
const $70835a6aefe6c403$export$ea24a1e73cdd39d8 = (groups = [])=>{
    const attrs = {
        linkCount: 0,
        productBreakdown: {},
        authorizedLinkCount: 0,
        unauthorizedLinkCount: 0,
        connectableLinkCount: 0
    }; // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- linear in total link count; groups partition a finite link set
    for (const group of groups)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- linear in total link count; groups partition a finite link set
    for (const item of group.items){
        attrs.linkCount += 1;
        attrs.productBreakdown[group.productKey] = (attrs.productBreakdown[group.productKey] ?? 0) + 1;
        const isAuthorized = item.access === 'granted';
        if (isAuthorized) attrs.authorizedLinkCount += 1;
        else {
            attrs.unauthorizedLinkCount += 1;
            if ((item.authProviders?.length ?? 0) > 0) attrs.connectableLinkCount += 1;
        }
    }
    return attrs;
};
const $70835a6aefe6c403$export$b19b53e17ade0c8f = (links = [])=>links.filter((link)=>link.access === 'unauthorized').length;
const $70835a6aefe6c403$export$e4220f7b255072a8 = ({ showFooter: showFooter = true, links: links, incomingLinks: incomingLinks, incomingLinksHaveMore: incomingLinksHaveMore = false, incomingLinksSettled: incomingLinksSettled = true, additionalIcons: additionalIcons, minIcons: minIcons, relatedContentLinks: relatedContentLinks, relatedContentLoading: relatedContentLoading = false, devDocsConnection: devDocsConnection, contentId: contentId, refreshLinkUrl: refreshLinkUrl, onNavigate: onNavigate, onOpenPreviewPanel: onOpenPreviewPanel })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)(); // The sections render only once every source that fills the shared row slots has answered.
    const sectionsSettled = incomingLinksSettled && !relatedContentLoading; // Related content leads; Appears in and Links to fill the remaining rows when it is thin.
    const menuLinks = (0, $cozmU.useMemo)(()=>(0, $f18dee4c2180353b$export$2fb5469733250ea6)({
            relatedContentLinks: relatedContentLinks,
            incomingLinks: incomingLinks,
            outgoingLinks: links
        }), [
        relatedContentLinks,
        incomingLinks,
        links
    ]);
    const visibleLinks = (0, $cozmU.useMemo)(()=>[
            ...menuLinks.relatedContent,
            ...menuLinks.appearsIn,
            ...menuLinks.linksTo
        ], [
        menuLinks
    ]); // Only rendered rows count as viewed links; the footer and app icons read the full lists.
    const menuShownAttributes = (0, $cozmU.useMemo)(()=>({
            ...$70835a6aefe6c403$export$ea24a1e73cdd39d8((0, $7d8abc6089406daa$export$e6dd401ecbdb01d)(visibleLinks)),
            relatedContentCount: menuLinks.relatedContent.length,
            appearsInCount: menuLinks.appearsIn.length,
            linksToCount: menuLinks.linksTo.length
        }), [
        menuLinks,
        visibleLinks
    ]);
    const unauthenticatedLinkCount = (0, $cozmU.useMemo)(()=>$70835a6aefe6c403$export$b19b53e17ade0c8f(visibleLinks), [
        visibleLinks
    ]);
    const hasFiredRef = (0, $cozmU.useRef)(false);
    const hasFiredUnauthenticatedRef = (0, $cozmU.useRef)(false);
    const handleViewMoreContext = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'connectionsBylineViewMoreContext',
                source: 'connectionsBylineMenu'
            }
        }).fire();
        onOpenPreviewPanel();
    }, [
        createAnalyticsEvent,
        onOpenPreviewPanel
    ]); // Both viewed events wait for the sections to render so their counts match what was shown.
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current || !sectionsSettled) return;
        hasFiredRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'menu',
                actionSubjectId: 'connectionsBylineMenu',
                source: 'connectionsBylineMenu',
                attributes: menuShownAttributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        menuShownAttributes,
        sectionsSettled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredUnauthenticatedRef.current || !sectionsSettled || unauthenticatedLinkCount === 0) return;
        hasFiredUnauthenticatedRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'unauthenticatedSmartlink',
                actionSubjectId: 'connectionsBylineMenu',
                source: 'connectionsBylineMenu',
                attributes: {
                    unauthenticatedLinkCount: unauthenticatedLinkCount
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        unauthenticatedLinkCount,
        sectionsSettled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $70835a6aefe6c403$var$styles.menu,
        role: "dialog",
        "aria-label": formatMessage($70835a6aefe6c403$var$i18n.connectionsTwg)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $70835a6aefe6c403$var$styles.twgContent,
        testId: "connections-byline-menu.content"
    }, devDocsConnection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0311709cd7c6fed$export$23d9bfb525ce3655), {
        connection: devDocsConnection,
        onNavigate: onNavigate
    })) : null, !sectionsSettled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $70835a6aefe6c403$var$styles.loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        testId: "connections-byline-menu.loading"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92feead83550977e$export$825be6248d440e90), {
        heading: formatMessage($70835a6aefe6c403$var$i18n.relatedContent, $70835a6aefe6c403$export$24b96fcc263af8cb(menuLinks.relatedContent.length, relatedContentLinks?.length ?? 0)),
        links: menuLinks.relatedContent,
        refreshLinkUrl: refreshLinkUrl,
        linkDirection: "incoming",
        onNavigate: onNavigate,
        compact: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92feead83550977e$export$825be6248d440e90), {
        heading: formatMessage($70835a6aefe6c403$var$i18n.appearsIn, $70835a6aefe6c403$export$24b96fcc263af8cb(menuLinks.appearsIn.length, incomingLinks?.length ?? 0, incomingLinksHaveMore)),
        links: menuLinks.appearsIn,
        refreshLinkUrl: refreshLinkUrl,
        linkDirection: "incoming",
        onNavigate: onNavigate,
        compact: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92feead83550977e$export$825be6248d440e90), {
        heading: formatMessage($70835a6aefe6c403$var$i18n.linksTo, $70835a6aefe6c403$export$24b96fcc263af8cb(menuLinks.linksTo.length, links?.length ?? 0)),
        links: menuLinks.linksTo,
        refreshLinkUrl: refreshLinkUrl,
        linkDirection: "outgoing",
        onNavigate: onNavigate,
        compact: true
    }), showFooter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdf06e0777a6f6ad$export$5a9fbaf775882c40), {
        links: links ?? [],
        contentId: contentId
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $70835a6aefe6c403$var$styles.viewMoreContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))),
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        shouldFitContainer: true,
        onClick: handleViewMoreContext,
        testId: "connections-byline-menu.view-more-context-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "regular"
    }, formatMessage($70835a6aefe6c403$var$i18n.viewMoreContext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTfX9.BylineConnectionIconStack), {
        links: links ?? [],
        incomingLinks: incomingLinks,
        additionalIcons: additionalIcons,
        minIcons: minIcons,
        spacing: "none"
    }))))))));
};


/* EmbeddedConnectionsByLineMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 






























var $kC09O = parcelRequire("kC09O");

const $413f8f6d87a9e0c2$var$MENU_WIDTH = '320px';
const $413f8f6d87a9e0c2$var$MENU_BODY_MAX_HEIGHT = '600px';
const $413f8f6d87a9e0c2$var$i18n = (0, $kSwu1.defineMessages)({
    menuLabel: {
        id: "byline-connections.embedded-menu.label.do-not-translate",
        defaultMessage: "Teamwork Graph"
    },
    linksTo: {
        id: "byline-connections.embedded-menu.section.links-to",
        defaultMessage: "Links to ({count})"
    },
    empty: {
        id: "byline-connections.embedded-menu.empty",
        defaultMessage: "This content doesn\u2019t have any related content or links yet."
    }
});
const $413f8f6d87a9e0c2$var$styles = {
    menu: "_0bjKvDKTcp _39xV02sz7G _0KLXruoI2d",
    content: "_4c065U2ADO _0NUa3rpNyl _2WAcuGIZbP",
    showMore: "_2Y7lL48HPE _0xmtko2ADO",
    emptyState: "_4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _37wbyuDIqT"
};
// preview panel, so this is the only way to see more.
const $413f8f6d87a9e0c2$var$EmbeddedLinkSection = ({ section: section, heading: heading, links: links, linkDirection: linkDirection, compact: compact, refreshLinkUrl: refreshLinkUrl, onNavigate: onNavigate })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const hasMore = links.length > (0, $86sr7.DEFAULT_VISIBLE_LINK_COUNT);
    const visibleLinks = (0, $cozmU.useMemo)(()=>isExpanded ? links : links.slice(0, (0, $86sr7.DEFAULT_VISIBLE_LINK_COUNT)), [
        isExpanded,
        links
    ]);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.MENU_SHOW_MORE_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.EMBEDDED_MENU_SOURCE),
                attributes: {
                    section: section,
                    isExpanded: !isExpanded,
                    linkCount: links.length
                }
            }
        }).fire();
        setIsExpanded((wasExpanded)=>!wasExpanded);
    }, [
        createAnalyticsEvent,
        isExpanded,
        links.length,
        section
    ]);
    if (links.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92feead83550977e$export$825be6248d440e90), {
        heading: heading,
        links: visibleLinks,
        refreshLinkUrl: refreshLinkUrl,
        linkDirection: linkDirection,
        onNavigate: onNavigate,
        compact: compact,
        analyticsSource: (0, $I7TEB.EMBEDDED_MENU_SOURCE)
    }), hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $413f8f6d87a9e0c2$var$styles.showMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handleToggle,
        "aria-expanded": isExpanded,
        testId: `connections-byline-embedded-menu.${section}.show-more-button`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "regular",
        color: "color.text.subtlest"
    }, formatMessage(isExpanded ? (0, $kC09O.showLessMessage) : (0, $kC09O.showMoreMessage))))) : null);
};
const $413f8f6d87a9e0c2$export$661e43968c0d4a47 = ({ links: links, relatedContentLinks: relatedContentLinks, relatedContentLoading: relatedContentLoading = false, refreshLinkUrl: refreshLinkUrl, onNavigate: onNavigate })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const relatedLinks = (0, $cozmU.useMemo)(()=>relatedContentLinks ?? [], [
        relatedContentLinks
    ]); // Same order as the preview panel's Links to: unconnected first, then document order.
    const linksToLinks = (0, $cozmU.useMemo)(()=>(0, $86sr7.getTopConnectionLinks)(links ?? [], links?.length ?? 0), [
        links
    ]);
    const initiallyVisibleLinks = (0, $cozmU.useMemo)(()=>[
            ...relatedLinks.slice(0, (0, $86sr7.DEFAULT_VISIBLE_LINK_COUNT)),
            ...linksToLinks.slice(0, (0, $86sr7.DEFAULT_VISIBLE_LINK_COUNT))
        ], [
        relatedLinks,
        linksToLinks
    ]);
    const menuShownAttributes = (0, $cozmU.useMemo)(()=>(0, $70835a6aefe6c403$export$ea24a1e73cdd39d8)((0, $7d8abc6089406daa$export$e6dd401ecbdb01d)(initiallyVisibleLinks)), [
        initiallyVisibleLinks
    ]);
    const unauthenticatedLinkCount = (0, $cozmU.useMemo)(()=>(0, $70835a6aefe6c403$export$b19b53e17ade0c8f)(initiallyVisibleLinks), [
        initiallyVisibleLinks
    ]);
    const hasFiredRef = (0, $cozmU.useRef)(false);
    const hasFiredUnauthenticatedRef = (0, $cozmU.useRef)(false);
    const isEmpty = relatedLinks.length === 0 && linksToLinks.length === 0;
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'menu',
                actionSubjectId: 'connectionsBylineMenu',
                source: (0, $I7TEB.EMBEDDED_MENU_SOURCE),
                attributes: menuShownAttributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        menuShownAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredUnauthenticatedRef.current || unauthenticatedLinkCount === 0) return;
        hasFiredUnauthenticatedRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'unauthenticatedSmartlink',
                actionSubjectId: 'connectionsBylineMenu',
                source: (0, $I7TEB.EMBEDDED_MENU_SOURCE),
                attributes: {
                    unauthenticatedLinkCount: unauthenticatedLinkCount
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        unauthenticatedLinkCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $413f8f6d87a9e0c2$var$styles.menu,
        role: "dialog",
        "aria-label": formatMessage($413f8f6d87a9e0c2$var$i18n.menuLabel),
        testId: "connections-byline-embedded-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $413f8f6d87a9e0c2$var$styles.content,
        testId: "connections-byline-embedded-menu.content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($413f8f6d87a9e0c2$var$EmbeddedLinkSection, {
        section: "relatedContent",
        heading: formatMessage((0, $70835a6aefe6c403$export$80311957bc63d8ad), {
            count: relatedLinks.length,
            isTruncated: 'false'
        }),
        links: relatedLinks,
        linkDirection: "incoming",
        refreshLinkUrl: refreshLinkUrl,
        onNavigate: onNavigate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($413f8f6d87a9e0c2$var$EmbeddedLinkSection, {
        section: "linksTo",
        heading: formatMessage($413f8f6d87a9e0c2$var$i18n.linksTo, {
            count: linksToLinks.length
        }),
        links: linksToLinks,
        linkDirection: "outgoing",
        refreshLinkUrl: refreshLinkUrl,
        onNavigate: onNavigate,
        compact: true
    }), isEmpty && relatedContentLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $413f8f6d87a9e0c2$var$styles.emptyState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        testId: "connections-byline-embedded-menu.loading"
    })) : null, isEmpty && !relatedContentLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $413f8f6d87a9e0c2$var$styles.emptyState,
        testId: "connections-byline-embedded-menu.empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($413f8f6d87a9e0c2$var$i18n.empty))) : null));
};



var $jJhQa = parcelRequire("jJhQa");

const $6446e86d25470e0f$export$7d80207c8e349893 = ({ isEmbeddedMenu: isEmbeddedMenu, ...props })=>isEmbeddedMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $413f8f6d87a9e0c2$export$661e43968c0d4a47), {
        links: props.links,
        relatedContentLinks: props.relatedContentLinks,
        relatedContentLoading: props.relatedContentLoading,
        refreshLinkUrl: props.refreshLinkUrl,
        onNavigate: props.onNavigate
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70835a6aefe6c403$export$e4220f7b255072a8), {
        ...props,
        minIcons: (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS),
        showFooter: (props.links?.length ?? 0) > 0
    });









var $lpNn5 = parcelRequire("lpNn5");


const $3b26d85faa48c333$var$i18n = (0, $kSwu1.defineMessages)({
    tooltipTwg: {
        id: "byline-connections.tooltip-twg-v2",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "See how this content connects to your team's work"
    }
});
const $3b26d85faa48c333$export$d734136a7b018efe = (ref, node)=>{
    if (typeof ref === 'function') ref(node);
    else if (ref && 'current' in ref) ref.current = node;
};
/**
 * Resolves the byline tooltip text. Returns an empty string while the menu is
 * open (the tooltip is suppressed then), otherwise the Teamwork Graph label.
 */ const $3b26d85faa48c333$var$getTooltipContent = (isOpen, formatMessage)=>{
    if (isOpen) return '';
    return formatMessage($3b26d85faa48c333$var$i18n.tooltipTwg);
};
// Hooks belong to this component rather than the Tooltip render callback.
const $3b26d85faa48c333$var$TooltipTriggerButton = ({ links: links, incomingLinks: incomingLinks, additionalIcons: additionalIcons, minIcons: minIcons, isOpen: isOpen, popupTriggerProps: popupTriggerProps, triggerRef: triggerRef, onToggle: onToggle, tooltipTriggerProps: tooltipTriggerProps })=>{
    const popupRef = popupTriggerProps.ref;
    const tooltipRef = tooltipTriggerProps.ref;
    const setTriggerRef = (0, $cozmU.useCallback)((node)=>{
        triggerRef.current = node;
        $3b26d85faa48c333$export$d734136a7b018efe(popupRef, node);
        tooltipRef(node);
    }, [
        triggerRef,
        popupRef,
        tooltipRef
    ]);
    const buttonProps = (0, $cozmU.useMemo)(()=>({
            ...tooltipTriggerProps,
            ...popupTriggerProps,
            ref: setTriggerRef,
            onClick: (event)=>{
                tooltipTriggerProps.onClick(event);
                onToggle();
            },
            'aria-expanded': isOpen,
            'aria-haspopup': 'dialog'
        }), [
        popupTriggerProps,
        tooltipTriggerProps,
        setTriggerRef,
        onToggle,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55dbae87bfebb50e$export$a5631cafd5b67535), {
        appearance: "loaded",
        links: links,
        incomingLinks: incomingLinks,
        additionalIcons: additionalIcons,
        minIcons: minIcons,
        buttonProps: buttonProps
    });
};
const $3b26d85faa48c333$export$89fbf9e9996a306c = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: $3b26d85faa48c333$var$getTooltipContent(props.isOpen, formatMessage)
    }, (tooltipTriggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3b26d85faa48c333$var$TooltipTriggerButton, {
            ...props,
            tooltipTriggerProps: tooltipTriggerProps
        }));
};


const $d9aa28ddd15f0f51$export$bec8506dda89613f = ({ isOpen: isOpen, onClose: onClose, menuProps: menuProps, triggerProps: triggerProps })=>{
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const content = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6446e86d25470e0f$export$7d80207c8e349893), menuProps), [
        menuProps
    ]);
    const trigger = (0, $cozmU.useCallback)((popupTriggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3b26d85faa48c333$export$89fbf9e9996a306c), {
            ...triggerProps,
            isOpen: isOpen,
            popupTriggerProps: popupTriggerProps
        }), [
        triggerProps,
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55dbae87bfebb50e$export$8b56d9356350e1f6), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        shouldReturnFocus: false,
        content: content,
        trigger: trigger
    }));
};






var $fZLJ8 = parcelRequire("fZLJ8");

/* BylineConnectionsPlaceholderVisual.tsx generated by @compiled/babel-plugin v3.0.2 */ 



















var $f0mzK = parcelRequire("f0mzK");

const $25cd036cbf182d70$var$i18n = (0, $kSwu1.defineMessages)({
    loadingConnections: {
        id: "byline-connections.loading",
        defaultMessage: "Loading connections"
    }
});
const $25cd036cbf182d70$var$styles = {
    loadingMenu: "_0bjKvDKTcp _4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _37wbyuDIqT _39xV02sz7G _0KLXruoI2d"
};
const $25cd036cbf182d70$var$placeholderIcons = Array.from({
    length: (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS)
}, (_, index)=>(0, $f0mzK.createPlaceholderConnectionIcon)(index)); /**
                                                           * The Teamwork Graph logo + label + app-icon stack placeholder shown while the byline
                                                           * connections item is resolving. Shared by the SSR/loadable placeholder and the
                                                           * loaded component's own loading state so the footprint lines up across the
                                                           * SSR → client-load → data-load → item handoff, avoiding layout shift. All loading
                                                           * states reserve three tiles; the loaded stack fills spare slots with AI tool icons.
                                                           *
                                                           * The byline controls the popup state during data loading so it survives the placeholder handoff.
                                                           */ 
const $25cd036cbf182d70$export$3914fbcb8a4d6407 = ({ testId: testId = 'byline-connections-ssr-placeholder', isOpen: controlledIsOpen, onOpenChange: onOpenChange })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const [localIsOpen, setLocalIsOpen] = (0, $cozmU.useState)(false);
    const isOpen = controlledIsOpen ?? localIsOpen;
    const setIsOpen = onOpenChange ?? setLocalIsOpen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55dbae87bfebb50e$export$8b56d9356350e1f6), {
        role: "status",
        "aria-label": formatMessage($25cd036cbf182d70$var$i18n.loadingConnections),
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $25cd036cbf182d70$var$styles.loadingMenu,
                role: "dialog",
                "aria-busy": "true",
                "aria-label": formatMessage($25cd036cbf182d70$var$i18n.loadingConnections)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "medium",
                testId: "byline-connections-loading-menu-spinner"
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55dbae87bfebb50e$export$a5631cafd5b67535), {
                appearance: "placeholder",
                links: [],
                additionalIcons: $25cd036cbf182d70$var$placeholderIcons,
                buttonProps: {
                    ...triggerProps,
                    onClick: ()=>setIsOpen(!isOpen),
                    'aria-expanded': isOpen,
                    'aria-haspopup': 'dialog'
                }
            })
    }));
};



const $2e2c24ad29df8d85$var$countSampledRows = (state)=>state?.status === 'present' ? state.count : 0;
const $2e2c24ad29df8d85$export$668fe94d630a199 = ({ outboundState: outboundState, incomingLinksState: incomingLinksState, relatedContentState: relatedContentState, hasDevDocsConnection: hasDevDocsConnection })=>{
    if (hasDevDocsConnection) return true;
    const outboundLinkCount = outboundState?.status === 'present' ? outboundState.linkCount : 0;
    const sampledLinkCount = outboundLinkCount + $2e2c24ad29df8d85$var$countSampledRows(incomingLinksState) + $2e2c24ad29df8d85$var$countSampledRows(relatedContentState);
    return sampledLinkCount >= (0, $f18dee4c2180353b$export$7ca6ed2e32ded1fd);
};


// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $jMyy4 = parcelRequire("jMyy4");





var $6WgQx = parcelRequire("6WgQx");


var $47TZD = parcelRequire("47TZD");

// Passed only while the read is skipped, so the exact value never keys a real cache lookup.
const $c1244bdd1b458e82$var$SKIPPED_VARIABLES = {
    cypherQuery: '',
    first: 0,
    after: null
};
const $c1244bdd1b458e82$export$36c53bcdf571f79b = (contentId, contentType)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const variables = !contentId || !cloudId ? undefined : (0, $47TZD.buildIncomingLinksSampleVariables)(cloudId, contentId, contentType);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $6WgQx.default), {
        variables: variables ?? $c1244bdd1b458e82$var$SKIPPED_VARIABLES,
        fetchPolicy: 'cache-only',
        skip: variables === undefined,
        interopApolloAggClient: true,
        __callerPackage__: "byline-connections"
    });
    // An undefined `variables` forces `skip`, which forces `data` undefined, so the `data` guard
    // already covers it; the `contentId` guard also narrows it to a string for the normalizer.
    if (!contentId || data === undefined) return undefined;
    return (0, $47TZD.normalizeIncomingLinksSsrState)(contentId, data);
};



var $6SsN4 = parcelRequire("6SsN4");


var $8VTwN = parcelRequire("8VTwN");





var $3C8hL = parcelRequire("3C8hL");

const $4fdcf8c799fd8a14$export$4ec68330314c7b96 = (contentId)=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $8VTwN.default), {
        contentId: contentId ?? '',
        first: (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS),
        smartLinksFromDraft: false
    }, {
        fetchPolicy: 'store-only'
    });
    if (contentId === undefined) return undefined;
    return (0, $3C8hL.normalizeOutboundBylineSsrState)(contentId, data);
};









var $7pgTN = parcelRequire("7pgTN");


var $26brz = parcelRequire("26brz");

// Read with these only when there is nothing to look up, so the exact value never keys a real store
// read. A store-only read never touches the network, so a dummy lookup is free.
const $15ca35a849ff5bf4$var$SKIPPED_VARIABLES = {
    cypherQuery: '',
    queryContext: '',
    version: 'V3',
    first: 0
};
const $15ca35a849ff5bf4$export$58c3bd07661395fe = (contentId, contentType)=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const variables = !contentId || !cloudId || !activationId ? undefined : (0, $26brz.buildRelatedContentSampleVariables)(cloudId, activationId, contentId, contentType);
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $7pgTN.default), variables ?? $15ca35a849ff5bf4$var$SKIPPED_VARIABLES, {
        fetchPolicy: 'store-only'
    });
    if (!contentId || variables === undefined || data?.graphStore_cypherQueryV2 == null) return undefined;
    return (0, $26brz.normalizeRelatedContentSsrState)(contentId, data);
};


const $d13ffa3aaf9dd66c$export$f8ba3742be6a3e0d = ({ contentId: contentId, contentType: contentType, connectionAncestors: connectionAncestors, isOpen: isOpen, onOpenChange: onOpenChange })=>{
    // Read the preloaded states on the client too (store-only, hydrated from the SSR preloads). This
    // lets the placeholder stay visible after the post-paint hydration and while the LoadableAfterPaint
    // chunk loads, instead of blanking — which caused the "SSR placeholder → nothing → skeleton → item"
    // flash. The result is derived purely from the hydrated store and dev-docs, so it is identical on
    // the server and the client's first render (no hydration mismatch). CCINT-8752
    const outboundState = (0, $4fdcf8c799fd8a14$export$4ec68330314c7b96)(contentId);
    const incomingLinksState = (0, $c1244bdd1b458e82$export$36c53bcdf571f79b)(contentId, contentType);
    const relatedContentState = (0, $15ca35a849ff5bf4$export$58c3bd07661395fe)(contentId, contentType);
    const devDocsConnection = (0, $fZLJ8.useDevDocsBylineConnection)(connectionAncestors);
    // Paint only when the sampled sources together reach the byline's row minimum (or Dev Docs), the
    // same rule the loaded byline applies, so a page that will hide keeps no footprint. CCINT-9359
    const shouldPaint = (0, $2e2c24ad29df8d85$export$668fe94d630a199)({
        outboundState: outboundState,
        incomingLinksState: incomingLinksState,
        relatedContentState: relatedContentState,
        hasDevDocsConnection: devDocsConnection !== null
    });
    if (!shouldPaint) return null;
    // The footprint is fixed at three tiles for any positive signal. CCINT-9354
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $25cd036cbf182d70$export$3914fbcb8a4d6407), {
        isOpen: isOpen,
        onOpenChange: onOpenChange
    });
};


















var $kcIQr = parcelRequire("kcIQr");





var $5ZqQS = parcelRequire("5ZqQS");





var $8wK2O = parcelRequire("8wK2O");


var $8jDil = parcelRequire("8jDil");


var $6PfFM = parcelRequire("6PfFM");

const $03bac7ea60cf471f$export$492c3dde363c3c4a = 300;
const $03bac7ea60cf471f$var$CARD_NODE_TYPES = new Set([
    'inlineCard',
    'blockCard',
    'embedCard'
]);
const $03bac7ea60cf471f$var$BLOCK_CONTAINERS = new Set([
    'paragraph',
    'heading',
    'blockquote',
    'listItem',
    'tableCell',
    'tableHeader'
]);
const $03bac7ea60cf471f$var$asUrl = (value)=>typeof value === 'string' && value ? value : undefined;
const $03bac7ea60cf471f$var$cardUrl = (node)=>{
    if (!$03bac7ea60cf471f$var$CARD_NODE_TYPES.has(node.type ?? '')) return undefined;
    return $03bac7ea60cf471f$var$asUrl(node.attrs?.url);
};
/**
 * `href` of the node's `link` mark, i.e. an ordinary text hyperlink. These are
 * smart links too: `collectSmartLinks` walks the ADF with link marks included,
 * so a bare `<a>` in prose becomes a connection row and needs an excerpt.
 */ const $03bac7ea60cf471f$var$linkMarkUrl = (node)=>$03bac7ea60cf471f$var$asUrl(node.marks?.find((mark)=>mark?.type === 'link')?.attrs?.href);
const $03bac7ea60cf471f$var$readText = (node)=>{
    if (!node) return '';
    if (typeof node.text === 'string') return node.text;
    if ($03bac7ea60cf471f$var$cardUrl(node)) return '';
    if (!Array.isArray(node.content)) return '';
    const parts = [];
    for (const child of node.content){
        // ADF documents are bounded trees; this walk is linear in node count.
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        const text = $03bac7ea60cf471f$var$readText(child);
        if (text) parts.push(text);
    }
    return parts.join(' ');
};
const $03bac7ea60cf471f$var$collectLinkUrls = (node, urls)=>{
    const url = $03bac7ea60cf471f$var$cardUrl(node) ?? $03bac7ea60cf471f$var$linkMarkUrl(node);
    if (url) urls.push(url);
    if (!Array.isArray(node.content)) return;
    for (const child of node.content)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    $03bac7ea60cf471f$var$collectLinkUrls(child, urls);
};
const $03bac7ea60cf471f$var$normalizeExcerpt = (text)=>{
    const excerpt = text.replace(/\s+/g, ' ').trim().slice(0, $03bac7ea60cf471f$export$492c3dde363c3c4a);
    return excerpt || undefined;
};
const $03bac7ea60cf471f$export$6c4343d44e5cebbf = (adf)=>{
    const excerpts = new Map();
    if (!adf) return excerpts;
    const visit = (node)=>{
        if (node.type && $03bac7ea60cf471f$var$BLOCK_CONTAINERS.has(node.type)) {
            const urls = [];
            $03bac7ea60cf471f$var$collectLinkUrls(node, urls);
            const excerpt = $03bac7ea60cf471f$var$normalizeExcerpt($03bac7ea60cf471f$var$readText(node));
            if (excerpt) {
                for (const url of urls)if (!excerpts.has(url)) excerpts.set(url, excerpt);
            }
        }
        if (!Array.isArray(node.content)) return;
        for (const child of node.content)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        visit(child);
    };
    visit(adf);
    return excerpts;
};


const $db72bc08cbbd6b4c$export$ec1ca82b1edf9048 = 12000;
const $db72bc08cbbd6b4c$var$BLOCK_CONTAINERS = new Set([
    'doc',
    'bulletList',
    'orderedList',
    'blockquote'
]);
const $db72bc08cbbd6b4c$var$readNode = (node)=>{
    if (!node) return '';
    if (typeof node.text === 'string') return node.text;
    if (!Array.isArray(node.content)) return '';
    const parts = [];
    for (const child of node.content){
        // ADF documents are bounded trees; this walk is linear in node count.
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        const text = $db72bc08cbbd6b4c$var$readNode(child);
        if (text) parts.push(text);
    }
    const joiner = node.type && $db72bc08cbbd6b4c$var$BLOCK_CONTAINERS.has(node.type) ? '\n' : '';
    return parts.join(joiner);
};
const $db72bc08cbbd6b4c$export$a8e659250f355f39 = (adf, limit = $db72bc08cbbd6b4c$export$ec1ca82b1edf9048)=>{
    const text = $db72bc08cbbd6b4c$var$readNode(adf).trim();
    return {
        excerpt: text.slice(0, limit),
        truncated: text.length > limit
    };
};


const $ecb19719bff78326$export$2fae90a4e4e36b78 = 500;
const $ecb19719bff78326$export$9416c2a80a09f13b = 500;
const $ecb19719bff78326$export$48d048be5cad15bc = 200;
const $ecb19719bff78326$export$9683d79c925e4028 = 100;
const $ecb19719bff78326$export$a550edcb8bc20dd8 = 100;
const $ecb19719bff78326$export$365e7098654a67ce = 35;
const $ecb19719bff78326$var$bound = (value, limit)=>{
    const normalized = value?.trim();
    return normalized ? normalized.slice(0, limit) : undefined;
};
const $ecb19719bff78326$var$toIsoInstant = (value)=>{
    if (typeof value !== 'string') return undefined;
    const normalized = value.trim();
    if (!normalized || !/(?:Z|[+-]\d{2}:\d{2})$/i.test(normalized)) return undefined;
    const timestamp = new Date(normalized);
    return Number.isNaN(timestamp.getTime()) ? undefined : timestamp.toISOString();
};
const $ecb19719bff78326$var$toPositiveContentVersion = (value)=>typeof value === 'number' && Number.isInteger(value) && value > 0 ? value : undefined;
const $ecb19719bff78326$var$relationshipFor = (collection, link, sourceExcerpts)=>{
    if (collection === 'appears_in') return {
        collection: collection,
        type: 'content_referenced_entity',
        direction: 'incoming',
        source_excerpt: null
    };
    if (collection === 'related_content') return {
        collection: collection,
        type: 'confluence_content_has_related_confluence_content',
        direction: 'outgoing',
        source_excerpt: null
    };
    return {
        collection: collection,
        type: 'page_contains_smart_link',
        direction: 'outgoing',
        source_excerpt: $ecb19719bff78326$var$bound(sourceExcerpts.get(link.url), (0, $03bac7ea60cf471f$export$492c3dde363c3c4a)) ?? null
    };
};
const $ecb19719bff78326$var$entityContextFor = (link)=>{
    const summary = $ecb19719bff78326$var$bound(link.summary, $ecb19719bff78326$export$9416c2a80a09f13b);
    const status = $ecb19719bff78326$var$bound(link.taskStatus, $ecb19719bff78326$export$48d048be5cad15bc) ?? $ecb19719bff78326$var$bound(link.state, $ecb19719bff78326$export$48d048be5cad15bc);
    const updatedAt = $ecb19719bff78326$var$toIsoInstant(link.updatedAt);
    return summary || status || updatedAt ? {
        ...summary ? {
            summary: summary
        } : {},
        ...status ? {
            status: status
        } : {},
        ...updatedAt ? {
            updated_at: updatedAt
        } : {}
    } : undefined;
};
const $ecb19719bff78326$var$mergeEntityContext = (primary, secondary)=>{
    if (!primary) return secondary;
    if (!secondary) return primary;
    const summary = primary.summary ?? secondary.summary;
    const status = primary.status ?? secondary.status;
    const updatedAt = primary.updated_at ?? secondary.updated_at;
    return {
        ...summary ? {
            summary: summary
        } : {},
        ...status ? {
            status: status
        } : {},
        ...updatedAt ? {
            updated_at: updatedAt
        } : {}
    };
};
const $ecb19719bff78326$var$toEntity = (link, collection, sourceExcerpts)=>{
    const title = $ecb19719bff78326$var$bound(link.title, $ecb19719bff78326$export$2fae90a4e4e36b78);
    if (link.access !== 'granted' || !link.ari || !title) return null;
    const entityContext = $ecb19719bff78326$var$entityContextFor(link);
    const product = $ecb19719bff78326$var$bound(link.product, $ecb19719bff78326$export$9683d79c925e4028);
    const resourceType = $ecb19719bff78326$var$bound(link.resourceType, $ecb19719bff78326$export$a550edcb8bc20dd8);
    return {
        ari: link.ari,
        title: title,
        ...product ? {
            product: product
        } : {},
        ...resourceType ? {
            resource_type: resourceType
        } : {},
        relationships: [
            $ecb19719bff78326$var$relationshipFor(collection, link, sourceExcerpts)
        ],
        ...entityContext ? {
            entity_context: entityContext
        } : {}
    };
};
const $ecb19719bff78326$var$collectEntities = (links, collection, sourceExcerpts)=>{
    const entities = [];
    for (const link of links){
        const entity = $ecb19719bff78326$var$toEntity(link, collection, sourceExcerpts);
        if (entity) entities.push(entity);
    }
    return entities;
};
const $ecb19719bff78326$var$structuralParentEntityFor = (cloudId, ancestors)=>{
    if (!ancestors) return null;
    // Confluence ancestors are root-first. Select one nearest page ancestor so
    // hierarchy evidence stays useful and bounded even below folders/databases.
    for(let index = ancestors.length - 1; index >= 0; index--){
        const ancestor = ancestors[index];
        const id = ancestor?.id?.trim();
        const title = $ecb19719bff78326$var$bound(ancestor?.title ?? undefined, $ecb19719bff78326$export$2fae90a4e4e36b78);
        if (!id || !title || ancestor?.type?.toLowerCase() !== 'page') continue;
        return {
            ari: (0, $8jDil.ConfluencePageAri).create({
                siteId: cloudId,
                pageId: id
            }).toString(),
            title: title,
            product: 'confluence',
            resource_type: 'page',
            relationships: [
                {
                    collection: 'ancestors',
                    type: 'confluence_page_has_child_confluence_page',
                    direction: 'incoming',
                    source_excerpt: null
                }
            ]
        };
    }
    return null;
};
/**
 * Deduplicates entities by ARI and keeps one relationship per collection. An entity reached
 * through several collections carries all of them: each names a different thing the page and the
 * entity have to do with each other, and only the `links_to` relationship can carry a
 * `source_excerpt`. The count needs no limit of its own — `AtAGlanceCollection` has four members,
 * so four relationships is the ceiling.
 */ const $ecb19719bff78326$var$mergeByAri = (entities)=>{
    const byAri = new Map();
    for (const entity of entities){
        const existing = byAri.get(entity.ari);
        const nextRelationship = entity.relationships[0];
        if (!existing) {
            byAri.set(entity.ari, entity);
            continue;
        }
        if (!nextRelationship) continue;
        const existingRelationshipIndex = existing.relationships.findIndex((relationship)=>relationship.collection === nextRelationship.collection);
        if (existingRelationshipIndex !== -1) {
            const existingRelationship = existing.relationships[existingRelationshipIndex];
            if (!existingRelationship) continue;
            const entityContext = $ecb19719bff78326$var$mergeEntityContext(existing.entity_context, entity.entity_context);
            const relationship = !existingRelationship.source_excerpt && nextRelationship.source_excerpt ? {
                ...existingRelationship,
                source_excerpt: nextRelationship.source_excerpt
            } : existingRelationship;
            const relationships = [
                ...existing.relationships
            ];
            relationships[existingRelationshipIndex] = relationship;
            byAri.set(entity.ari, {
                ...existing,
                product: existing.product ?? entity.product,
                resource_type: existing.resource_type ?? entity.resource_type,
                relationships: relationships,
                ...entityContext ? {
                    entity_context: entityContext
                } : {}
            });
            continue;
        }
        const entityContext = $ecb19719bff78326$var$mergeEntityContext(existing.entity_context, entity.entity_context);
        byAri.set(entity.ari, {
            ...existing,
            product: existing.product ?? entity.product,
            resource_type: existing.resource_type ?? entity.resource_type,
            relationships: [
                ...existing.relationships,
                nextRelationship
            ],
            ...entityContext ? {
                entity_context: entityContext
            } : {}
        });
    }
    return [
        ...byAri.values()
    ];
};
const $ecb19719bff78326$export$1d4beabc419323b8 = ({ cloudId: cloudId, contentId: contentId, contentType: contentType, locale: locale, pageTitle: pageTitle, pageVersion: pageVersion, pageUpdatedAt: pageUpdatedAt, pageAdf: pageAdf, structuralAncestors: structuralAncestors, incomingLinks: incomingLinks, outgoingLinks: outgoingLinks, relatedContentLinks: relatedContentLinks = [] })=>{
    const normalizedLocale = locale.trim();
    const title = $ecb19719bff78326$var$bound(pageTitle, $ecb19719bff78326$export$2fae90a4e4e36b78);
    if (!normalizedLocale || normalizedLocale.length > $ecb19719bff78326$export$365e7098654a67ce || !title) return null;
    const { excerpt: excerpt, truncated: truncated } = (0, $db72bc08cbbd6b4c$export$a8e659250f355f39)(pageAdf);
    if (!excerpt) return null;
    const sourceExcerpts = outgoingLinks.length > 0 ? (0, $03bac7ea60cf471f$export$6c4343d44e5cebbf)(pageAdf) : new Map();
    const incoming = $ecb19719bff78326$var$collectEntities(incomingLinks, 'appears_in', sourceExcerpts);
    const outgoing = $ecb19719bff78326$var$collectEntities(outgoingLinks, 'links_to', sourceExcerpts);
    const related = $ecb19719bff78326$var$collectEntities(relatedContentLinks, 'related_content', sourceExcerpts);
    const structuralParent = $ecb19719bff78326$var$structuralParentEntityFor(cloudId, structuralAncestors);
    // Every deduplicated entity is sent. cc-smarts reconciles this inventory with its own
    // unbounded graph discovery, and it cannot recover what is dropped here: incoming-only
    // entities, related content, ancestors, and outgoing links whose graph type its discovery
    // does not decode all reach the model only via this list.
    //
    // The order is evidence strength, not priority for a cap: related content (the only
    // collection whose one-liners the UI renders), then the structural parent, then links the
    // page makes explicitly, then references to it. `mergeByAri` keeps an entity at its first
    // occurrence, so the order is deterministic and the request body stays a stable cache key.
    const linkedEntities = $ecb19719bff78326$var$mergeByAri([
        ...related,
        ...structuralParent ? [
            structuralParent
        ] : [],
        ...outgoing,
        ...incoming
    ]);
    const version = $ecb19719bff78326$var$toPositiveContentVersion(pageVersion);
    const updatedAt = $ecb19719bff78326$var$toIsoInstant(pageUpdatedAt);
    return {
        content_ari: (0, $6PfFM.buildContentAri)(cloudId, contentId, contentType),
        locale: normalizedLocale,
        central_page: {
            title: title,
            mime_type: 'text/markdown',
            excerpt: excerpt,
            truncated: truncated,
            ...version ? {
                version: version
            } : {},
            ...updatedAt ? {
                updated_at: updatedAt
            } : {}
        },
        linked_entities: linkedEntities
    };
};


const $994dd0020fdf55a7$var$MAX_OVERVIEW_ITEMS = 3;
const $994dd0020fdf55a7$var$MAX_SUMMARIES = 30;
const $994dd0020fdf55a7$var$MAX_ARI_LENGTH = 1000;
const $994dd0020fdf55a7$var$MAX_OUTPUT_TEXT_LENGTH = 500;
const $994dd0020fdf55a7$var$MAX_LABEL_LENGTH = 40;
const $994dd0020fdf55a7$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $994dd0020fdf55a7$var$isNonEmptyString = (value, limit)=>typeof value === 'string' && value.trim().length > 0 && value.length <= limit;
const $994dd0020fdf55a7$var$adaptOverviewItem = (value)=>{
    const normalized = value.replace(/\*\*/g, '').trim();
    const separatorIndex = normalized.indexOf(': ');
    if (separatorIndex <= 0 || separatorIndex > $994dd0020fdf55a7$var$MAX_LABEL_LENGTH) return {
        label: '',
        text: normalized,
        evidence: []
    };
    return {
        label: normalized.slice(0, separatorIndex),
        text: normalized.slice(separatorIndex + 2),
        evidence: []
    };
};
const $994dd0020fdf55a7$export$6b24c40e5c2263a8 = (value)=>{
    const { overview: overview, summaries: summaries } = value;
    if ('status' in value || !Array.isArray(overview) || !Array.isArray(summaries)) return null;
    const parsedOverview = [];
    const seenOverview = new Set();
    for (const item of overview){
        if (!$994dd0020fdf55a7$var$isNonEmptyString(item, $994dd0020fdf55a7$var$MAX_OUTPUT_TEXT_LENGTH)) continue;
        const normalized = item.trim();
        if (seenOverview.has(normalized)) continue;
        seenOverview.add(normalized);
        parsedOverview.push($994dd0020fdf55a7$var$adaptOverviewItem(normalized));
        if (parsedOverview.length === $994dd0020fdf55a7$var$MAX_OVERVIEW_ITEMS) break;
    }
    const parsedSummaries = [];
    for (const summary of summaries){
        if (!$994dd0020fdf55a7$var$isRecord(summary)) continue;
        if (!$994dd0020fdf55a7$var$isNonEmptyString(summary.ari, $994dd0020fdf55a7$var$MAX_ARI_LENGTH) || !$994dd0020fdf55a7$var$isNonEmptyString(summary.title, $994dd0020fdf55a7$var$MAX_OUTPUT_TEXT_LENGTH) || !$994dd0020fdf55a7$var$isNonEmptyString(summary.oneLiner, $994dd0020fdf55a7$var$MAX_OUTPUT_TEXT_LENGTH)) continue;
        parsedSummaries.push({
            ari: summary.ari.trim(),
            title: summary.title.trim(),
            oneLiner: summary.oneLiner.trim(),
            evidence: []
        });
        if (parsedSummaries.length === $994dd0020fdf55a7$var$MAX_SUMMARIES) break;
    }
    return {
        status: 'GENERATED',
        overview: parsedOverview,
        summaries: parsedSummaries
    };
};


const $66ddd238965febb3$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $66ddd238965febb3$var$isNonEmptyString = (value)=>typeof value === 'string' && value.trim().length > 0;
const $66ddd238965febb3$var$isStatus = (value)=>value === 'GENERATED' || value === 'INSUFFICIENT_EVIDENCE' || value === 'UNAVAILABLE';
const $66ddd238965febb3$var$parseEvidence = (value)=>{
    if (!Array.isArray(value)) return null;
    const evidence = [];
    for (const item of value){
        if (!$66ddd238965febb3$var$isRecord(item)) continue;
        const { id: id, type: type, entityAri: entityAri, label: label, observedAt: observedAt } = item;
        if (!$66ddd238965febb3$var$isNonEmptyString(id) || !$66ddd238965febb3$var$isNonEmptyString(type) || !$66ddd238965febb3$var$isNonEmptyString(entityAri) || !$66ddd238965febb3$var$isNonEmptyString(label) || !(observedAt === undefined || observedAt === null || typeof observedAt === 'string')) continue;
        evidence.push({
            id: id.trim(),
            type: type.trim(),
            entityAri: entityAri.trim(),
            label: label.trim(),
            observedAt: observedAt ?? null
        });
    }
    return evidence;
};
const $66ddd238965febb3$export$e55d72037394dd46 = (value)=>{
    if (!$66ddd238965febb3$var$isRecord(value)) return null;
    const output = value.ai_feature_output;
    if (!$66ddd238965febb3$var$isRecord(output)) return null;
    const { status: status, overview: overview, summaries: summaries } = output;
    if (!$66ddd238965febb3$var$isStatus(status)) return (0, $994dd0020fdf55a7$export$6b24c40e5c2263a8)(output);
    if (!Array.isArray(overview) || !Array.isArray(summaries)) return null;
    if (overview.some((item)=>typeof item === 'string')) return null;
    const parsedOverview = [];
    for (const item of overview){
        if (!$66ddd238965febb3$var$isRecord(item)) continue;
        const evidence = $66ddd238965febb3$var$parseEvidence(item.evidence);
        if (!$66ddd238965febb3$var$isNonEmptyString(item.label) || !$66ddd238965febb3$var$isNonEmptyString(item.text) || !evidence) continue;
        parsedOverview.push({
            label: item.label.trim(),
            text: item.text.trim(),
            evidence: evidence
        });
    }
    const parsedSummaries = [];
    for (const summary of summaries){
        if (!$66ddd238965febb3$var$isRecord(summary)) continue;
        const evidence = $66ddd238965febb3$var$parseEvidence(summary.evidence);
        if (!$66ddd238965febb3$var$isNonEmptyString(summary.ari) || !$66ddd238965febb3$var$isNonEmptyString(summary.title) || !$66ddd238965febb3$var$isNonEmptyString(summary.oneLiner) || !evidence) continue;
        parsedSummaries.push({
            ari: summary.ari.trim(),
            title: summary.title.trim(),
            oneLiner: summary.oneLiner.trim(),
            evidence: evidence
        });
    }
    return {
        status: status,
        overview: parsedOverview,
        summaries: parsedSummaries
    };
};


const $47daad24abd23110$var$DEFAULT_RETRY_DELAY_MS = 30000;
const $47daad24abd23110$var$MAX_TIMEOUT_MS = 2147483647;
const $47daad24abd23110$export$acd1047e7af44a28 = (status, code, retryable)=>{
    if (!retryable) return undefined;
    if (status === 503 && code === 'AI_FEATURE_RATE_LIMITED') return 'rateLimited';
    if (status === 504 && code === 'AI_FEATURE_TIMEOUT' || status === 503 && code === 'AI_FEATURE_DEPENDENCY_FAILURE' || status === 502 && (code === 'AI_FEATURE_EMPTY_RESPONSE' || code === 'AI_FEATURE_INVALID_RESPONSE')) return 'transientServiceError';
    return undefined;
};
const $47daad24abd23110$export$86526f40287dee0d = (header, fallbackDelayMs = $47daad24abd23110$var$DEFAULT_RETRY_DELAY_MS)=>{
    if (header !== null && /^\d+$/.test(header.trim())) {
        const seconds = Number(header);
        if (Number.isSafeInteger(seconds) && seconds <= 2147483647) return seconds * 1000;
    }
    return fallbackDelayMs;
};
const $47daad24abd23110$export$334a87e4fb3ba41a = (notBefore, callback)=>{
    let timer;
    const schedule = ()=>{
        const remaining = notBefore - Date.now();
        if (remaining <= 0) {
            callback();
            return;
        }
        timer = setTimeout(schedule, Math.min(remaining, $47daad24abd23110$var$MAX_TIMEOUT_MS));
    };
    schedule();
    return ()=>clearTimeout(timer);
};
// Quota applies across payloads. Keep its deadline outside the request effect so
// refreshed connection data and byline remounts cannot bypass the server cooldown.
const $47daad24abd23110$var$quotaCooldowns = new Map();
const $47daad24abd23110$export$73d5fe48c1c4d4c8 = (cloudId)=>{
    const notBefore = $47daad24abd23110$var$quotaCooldowns.get(cloudId) ?? 0;
    if (notBefore <= Date.now()) {
        $47daad24abd23110$var$quotaCooldowns.delete(cloudId);
        return 0;
    }
    return notBefore;
};
const $47daad24abd23110$export$9a885ad8bd8be41f = (cloudId, notBefore)=>{
    for (const [key, deadline] of $47daad24abd23110$var$quotaCooldowns)if (deadline <= Date.now()) $47daad24abd23110$var$quotaCooldowns.delete(key);
    $47daad24abd23110$var$quotaCooldowns.set(cloudId, Math.max($47daad24abd23110$export$73d5fe48c1c4d4c8(cloudId), notBefore));
};
const $47daad24abd23110$export$d7cd69db6d6ad945 = ()=>{
    $47daad24abd23110$var$quotaCooldowns.clear();
};


const $e2bf91e4975d6fca$var$ENDPOINT = '/gateway/api/ai/v2/ai-feature/twg-hub-summaries';
const $e2bf91e4975d6fca$var$EXPERIENCE_ID = 'confluence-twg-hub-summaries';
const $e2bf91e4975d6fca$var$REQUEST_TIMEOUT_MS = 60000;
const $e2bf91e4975d6fca$var$RECOVERY_BUDGET_MS = 120000;
class $e2bf91e4975d6fca$var$AtAGlanceTimeoutError extends Error {
    constructor(){
        super('At a Glance recovery timed out');
        this.name = 'AtAGlanceTimeoutError';
    }
}
const $e2bf91e4975d6fca$var$createSingleEntryCache = ()=>{
    let entry;
    return {
        get: (key)=>entry?.key === key ? entry.value : undefined,
        set: (key, value)=>{
            entry = {
                key: key,
                value: value
            };
        },
        clear: ()=>{
            entry = undefined;
        }
    };
};
// Reuse only the most recent successful response. This survives panel/modal
// remounts without accumulating one entry per page, and the exact request body
// makes every input that can affect the summaries part of cache identity.
// This intentionally has no TTL: backend-only prompt or model changes are not
// observed until another success replaces the entry or the page reloads. That
// trade-off is acceptable because this cache targets immediate consecutive opens.
const $e2bf91e4975d6fca$var$resultCache = $e2bf91e4975d6fca$var$createSingleEntryCache();
const $e2bf91e4975d6fca$export$2317690a8ca68a01 = ()=>{
    $e2bf91e4975d6fca$var$resultCache.clear();
    (0, $47daad24abd23110$export$d7cd69db6d6ad945)();
};
const $e2bf91e4975d6fca$var$isAbortError = (error)=>typeof error === 'object' && error !== null && 'name' in error && error.name === 'AbortError';
const $e2bf91e4975d6fca$var$toError = (error)=>error instanceof Error ? error : new Error(String(error));
const $e2bf91e4975d6fca$var$isAiFeatureErrorResponse = (value)=>{
    if (!value || typeof value !== 'object') return false;
    const error = value.error;
    if (!error || typeof error !== 'object') return false;
    const candidate = error;
    return typeof candidate.code === 'string' && typeof candidate.message === 'string' && typeof candidate.retryable === 'boolean' && typeof candidate.requestId === 'string';
};
class $e2bf91e4975d6fca$export$fa6239a82d776b89 extends Error {
    constructor(status, responseBody, retryAfter = null){
        super(`At a Glance request failed with HTTP ${status}`);
        this.status = void 0;
        this.code = void 0;
        this.retryable = void 0;
        this.requestId = void 0;
        this.serviceMessage = void 0;
        this.retryAfterMs = void 0;
        this.retryReason = void 0;
        this.name = 'AtAGlanceRequestError';
        this.status = status;
        if ($e2bf91e4975d6fca$var$isAiFeatureErrorResponse(responseBody)) {
            this.code = responseBody.error.code;
            this.retryable = responseBody.error.retryable;
            this.requestId = responseBody.error.requestId;
            this.serviceMessage = responseBody.error.message;
        }
        this.retryReason = (0, $47daad24abd23110$export$acd1047e7af44a28)(status, this.code, this.retryable);
        this.retryAfterMs = (0, $47daad24abd23110$export$86526f40287dee0d)(retryAfter, this.retryReason === 'transientServiceError' ? 2000 : undefined);
    }
}
const $e2bf91e4975d6fca$export$72b2d05bd0aa0669 = ({ enabled: enabled, contentId: contentId, contentType: contentType, connections: connections, pageTitle: pageTitle, pageAdf: pageAdf, pageVersion: pageVersion, pageUpdatedAt: pageUpdatedAt, structuralAncestors: structuralAncestors, outgoingLinksLoading: outgoingLinksLoading = false })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const [resultState, setResultState] = (0, $cozmU.useState)(null);
    const relatedContentLoading = Boolean(connections.relatedContent.enabled && connections.relatedContent.loading);
    const requestBody = (0, $cozmU.useMemo)(()=>{
        if (!enabled || !contentId || !cloudId || !pageAdf || typeof pageTitle !== 'string' || connections.appearsIn.loading || outgoingLinksLoading || relatedContentLoading) return null;
        const input = (0, $ecb19719bff78326$export$1d4beabc419323b8)({
            cloudId: cloudId,
            contentId: contentId,
            contentType: contentType,
            locale: locale,
            pageTitle: pageTitle,
            pageVersion: pageVersion,
            pageUpdatedAt: pageUpdatedAt,
            pageAdf: pageAdf,
            structuralAncestors: structuralAncestors,
            incomingLinks: connections.appearsIn.links,
            outgoingLinks: connections.linksTo.links,
            relatedContentLinks: connections.relatedContent.links
        });
        if (!input) return null;
        return JSON.stringify({
            ai_feature_input: input
        });
    }, [
        enabled,
        pageAdf,
        pageTitle,
        pageUpdatedAt,
        pageVersion,
        structuralAncestors,
        cloudId,
        connections.appearsIn.links,
        connections.appearsIn.loading,
        outgoingLinksLoading,
        relatedContentLoading,
        connections.linksTo.links,
        connections.relatedContent.links,
        contentId,
        contentType,
        locale
    ]);
    const cachedOutput = requestBody ? $e2bf91e4975d6fca$var$resultCache.get(requestBody) ?? null : null;
    const currentResultState = resultState?.contentId === contentId ? resultState : null;
    const output = cachedOutput ?? currentResultState?.output ?? null;
    const error = cachedOutput ? null : currentResultState?.error ?? null;
    // Raw link counts for analytics, in a ref so they never drive the effect: the
    // payload filters and caps these links, so the counts can change while the
    // request body does not. The effect snapshots them when it fires.
    const linkCountsRef = (0, $cozmU.useRef)({
        incomingLinkCount: 0,
        outgoingLinkCount: 0
    });
    linkCountsRef.current = {
        incomingLinkCount: connections.appearsIn.links.length,
        outgoingLinkCount: connections.linksTo.links.length
    };
    (0, $cozmU.useEffect)(()=>{
        if (!requestBody || !cloudId || !contentId) {
            setResultState((current)=>current ? {
                    contentId: current.contentId,
                    output: current.output,
                    error: current.error
                } : null);
            return;
        }
        const cachedResult = $e2bf91e4975d6fca$var$resultCache.get(requestBody);
        if (cachedResult) {
            // Keep this mounted consumer stable if another page later replaces the
            // single module-level cache entry. A cache hit is not a request, so no
            // operational event fires here.
            setResultState({
                contentId: contentId,
                output: cachedResult,
                error: null
            });
            return;
        }
        const controller = new AbortController();
        const startedAt = performance.now();
        const { incomingLinkCount: incomingLinkCount, outgoingLinkCount: outgoingLinkCount } = linkCountsRef.current;
        let cancelled = false;
        let settled = false;
        let cancelRetryTimer;
        let requestTimer;
        let recoveryTimer;
        const clearRequestTimers = ()=>{
            clearTimeout(requestTimer);
            clearTimeout(recoveryTimer);
            cancelRetryTimer?.();
        };
        let retryCount = 0;
        let retryReason;
        let serviceErrorCode;
        let retryDelayMs = 0;
        const recoveryAttributes = (recoveryOutcome)=>({
                ...serviceErrorCode ? {
                    serviceErrorCode: serviceErrorCode
                } : {},
                ...retryReason ? {
                    retryCount: retryCount,
                    retryReason: retryReason,
                    retryDelayMs: retryDelayMs,
                    recoveryOutcome: recoveryOutcome
                } : {}
            });
        setResultState((current)=>({
                contentId: contentId,
                output: current && current.contentId === contentId ? current.output : null,
                error: null
            }));
        // Deliberately preserve the current output: hold the bullets we have while a refetch is in
        // flight. `requestBody` changes whenever the links do, and one response now feeds both
        // the panel and the modal — so clearing here would blank both surfaces back to
        // skeletons the moment a reader pressed "show more" on "Appears in", and make them wait
        // out a fresh LLM round trip for an answer already on screen. `loading` stays false for
        // the same reason (see below).
        const elapsedMs = ()=>Math.round(performance.now() - startedAt);
        const reportFailure = (reason, failure, statusCode)=>{
            if (cancelled || settled) return;
            settled = true;
            clearRequestTimers();
            setResultState((current)=>({
                    contentId: contentId,
                    output: current && current.contentId === contentId ? current.output : null,
                    error: failure
                }));
            (0, $5ZqQS.getMonitoringClient)().submitError(failure, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            createEvent((0, $8wK2O.getAtAGlanceFailedEvent)({
                reason: reason,
                statusCode: statusCode,
                incomingLinkCount: incomingLinkCount,
                outgoingLinkCount: outgoingLinkCount,
                durationMs: elapsedMs(),
                ...recoveryAttributes('exhausted')
            })).fire();
        };
        const setRetryState = (retryPending)=>{
            setResultState((current)=>({
                    contentId: contentId,
                    output: current?.contentId === contentId ? current.output : null,
                    error: retryPending ? null : current?.error ?? null,
                    retryPending: retryPending,
                    retryReason: retryPending ? retryReason : undefined
                }));
        };
        const onTimeout = ()=>{
            reportFailure('timeout', new $e2bf91e4975d6fca$var$AtAGlanceTimeoutError());
            controller.abort();
        };
        recoveryTimer = setTimeout(onTimeout, $e2bf91e4975d6fca$var$RECOVERY_BUDGET_MS);
        const runRequest = (allowAutomaticRetry)=>{
            if (cancelled) return;
            const quotaNotBefore = (0, $47daad24abd23110$export$73d5fe48c1c4d4c8)(cloudId);
            if (quotaNotBefore > Date.now()) {
                retryReason = 'rateLimited';
                serviceErrorCode = 'AI_FEATURE_RATE_LIMITED';
                retryDelayMs += quotaNotBefore - Date.now();
                setRetryState(true);
                cancelRetryTimer = (0, $47daad24abd23110$export$334a87e4fb3ba41a)(quotaNotBefore, ()=>runRequest(allowAutomaticRetry));
                return;
            }
            if (!allowAutomaticRetry) retryCount = 1;
            setRetryState(false);
            requestTimer = setTimeout(onTimeout, $e2bf91e4975d6fca$var$REQUEST_TIMEOUT_MS);
            // oxlint-disable-next-line eslint-core/no-restricted-syntax
            fetch($e2bf91e4975d6fca$var$ENDPOINT, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'ATL-CloudId': cloudId,
                    'x-experience-id': $e2bf91e4975d6fca$var$EXPERIENCE_ID,
                    'x-product': 'confluence'
                },
                body: requestBody,
                signal: controller.signal
            }).then(async (response)=>{
                const responseBody = await response.json().catch(()=>null);
                clearTimeout(requestTimer);
                if (cancelled || settled) return;
                if (!response.ok) throw new $e2bf91e4975d6fca$export$fa6239a82d776b89(response.status, responseBody, response.headers.get('Retry-After'));
                const parsed = (0, $66ddd238965febb3$export$e55d72037394dd46)(responseBody);
                if (!parsed) {
                    reportFailure('malformedResponse', new Error('At a Glance response envelope is malformed'));
                    return;
                }
                settled = true;
                clearRequestTimers();
                $e2bf91e4975d6fca$var$resultCache.set(requestBody, parsed);
                setResultState({
                    contentId: contentId,
                    output: parsed,
                    error: null
                });
                createEvent((0, $8wK2O.getAtAGlanceSucceededEvent)({
                    overviewCount: parsed.overview.length,
                    summariesCount: parsed.summaries.length,
                    incomingLinkCount: incomingLinkCount,
                    outgoingLinkCount: outgoingLinkCount,
                    durationMs: elapsedMs(),
                    ...recoveryAttributes('recovered')
                })).fire();
            }).catch((caught)=>{
                clearTimeout(requestTimer);
                if (cancelled || settled || $e2bf91e4975d6fca$var$isAbortError(caught)) return;
                const requestError = caught instanceof $e2bf91e4975d6fca$export$fa6239a82d776b89 ? caught : undefined;
                serviceErrorCode = (0, $8wK2O.getServiceErrorCodeForAnalytics)(requestError?.code);
                const rateLimited = requestError?.retryReason === 'rateLimited';
                const retryNotBefore = requestError?.retryReason ? Date.now() + requestError.retryAfterMs + 250 + Math.floor(Math.random() * 1000) : 0;
                if (rateLimited) (0, $47daad24abd23110$export$9a885ad8bd8be41f)(cloudId, retryNotBefore);
                if (requestError?.retryReason && allowAutomaticRetry) {
                    retryReason = requestError.retryReason;
                    retryDelayMs += Math.max(0, retryNotBefore - Date.now());
                    setRetryState(true);
                    cancelRetryTimer = (0, $47daad24abd23110$export$334a87e4fb3ba41a)(retryNotBefore, ()=>{
                        setRetryState(false);
                        runRequest(false);
                    });
                    return;
                }
                reportFailure(rateLimited ? 'rateLimited' : caught instanceof $e2bf91e4975d6fca$export$fa6239a82d776b89 ? 'httpError' : 'networkError', $e2bf91e4975d6fca$var$toError(caught), caught instanceof $e2bf91e4975d6fca$export$fa6239a82d776b89 ? caught.status : undefined);
            });
        };
        runRequest(true);
        return ()=>{
            cancelled = true;
            clearRequestTimers();
            controller.abort();
            if (!settled) createEvent((0, $8wK2O.getAtAGlanceAbortedEvent)({
                incomingLinkCount: incomingLinkCount,
                outgoingLinkCount: outgoingLinkCount,
                durationMs: elapsedMs(),
                ...recoveryAttributes(retryCount ? 'cancelledAfterRetry' : 'cancelledBeforeRetry')
            })).fire();
        };
    }, [
        cloudId,
        contentId,
        createEvent,
        requestBody
    ]);
    const waitingOnPrereqs = Boolean(contentId && cloudId && (!pageAdf || pageTitle === undefined || connections.appearsIn.loading || outgoingLinksLoading || relatedContentLoading));
    const loading = Boolean(enabled && !output && !error && (waitingOnPrereqs || requestBody));
    const retryPending = cachedOutput ? false : currentResultState?.retryPending;
    const retryReason = retryPending ? currentResultState?.retryReason : undefined;
    return (0, $cozmU.useMemo)(()=>({
            output: output,
            error: error,
            loading: loading,
            retryPending: retryPending,
            retryReason: retryReason
        }), [
        output,
        error,
        loading,
        retryPending,
        retryReason
    ]);
};



var $jDHty = parcelRequire("jDHty");

const $e881057e0de27ea9$export$3b542486c8925d39 = {
    contentId: undefined,
    atAGlance: {
        output: null,
        loading: true,
        error: null
    }
};
// BylineConnections is the sole producer. Readers never fetch or hydrate this stream.
const $e881057e0de27ea9$var$bridge = (0, $jDHty.createPanelDataBridge)($e881057e0de27ea9$export$3b542486c8925d39);
const $e881057e0de27ea9$export$d7ea14a22c3a1260 = $e881057e0de27ea9$var$bridge.publish;
const $e881057e0de27ea9$export$932fff4b8bd41d62 = $e881057e0de27ea9$var$bridge.clear;
const $e881057e0de27ea9$export$850ea50adc381c = $e881057e0de27ea9$var$bridge.useValue;
const $e881057e0de27ea9$export$e980d9608a04fb97 = $e881057e0de27ea9$var$bridge.clearForTesting;





const $3b6532377f19c330$export$8e74f165501ea398 = {
    contentId: undefined,
    devDocsConnection: null
};
/**
 * Carries the Dev Docs source the connections byline resolved from the content
 * header's `ancestors`. See `createPanelDataBridge` for why the panel needs a
 * bridge at all.
 *
 * Kept separate from `outgoingLinksBridge` because the producers differ: links come
 * from walking the page ADF, this from a GraphQL query, so the two resolve at
 * different times and sharing one store would let each clobber the other.
 *
 * Only ever written from an effect, so nothing publishes during SSR and this
 * module-level state cannot leak between server requests.
 */ const $3b6532377f19c330$var$devDocsConnectionBridge = (0, $jDHty.createPanelDataBridge)($3b6532377f19c330$export$8e74f165501ea398);
const $3b6532377f19c330$export$bef8e2d39680b9a8 = $3b6532377f19c330$var$devDocsConnectionBridge.publish;
const $3b6532377f19c330$export$962a90b3959f19a3 = $3b6532377f19c330$var$devDocsConnectionBridge.clear;
const $3b6532377f19c330$export$e9fa78d134203a1f = $3b6532377f19c330$var$devDocsConnectionBridge.subscribe;
const $3b6532377f19c330$export$27db6e7d91fcef66 = $3b6532377f19c330$var$devDocsConnectionBridge.useValue;
const $3b6532377f19c330$export$4c93bdc6dd1bcc11 = $3b6532377f19c330$var$devDocsConnectionBridge.clearForTesting;



var $21leH = parcelRequire("21leH");


var $Hnn0l = parcelRequire("Hnn0l");


var $4ao9J = parcelRequire("4ao9J");








var $bI14T = parcelRequire("bI14T");











var $7Sm4c = parcelRequire("7Sm4c");










const $ee2745eaeec65808$export$d8eacd4aa2ac0652 = (url)=>{
    try {
        const { origin: origin, pathname: pathname } = new URL(url);
        return `${origin}${pathname}`;
    } catch  {
        return url;
    }
};
const $ee2745eaeec65808$export$a253d02843d1519 = (seed = [])=>{
    const keptAris = new Set();
    const keptPaths = new Set();
    // Paths of kept links without an ari: the only kept links a resolved link can match by path.
    const keptPathsWithoutAri = new Set();
    const isDuplicate = (link)=>{
        const path = $ee2745eaeec65808$export$d8eacd4aa2ac0652(link.url);
        const duplicate = link.ari ? keptAris.has(link.ari) || keptPathsWithoutAri.has(path) : keptPaths.has(path);
        if (duplicate) return true;
        keptPaths.add(path);
        if (link.ari) keptAris.add(link.ari);
        else keptPathsWithoutAri.add(path);
        return false;
    };
    seed.forEach(isDuplicate);
    return isDuplicate;
};



var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");

// The endpoint also groups sprints and versions, which are not work items.
const $422ca959341ef1a3$var$WORK_ITEM_GROUP_TYPES = new Set([
    'ISSUES',
    'EPICS'
]);
const $422ca959341ef1a3$var$getEndpoint = (contentId)=>`/wiki/rest/jira-metadata/1.0/metadata?pageId=${encodeURIComponent(contentId)}`;
const $422ca959341ef1a3$export$cebabc0ace696965 = async (contentId, signal)=>{
    const response = await (0, $f7B1p.cfetch)($422ca959341ef1a3$var$getEndpoint(contentId), {
        method: 'GET',
        headers: {
            Accept: 'application/json'
        },
        credentials: 'include',
        signal: signal
    });
    const body = await response.json();
    const urls = new Set();
    (body.groups ?? []).forEach((group)=>{
        if (!$422ca959341ef1a3$var$WORK_ITEM_GROUP_TYPES.has(group.type ?? '')) return;
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- linear in total item count; four fixed group types partition it
        (group.items ?? []).forEach((item)=>{
            if (item.url) urls.add(item.url);
        });
    });
    return [
        ...urls
    ];
};
const $422ca959341ef1a3$export$77f9d78cd4f4f375 = (error)=>(0, $hBkCm.BadStatusError).isBadStatusError(error) && error.response.status < 500;
const $422ca959341ef1a3$export$2904b0e5724f3bd5 = (error, timedOut)=>{
    if (timedOut) return 'timeout';
    if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return 'badStatus';
    if (error instanceof SyntaxError) return 'parse';
    return 'network';
};










var $6CHZa = parcelRequire("6CHZa");


var $7LPcf = parcelRequire("7LPcf");


var $lXmY5 = parcelRequire("lXmY5");


var $ddzkt = parcelRequire("ddzkt");


var $cbT5r = parcelRequire("cbT5r");


var $e1RBl = parcelRequire("e1RBl");


var $ltT9o = parcelRequire("ltT9o");


var $hHrlI = parcelRequire("hHrlI");


var $7YvXl = parcelRequire("7YvXl");


var $4FdKz = parcelRequire("4FdKz");


var $2GG3F = parcelRequire("2GG3F");

/**
 * Extracts a plain string status name from the raw `atlassian:state` JSON-LD
 * field, which can appear in several forms:
 *
 *   - a bare string          e.g. "open", "merged", "draft"
 *   - an Object with .name  e.g. { "@type": "Object", "name": "In Progress" }
 *
 * Returns undefined when the field is absent or carries no usable name.
 * Applies to Document, SourceCodePullRequest, Project, and Goal data shapes.
 */ function $66be44d2f9c9a1f4$export$e0422c1366f8a53d(rawState) {
    if (typeof rawState === 'string' && rawState.length > 0) return rawState;
    if (typeof rawState === 'object' && rawState !== null) {
        const name = rawState.name;
        if (typeof name === 'string' && name.length > 0) return name;
    }
    return undefined;
}






var $giSsj = parcelRequire("giSsj");

const $78ed55159915b828$var$DISPLAY_NAME_PREFIX_REGEX = /^Atlassian(?:\s+(?:Links|Connector))?\s*-\s*/i;
const $78ed55159915b828$var$stripDisplayNamePrefix = (displayName)=>displayName.replace($78ed55159915b828$var$DISPLAY_NAME_PREFIX_REGEX, '').trim();
const $78ed55159915b828$var$statusNameFromTagItem = (value)=>{
    if (typeof value === 'string') return value.trim() || undefined;
    if (!value || typeof value !== 'object') return undefined;
    const name = value.name;
    return typeof name === 'string' ? name.trim() || undefined : undefined;
};
/**
 * Mirrors Smart Card's visible Task-lozenge precedence without using its
 * private extractor: tag may be a string, array, or object, and its first
 * usable name wins over atlassian:taskStatus.
 */ const $78ed55159915b828$var$statusNameFromTaskTag = (value)=>{
    if (!Array.isArray(value)) return $78ed55159915b828$var$statusNameFromTagItem(value);
    for (const item of value){
        const name = $78ed55159915b828$var$statusNameFromTagItem(item);
        if (name) return name;
    }
    return undefined;
};
function $78ed55159915b828$export$9ebf81041d234ef6(url, occurrenceIndex, response, normalizeShallowJira = false) {
    const resp = response ?? undefined;
    const data = resp?.data;
    const meta = resp?.meta;
    // The ORS batch resolver ("Referenced in") can return a shallow Jira payload — the raw Jira REST
    // issue (no top-level `data.icon`, with the issue type under `data.fields.issuetype`). Read the
    // icon and type from there. Gated so the hydrated "Links to" path is untouched.
    const issuetype = normalizeShallowJira && !data?.icon ? data?.fields?.issuetype : undefined;
    const shallowJiraIssuetype = issuetype?.iconUrl ? issuetype : undefined;
    // ── identity ──────────────────────────────────────────────────────────────
    const ari = data ? (0, $lXmY5.extractSmartLinkAri)(resp) : undefined;
    // ── display ───────────────────────────────────────────────────────────────
    const title = data ? (0, $7YvXl.extractSmartLinkTitle)(resp) : undefined;
    const summaryRaw = data && 'summary' in data ? data.summary : undefined;
    const summary = typeof summaryRaw === 'string' && summaryRaw.trim() ? summaryRaw.trim() : undefined;
    const iconUrl = data?.icon ? (0, $2GG3F.extractUrlFromIconJsonLd)(data.icon) : shallowJiraIssuetype?.iconUrl;
    // ── classification ────────────────────────────────────────────────────────
    const key = meta?.key != null ? String(meta.key) : undefined;
    const metaProduct = meta?.product != null ? String(meta.product) : undefined;
    const subproduct = meta?.subproduct != null ? String(meta.subproduct) : undefined;
    const resourceTypeRaw = meta?.resourceSubType ?? shallowJiraIssuetype?.name ?? meta?.resourceType;
    const fallbackResourceType = resourceTypeRaw != null ? String(resourceTypeRaw) : undefined;
    // The JSON-LD generator names the app that produced the object (e.g. "Focus",
    // "Loom"). It's the product-name fallback when `meta.product` is absent, and
    // the per-row app label for the collapsed townsquare/"Goals" group. Skip the
    // bare-string generator — extractSmartLinkProvider (via extractProvider)
    // throws on it rather than returning undefined.
    const generatorName = data != null && typeof data.generator !== 'string' ? (0, $hHrlI.extractSmartLinkProvider)(resp)?.text : undefined;
    // Atlas Projects/Goals arrive as the `townsquare` codename and collapse under
    // the "Goals" group; surface the specific app (generator name) as the row's
    // resource type so the metadata line shows the real product.
    const isTownsquare = (0, $giSsj.isTownsquareProduct)(metaProduct);
    const resourceType = isTownsquare ? generatorName ?? fallbackResourceType : fallbackResourceType;
    const jsonLdTypes = data ? (0, $4FdKz.extractType)(data) : undefined;
    const jsonLdType = jsonLdTypes?.[0];
    const isTask = jsonLdTypes?.includes('atlassian:Task') ?? false;
    // ── people ────────────────────────────────────────────
    const owner = data ? (0, $7LPcf.extractPersonOwnedBy)(data)?.[0]?.name : undefined;
    const assignedTo = data ? (0, $6CHZa.extractPersonAssignedTo)(data)?.name : undefined;
    const createdBy = data ? (0, $ddzkt.extractSmartLinkCreatedBy)(resp) : undefined;
    const updatedBy = data ? (0, $e1RBl.extractSmartLinkModifiedBy)(resp) : undefined;
    // ── dates ─────────────────────────────────────────────────────────────────
    const createdAt = data ? (0, $cbT5r.extractSmartLinkCreatedOn)(resp) : undefined;
    const updatedAt = data ? (0, $ltT9o.extractSmartLinkModifiedOn)(resp) : undefined;
    // ── status ────────────────────────────────────────────────────────────────
    const taskStatusRaw = data?.['atlassian:taskStatus'];
    const taskStatusFromObject = taskStatusRaw?.name != null ? String(taskStatusRaw.name).trim() || undefined : undefined;
    const taskStatus = (isTask ? $78ed55159915b828$var$statusNameFromTaskTag(data?.tag) : undefined) ?? taskStatusFromObject;
    const state = (0, $66be44d2f9c9a1f4$export$e0422c1366f8a53d)(data?.['atlassian:state']);
    // ── auth ──────────────────────────────────────────────────────────────────
    const access = meta?.access;
    const visibility = meta?.visibility;
    const authProviders = Array.isArray(meta?.auth) ? meta.auth.filter((a)=>typeof a === 'object' && typeof a.displayName === 'string' && typeof a.key === 'string' && typeof a.url === 'string') : [];
    const providerDisplayName = authProviders[0]?.displayName;
    const productFromAuthProvider = typeof providerDisplayName === 'string' && providerDisplayName.length > 0 ? $78ed55159915b828$var$stripDisplayNamePrefix(providerDisplayName) : undefined;
    // `meta.product` wins; else the connected provider's display name (unauthorized
    // 3P links); else the JSON-LD generator name (Focus, Loom, …) — which is how
    // product-less 1P links get classified instead of falling into "Other".
    const resolvedProduct = metaProduct ?? productFromAuthProvider ?? generatorName;
    const iconSource = {
        ari: ari,
        occurrenceIndex: occurrenceIndex,
        product: resolvedProduct,
        url: url
    };
    const icon = shallowJiraIssuetype?.iconUrl ? (0, $5b9Ab.buildImageIcon)(shallowJiraIssuetype.iconUrl, iconSource) : (0, $5b9Ab.extractSmartLinkIcon)(resp, iconSource);
    return {
        url: url,
        occurrenceIndex: occurrenceIndex,
        ari: ari,
        title: title,
        summary: summary,
        icon: icon,
        iconUrl: iconUrl,
        product: resolvedProduct,
        key: key,
        subproduct: subproduct,
        resourceType: resourceType,
        jsonLdType: jsonLdType,
        isTask: isTask,
        owner: owner,
        assignedTo: assignedTo,
        createdBy: createdBy,
        updatedBy: updatedBy,
        createdAt: createdAt,
        updatedAt: updatedAt,
        taskStatus: taskStatus,
        state: state,
        access: access,
        visibility: visibility,
        authProviders: authProviders
    };
}


const $f79f602b4ce45ce7$var$EXACT_ISSUE_KEY_JQL = /^(?:key|issuekey)\s*=\s*(?:"([a-z][a-z0-9_]*-\d+)"|([a-z][a-z0-9_]*-\d+))\s*$/i;
const $f79f602b4ce45ce7$export$95cb0164e578921c = (value)=>{
    let url;
    try {
        url = new URL(value);
    } catch  {
        return value;
    }
    if (url.protocol !== 'https:' || url.pathname !== '/issues' && url.pathname !== '/issues/') return value;
    const jql = url.searchParams.get('jql');
    const match = jql?.match($f79f602b4ce45ce7$var$EXACT_ISSUE_KEY_JQL);
    const issueKey = match?.[1] ?? match?.[2];
    if (!issueKey) return value;
    return new URL(`/browse/${issueKey.toUpperCase()}`, url.origin).toString();
};


// ORS has no provider for the URL, so a retry cannot change the answer.
const $7454a2cee359837e$var$UNSUPPORTED_ERROR_TYPES = new Set([
    'UnsupportedError',
    'ResolveUnsupportedError'
]);
const $7454a2cee359837e$var$unresolvableUrls = new Set();
const $7454a2cee359837e$export$33c396b527166c44 = (url)=>$7454a2cee359837e$var$unresolvableUrls.has(url);
const $7454a2cee359837e$export$3cf1317826e24a95 = (error)=>{
    const type = error?.type;
    return typeof type === 'string' && $7454a2cee359837e$var$UNSUPPORTED_ERROR_TYPES.has(type);
};
const $7454a2cee359837e$export$b646b603813a2189 = (url)=>{
    $7454a2cee359837e$var$unresolvableUrls.add(url);
};
const $7454a2cee359837e$export$b0f64faf64d11b1 = ()=>{
    $7454a2cee359837e$var$unresolvableUrls.clear();
};


async function $7e1486aa62dbf166$export$ab14756fcd367a5(url, occurrenceIndex, store, cardClient) {
    const resolutionUrl = (0, $f79f602b4ce45ce7$export$95cb0164e578921c)(url);
    const cached = store.getState()[resolutionUrl]?.details;
    let response = cached?.data ? cached : null;
    // Failed resolves never reach the store, so every pass would re-request them.
    if (!response && !(0, $7454a2cee359837e$export$33c396b527166c44)(resolutionUrl)) response = await cardClient.fetchData(resolutionUrl).catch((err)=>{
        // Expected for a plain hyperlink, so remember it instead of reporting it.
        if ((0, $7454a2cee359837e$export$3cf1317826e24a95)(err)) {
            (0, $7454a2cee359837e$export$b646b603813a2189)(resolutionUrl);
            return null;
        }
        const errorObj = err instanceof Error ? err : new Error(String(err));
        (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        return null;
    });
    return {
        link: (0, $78ed55159915b828$export$9ebf81041d234ef6)(url, occurrenceIndex, response),
        isResolved: response != null
    };
}


async function $89f81df02d4c8ccc$export$4f12cb865d88dee(urls, store, cardClient) {
    const resolved = await Promise.all(urls.map((url, index)=>(0, $7e1486aa62dbf166$export$ab14756fcd367a5)(url, index, store, cardClient)));
    const links = [];
    const isDuplicate = (0, $ee2745eaeec65808$export$a253d02843d1519)();
    resolved.forEach(({ link: link, isResolved: isResolved })=>{
        if (!isResolved || isDuplicate(link)) return;
        links.push(link);
    });
    return links;
}








/**
 * @generated SignedSource<<ca905a33aedcb0ca46e4cc8b0f597b95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5d1460e83753641a$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "incomingLinkTypes_node",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceBlogPost_links",
                        "concreteType": "ConfluenceBlogPostLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceBlogPost"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceDatabase_links",
                        "concreteType": "ConfluenceDatabaseLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceDatabase"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceEmbed_links",
                        "concreteType": "ConfluenceEmbedLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceEmbed"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceFolder_links",
                        "concreteType": "ConfluenceFolderLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceFolder"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceFooterComment_links",
                        "concreteType": "ConfluenceCommentLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceFooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceInlineComment_links",
                        "concreteType": "ConfluenceCommentLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceInlineComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluencePage_links",
                        "concreteType": "ConfluencePageLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluencePage"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceSlide_links",
                        "concreteType": "ConfluenceSlideLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceSlide"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceSpace_links",
                        "concreteType": "ConfluenceSpaceLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceSpace"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceWhiteboard_links",
                        "concreteType": "ConfluenceWhiteboardLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceWhiteboard"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "JiraIssue_webUrl",
                        "kind": "ScalarField",
                        "name": "webUrl"
                    }
                ],
                "type": "JiraIssue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "JiraPlatformComment_webUrl",
                        "kind": "ScalarField",
                        "name": "webUrl"
                    }
                ],
                "type": "JiraPlatformComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "JiraProject_webUrl",
                        "kind": "ScalarField",
                        "name": "webUrl"
                    }
                ],
                "type": "JiraProject"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "JiraServiceManagementComment_webUrl",
                        "kind": "ScalarField",
                        "name": "webUrl"
                    }
                ],
                "type": "JiraServiceManagementComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "TownsquareComment_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "TownsquareComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "TownsquareGoal_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "TownsquareGoal"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "TownsquareGoalUpdate_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "TownsquareGoalUpdate"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "TownsquareProject_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "TownsquareProject"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "TownsquareProjectUpdate_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "TownsquareProjectUpdate"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "LoomComment_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "LoomComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "LoomSpace_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "LoomSpace"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "LoomVideo_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "LoomVideo"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "MercuryAsk_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "MercuryAsk"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "MercuryFocusArea_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "MercuryFocusArea"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "BitbucketRepository_href",
                        "kind": "ScalarField",
                        "name": "href"
                    }
                ],
                "type": "BitbucketRepository"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DeploymentSummary_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DeploymentSummary"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsDesign_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsDesign"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsDocument_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsDocument"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsOperationsIncidentDetails_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsOperationsIncidentDetails"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsOperationsPostIncidentReviewDetails_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsOperationsPostIncidentReviewDetails"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsProjectDetails_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsProjectDetails"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsPullRequestDetails_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsPullRequestDetails"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsRepository_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsRepository"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsSecurityVulnerabilityDetails_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsSecurityVulnerabilityDetails"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "CompassComponent_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "CompassComponent"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalBranch_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalBranch"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalBuildInfo_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalBuildInfo"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalCalendarEvent_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalCalendarEvent"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalComment_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalCommit_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalCommit"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalConversation_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalConversation"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDashboard_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDashboard"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDataTable_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDataTable"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDeal_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDeal"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDeployment_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDeployment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDesign_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDesign"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDocument_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDocument"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalMessage_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalMessage"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalPullRequest_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalPullRequest"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalRemoteLink_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalRemoteLink"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalRepository_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalRepository"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalSoftwareService_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalSoftwareService"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalSpace_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalSpace"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalTest_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalTest"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalVideo_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalVideo"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalVulnerability_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalVulnerability"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalWorkItem_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalWorkItem"
            }
        ],
        "type": "GraphStoreCypherQueryV2AriNodeUnion",
        "abstractKey": "__isGraphStoreCypherQueryV2AriNodeUnion"
    };
}();
$5d1460e83753641a$var$node.hash = "fe89e1513a003dbeaf6c82d35fb23448";
var $5d1460e83753641a$export$2e2bcd8739ae039 = $5d1460e83753641a$var$node;


const $2489f951d151b954$export$b4eefb28d6bb1ef8 = {
    // Confluence — `links.webUi` is site-relative and needs `links.base` prepended.
    ConfluenceBlogPost: 'links',
    ConfluenceDatabase: 'links',
    ConfluenceEmbed: 'links',
    ConfluenceFolder: 'links',
    ConfluenceFooterComment: 'links',
    ConfluenceInlineComment: 'links',
    ConfluencePage: 'links',
    ConfluenceSlide: 'links',
    ConfluenceSpace: 'links',
    ConfluenceWhiteboard: 'links',
    // Jira
    JiraIssue: 'webUrl',
    JiraPlatformComment: 'webUrl',
    JiraProject: 'webUrl',
    JiraServiceManagementComment: 'webUrl',
    // Atlas (townsquare)
    TownsquareComment: 'url',
    TownsquareGoal: 'url',
    TownsquareGoalUpdate: 'url',
    TownsquareProject: 'url',
    TownsquareProjectUpdate: 'url',
    // Loom
    LoomComment: 'url',
    LoomSpace: 'url',
    LoomVideo: 'url',
    // Focus (mercury)
    MercuryAsk: 'url',
    MercuryFocusArea: 'url',
    // Bitbucket and the DevOps graph
    BitbucketRepository: 'href',
    DeploymentSummary: 'url',
    DevOpsDesign: 'url',
    DevOpsDocument: 'url',
    DevOpsOperationsIncidentDetails: 'url',
    DevOpsOperationsPostIncidentReviewDetails: 'url',
    DevOpsProjectDetails: 'url',
    DevOpsPullRequestDetails: 'url',
    DevOpsRepository: 'url',
    DevOpsSecurityVulnerabilityDetails: 'url',
    // Compass
    CompassComponent: 'url',
    // Third-party ("External") peers
    ExternalBranch: 'url',
    ExternalBuildInfo: 'url',
    ExternalCalendarEvent: 'url',
    ExternalComment: 'url',
    ExternalCommit: 'url',
    ExternalConversation: 'url',
    ExternalDashboard: 'url',
    ExternalDataTable: 'url',
    ExternalDeal: 'url',
    ExternalDeployment: 'url',
    ExternalDesign: 'url',
    ExternalDocument: 'url',
    ExternalMessage: 'url',
    ExternalPullRequest: 'url',
    ExternalRemoteLink: 'url',
    ExternalRepository: 'url',
    ExternalSoftwareService: 'url',
    ExternalSpace: 'url',
    ExternalTest: 'url',
    ExternalVideo: 'url',
    ExternalVulnerability: 'url',
    ExternalWorkItem: 'url'
};
const $2489f951d151b954$export$f73902fb102e0802 = Object.keys($2489f951d151b954$export$b4eefb28d6bb1ef8);
const $2489f951d151b954$export$937a624f4e276713 = (typename)=>typename != null && typename in $2489f951d151b954$export$b4eefb28d6bb1ef8;
const $2489f951d151b954$export$83340287504d9ea3 = (typename)=>`${typename}_${$2489f951d151b954$export$b4eefb28d6bb1ef8[typename]}`;
const $2489f951d151b954$export$e255b16248ce204b = (0, $5d1460e83753641a$export$2e2bcd8739ae039);


const $feb6b0240ba5ead3$var$joinLinks = (links)=>{
    if (!links?.base || !links.webUi) return undefined;
    return `${links.base.replace(/\/+$/, '')}/${links.webUi.replace(/^\/+/, '')}`;
};
const $feb6b0240ba5ead3$export$367b5466dd42229d = (data)=>{
    const typename = data?.__typename;
    if (!data || !(0, $2489f951d151b954$export$937a624f4e276713)(typename)) return undefined;
    // The alias is built at runtime from the typename, so the generated union type
    // can't narrow the lookup — hence the one cast, over both shapes a curated type
    // can carry.
    const selected = data[(0, $2489f951d151b954$export$83340287504d9ea3)(typename)];
    return typeof selected === 'string' ? selected || undefined : $feb6b0240ba5ead3$var$joinLinks(selected);
};



const $ceb5f0113009896a$export$7d6dd950f56cfaae = (data)=>{
    const urls = [];
    const seenUrls = new Set();
    const uncataloguedTypenames = new Set();
    let missingUrlCount = 0;
    // Work is bounded by the query's `first` (≤1000 rows, each with a single
    // column), so this flat/map chain is linear, not quadratic.
    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    const nodeData = (data?.graphStore_cypherQueryV2?.edges ?? []).flatMap((edge)=>edge?.node?.columns ?? []).map((column)=>column?.value?.data);
    nodeData.forEach((node)=>{
        if (!node) return;
        const url = (0, $feb6b0240ba5ead3$export$367b5466dd42229d)(node);
        if (url) {
            if (!seenUrls.has(url)) {
                seenUrls.add(url);
                urls.push(url);
            }
            return;
        }
        if ((0, $2489f951d151b954$export$937a624f4e276713)(node.__typename)) missingUrlCount += 1;
        else uncataloguedTypenames.add(node.__typename);
    });
    if (uncataloguedTypenames.size > 0) (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`readIncomingLinkUrls: incoming link node type(s) missing from the catalog: ${[
        ...uncataloguedTypenames
    ].join(', ')}`), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
    if (missingUrlCount > 0) (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`readIncomingLinkUrls: ${missingUrlCount} curated incoming link node(s) had no url`), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
    return urls;
};





const $48cafc2affcc1872$export$f7e6e403c5c87e79 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: (0, $I7TEB.INCOMING_LINKS_ACTION_SUBJECT),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $48cafc2affcc1872$export$76206bc26a4d1ef = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: (0, $I7TEB.INCOMING_LINKS_ACTION_SUBJECT),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $48cafc2affcc1872$export$974f529324b8e135 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: (0, $I7TEB.INCOMING_LINKS_LOAD_MORE_ACTION_SUBJECT),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $48cafc2affcc1872$export$b3fd30ea5db1f6f = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: (0, $I7TEB.INCOMING_LINKS_REMOTE_LINKS_ACTION_SUBJECT),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $48cafc2affcc1872$export$3d15b11c4ee81ef1 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: (0, $I7TEB.INCOMING_LINKS_REMOTE_LINKS_ACTION_SUBJECT),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });


const $8a6630d12e0f6d27$export$ce3a4a8f39618efe = 50;
const $8a6630d12e0f6d27$export$852c54c52214ab2 = 50;
const $8a6630d12e0f6d27$var$INITIAL_RESOLVED_LINK_TARGET = 3;
// Bounds the best-effort Jira remote-link fallback so a stuck app-link call is reported as a timeout
// instead of merging minutes later.
const $8a6630d12e0f6d27$var$REMOTE_LINKS_TIMEOUT_MS = 5000;
// Classify by the error's contents rather than the code path: an Apollo error
// with only a networkError is transport-level; one carrying graphQLErrors is a
// query/data failure. Anything unrecognised is treated as a network error.
const $8a6630d12e0f6d27$var$classifyError = (err)=>!err.networkError && err.graphQLErrors?.length ? 'graphql' : 'network';
// Upper bound on the rows the graph will match; 1000 is the AGG cypherQueryV2
// max. Pagination (`first`/`after`) walks this matched set a page at a time.
const $8a6630d12e0f6d27$var$MAX_INCOMING_LINKS = 1000;
// `(source)-[:content_referenced_entity]->(content:ConfluencePage)`, or `ConfluenceBlogpost`
// for a blog post: any-product or third-party entity that references this content.
// Confirmed against real TWG data by the [Spike] 3P Incoming Links investigation. Pages
// and blog posts are distinct graph node types, so the label and ARI both come from the
// content type (see `contentAri.ts`).
const $8a6630d12e0f6d27$var$LINKS_RELATIONSHIP = 'content_referenced_entity';
// AGG requires an `X-Query-Context` header naming the site (or workspace) ARI for
// `graphStore_*` fields, otherwise the gateway rejects the request with
// "Query context must not be null". The site ARI is derived from the cloudId.
const $8a6630d12e0f6d27$var$buildQueryContext = (cloudId)=>`ari:cloud:platform::site/${cloudId}`;
// `ORDER BY` puts the most recently updated referencing entities on page 1, which
// is all either surface shows: the byline's top-3 and the section's first page both
// stop well short of the 1000 matched rows.
//
// `lastUpdated` resolves against the *graph* node types this relationship can bind
// (`JiraIssue`, `GraphPullRequest`, ...), not the AGG types in the `data` union
// below -- the two namespaces disagree, e.g. `ExternalPullRequest` carries
// `lastUpdate` and no `lastUpdated`. No `content-referenced-entity` source type
// opts out of `lastUpdated`, but 32 node types do, so check
// `graph-catalogue/src/data/nodes.ts` (not the AGG schema) before ordering on any
// other property. Do not reach for `coalesce()` to bridge the namespaces: the
// gateway rejects the whole query.
const $8a6630d12e0f6d27$var$buildIncomingLinksCypher = (contentAri, contentType)=>{
    const label = (0, $6PfFM.getContentGraphNodeLabel)(contentType);
    return [
        `MATCH (source)-[:${$8a6630d12e0f6d27$var$LINKS_RELATIONSHIP}]->(content:${label} {ari: "${contentAri}"})`,
        `RETURN source`,
        `ORDER BY source.lastUpdated DESC`,
        `LIMIT ${$8a6630d12e0f6d27$var$MAX_INCOMING_LINKS}`
    ].join('\n');
};
// The preload uses this query too, so the browser can reuse the complete first page.
const $8a6630d12e0f6d27$var$IncomingLinksQuery = (0, $6WgQx.default);
// Appends the links not already present — by `createLinkDeduper`, the same identity
// `hydrateIncomingLinks` dedupes on — re-indexed so `occurrenceIndex` stays the global position and
// recency order is preserved across pages.
const $8a6630d12e0f6d27$var$appendNewLinks = (prev, incoming)=>{
    const isDuplicate = (0, $ee2745eaeec65808$export$a253d02843d1519)(prev);
    const fresh = [];
    incoming.forEach((link)=>{
        if (isDuplicate(link)) return;
        fresh.push({
            ...link,
            occurrenceIndex: prev.length + fresh.length
        });
    });
    return fresh.length > 0 ? [
        ...prev,
        ...fresh
    ] : prev;
};
const $8a6630d12e0f6d27$var$readPageInfo = (data)=>{
    const pageInfo = data?.graphStore_cypherQueryV2?.pageInfo;
    return {
        hasNextPage: pageInfo?.hasNextPage ?? false,
        endCursor: pageInfo?.endCursor ?? null
    };
};
// `updateQuery` merge shared by both paged fetches (the initial catch-up loop and
// `loadMore`): append the incoming page's edges after the ones already in the cache
// entry, and adopt the new page's `pageInfo` so the next fetch reads the latest
// cursor. A response with no connection leaves the cache untouched.
const $8a6630d12e0f6d27$var$appendNextPage = (previousResult, fetchMoreResult)=>{
    const nextConnection = fetchMoreResult?.graphStore_cypherQueryV2;
    if (!nextConnection) return previousResult;
    const previousEdges = previousResult?.graphStore_cypherQueryV2?.edges ?? [];
    return {
        ...previousResult,
        graphStore_cypherQueryV2: {
            ...nextConnection,
            edges: [
                ...previousEdges,
                ...nextConnection.edges
            ],
            pageInfo: nextConnection.pageInfo
        }
    };
};
const $8a6630d12e0f6d27$export$4a27c1a938f63c6e = (contentId, options)=>{
    const initialPageSize = options?.initialPageSize ?? $8a6630d12e0f6d27$export$ce3a4a8f39618efe;
    const loadMorePageSize = options?.loadMorePageSize ?? $8a6630d12e0f6d27$export$852c54c52214ab2;
    const enabled = options?.enabled ?? true;
    const contentType = options?.contentType;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { connections: connections, store: store } = (0, $bI14T.useSmartLinkContext)();
    // `@confluence/analytics`, not the platform analytics-bridge helper. `fireOperationalAnalytics`
    // fires on the `analyticsBridge` channel, and `AnalyticsListener` only invokes its handler when
    // its own `channel` is `'*'` or equal to the event's; `ConfluenceAnalyticsListener` passes no
    // `channel`, so bridge events never reached it at all. See `.agents/incoming-links.md`. CCINT-9105
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    // Dedupes across pages so re-renders and merged-store updates never re-resolve a url.
    const knownUrlsRef = (0, $cozmU.useRef)(new Set());
    const initialResolvedRef = (0, $cozmU.useRef)(false);
    // The SmartCard provider rebuilds its context value with `lodash.merge({}, ...)`, which mints a
    // new `store` object on every recompute even though the underlying Redux store is unchanged. We
    // read it through a ref and keep it out of the hydration callback's deps so an ancestor re-render
    // does not re-create the callback and re-fire the hydration effect.
    const storeRef = (0, $cozmU.useRef)(store);
    (0, $cozmU.useEffect)(()=>{
        storeRef.current = store;
    }, [
        store
    ]);
    const skip = !enabled || !contentId || !cloudId;
    const [links, setLinks] = (0, $cozmU.useState)([]);
    const [initialResolved, setInitialResolved] = (0, $cozmU.useState)(false);
    const [resolving, setResolving] = (0, $cozmU.useState)(false);
    const [loadingMore, setLoadingMore] = (0, $cozmU.useState)(false);
    const [remoteLinksResult, setRemoteLinksResult] = (0, $cozmU.useState)(null);
    // Latches the merge so a graph refetch cannot un-merge the remote links or re-fire their event.
    const remoteLinksMergedRef = (0, $cozmU.useRef)(false);
    const reportError = (0, $cozmU.useCallback)((err)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(err, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        (0, $7Sm4c.markErrorAsHandled)(err);
        createEvent((0, $48cafc2affcc1872$export$76206bc26a4d1ef)({
            errorType: $8a6630d12e0f6d27$var$classifyError(err)
        })).fire();
    }, [
        createEvent
    ]);
    const { data: data, loading: queryLoading, error: error, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)($8a6630d12e0f6d27$var$IncomingLinksQuery, {
        variables: {
            cypherQuery: skip ? '' : $8a6630d12e0f6d27$var$buildIncomingLinksCypher((0, $6PfFM.buildContentAri)(cloudId, contentId, contentType), contentType),
            first: initialPageSize,
            after: null
        },
        skip: skip,
        interopApolloAggClient: true,
        // Keep partial data on GraphQL errors. Hydrating cross-activation 3P
        // entities can raise a per-node error ("Cross activation id requests are
        // not allowed") while still returning the rest of the rows; with the
        // default 'none' policy that partial data is discarded before it reaches
        // us. 'all' surfaces `data` alongside `error` so we can render what came
        // back (see the effect below), and `onError` still reports the error.
        errorPolicy: 'all',
        context: skip ? undefined : {
            headers: {
                'X-Query-Context': $8a6630d12e0f6d27$var$buildQueryContext(cloudId)
            }
        },
        onError: reportError,
        __callerPackage__: "byline-connections"
    });
    const { hasNextPage: hasNextPage, endCursor: endCursor } = $8a6630d12e0f6d27$var$readPageInfo(data);
    // Hydrate only the urls not seen before and append them in order. `knownUrlsRef`
    // is advanced only after a hydration commits, so a cancelled attempt (e.g.
    // StrictMode double-invoke) leaves those urls for the surviving attempt.
    const hydrateAndAppendPage = (0, $cozmU.useCallback)(async (urls, isCancelled)=>{
        const newUrls = urls.filter((url)=>!knownUrlsRef.current.has(url));
        if (newUrls.length === 0) return 0;
        const hydrated = await (0, $89f81df02d4c8ccc$export$4f12cb865d88dee)(newUrls, storeRef.current, connections.client);
        if (isCancelled()) return 0;
        newUrls.forEach((url)=>knownUrlsRef.current.add(url));
        setLinks((prev)=>$8a6630d12e0f6d27$var$appendNewLinks(prev, hydrated));
        return hydrated.length;
    }, [
        connections.client
    ]);
    // Hydrate the initial page once the query settles. We deliberately do NOT gate on
    // `error`: with `errorPolicy: 'all'` a partial cross-activation error still returns
    // usable rows, and bailing here would drop them (see the query's `errorPolicy`
    // note) — error *reporting* stays in `onError`. `initialResolvedRef` stops
    // loadMore's merged-store updates from re-running this initial hydration.
    (0, $cozmU.useEffect)(()=>{
        if (skip || queryLoading || !data || initialResolvedRef.current) return;
        let cancelled = false;
        setResolving(true);
        // When the first graph page hydrates to 0 displayable links (common when
        // page-1 rows are uncatalogued or unresolvable), keep paging until we have
        // enough links to render the initial section or pagination is exhausted.
        const hydrateInitialPages = async ()=>{
            let resolvedCount = 0;
            let currentData = data;
            while(!cancelled){
                resolvedCount += await hydrateAndAppendPage((0, $ceb5f0113009896a$export$7d6dd950f56cfaae)(currentData), ()=>cancelled);
                const currentPageInfo = $8a6630d12e0f6d27$var$readPageInfo(currentData);
                if (cancelled || resolvedCount >= $8a6630d12e0f6d27$var$INITIAL_RESOLVED_LINK_TARGET) break;
                if (!currentPageInfo.hasNextPage || !currentPageInfo.endCursor) break;
                const nextPageResult = await fetchMore({
                    variables: {
                        first: loadMorePageSize,
                        after: currentPageInfo.endCursor
                    },
                    updateQuery: (previousResult, { fetchMoreResult: fetchMoreResult })=>$8a6630d12e0f6d27$var$appendNextPage(previousResult, fetchMoreResult)
                });
                currentData = nextPageResult.data;
            }
            return resolvedCount;
        };
        hydrateInitialPages().then((count)=>{
            if (cancelled) return;
            initialResolvedRef.current = true;
            setInitialResolved(true);
            setResolving(false);
            if (!hasFiredRef.current) {
                hasFiredRef.current = true;
                createEvent((0, $48cafc2affcc1872$export$f7e6e403c5c87e79)({
                    count: count
                })).fire();
            }
        }).catch((err)=>{
            // hydrateIncomingLinks/resolveSmartLinkByUrl swallow and report per-url
            // failures themselves; report unexpected pipeline rejections here and avoid
            // leaving `resolving` stuck. Mark the initial attempt resolved (even though it
            // failed) so the `initialResolutionPending` loading window closes and the effect
            // does not retry.
            if (!cancelled) {
                (0, $5ZqQS.getMonitoringClient)().submitError(err instanceof Error ? err : new Error(String(err)), {
                    attribution: (0, $3IBnw.Attribution).INTEGRATIONS
                });
                initialResolvedRef.current = true;
                setInitialResolved(true);
                setResolving(false);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        skip,
        queryLoading,
        data,
        loadMorePageSize,
        fetchMore,
        hydrateAndAppendPage,
        createEvent
    ]);
    // Remote-linked Jira work items (see `fetchLinkedJiraWorkItemUrls`). Runs alongside the graph
    // query; a failure is reported here and never reaches the query's `error`. CCINT-9346
    (0, $cozmU.useEffect)(()=>{
        if (skip || !contentId) return;
        let cancelled = false;
        let timedOut = false;
        const controller = new AbortController();
        const timer = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, $8a6630d12e0f6d27$var$REMOTE_LINKS_TIMEOUT_MS);
        (0, $422ca959341ef1a3$export$cebabc0ace696965)(contentId, controller.signal).then(async (urls)=>{
            // The deadline covers the REST call only; hydration has ORS's own failure handling.
            clearTimeout(timer);
            return {
                fetched: urls.length,
                links: urls.length > 0 ? await (0, $89f81df02d4c8ccc$export$4f12cb865d88dee)(urls, storeRef.current, connections.client) : []
            };
        }).then(({ fetched: fetched, links: hydrated })=>{
            if (!cancelled) setRemoteLinksResult({
                status: 'resolved',
                fetched: fetched,
                links: hydrated
            });
        }).catch((err)=>{
            if (cancelled) return;
            // 4xx is expected for anonymous viewers and sites without a Jira app link, and a
            // timeout is our own deadline; neither is worth a monitoring report.
            if (!(0, $422ca959341ef1a3$export$77f9d78cd4f4f375)(err) && !timedOut) {
                const error = err instanceof Error ? err : new Error(String(err));
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).INTEGRATIONS
                });
            }
            createEvent((0, $48cafc2affcc1872$export$3d15b11c4ee81ef1)({
                errorType: (0, $422ca959341ef1a3$export$2904b0e5724f3bd5)(err, timedOut)
            })).fire();
            setRemoteLinksResult({
                status: 'failed'
            });
        });
        return ()=>{
            cancelled = true;
            clearTimeout(timer);
            controller.abort();
        };
    }, [
        skip,
        contentId,
        connections.client,
        createEvent
    ]);
    // Merge only once the graph has settled (initial hydration committed, or the query returned no
    // data) so its recency-ordered rows stay ahead of the appended remote links.
    const graphSettled = !skip && !queryLoading && (initialResolved || data == null);
    const remoteLinksMerged = remoteLinksResult != null && (graphSettled || remoteLinksMergedRef.current);
    (0, $cozmU.useEffect)(()=>{
        if (!remoteLinksMerged || remoteLinksMergedRef.current) return;
        remoteLinksMergedRef.current = true;
        if (remoteLinksResult?.status === 'resolved') createEvent((0, $48cafc2affcc1872$export$b3fd30ea5db1f6f)({
            fetched: remoteLinksResult.fetched,
            resolved: remoteLinksResult.links.length,
            added: $8a6630d12e0f6d27$var$appendNewLinks(links, remoteLinksResult.links).length - links.length
        })).fire();
    }, [
        remoteLinksMerged,
        remoteLinksResult,
        links,
        createEvent
    ]);
    // `links` state stays graph-only; the remote links are appended as a derived view so a later
    // graph page that ingests the same work item keeps the graph row and drops the remote copy.
    const mergedLinks = (0, $cozmU.useMemo)(()=>remoteLinksMerged && remoteLinksResult?.status === 'resolved' ? $8a6630d12e0f6d27$var$appendNewLinks(links, remoteLinksResult.links) : links, [
        links,
        remoteLinksMerged,
        remoteLinksResult
    ]);
    const loadMore = (0, $cozmU.useCallback)(()=>{
        // `initialResolvedRef` gates against a click landing before the first page's
        // urls are committed to `knownUrlsRef`, which would re-resolve page 1 and
        // duplicate its links.
        if (skip || loadingMore || !hasNextPage || !endCursor || !initialResolvedRef.current) return;
        setLoadingMore(true);
        fetchMore({
            variables: {
                first: loadMorePageSize,
                after: endCursor
            },
            updateQuery: (previousResult, { fetchMoreResult: fetchMoreResult })=>$8a6630d12e0f6d27$var$appendNextPage(previousResult, fetchMoreResult)
        }).then((result)=>hydrateAndAppendPage((0, $ceb5f0113009896a$export$7d6dd950f56cfaae)(result.data), ()=>false).then((count)=>{
                createEvent((0, $48cafc2affcc1872$export$974f529324b8e135)({
                    count: count
                })).fire();
            }))// fetchMore errors surface via the query `onError`; just release the flag.
        .catch(()=>{}).finally(()=>setLoadingMore(false));
    }, [
        skip,
        loadingMore,
        hasNextPage,
        endCursor,
        loadMorePageSize,
        fetchMore,
        hydrateAndAppendPage,
        createEvent
    ]);
    // Stay `loading` from query start through the first hydration commit. `queryLoading || resolving`
    // alone leaves a gap: after the query settles (`queryLoading` → false) but before the hydration
    // effect sets `resolving`, one render commits with `loading` false and `links` still empty. An
    // inbound-only byline returns `null` on that render, so it flashes out and back in before the
    // resolved trigger appears. Deriving the pending window from `data`/`initialResolved` (both
    // available during render, no effect latency) closes the gap. CCINT-8932
    // Keep completion in state as well as the guard ref: an empty/cached page can resolve before
    // React commits `resolving: true`, and automatic batching can otherwise collapse the true/false
    // updates without producing the render that observes the updated ref. CCINT-9096
    const initialResolutionPending = !skip && data != null && !initialResolved;
    // `loading` deliberately ignores the remote-link fallback: nothing painted depends on it.
    // `settled` is the flag for the one reader that does (the menu's section count).
    const loading = queryLoading || resolving || initialResolutionPending;
    return {
        links: mergedLinks,
        twgLinks: links,
        loading: loading,
        settled: skip || !loading && remoteLinksMerged,
        loadingMore: loadingMore,
        hasNextPage: hasNextPage,
        endCursor: endCursor,
        loadMore: loadMore,
        error: error
    };
};












var $kyH1y = parcelRequire("kyH1y");




























var $jHgXN = parcelRequire("jHgXN");

const $632b20f216f6f413$var$recencyTimestamp = (link)=>{
    const raw = link.updatedAt ?? link.createdAt;
    if (!raw) return Number.NEGATIVE_INFINITY;
    const time = Date.parse(raw);
    return Number.isNaN(time) ? Number.NEGATIVE_INFINITY : time;
};
const $632b20f216f6f413$export$39c6ffa318fec2a1 = (links)=>[
        ...links
    ].sort((left, right)=>$632b20f216f6f413$var$recencyTimestamp(right) - $632b20f216f6f413$var$recencyTimestamp(left));





const $fd09cd053ed09fc1$export$cabc6f3cbae372ae = ()=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'requested',
            actionSubject: (0, $I7TEB.RELATED_CONTENT_ACTION_SUBJECT),
            source: (0, $I7TEB.PANEL_SOURCE)
        }
    });
const $fd09cd053ed09fc1$export$a1bd93651ef6059c = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: (0, $I7TEB.RELATED_CONTENT_ACTION_SUBJECT),
            source: (0, $I7TEB.PANEL_SOURCE),
            attributes: attributes
        }
    });
const $fd09cd053ed09fc1$export$9b59566ec381a62 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: (0, $I7TEB.RELATED_CONTENT_ACTION_SUBJECT),
            source: (0, $I7TEB.PANEL_SOURCE),
            attributes: attributes
        }
    });


const $8d208cf49c8d5b5a$var$classifyError = (error)=>!error.networkError && error.graphQLErrors?.length ? 'graphql' : 'network';
const $8d208cf49c8d5b5a$var$RelatedContentQuery = (0, $7pgTN.default);
const $8d208cf49c8d5b5a$export$e0a19cb5df8c4186 = (contentId, options)=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { connections: connections, store: store } = (0, $bI14T.useSmartLinkContext)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const hasRequestedRef = (0, $cozmU.useRef)(false);
    const hasSucceededRef = (0, $cozmU.useRef)(false);
    const hasReportedErrorRef = (0, $cozmU.useRef)(false);
    const skip = options?.enabled === false || !contentId || !cloudId || !activationId || !(0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment');
    const [links, setLinks] = (0, $cozmU.useState)([]);
    const [resolving, setResolving] = (0, $cozmU.useState)(false);
    const resolvedDataRef = (0, $cozmU.useRef)(undefined);
    const storeRef = (0, $cozmU.useRef)(store);
    (0, $cozmU.useEffect)(()=>{
        storeRef.current = store;
    }, [
        store
    ]);
    const reportError = (0, $cozmU.useCallback)((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        createEvent((0, $fd09cd053ed09fc1$export$9b59566ec381a62)({
            errorType: $8d208cf49c8d5b5a$var$classifyError(error)
        })).fire();
    }, [
        createEvent
    ]);
    // `skip` gates the query, so its first `false` is the moment the fetch fires.
    (0, $cozmU.useEffect)(()=>{
        if (skip || hasRequestedRef.current) return;
        hasRequestedRef.current = true;
        createEvent((0, $fd09cd053ed09fc1$export$cabc6f3cbae372ae)()).fire();
    }, [
        skip,
        createEvent
    ]);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($8d208cf49c8d5b5a$var$RelatedContentQuery, {
        variables: {
            cypherQuery: skip ? '' : (0, $jHgXN.buildRelatedContentCypher)((0, $6PfFM.buildContentAri)(cloudId, contentId, options?.contentType)),
            queryContext: skip ? '' : (0, $kyH1y.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            version: 'V3',
            first: (0, $jHgXN.MAX_RELATED_CONTENT)
        },
        skip: skip,
        interopApolloAggClient: true,
        errorPolicy: 'all',
        __callerPackage__: "byline-connections"
    });
    // Report from the returned `error`, not the query's `onError`. Under `errorPolicy: 'all'`
    // the Apollo route delivers GraphQL errors as `{ data, error }` and never calls `onError`
    // (it only fires for network errors), so a GraphQL failure would otherwise go unreported.
    // Driving off `error` covers both network and GraphQL errors on either route. Fired once;
    // the ref resets when `error` clears so a later refetch can report again.
    (0, $cozmU.useEffect)(()=>{
        if (!error) {
            hasReportedErrorRef.current = false;
            return;
        }
        if (hasReportedErrorRef.current) return;
        hasReportedErrorRef.current = true;
        reportError(error);
    }, [
        error,
        reportError
    ]);
    const urls = (0, $cozmU.useMemo)(()=>(0, $ceb5f0113009896a$export$7d6dd950f56cfaae)(data), [
        data
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (skip || loading || !data) {
            resolvedDataRef.current = undefined;
            setLinks([]);
            setResolving(false);
            return;
        }
        let cancelled = false;
        setResolving(true);
        (0, $89f81df02d4c8ccc$export$4f12cb865d88dee)(urls, storeRef.current, connections.client).then((resolvedLinks)=>{
            if (!cancelled) {
                resolvedDataRef.current = data;
                setLinks((0, $632b20f216f6f413$export$39c6ffa318fec2a1)(resolvedLinks));
                setResolving(false);
                if (!hasSucceededRef.current && !error) {
                    hasSucceededRef.current = true;
                    createEvent((0, $fd09cd053ed09fc1$export$a1bd93651ef6059c)({
                        resolvedCount: resolvedLinks.length,
                        totalCount: data.graphStore_cypherQueryV2?.edges?.length ?? 0
                    })).fire();
                }
            }
        }).catch((error)=>{
            // Per-URL resolution reports expected ORS failures. This only prevents an
            // unexpected rejection from leaving the hook in a loading state.
            if (!cancelled) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error instanceof Error ? error : new Error(String(error)), {
                    attribution: (0, $3IBnw.Attribution).INTEGRATIONS
                });
                resolvedDataRef.current = data;
                setLinks([]);
                setResolving(false);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        connections.client,
        createEvent,
        data,
        error,
        loading,
        skip,
        urls
    ]);
    const resolutionPending = !skip && data != null && resolvedDataRef.current !== data;
    return {
        enabled: !skip,
        links: links,
        loading: loading || resolving || resolutionPending,
        error: error
    };
};





















var $cUB5n = parcelRequire("cUB5n");





var $5J49L = parcelRequire("5J49L");


var $de2j9 = parcelRequire("de2j9");


var $grd6j = parcelRequire("grd6j");

const $ab91ec1e712ab335$var$EMPTY_DOCUMENT = {
    adf: null,
    contentId: undefined
};
function $ab91ec1e712ab335$export$3b493f85f069c3ed(contentId) {
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const editorDocument = (0, $5J49L.usePageAdf)(isEditorPage ? contentId : undefined);
    const skipQuery = isEditorPage || !contentId;
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $grd6j.default), {
        contentId: skipQuery ? null : contentId ?? null
    }, {
        fetchPolicy: skipQuery ? 'store-only' : 'store-or-network'
    });
    const content = data?.content?.nodes?.find((node)=>node?.id === contentId);
    const body = content?.body?.dynamic;
    const queryAdf = (0, $cozmU.useMemo)(()=>{
        if (body?.representation !== 'atlas_doc_format' || !body.value) return null;
        try {
            let doc;
            if (contentId && (0, $6mKj3.expValEquals)('cc-proj-xl-use-shared-adf-parsing', 'isEnabled', true)) {
                const result = (0, $cUB5n.getOrParseContentBodyAdf)(contentId, body.value);
                if (!result.ok) return null;
                doc = result.doc;
            } else doc = JSON.parse(body.value);
            return doc?.type === 'doc' && doc.version === 1 && Array.isArray(doc.content) ? doc : null;
        } catch  {
            return null;
        }
    }, [
        body?.representation,
        body?.value,
        contentId
    ]);
    if (isEditorPage) return editorDocument;
    return queryAdf ? {
        adf: queryAdf,
        contentId: contentId
    } : $ab91ec1e712ab335$var$EMPTY_DOCUMENT;
}



var $bnSPF = parcelRequire("bnSPF");



const $316ae114bb16e7af$var$getDraftSmartCardsFromWindow = ()=>{
    const draftCards = globalThis.__SMART_CARDS_IN_DRAFT__;
    return Array.isArray(draftCards) ? draftCards : [];
};
const $316ae114bb16e7af$var$getDraftSmartLinkPositions = (smartCardsInDraft)=>{
    const seen = new Set();
    const positions = [];
    let counter = 0;
    for (const card of smartCardsInDraft){
        const type = card?.type;
        const url = card?.attrs?.url;
        const isSmartCardType = type === 'inlineCard' || type === 'blockCard' || type === 'embedCard';
        if (!isSmartCardType || typeof url !== 'string' || url.length === 0 || seen.has(url)) continue;
        seen.add(url);
        positions.push({
            url: url,
            occurrenceIndex: counter++
        });
    }
    return positions;
};
async function $316ae114bb16e7af$export$4d683cb1a551a6b2(adf, store, cardClient) {
    const adfPositions = (0, $bnSPF.extractSmartLinksFromAdf)(adf, true);
    // The page ADF document is authoritative for the current page once it is available.
    // Only bridge with the draft snapshot (`__SMART_CARDS_IN_DRAFT__`) while the document is
    // not yet available (`adf == null`); otherwise a brand-new/empty page would surface the
    // previous page's stale draft smart cards, since that window global persists across
    // client-side navigation and is not reset when creating a new page.
    const smartCardsInDraft = $316ae114bb16e7af$var$getDraftSmartCardsFromWindow();
    const draftPositions = $316ae114bb16e7af$var$getDraftSmartLinkPositions(smartCardsInDraft);
    const positions = (adf ? adfPositions : draftPositions).filter(({ url: url })=>!url.trimStart().startsWith('#'));
    if (positions.length === 0) return [];
    const links = await Promise.all(positions.map(async ({ url: url, occurrenceIndex: occurrenceIndex })=>{
        const { link: link } = await (0, $7e1486aa62dbf166$export$ab14756fcd367a5)(url, occurrenceIndex, store, cardClient);
        return link;
    }));
    const isDuplicate = (0, $ee2745eaeec65808$export$a253d02843d1519)();
    const uniqueLinks = [];
    links.forEach((link)=>{
        if (!isDuplicate(link)) uniqueLinks.push({
            ...link,
            occurrenceIndex: uniqueLinks.length
        });
    });
    return uniqueLinks;
}




const $20238d45d0fd30b1$var$ADF_WAIT_TIMEOUT_MS = 10000;
const $20238d45d0fd30b1$var$reportSmartLinkError = (err)=>{
    const errorObj = err instanceof Error ? err : new Error(String(err));
    (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
    return errorObj;
};
const $20238d45d0fd30b1$var$mergeRefreshedSmartLink = (link, response)=>{
    const refreshedLink = (0, $78ed55159915b828$export$9ebf81041d234ef6)(link.url, link.occurrenceIndex, response);
    return {
        ...refreshedLink,
        iconUrl: refreshedLink.iconUrl ?? link.iconUrl,
        product: link.product ?? refreshedLink.product,
        subproduct: link.subproduct ?? refreshedLink.subproduct
    };
};
function $20238d45d0fd30b1$export$379fef9d512fc4aa(contentId) {
    const document = (0, $ab91ec1e712ab335$export$3b493f85f069c3ed)(contentId);
    const adf = document.contentId === contentId ? document.adf : null;
    const { connections: connections, store: store } = (0, $bI14T.useSmartLinkContext)();
    const [result, setResult] = (0, $cozmU.useState)({
        contentId: contentId,
        links: [],
        adf: null,
        loading: true,
        refreshing: false,
        hasResolved: false,
        error: null
    });
    const linksRef = (0, $cozmU.useRef)([]);
    const currentContentId = (0, $cozmU.useRef)(contentId);
    currentContentId.current = contentId;
    const storeRef = (0, $cozmU.useRef)(store);
    (0, $cozmU.useEffect)(()=>{
        storeRef.current = store;
    }, [
        store
    ]);
    (0, $cozmU.useEffect)(()=>{
        linksRef.current = [];
    }, [
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        let cancelled = false;
        setResult((previous)=>{
            const samePage = previous.contentId === contentId;
            return {
                contentId: contentId,
                links: samePage ? previous.links : [],
                adf: samePage ? previous.adf : null,
                hasResolved: samePage && previous.hasResolved,
                loading: !samePage || !previous.hasResolved,
                refreshing: true,
                error: null
            };
        });
        if (!adf) {
            const timeout = setTimeout(()=>{
                setResult((previous)=>({
                        ...previous,
                        loading: false,
                        refreshing: false
                    }));
            }, $20238d45d0fd30b1$var$ADF_WAIT_TIMEOUT_MS);
            return ()=>clearTimeout(timeout);
        }
        (0, $316ae114bb16e7af$export$4d683cb1a551a6b2)(adf, storeRef.current, connections.client).then((links)=>{
            if (cancelled) return;
            linksRef.current = links;
            setResult({
                contentId: contentId,
                links: links,
                adf: adf,
                loading: false,
                refreshing: false,
                hasResolved: true,
                error: null
            });
        }).catch((err)=>{
            if (cancelled) return;
            const error = $20238d45d0fd30b1$var$reportSmartLinkError(err);
            setResult((previous)=>({
                    ...previous,
                    loading: false,
                    refreshing: false,
                    error: error
                }));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        adf,
        contentId,
        connections.client
    ]);
    const refreshLinkUrl = (0, $cozmU.useCallback)(async (item)=>{
        const productLabel = (0, $7d8abc6089406daa$export$d5a13f0f4d135b4b)(item);
        const productLinks = [];
        for (const link of linksRef.current){
            const isSameProduct = (0, $7d8abc6089406daa$export$d5a13f0f4d135b4b)(link) === productLabel;
            if (isSameProduct) productLinks.push(link);
        }
        const urlsToRefresh = [];
        const seenUrls = new Set();
        for (const link of productLinks)if (!seenUrls.has(link.url)) {
            seenUrls.add(link.url);
            urlsToRefresh.push(link.url);
        }
        const refreshedDataByUrl = new Map();
        await Promise.all(urlsToRefresh.map(async (url)=>{
            try {
                const response = await connections.client.fetchData(url, true);
                refreshedDataByUrl.set(url, response);
            } catch (err) {
                $20238d45d0fd30b1$var$reportSmartLinkError(err);
            }
        }));
        if (currentContentId.current !== contentId || refreshedDataByUrl.size === 0) return undefined;
        let refreshedMatchingItem;
        const refreshedLinks = linksRef.current.map((link)=>{
            if ((0, $7d8abc6089406daa$export$d5a13f0f4d135b4b)(link) !== productLabel) return link;
            const response = refreshedDataByUrl.get(link.url);
            if (!response) return link;
            const refreshedLink = $20238d45d0fd30b1$var$mergeRefreshedSmartLink(link, response);
            if (link.url === item.url && link.occurrenceIndex === item.occurrenceIndex) refreshedMatchingItem = refreshedLink;
            return refreshedLink;
        });
        linksRef.current = refreshedLinks;
        setResult((previous)=>({
                ...previous,
                links: refreshedLinks
            }));
        return refreshedMatchingItem;
    }, [
        connections.client,
        contentId
    ]);
    const links = (0, $cozmU.useMemo)(()=>result.contentId === contentId ? result.links : [], [
        result.contentId,
        result.links,
        contentId
    ]);
    const samePage = result.contentId === contentId;
    return {
        links: links,
        collectedForContentId: samePage && result.hasResolved ? contentId : undefined,
        collectedAdf: samePage ? result.adf : null,
        loading: !samePage || result.loading,
        refreshing: !samePage || result.refreshing,
        error: samePage ? result.error : null,
        refreshLinkUrl: refreshLinkUrl
    };
}


const $14b4659b7aaed708$export$bb74724ea117ee6f = ({ atAGlanceEnabled: atAGlanceEnabled, contentId: contentId, contentType: contentType, connectionAncestors: connectionAncestors, pageVersion: pageVersion, pageUpdatedAt: pageUpdatedAt, pageTitle: pageTitle })=>{
    const outgoing = (0, $20238d45d0fd30b1$export$379fef9d512fc4aa)(contentId);
    const { links: incomingLinks, twgLinks: incomingTwgLinks, loading: loading, settled: settled, loadingMore: loadingMore, hasNextPage: hasNextPage, endCursor: endCursor, loadMore: loadMore, error: error } = (0, $8a6630d12e0f6d27$export$4a27c1a938f63c6e)(contentId, {
        contentType: contentType
    });
    // Keep bridge snapshots stable when unrelated byline or AI state changes.
    const incoming = (0, $cozmU.useMemo)(()=>({
            links: incomingLinks,
            twgLinks: incomingTwgLinks,
            loading: loading,
            settled: settled,
            loadingMore: loadingMore,
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            loadMore: loadMore,
            error: error
        }), [
        incomingLinks,
        incomingTwgLinks,
        loading,
        settled,
        loadingMore,
        hasNextPage,
        endCursor,
        loadMore,
        error
    ]);
    const { enabled: enabled, links: relatedLinks, loading: relatedLoading, error: relatedError } = (0, $8d208cf49c8d5b5a$export$e0a19cb5df8c4186)(contentId, {
        contentType: contentType
    });
    const relatedContent = (0, $cozmU.useMemo)(()=>({
            enabled: enabled,
            links: relatedLinks,
            loading: relatedLoading,
            error: relatedError
        }), [
        enabled,
        relatedLinks,
        relatedLoading,
        relatedError
    ]);
    const devDocsConnection = (0, $fZLJ8.useDevDocsBylineConnection)(connectionAncestors);
    const atAGlance = (0, $e2bf91e4975d6fca$export$72b2d05bd0aa0669)({
        enabled: atAGlanceEnabled,
        contentId: contentId,
        contentType: contentType,
        pageTitle: pageTitle,
        pageAdf: outgoing.collectedForContentId === contentId ? outgoing.collectedAdf : null,
        pageVersion: pageVersion,
        pageUpdatedAt: pageUpdatedAt,
        structuralAncestors: connectionAncestors,
        outgoingLinksLoading: outgoing.loading || outgoing.refreshing,
        // useAtAGlance also waits for incoming.loading via appearsIn and for
        // enabled Related content to settle before the first request.
        connections: {
            appearsIn: incoming,
            linksTo: {
                links: outgoing.links
            },
            relatedContent: relatedContent
        }
    });
    // The preview panel mounts outside this subtree and reads the bridge.
    // Tag links with their collected-for id to keep page transitions consistent.
    (0, $cozmU.useEffect)(()=>{
        (0, $Hnn0l.publishOutgoingLinks)({
            contentId: outgoing.collectedForContentId,
            outgoingLinks: outgoing.links
        });
    }, [
        outgoing.collectedForContentId,
        outgoing.links
    ]);
    // Separate from the publish effect so the store is only emptied when the
    // byline actually goes away, not on every republish.
    (0, $cozmU.useEffect)(()=>(0, $Hnn0l.clearOutgoingLinks), []);
    // Tagged with `contentId` rather than a collected-for id because
    // `connectionAncestors` arrives as a prop alongside it, so the two move together.
    (0, $cozmU.useEffect)(()=>{
        (0, $3b6532377f19c330$export$bef8e2d39680b9a8)({
            contentId: contentId,
            devDocsConnection: devDocsConnection
        });
    }, [
        contentId,
        devDocsConnection
    ]);
    (0, $cozmU.useEffect)(()=>(0, $3b6532377f19c330$export$962a90b3959f19a3), []);
    (0, $cozmU.useEffect)(()=>{
        (0, $21leH.publishIncomingLinks)({
            contentId: contentId,
            incomingLinks: incoming
        });
    }, [
        contentId,
        incoming
    ]);
    (0, $cozmU.useEffect)(()=>(0, $21leH.clearIncomingLinks), []);
    (0, $cozmU.useEffect)(()=>{
        (0, $4ao9J.publishRelatedContent)({
            contentId: contentId,
            relatedContent: relatedContent
        });
    }, [
        contentId,
        relatedContent
    ]);
    (0, $cozmU.useEffect)(()=>(0, $4ao9J.clearRelatedContent), []);
    (0, $cozmU.useEffect)(()=>{
        (0, $e881057e0de27ea9$export$d7ea14a22c3a1260)({
            contentId: contentId,
            atAGlance: atAGlance
        });
    }, [
        contentId,
        atAGlance
    ]);
    (0, $cozmU.useEffect)(()=>(0, $e881057e0de27ea9$export$932fff4b8bd41d62), []);
    return {
        outgoing: outgoing,
        incoming: incoming,
        relatedContent: relatedContent,
        devDocsConnection: devDocsConnection
    };
};











const $cd0c0d2e80124538$export$3969396859eef22e = ({ contentId: contentId, isTeamworkGraphPreviewPanelOpen: isTeamworkGraphPreviewPanelOpen, openTeamworkGraphPreviewPanel: openTeamworkGraphPreviewPanel })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [menuState, setMenuState] = (0, $cozmU.useState)({
        contentId: contentId,
        isOpen: false,
        hasOpenedPanel: false
    });
    if (menuState.contentId !== contentId) setMenuState({
        contentId: contentId,
        isOpen: false,
        hasOpenedPanel: isTeamworkGraphPreviewPanelOpen
    });
    else if (isTeamworkGraphPreviewPanelOpen && !menuState.hasOpenedPanel) setMenuState({
        ...menuState,
        hasOpenedPanel: true
    });
    const isCurrentPage = menuState.contentId === contentId;
    const isOpen = isCurrentPage && menuState.isOpen;
    // The popup's focus trap returns focus to the trigger on close by calling
    // `.focus()` (without `preventScroll`), which scrolls the trigger back into
    // view. For a link navigation that fights the in-page scroll, so we disable
    // the trap's focus return (`shouldReturnFocus={false}`) and instead restore
    // focus ourselves on non-navigation closes (Esc / outside click) using
    // `preventScroll` — keeping keyboard a11y without the scroll jump.
    const triggerRef = (0, $cozmU.useRef)(null);
    const navigatedRef = (0, $cozmU.useRef)(false);
    const handleClose = (0, $cozmU.useCallback)((isEmbeddedMenu)=>{
        setMenuState((current)=>({
                ...current,
                isOpen: false
            }));
        // Navigating away lands here too — the popup fires `onClose` once the panel
        // opens — and that is not a dismissal: it reports its own event, and focus belongs to
        // whatever is opening rather than back on the trigger.
        if (navigatedRef.current) return;
        // What is left is every real dismissal — Esc and outside clicks — so this is
        // one close event per close, mirroring the modals.
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.MENU_CLOSE_ACTION_SUBJECT_ID),
                source: isEmbeddedMenu ? (0, $I7TEB.EMBEDDED_MENU_SOURCE) : (0, $I7TEB.MENU_SOURCE)
            }
        }).fire();
        // Esc / outside-click close: return focus to the trigger without scrolling.
        triggerRef.current?.focus({
            preventScroll: true
        });
    }, [
        createAnalyticsEvent
    ]);
    const handleNavigate = (0, $cozmU.useCallback)(()=>{
        navigatedRef.current = true;
        setMenuState((current)=>({
                ...current,
                isOpen: false
            }));
    }, []);
    const handleOpenPreviewPanel = (0, $cozmU.useCallback)(()=>{
        navigatedRef.current = true;
        openTeamworkGraphPreviewPanel();
        setMenuState((current)=>({
                ...current,
                isOpen: false
            }));
    }, [
        openTeamworkGraphPreviewPanel
    ]);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        navigatedRef.current = false;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.BYLINE_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE)
            }
        }).fire();
        setMenuState((current)=>({
                ...current,
                isOpen: !isOpen
            }));
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    const handlePlaceholderOpenChange = (0, $cozmU.useCallback)((isOpen)=>{
        if (isOpen) navigatedRef.current = false;
        setMenuState((current)=>({
                ...current,
                isOpen: isOpen
            }));
    }, []);
    return {
        isOpen: isOpen,
        atAGlanceEnabled: isCurrentPage && menuState.hasOpenedPanel,
        triggerRef: triggerRef,
        handleClose: handleClose,
        handleNavigate: handleNavigate,
        handleOpenPreviewPanel: handleOpenPreviewPanel,
        handleToggle: handleToggle,
        handlePlaceholderOpenChange: handlePlaceholderOpenChange
    };
};






var $1P7Cq = parcelRequire("1P7Cq");












const $e23f8c791f566bf8$export$2b794d642b6119fd = ({ isEmbeddedMenu: isEmbeddedMenu, outgoingLinks: outgoingLinks, incomingLinks: incomingLinks, relatedContentLinks: relatedContentLinks, hasDevDocsConnection: hasDevDocsConnection, outgoingLinksLoading: outgoingLinksLoading, incomingLinksLoading: incomingLinksLoading, relatedContentLoading: relatedContentLoading, outgoingFillsStack: outgoingFillsStack, reservedIconCount: reservedIconCount })=>{
    const hasConnection = isEmbeddedMenu ? outgoingLinks.length > 0 || hasDevDocsConnection || incomingLinks.length > 0 : hasDevDocsConnection || (0, $f18dee4c2180353b$export$4184afff02de6fec)({
        relatedContentLinks: relatedContentLinks,
        incomingLinks: incomingLinks,
        outgoingLinks: outgoingLinks
    });
    const isResolving = outgoingLinksLoading || incomingLinksLoading && !outgoingFillsStack || !isEmbeddedMenu && !hasConnection && relatedContentLoading;
    const shouldRenderByline = hasConnection || isEmbeddedMenu && reservedIconCount > 0;
    return {
        hasConnection: hasConnection,
        isResolving: isResolving,
        shouldRenderByline: shouldRenderByline
    };
};






var $idfQJ = parcelRequire("idfQJ");


var $fONL3 = parcelRequire("fONL3");

const $b3c77e69626f7927$var$getIconKey = (providerDisplayName)=>providerDisplayName?.replace(/([a-z])([A-Z])/g, '$1 $2') ?? 'Repository';
const $b3c77e69626f7927$var$getProviderIcon = (provider, providerDisplayName)=>{
    return {
        key: `devdocs-provider-${$b3c77e69626f7927$var$getIconKey(providerDisplayName)}`,
        kind: 'element',
        label: providerDisplayName,
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idfQJ.DevDocsScmProviderIcon), {
            provider: provider
        })
    };
};
const $b3c77e69626f7927$export$65120229cda600d = (connection)=>{
    if (!connection) return null;
    const providerConfig = (0, $fONL3.getDevDocsSourceProviderConfigFromValue)(connection.provider);
    const providerDisplayName = providerConfig?.displayName ?? (0, $fONL3.getDevDocsSourceProviderDisplayName)(connection.provider);
    if (!providerDisplayName) return null;
    return {
        key: providerConfig ? $b3c77e69626f7927$var$getIconKey(providerConfig.displayName) : providerDisplayName,
        label: providerDisplayName,
        icon: $b3c77e69626f7927$var$getProviderIcon(connection.provider, providerDisplayName)
    };
};


const $40aeb62f0bf503d6$export$f234f5d8855b4379 = (connection)=>{
    const icon = (0, $b3c77e69626f7927$export$65120229cda600d)(connection);
    return icon ? [
        icon
    ] : undefined;
};


const $5e78f14186af6ae0$export$41ce1d5f545c25ec = ({ contentId: contentId, contentType: contentType, isEmbeddedMenu: isEmbeddedMenu, data: data })=>{
    const { outgoing: outgoing, incoming: incoming, relatedContent: relatedContent, devDocsConnection: devDocsConnection } = data;
    const { links: outgoingLinks, loading: outgoingLinksLoading } = outgoing;
    const { twgLinks: twgIncomingLinks, loading: incomingLinksLoading } = incoming;
    const { links: relatedContentLinks, loading: relatedContentLoading } = relatedContent;
    const devDocsIcons = (0, $cozmU.useMemo)(()=>(0, $40aeb62f0bf503d6$export$f234f5d8855b4379)(devDocsConnection), [
        devDocsConnection
    ]);
    // Outgoing links fill the stack first, so once they alone fill it no incoming icon can change
    // what is painted and the trigger need not wait for the graph query.
    const outgoingFillsStack = (0, $cozmU.useMemo)(()=>(0, $jJhQa.getBylineConnectionIcons)(outgoingLinks, devDocsIcons).length >= (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS), [
        outgoingLinks,
        devDocsIcons
    ]);
    const outboundState = (0, $4fdcf8c799fd8a14$export$4ec68330314c7b96)(contentId);
    const incomingState = (0, $c1244bdd1b458e82$export$36c53bcdf571f79b)(contentId, contentType);
    const relatedContentState = (0, $15ca35a849ff5bf4$export$58c3bd07661395fe)(contentId, contentType);
    const isSSROrHydrating = (0, $1P7Cq.useIsSSROrHydrating)();
    // Keep the server's hide decision until navigation, even if client queries find more links.
    const [hiddenSsrContent, setHiddenSsrContent] = (0, $cozmU.useState)(()=>isSSROrHydrating && !(0, $2e2c24ad29df8d85$export$668fe94d630a199)({
            outboundState: outboundState,
            incomingLinksState: incomingState,
            relatedContentState: relatedContentState,
            hasDevDocsConnection: devDocsConnection !== null
        }) ? {
            contentId: contentId,
            contentType: contentType
        } : null);
    const hiddenBySsr = hiddenSsrContent?.contentId === contentId && hiddenSsrContent.contentType === contentType;
    if (hiddenSsrContent && !hiddenBySsr) setHiddenSsrContent(null);
    const reservedIconCount = (0, $3C8hL.getReservedBylineIconCount)(outboundState, devDocsConnection !== null, incomingState?.status === 'present');
    // The show/hide and wait rules for both menus live in `getBylineVisibility`.
    const { hasConnection: hasConnection, isResolving: isResolving, shouldRenderByline: shouldRenderByline } = (0, $cozmU.useMemo)(()=>(0, $e23f8c791f566bf8$export$2b794d642b6119fd)({
            isEmbeddedMenu: isEmbeddedMenu,
            outgoingLinks: outgoingLinks,
            incomingLinks: twgIncomingLinks,
            relatedContentLinks: relatedContentLinks,
            hasDevDocsConnection: devDocsConnection !== null,
            outgoingLinksLoading: outgoingLinksLoading,
            incomingLinksLoading: incomingLinksLoading,
            relatedContentLoading: relatedContentLoading,
            outgoingFillsStack: outgoingFillsStack,
            reservedIconCount: reservedIconCount
        }), [
        isEmbeddedMenu,
        outgoingLinks,
        twgIncomingLinks,
        relatedContentLinks,
        devDocsConnection,
        outgoingLinksLoading,
        incomingLinksLoading,
        relatedContentLoading,
        outgoingFillsStack,
        reservedIconCount
    ]);
    return {
        hiddenBySsr: hiddenBySsr,
        hasConnection: hasConnection,
        isResolving: isResolving,
        shouldRenderByline: shouldRenderByline,
        devDocsIcons: devDocsIcons
    };
};











const $7263096a4038dcc7$export$568fc844f3097c27 = ({ hiddenBySsr: hiddenBySsr, isResolving: isResolving, shouldRenderByline: shouldRenderByline })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const hasFiredViewedRef = (0, $cozmU.useRef)(false);
    // Fire a single "viewed" event the first time the byline actually renders its
    // content — skip while resolving and while there is nothing to show (both cases
    // early-return before the trigger is visible).
    (0, $cozmU.useEffect)(()=>{
        if (hiddenBySsr || hasFiredViewedRef.current || isResolving || !shouldRenderByline) return;
        hasFiredViewedRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'byline',
                actionSubjectId: (0, $I7TEB.BYLINE_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE)
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        hiddenBySsr,
        isResolving,
        shouldRenderByline
    ]);
};









var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");

const $460c5801038ac219$export$7705042750e63836 = (contentId, isResolving, hasConnection, error)=>{
    const tracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const activeLoad = (0, $cozmU.useRef)(undefined);
    // Match the page before using a clock retained from an earlier route.
    let pageExperience;
    for (const name of [
        (0, $irVI7.VIEW_PAGE_EXPERIENCE),
        (0, $irVI7.EDIT_PAGE_EXPERIENCE)
    ]){
        const state = tracker.getExperienceState(name);
        if (state && (state.taskId === contentId || state.attributes?.contentId === contentId) && (!pageExperience || state.startTime > pageExperience.startTime)) pageExperience = state;
    }
    const pageExperienceName = pageExperience?.name;
    const startTime = pageExperience?.startTime;
    const loadId = pageExperience ? `${contentId}:${pageExperience.name}:${pageExperience.startTime}` : undefined;
    (0, $cozmU.useEffect)(()=>{
        const name = (0, $irVI7.BYLINE_CONNECTIONS_LOAD_EXPERIENCE);
        activeLoad.current = loadId;
        if (!loadId || startTime === undefined) return;
        if (tracker.getExperienceState(name)?.taskId !== loadId) tracker.start({
            name: name,
            id: loadId,
            startTime: startTime,
            attributes: {
                pageExperience: pageExperienceName,
                errorAttribution: (0, $3IBnw.Attribution).INTEGRATIONS
            }
        });
        if (!isResolving) {
            if (error) tracker.stopOnError({
                name: name,
                error: error
            });
            else tracker.succeed({
                name: name,
                attributes: {
                    hasConnection: hasConnection
                }
            });
        }
        return ()=>{
            activeLoad.current = undefined;
            // Let StrictMode restore the effect before treating cleanup as navigation.
            Promise.resolve().then(()=>{
                const state = tracker.getExperienceState(name);
                if (activeLoad.current !== loadId && state?.taskId === loadId) tracker.abort({
                    name: name,
                    reason: 'Byline connections unmounted before resolution'
                });
            });
        };
    }, [
        error,
        tracker,
        hasConnection,
        isResolving,
        loadId,
        pageExperienceName,
        startTime
    ]);
};






var $87whh = parcelRequire("87whh");


var $lRhY3 = parcelRequire("lRhY3");

const $5f7d816a14638938$export$ddbac920bdbdb256 = 'confluencePreviewPanel';
const $5f7d816a14638938$export$e8a5079e96625ede = 'confluence-teamworkGraph';
const $5f7d816a14638938$export$f6fc4a5779d5dc2c = 'confluence';
const $5f7d816a14638938$export$e043f5004f4e5a4 = 'teamwork-graph-preview-panel';


/* TeamworkGraphPreviewPanel.tsx generated by @compiled/babel-plugin v3.0.2 */ 








var $5WTxQ = parcelRequire("5WTxQ");


var $kMhHg = parcelRequire("kMhHg");


var $fE1YT = parcelRequire("fE1YT");





















var $6Cgm9 = parcelRequire("6Cgm9");


var $3u0dr = parcelRequire("3u0dr");











var $euL71 = parcelRequire("euL71");





var $kwDQA = parcelRequire("kwDQA");


var $kaFRI = parcelRequire("kaFRI");


var $1MB8j = parcelRequire("1MB8j");

const $df93accb317ff293$export$de2d69f0cd77adf5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const skip = t0 === undefined ? false : t0;
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const isPrivacyModeEligible = (0, $1MB8j.useIsPrivacyModeEligible)();
    const enabled = !skip && !!contentId && !!cloudId && edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let t1;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== enabled || $[3] !== environment || $[4] !== isPrivacyModeEligible) {
        t1 = {
            contentId: contentId,
            cloudId: cloudId,
            enabled: enabled,
            isPrivacyModeEligible: isPrivacyModeEligible,
            environment: environment
        };
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = enabled;
        $[3] = environment;
        $[4] = isPrivacyModeEligible;
        $[5] = t1;
    } else t1 = $[5];
    const request = t1;
    const [result, setResult] = (0, $cozmU.useState)();
    let t2;
    let t3;
    if ($[6] !== request) {
        t2 = ()=>{
            if (!request.enabled) return;
            let permission;
            let privacy;
            let error;
            const publish = ()=>{
                const isPrivacyModeEnabled = request.isPrivacyModeEligible && privacy?.privacyMode?.isPrivacyModeEnabled !== false;
                const loading = !error && (!permission || request.isPrivacyModeEligible && !privacy);
                setResult({
                    request: request,
                    access: {
                        canView: !loading && !error && !isPrivacyModeEnabled && permission?.user?.confluence?.permissionType === "INTERNAL",
                        isPrivacyModeEnabled: isPrivacyModeEnabled,
                        loading: loading,
                        error: error
                    }
                });
            };
            const onError = (queryError)=>{
                error = queryError;
                publish();
            };
            const permissionSubscription = (0, $6SsN4.fetchQuery)(request.environment, (0, $kwDQA.default), {
                contentId: request.contentId
            }, {
                fetchPolicy: "store-or-network"
            }).subscribe({
                next: (data)=>{
                    permission = data;
                    publish();
                },
                error: onError
            });
            const privacySubscription = request.isPrivacyModeEligible ? (0, $6SsN4.fetchQuery)(request.environment, (0, $kaFRI.default), {
                contentId: request.contentId,
                cloudId: request.cloudId,
                isPrivacyModeGateEnabled: true
            }, {
                fetchPolicy: "store-or-network"
            }).subscribe({
                next: (data_0)=>{
                    privacy = data_0;
                    publish();
                },
                error: onError
            }) : undefined;
            return ()=>{
                permissionSubscription.unsubscribe();
                privacySubscription?.unsubscribe();
            };
        };
        t3 = [
            request
        ];
        $[6] = request;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[9] !== enabled || $[10] !== isPrivacyModeEligible || $[11] !== request || $[12] !== result) {
        t4 = enabled && result?.request === request ? result.access : {
            canView: false,
            isPrivacyModeEnabled: isPrivacyModeEligible,
            loading: enabled,
            error: undefined
        };
        $[9] = enabled;
        $[10] = isPrivacyModeEligible;
        $[11] = request;
        $[12] = result;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : (contentId, skip = false)=>{
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const isPrivacyModeEligible = (0, $1MB8j.useIsPrivacyModeEligible)();
    const enabled = !skip && !!contentId && !!cloudId && edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const request = (0, $cozmU.useMemo)(()=>({
            contentId: contentId,
            cloudId: cloudId,
            enabled: enabled,
            isPrivacyModeEligible: isPrivacyModeEligible,
            environment: environment
        }), [
        contentId,
        cloudId,
        enabled,
        isPrivacyModeEligible,
        environment
    ]);
    const [result, setResult] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!request.enabled) return;
        let permission;
        let privacy;
        let error;
        const publish = ()=>{
            const isPrivacyModeEnabled = request.isPrivacyModeEligible && privacy?.privacyMode?.isPrivacyModeEnabled !== false;
            const loading = !error && (!permission || request.isPrivacyModeEligible && !privacy);
            setResult({
                request: request,
                access: {
                    canView: !loading && !error && !isPrivacyModeEnabled && permission?.user?.confluence?.permissionType === 'INTERNAL',
                    isPrivacyModeEnabled: isPrivacyModeEnabled,
                    loading: loading,
                    error: error
                }
            });
        };
        const onError = (queryError)=>{
            error = queryError;
            publish();
        };
        const permissionSubscription = (0, $6SsN4.fetchQuery)(request.environment, (0, $kwDQA.default), {
            contentId: request.contentId
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                permission = data;
                publish();
            },
            error: onError
        });
        const privacySubscription = request.isPrivacyModeEligible ? (0, $6SsN4.fetchQuery)(request.environment, (0, $kaFRI.default), {
            contentId: request.contentId,
            cloudId: request.cloudId,
            isPrivacyModeGateEnabled: true
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data_0)=>{
                privacy = data_0;
                publish();
            },
            error: onError
        }) : undefined;
        return ()=>{
            permissionSubscription.unsubscribe();
            privacySubscription?.unsubscribe();
        };
    }, [
        request
    ]);
    // Previous-page access must not enable viewer fetching while the next request starts.
    return enabled && result?.request === request ? result.access : {
        canView: false,
        isPrivacyModeEnabled: isPrivacyModeEligible,
        loading: enabled,
        error: undefined
    };
};

















const $6e04cdfd924900fc$export$63b388e9743a81ae = (contentId)=>{
    const access = (0, $df93accb317ff293$export$de2d69f0cd77adf5)(contentId, !contentId || !(0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false));
    const skip = !access.canView;
    const { contentId: viewersContentId, viewers: viewers, loadViewers: loadViewers, isLoading: isLoading, isLoadViewersCalled: isLoadViewersCalled, error: error } = (0, $6Cgm9.usePageViews)(contentId, {
        // The shared hook requests one extra row; keep the request within the 200-row API limit.
        limit: 199,
        skip: skip,
        isPrivacyModeEnabled: access.isPrivacyModeEnabled,
        includeViewersActorType: true,
        includeAgentTypePreview: false
    });
    (0, $cozmU.useEffect)(()=>{
        if (!skip) loadViewers();
    }, [
        skip,
        loadViewers
    ]);
    const agents = (0, $cozmU.useMemo)(()=>skip || viewersContentId !== contentId ? [] : (viewers ?? []).filter((viewer)=>'isAgent' in viewer && viewer.isAgent === true), [
        skip,
        viewersContentId,
        contentId,
        viewers
    ]);
    const loading = access.loading || !skip && (isLoading || !isLoadViewersCalled);
    const resultError = access.error ?? (skip ? undefined : error);
    (0, $cozmU.useEffect)(()=>{
        if (resultError && !(0, $7Sm4c.isErrorMarkedAsHandled)(resultError)) {
            (0, $5ZqQS.getMonitoringClient)().submitError(resultError, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(resultError);
        }
    }, [
        resultError
    ]);
    return (0, $cozmU.useMemo)(()=>({
            agents: agents,
            loading: loading,
            error: resultError
        }), [
        agents,
        loading,
        resultError
    ]);
};









var $9U6SN = parcelRequire("9U6SN");





var $1uFM6 = parcelRequire("1uFM6");













const $26f2396e152670eb$export$f3067e0497a6667f = (data)=>(data?.confluence_contentCollaborators?.nodes ?? []).flatMap((node)=>{
        if (!node?.agent) return [];
        const { agent: agent, person: person } = node;
        return [
            {
                accountId: agent.accountId,
                name: agent.displayName ?? '',
                avatarURL: agent.profilePicture?.path ?? '',
                attributedUsers: [
                    {
                        id: person.accountId || null,
                        name: person.displayName ?? '',
                        avatarURL: person.profilePicture?.path
                    }
                ]
            }
        ];
    });


const $e4e9a1aeda282667$export$b08610bd07f7d5f0 = (contentId, { enabled: enabled = true } = {})=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const skip = !enabled || !contentId || !cloudId;
    const request = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId,
            contentId: contentId,
            skip: skip,
            environment: environment
        }), [
        cloudId,
        contentId,
        skip,
        environment
    ]);
    const [result, setResult] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (request.skip || !request.contentId || !request.cloudId) return;
        const subscription = (0, $6SsN4.fetchQuery)(request.environment, (0, $9U6SN.default), {
            cloudId: request.cloudId,
            id: request.contentId,
            first: 2147483647
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                setResult({
                    request: request,
                    data: data
                });
            },
            error: (error)=>{
                setResult({
                    request: request,
                    error: error
                });
            }
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        request
    ]);
    // Hide previous-page data immediately, before the next subscription starts.
    const currentResult = !skip && result?.request === request ? result : undefined;
    const data = currentResult?.data;
    const resultError = currentResult?.error;
    const loading = !skip && !currentResult;
    (0, $cozmU.useEffect)(()=>{
        if (resultError && !(0, $7Sm4c.isErrorMarkedAsHandled)(resultError)) {
            // Permission failures leave the independent people/viewer streams available.
            if (!(0, $1uFM6.isUnauthorizedError)(resultError)) (0, $5ZqQS.getMonitoringClient)().submitError(resultError, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(resultError);
        }
    }, [
        resultError
    ]);
    const availability = skip ? 'disabled' : loading ? 'loading' : resultError ? 'error' : data?.confluence_contentCollaborators == null ? 'unavailable' : 'available';
    const agents = (0, $cozmU.useMemo)(()=>availability === 'available' ? (0, $26f2396e152670eb$export$f3067e0497a6667f)(data) : [], [
        availability,
        data
    ]);
    return (0, $cozmU.useMemo)(()=>({
            agents: agents,
            loading: availability === 'loading',
            error: resultError,
            availability: availability
        }), [
        agents,
        availability,
        resultError
    ]);
};


/**
 * @generated SignedSource<<b14600f7c34b5ab0d87599e6d109da6b>>
 * @relayHash 94b2c6e0d3e4c04de93855fc6893a44a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f5191d9421bc8ec2898df082e1b0aabe61684736a663651ae2eeef06b1fa2fc
const $d01d6f08de6a92ee$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cypherQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "queryContext"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 110
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "cypherQuery"
        },
        {
            "kind": "Variable",
            "name": "queryContext",
            "variableName": "queryContext"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "version"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ 
        ],
        "type": "CustomerUser"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "stringValue",
                "kind": "ScalarField",
                "name": "value"
            }
        ],
        "type": "GraphStoreCypherQueryV2StringObject"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "timestampValue",
                "kind": "ScalarField",
                "name": "value"
            }
        ],
        "type": "GraphStoreCypherQueryV2TimestampObject"
    }, v13 = [
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePagePeopleQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        },
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePagePeopleQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsProjectDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "TeamCustomFieldValue"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "TeamType"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "ThirdPartyUser"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        },
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "94b2c6e0d3e4c04de93855fc6893a44a",
            "id": "4f5191d9421bc8ec2898df082e1b0aabe61684736a663651ae2eeef06b1fa2fc",
            "metadata": {},
            "name": "usePagePeopleQuery",
            "operationKind": "query",
            "text": "query usePagePeopleQuery($cypherQuery:String!,$queryContext:String!,$version:GraphStoreCypherQueryV2VersionEnum){graphStore_cypherQueryV2(query:$cypherQuery,queryContext:$queryContext,version:$version,first:110)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id,data{__typename,...on AtlassianAccountUser{id,accountId,name,picture,accountStatus,extendedProfile{jobTitle}},...on CustomerUser{id,accountId,name,picture,accountStatus},...on Node{__isNode:__typename,id},...on AppUser{id},...on DevOpsFeatureFlag{id},...on DevOpsOperationsComponentDetails{id},...on DevOpsOperationsIncidentDetails{id},...on DevOpsOperationsPostIncidentReviewDetails{id},...on DevOpsProjectDetails{id},...on DevOpsPullRequestDetails{id},...on DevOpsRepository{id},...on DevOpsSecurityVulnerabilityDetails{id},...on JiraAutodevJob{id},...on JiraConfluenceRemoteIssueLink{id},...on JiraCustomRemoteIssueLink{id},...on JiraIssueRemoteIssueLink{id},...on JiraWebRemoteIssueLink{id},...on TeamCustomFieldValue{id},...on TeamType{id},...on ThirdPartyUser{id}}},...on GraphStoreCypherQueryV2StringObject{stringValue:value},...on GraphStoreCypherQueryV2TimestampObject{timestampValue:value}}}}}}}"
        }
    };
}();
$d01d6f08de6a92ee$var$node.hash = "af3f187b46363a2e3ea7b5f9ee9a63d5";
var $d01d6f08de6a92ee$export$2e2bcd8739ae039 = $d01d6f08de6a92ee$var$node;
































const $cebcf46595f8344d$export$89a33a230d65db65 = [
    {
        cypherName: 'atlassian_user_created_confluence_page',
        relationship: 'created',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_contributed_to_confluence_page',
        relationship: 'contributed',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_owns_confluence_page',
        relationship: 'owns',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_updated_confluence_page',
        relationship: 'updated',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_viewed_confluence_page',
        relationship: 'viewed',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_favorited_confluence_page',
        relationship: 'favorited',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_liked_confluence_page',
        relationship: 'liked',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_mentioned_in_confluence_page',
        relationship: 'mentioned-in',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_snapshotted_confluence_page',
        relationship: 'snapshotted',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_watches_confluence_page',
        relationship: 'watches',
        direction: 'incoming'
    },
    {
        cypherName: 'confluence_page_shared_with_atlassian_user',
        relationship: 'shared-with',
        direction: 'outgoing'
    }
];
/**
 * The registry entries that connect a Confluence blog post and an Atlassian user. The registry
 * names these edges separately from the page ones and defines no owns, liked, mentioned-in, or
 * snapshotted edge for blog posts.
 */ const $cebcf46595f8344d$var$BLOGPOST_PEOPLE_RELATIONSHIPS = [
    {
        cypherName: 'atlassian_user_created_confluence_blogpost',
        relationship: 'created',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_contributed_to_confluence_blogpost',
        relationship: 'contributed',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_updated_confluence_blogpost',
        relationship: 'updated',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_viewed_confluence_blogpost',
        relationship: 'viewed',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_favorited_confluence_blogpost',
        relationship: 'favorited',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_watches_confluence_blogpost',
        relationship: 'watches',
        direction: 'incoming'
    },
    {
        cypherName: 'confluence_blogpost_shared_with_atlassian_user',
        relationship: 'shared-with',
        direction: 'outgoing'
    }
];
const $cebcf46595f8344d$export$8845d316349130d6 = (contentType)=>contentType === 'blogpost' ? $cebcf46595f8344d$var$BLOGPOST_PEOPLE_RELATIONSHIPS : $cebcf46595f8344d$export$89a33a230d65db65;
const $cebcf46595f8344d$export$3ad09bd8c18dea3b = (value)=>$cebcf46595f8344d$export$89a33a230d65db65.some(({ relationship: relationship })=>relationship === value);
const $cebcf46595f8344d$export$7cb477f6de87aaf0 = (value)=>value === 'incoming' || value === 'outgoing';


const $f27c506e525608c8$var$readColumn = (columns, key)=>columns.find((column)=>column.key === key)?.value ?? undefined;
const $f27c506e525608c8$var$isHydratedPerson = (user)=>(user?.__typename === 'AtlassianAccountUser' || user?.__typename === 'CustomerUser') && 'accountStatus' in user && user.accountStatus === 'active';
const $f27c506e525608c8$export$118d4ea22fb34073 = (data)=>{
    const peopleByAccount = new Map();
    const evidenceKeysByAccount = new Map();
    for (const edge of data?.graphStore_cypherQueryV2?.edges ?? []){
        const columns = edge.node.columns;
        const personValue = $f27c506e525608c8$var$readColumn(columns, 'person');
        const user = personValue?.data;
        const relationship = $f27c506e525608c8$var$readColumn(columns, 'relationship')?.stringValue;
        const direction = $f27c506e525608c8$var$readColumn(columns, 'direction')?.stringValue;
        if (!personValue?.id || !$f27c506e525608c8$var$isHydratedPerson(user) || !(0, $cebcf46595f8344d$export$3ad09bd8c18dea3b)(relationship) || !(0, $cebcf46595f8344d$export$7cb477f6de87aaf0)(direction)) continue;
        const accountKey = user.accountId || personValue.id;
        const evidence = {
            relationship: relationship,
            direction: direction,
            lastUpdated: $f27c506e525608c8$var$readColumn(columns, 'relationshipTimestamp')?.timestampValue ?? null
        };
        const existing = peopleByAccount.get(accountKey);
        const evidenceKey = `${evidence.relationship}:${evidence.direction}:${evidence.lastUpdated ?? ''}`;
        // Get-or-create rather than optional chaining: a missing Set would otherwise
        // silently drop the key while still merging the relationship, so the next
        // duplicate row would be merged a second time.
        let evidenceKeys = evidenceKeysByAccount.get(accountKey);
        if (!evidenceKeys) {
            evidenceKeys = new Set();
            evidenceKeysByAccount.set(accountKey, evidenceKeys);
        }
        if (existing) {
            if (evidenceKeys.has(evidenceKey)) continue;
            evidenceKeys.add(evidenceKey);
            peopleByAccount.set(accountKey, {
                ...existing,
                relationships: [
                    ...existing.relationships,
                    evidence
                ]
            });
            continue;
        }
        evidenceKeys.add(evidenceKey);
        peopleByAccount.set(accountKey, {
            ari: personValue.id,
            accountId: user.accountId,
            name: user.name,
            picture: user.picture,
            ...user.__typename === 'AtlassianAccountUser' && user.extendedProfile?.jobTitle ? {
                jobTitle: user.extendedProfile.jobTitle
            } : {},
            relationships: [
                evidence
            ]
        });
    }
    return [
        ...peopleByAccount.values()
    ];
};




var $4500S = parcelRequire("4500S");


const $ddf282c684c07729$var$EXCLUDED_RELATIONSHIP_PRIORITY = 5;
const $ddf282c684c07729$var$relationshipOrder = new Map((0, $cebcf46595f8344d$export$89a33a230d65db65).map(({ relationship: relationship }, index)=>[
        relationship,
        index
    ]));
const $ddf282c684c07729$var$priority = (relationship, isAgent)=>{
    switch(relationship){
        case 'owns':
            return 0;
        case 'created':
        case 'contributed':
        case 'updated':
            return isAgent ? 3 : 1;
        case 'viewed':
            return isAgent ? 4 : $ddf282c684c07729$var$EXCLUDED_RELATIONSHIP_PRIORITY;
        case 'mentioned-in':
            return 2;
        default:
            return $ddf282c684c07729$var$EXCLUDED_RELATIONSHIP_PRIORITY;
    }
};
// Graph timestamps are relationship recency evidence, not necessarily individual action times.
const $ddf282c684c07729$var$timestamp = (value)=>value != null && Number.isFinite(value) ? value : -Infinity;
const $ddf282c684c07729$var$compareText = (left, right)=>left < right ? -1 : left > right ? 1 : 0;
const $ddf282c684c07729$var$compareRelationships = (left, right, isAgent)=>$ddf282c684c07729$var$priority(left.relationship, isAgent) - $ddf282c684c07729$var$priority(right.relationship, isAgent) || $ddf282c684c07729$var$timestamp(right.lastUpdated) - $ddf282c684c07729$var$timestamp(left.lastUpdated) || ($ddf282c684c07729$var$relationshipOrder.get(left.relationship) ?? Number.MAX_SAFE_INTEGER) - ($ddf282c684c07729$var$relationshipOrder.get(right.relationship) ?? Number.MAX_SAFE_INTEGER);
const $ddf282c684c07729$var$pickPrimaryRelationship = (person, isAgent)=>{
    let primary;
    for (const relationship of person.relationships)if (!primary || $ddf282c684c07729$var$compareRelationships(relationship, primary, isAgent) < 0) primary = relationship;
    return primary;
};
const $ddf282c684c07729$var$lastViewedTimestamp = (agent)=>{
    const timestamp = agent.lastViewedAt ? Date.parse(agent.lastViewedAt) : NaN;
    return Number.isFinite(timestamp) ? timestamp : null;
};
const $ddf282c684c07729$export$b2b3a37b350489c1 = (people, agents, contributors = [])=>{
    const agentsByIdentity = new Map();
    for (const contributor of contributors)// Without contribution timestamps, keep the first returned entry for each agent.
    if (!agentsByIdentity.has(contributor.accountId)) agentsByIdentity.set(contributor.accountId, {
        id: contributor.accountId,
        identityAccountId: contributor.accountId,
        name: contributor.name,
        avatarURL: contributor.avatarURL,
        attributedUser: contributor.attributedUsers[0],
        relationship: 'contributed'
    });
    for (const agent of agents){
        // Analytics IDs can include an attributed user's ID; the identity is the agent itself.
        // Unresolved agents retain their source row ID rather than guessing from a display name.
        const identity = agent.identityAccountId || agent.id;
        const existing = agentsByIdentity.get(identity);
        if (existing?.relationship === 'contributed') continue;
        if (!existing || ($ddf282c684c07729$var$lastViewedTimestamp(agent) ?? -Infinity) > ($ddf282c684c07729$var$lastViewedTimestamp(existing) ?? -Infinity)) agentsByIdentity.set(identity, {
            id: agent.id,
            identityAccountId: agent.identityAccountId,
            name: agent.name,
            avatarURL: agent.avatarURL || existing?.avatarURL || '',
            agentIcon: agent.agentIcon,
            lastViewedAt: agent.lastViewedAt,
            attributedUser: agent.attributedUsers?.find(({ name: name })=>name.trim()),
            relationship: 'viewed'
        });
    }
    const agentsByKey = new Map();
    const agentCandidates = [];
    for (const [identity, agent] of agentsByIdentity){
        // A local row key, never a graph ARI or a navigation target.
        const key = `agent:${identity}`;
        agentsByKey.set(key, agent);
        agentCandidates.push({
            ari: key,
            accountId: agent.identityAccountId ?? '',
            name: agent.name,
            picture: agent.avatarURL || null,
            relationships: [
                {
                    relationship: agent.relationship,
                    direction: 'incoming',
                    lastUpdated: agent.relationship === 'viewed' ? $ddf282c684c07729$var$lastViewedTimestamp(agent) : null
                }
            ]
        });
    }
    const candidates = [
        ...people,
        ...agentCandidates
    ].map((person)=>{
        const agent = agentsByKey.get(person.ari);
        return {
            person: person,
            agent: agent,
            primary: $ddf282c684c07729$var$pickPrimaryRelationship(person, !!agent)
        };
    });
    const eligiblePeople = candidates.filter((candidate)=>!!candidate.primary && $ddf282c684c07729$var$priority(candidate.primary.relationship, !!candidate.agent) < $ddf282c684c07729$var$EXCLUDED_RELATIONSHIP_PRIORITY);
    return eligiblePeople.sort((left, right)=>$ddf282c684c07729$var$priority(left.primary.relationship, !!left.agent) - $ddf282c684c07729$var$priority(right.primary.relationship, !!right.agent) || $ddf282c684c07729$var$timestamp(right.primary.lastUpdated) - $ddf282c684c07729$var$timestamp(left.primary.lastUpdated) || $ddf282c684c07729$var$compareText(left.person.ari, right.person.ari) || $ddf282c684c07729$var$compareText(left.person.accountId, right.person.accountId)).map(({ person: person, primary: primary, agent: agent })=>({
            ari: person.ari,
            accountId: person.accountId,
            name: person.name,
            picture: person.picture,
            ...person.jobTitle ? {
                jobTitle: person.jobTitle
            } : {},
            primaryRelationship: primary.relationship,
            relationshipDirection: primary.direction,
            ...agent ? {
                agent: agent
            } : {}
        }));
};





const $e82ef10e7fc62f37$export$ad1a0f8a61572f42 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: (0, $I7TEB.PAGE_PEOPLE_ACTION_SUBJECT),
            source: (0, $I7TEB.PANEL_SOURCE),
            attributes: attributes
        }
    });
const $e82ef10e7fc62f37$export$61c3c7e275203673 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: (0, $I7TEB.PAGE_PEOPLE_ACTION_SUBJECT),
            source: (0, $I7TEB.PANEL_SOURCE),
            attributes: attributes
        }
    });


const $5e7e7afa96016adb$var$CANDIDATES_PER_RELATIONSHIP = 10;
const $5e7e7afa96016adb$var$classifyError = (error)=>!error.networkError && error.graphQLErrors?.length ? 'graphql' : 'network';
const $5e7e7afa96016adb$var$buildRelationshipBranch = (pageAri, { cypherName: cypherName, relationship: relationship, direction: direction })=>{
    const match = direction === 'incoming' ? `MATCH (person)-[rel:${cypherName}]->(page {ari: "${pageAri}"})` : `MATCH (page {ari: "${pageAri}"})-[rel:${cypherName}]->(person)`;
    return [
        match,
        'WITH person, rel',
        'ORDER BY rel.lastUpdated DESC',
        `LIMIT ${$5e7e7afa96016adb$var$CANDIDATES_PER_RELATIONSHIP}`,
        `RETURN person AS person, "${relationship}" AS relationship, "${direction}" AS direction, rel.lastUpdated AS relationshipTimestamp`
    ].join('\n');
};
const $5e7e7afa96016adb$export$1967eabe5eea0d7 = (pageAri, contentType)=>(0, $cebcf46595f8344d$export$8845d316349130d6)(contentType).map((definition)=>$5e7e7afa96016adb$var$buildRelationshipBranch(pageAri, definition)).join('\nUNION ALL\n');
const $5e7e7afa96016adb$var$PagePeopleQuery = (0, $d01d6f08de6a92ee$export$2e2bcd8739ae039);
const $5e7e7afa96016adb$export$bc557ba2ed417c5d = (contentId, options)=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    // `@confluence/analytics`, not the platform analytics-bridge helper. `fireOperationalAnalytics`
    // fires on the `analyticsBridge` channel, and `AnalyticsListener` only invokes its handler when
    // its own `channel` is `'*'` or equal to the event's; `ConfluenceAnalyticsListener` passes no
    // `channel`, so bridge events never reached it at all. See `.agents/teamwork-graph-modal.md`.
    // CCINT-9105
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    const skip = options?.enabled === false || !contentId || !cloudId || !activationId || !(0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment');
    const reportError = (0, $cozmU.useCallback)((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        createEvent((0, $e82ef10e7fc62f37$export$61c3c7e275203673)({
            errorType: $5e7e7afa96016adb$var$classifyError(error)
        })).fire();
    }, [
        createEvent
    ]);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($5e7e7afa96016adb$var$PagePeopleQuery, {
        variables: {
            cypherQuery: skip ? '' : $5e7e7afa96016adb$export$1967eabe5eea0d7((0, $6PfFM.buildContentAri)(cloudId, contentId, options?.contentType), options?.contentType),
            queryContext: skip ? '' : (0, $kyH1y.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            version: 'V3'
        },
        skip: skip,
        interopApolloAggClient: true,
        errorPolicy: 'all',
        onError: reportError,
        __callerPackage__: "byline-connections"
    });
    const candidates = (0, $cozmU.useMemo)(()=>skip ? [] : (0, $f27c506e525608c8$export$118d4ea22fb34073)(data), [
        data,
        skip
    ]);
    const rankedPeopleAndAgents = (0, $cozmU.useMemo)(()=>(0, $ddf282c684c07729$export$b2b3a37b350489c1)(candidates, options?.agents ?? [], options?.agentContributors ?? []), [
        candidates,
        options?.agents,
        options?.agentContributors
    ]);
    const canvasAgents = (0, $cozmU.useMemo)(()=>rankedPeopleAndAgents.filter((entry)=>!!entry.agent), [
        rankedPeopleAndAgents
    ]);
    const peopleAndAgents = (0, $cozmU.useMemo)(()=>rankedPeopleAndAgents.filter(({ agent: agent })=>agent || !loading && !error).slice(0, (0, $4500S.MAX_LISTED_PAGE_PEOPLE)), [
        rankedPeopleAndAgents,
        loading,
        error
    ]);
    // Once per hook instance, so a re-render or a cache update does not inflate the
    // success count. Preserve the discovered-human count (capped at ten), including relationships
    // excluded from display. Neither agent availability nor canvas selection changes this metric.
    const discoveredPeopleCount = Math.min(candidates.length, (0, $4500S.MAX_LISTED_PAGE_PEOPLE));
    (0, $cozmU.useEffect)(()=>{
        if (skip || loading || error || hasFiredRef.current) return;
        hasFiredRef.current = true;
        createEvent((0, $e82ef10e7fc62f37$export$ad1a0f8a61572f42)({
            count: discoveredPeopleCount
        })).fire();
    }, [
        skip,
        loading,
        error,
        discoveredPeopleCount,
        createEvent
    ]);
    return {
        rankedPeopleAndAgents: rankedPeopleAndAgents,
        canvasAgents: canvasAgents,
        peopleAndAgents: peopleAndAgents,
        loading: !skip && loading,
        error: error
    };
};









const $13c0a60f8ad3bb4e$export$275ee434c520938c = (contentId, contentType)=>{
    const { devDocsConnection: devDocsConnection } = (0, $3b6532377f19c330$export$27db6e7d91fcef66)(contentId);
    const { incomingLinks: incoming } = (0, $21leH.useIncomingLinksData)(contentId);
    const { links: incomingLinks, loading: loading, loadingMore: loadingMore, hasNextPage: hasNextPage, endCursor: endCursor, loadMore: loadMore, error: incomingError } = incoming;
    const { outgoingLinks: outgoingLinks } = (0, $Hnn0l.useOutgoingLinks)(contentId);
    const { relatedContent: relatedContent } = (0, $4ao9J.useRelatedContentData)(contentId);
    const { enabled: relatedContentEnabled, links: relatedContentLinks, loading: relatedContentLoading, error: relatedContentError } = relatedContent;
    const agentContributors = (0, $e4e9a1aeda282667$export$b08610bd07f7d5f0)(contentId);
    const agentViewers = (0, $6e04cdfd924900fc$export$63b388e9743a81ae)(contentId ?? '');
    const people = (0, $5e7e7afa96016adb$export$bc557ba2ed417c5d)(contentId, {
        contentType: contentType,
        agents: agentViewers.loading || agentViewers.error ? undefined : agentViewers.agents,
        agentContributors: agentContributors.availability === 'available' ? agentContributors.agents : undefined
    });
    return (0, $cozmU.useMemo)(()=>({
            syncedFrom: {
                connection: devDocsConnection
            },
            appearsIn: {
                links: incomingLinks,
                loading: loading,
                loadingMore: loadingMore,
                hasNextPage: hasNextPage,
                endCursor: endCursor,
                loadMore: loadMore,
                error: incomingError
            },
            linksTo: {
                links: outgoingLinks
            },
            relatedContent: {
                enabled: relatedContentEnabled,
                links: relatedContentLinks,
                loading: relatedContentLoading,
                error: relatedContentError
            },
            people: people,
            agentViewers: agentViewers,
            agentContributors: agentContributors
        }), [
        devDocsConnection,
        incomingLinks,
        loading,
        loadingMore,
        hasNextPage,
        endCursor,
        loadMore,
        incomingError,
        outgoingLinks,
        relatedContentEnabled,
        relatedContentLinks,
        relatedContentLoading,
        relatedContentError,
        people,
        agentViewers,
        agentContributors
    ]);
};
















var $ez9xU = parcelRequire("ez9xU");










const $c16ea8b659632d91$export$a02ae069a5aa8a95 = 'rovo_connector_authed_users_percentage_by_app';
function $c16ea8b659632d91$export$4555bcf1892bfb4({ skip: skip } = {}) {
    return (0, $8ab372ddb9ea7e6c$export$284907af4a465a72)($c16ea8b659632d91$export$a02ae069a5aa8a95, (0, $f1588a16e52e7972$export$983a3bcefb295c3f), {
        skip: skip
    });
}





/* ConnectorPromoBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 




















/* GhostConnectorIcons.tsx generated by @compiled/babel-plugin v3.0.2 */ 





// `ShareContextLogoPile` does: the stack's bordered tile doubles the border on 3P logos
// that already carry their own.
const $67edf747d1802569$var$styles = {
    pile: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _2YgrGrP0S5 _1YKVNsVx3j",
    firstTile: "_3iDTPbccYA _3YEZNOdnbC _42Yu6BPvK5",
    middleTile: "_3iDTPbccYA _3YEZNOdnbC _0GTcwR5UaJ _42Yu6Bbhqd _2AERac9ub0",
    lastTile: "_3iDTPbccYA _3YEZNOdnbC _0GTcwR5UaJ _42Yu6BgtVO"
};
const $67edf747d1802569$var$tileStyles = [
    $67edf747d1802569$var$styles.firstTile,
    $67edf747d1802569$var$styles.middleTile,
    $67edf747d1802569$var$styles.lastTile
];
const $67edf747d1802569$export$2792a10d5f4aa2f7 = ({ apps: apps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        testId: "teamwork-graph-promo-banner-ghost-icons",
        xcss: $67edf747d1802569$var$styles.pile
    }, apps.map(({ productKey: productKey, id: id, Icon: Icon }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: productKey,
            xcss: $67edf747d1802569$var$tileStyles[index] ?? $67edf747d1802569$var$styles.lastTile,
            testId: `teamwork-graph-promo-banner-ghost-icon-${id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            size: "xsmall",
            label: ""
        }))));


const $836e02dfba756f43$export$5237495f42936402 = 30;
const $836e02dfba756f43$var$i18n = (0, $kSwu1.defineMessages)({
    gdriveMessage: {
        id: "byline-connections.preview-panel.modal.promo-banner.gdrive",
        defaultMessage: "Connect Google Drive to get rich previews and more powerful search"
    },
    highAdoptionMessage: {
        id: "byline-connections.preview-panel.modal.promo-banner.high-adoption",
        defaultMessage: "{percent}% of your org uses connected apps to see how their pages connect to their team's work"
    },
    genericMessage: {
        id: "byline-connections.preview-panel.modal.promo-banner.generic",
        defaultMessage: "Top teams use connected apps to get rich previews and more powerful search"
    },
    connectApps: {
        id: "byline-connections.preview-panel.modal.promo-banner.connect-apps",
        defaultMessage: "Connect apps"
    }
});
/** Eyeballed from the mock — confirm against Figma. */ const $836e02dfba756f43$var$GRID_PITCH = '32px'; /** Negative moves the lines up. Wraps every `GRID_PITCH`, so stay under it. */ 
const $836e02dfba756f43$var$GRID_OFFSET_BLOCK = '-16px';
const $836e02dfba756f43$var$styles = {
    banner: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _23rrnHyKLB _4c065U5zaO _2Y7lL45zaO _3hxITiYbGa _3iDTPbvLZJ _39xV02N91d _24h04i2Njc _2fwxA57p2s _0KLXrunmFW _0wOv4Q7zJH _1mT5xdRAKS _1eOmH6o126",
    grid: "_1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _3iC0zddnbC _1OKFqYdnbC _3CkH9os4Wk _3OqcjTAe3X _1DJ2rVnolI _1pp6NdYbGa",
    content: "_1mT5xdRAKS",
    message: "_2sNsIg7NXe _1UtDYzy7kJ"
};
const $836e02dfba756f43$var$getMessageDescriptor = (variant, topAppPercent)=>{
    if (variant === 'gdrive') return $836e02dfba756f43$var$i18n.gdriveMessage;
     // Below the threshold the org copy is the generic copy, so the number is only quoted
    // when it is worth quoting.
    if (variant === 'orgConnectedApps' && topAppPercent !== undefined && topAppPercent >= $836e02dfba756f43$export$5237495f42936402) return $836e02dfba756f43$var$i18n.highAdoptionMessage;
    return $836e02dfba756f43$var$i18n.genericMessage;
}; /**
    * Deliberately not dismissible, unlike the byline menu footer banners: we want to see how
    * it performs before deciding whether users can hide it, so there is no dismissal state.
    */ 
const $836e02dfba756f43$export$f1c78716874e7f8b = ({ variant: variant, topAppPercent: topAppPercent, apps: apps, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $836e02dfba756f43$var$styles.banner,
        onClick: onClick,
        "aria-label": formatMessage($836e02dfba756f43$var$i18n.connectApps),
        testId: "teamwork-graph-promo-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $836e02dfba756f43$var$styles.grid,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $836e02dfba756f43$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67edf747d1802569$export$2792a10d5f4aa2f7), {
        apps: apps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $836e02dfba756f43$var$styles.message
    }, formatMessage($836e02dfba756f43$var$getMessageDescriptor(variant, topAppPercent), {
        percent: topAppPercent
    }))));
};





const $e40f091c99315ed8$export$b1294d95ffe11792 = 'connectorPromoBanner';
const $e40f091c99315ed8$export$57e0ff4c2905037a = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'viewed',
            actionSubject: 'banner',
            actionSubjectId: $e40f091c99315ed8$export$b1294d95ffe11792,
            source: (0, $I7TEB.MODAL_SOURCE),
            attributes: attributes
        }
    });
const $e40f091c99315ed8$export$1711eb8ab907f796 = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'banner',
            actionSubjectId: $e40f091c99315ed8$export$b1294d95ffe11792,
            source: (0, $I7TEB.MODAL_SOURCE),
            attributes: attributes
        }
    });
const $e40f091c99315ed8$export$3155a85848c110b5 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'notShown',
            actionSubject: 'banner',
            actionSubjectId: $e40f091c99315ed8$export$b1294d95ffe11792,
            source: (0, $I7TEB.MODAL_SOURCE),
            attributes: attributes
        }
    });






var $5c5T9 = parcelRequire("5c5T9");


var $6bk1K = parcelRequire("6bk1K");


var $i9pyX = parcelRequire("i9pyX");







const $adae1c9eea9b105b$export$e03f0449a68f3b = 2;
const $adae1c9eea9b105b$var$EMPTY_APPS = [];
const $adae1c9eea9b105b$export$33e731add22822fa = ({ pinnedProductKey: pinnedProductKey, rates: rates } = {})=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    // `undefined` until the fetch settles, distinguishing "loading" from "none qualified".
    const [unconnectedProductKeys, setUnconnectedProductKeys] = (0, $cozmU.useState)();
    const [apps, setApps] = (0, $cozmU.useState)($adae1c9eea9b105b$var$EMPTY_APPS);
    (0, $cozmU.useEffect)(()=>{
        if (!cloudId || !userId) {
            setUnconnectedProductKeys([]);
            return;
        }
        let isCurrent = true;
        Promise.all([
            (0, $i9pyX.get3pSearchConfig)({
                cloudId: cloudId,
                userId: userId
            }),
            (0, $8gF2o.fetchOutboundAuthAccounts)(userId)
        ]).then(([resources, grants])=>{
            if (!isCurrent) return;
            const env = (0, $8gF2o.detectEnvFromPayload)(grants) ?? undefined;
            setUnconnectedProductKeys(resources.reduce((keys, resource)=>{
                if (!(0, $6bk1K.isProductResourceTypes3P)(resource.type)) return keys;
                const productKey = (0, $5c5T9.connectorsConfig).getProductKey(resource.type);
                if (!productKey || keys.includes(productKey) || (0, $8gF2o.isAuthenticatedForProduct)(grants, productKey, env)) return keys;
                keys.push(productKey);
                return keys;
            }, []));
        }).catch(()=>{
            if (isCurrent) setUnconnectedProductKeys([]);
        });
        return ()=>{
            isCurrent = false;
        };
    }, [
        cloudId,
        userId
    ]);
    // Ranked before loading configs so only the winning two are imported.
    const topProductKeys = (0, $cozmU.useMemo)(()=>{
        if (unconnectedProductKeys === undefined) return undefined;
        const ranked = [
            ...unconnectedProductKeys
        ].filter((key)=>key !== pinnedProductKey).sort((a, b)=>(rates?.[b] ?? 0) - (rates?.[a] ?? 0));
        return (pinnedProductKey ? [
            pinnedProductKey,
            ...ranked
        ] : ranked).slice(0, $adae1c9eea9b105b$export$e03f0449a68f3b);
    }, [
        unconnectedProductKeys,
        rates,
        pinnedProductKey
    ]);
    // The effect below keys off the contents rather than the array, so a caller passing a
    // fresh `rates` object each render cannot spin it: new identity, same keys, no refetch.
    const topProductKeysId = topProductKeys?.join(',');
    const topProductKeysRef = (0, $cozmU.useRef)(topProductKeys);
    topProductKeysRef.current = topProductKeys;
    // Each config is a separate lazy chunk, hence a second async step rather than a
    // synchronous registry of every connector.
    (0, $cozmU.useEffect)(()=>{
        const keys = topProductKeysRef.current;
        if (keys === undefined || keys.length === 0) {
            setApps($adae1c9eea9b105b$var$EMPTY_APPS);
            return;
        }
        let isCurrent = true;
        Promise.all(keys.map((productKey)=>(0, $5c5T9.connectorsConfig).getConfig(productKey))).then((configs)=>{
            if (!isCurrent) return;
            setApps(configs.flatMap((config, index)=>config ? [
                    {
                        productKey: keys[index],
                        id: config.id,
                        // Not `iconBorderless`: the pile draws no container, so each logo
                        // supplies its own shape.
                        Icon: config.icon
                    }
                ] : []));
        }).catch(()=>{
            if (isCurrent) setApps($adae1c9eea9b105b$var$EMPTY_APPS);
        });
        return ()=>{
            isCurrent = false;
        };
    }, [
        topProductKeysId
    ]);
    return {
        apps: apps
    };
};





/** The gdrive banner reports `google` to line up with the org banner's trait keys. */ const $8e105220e5be9b9e$var$GDRIVE_ANALYTICS_CONNECTOR = 'google';
/** Attributed separately from the preview panel's "Manage connections" entry point. */ const $8e105220e5be9b9e$var$TEAMWORK_GRAPH_MODAL_SURFACE = 'confluence-teamwork-graph-modal';
/** The connector dialog's "Connect apps" tab — the banner is only ever about that one. */ const $8e105220e5be9b9e$var$APPS_TAB_ID = 'discovery';
/**
 * `ORG_CONNECTED_APPS_RATE_TRAIT` is keyed by smartlink provider family, which is coarser
 * than the `ProductKeys3P` the icons need — `google` covers Drive, Gmail and Calendar, so
 * Drive stands in for the family. Keys that already agree pass through.
 */ const $8e105220e5be9b9e$var$PROVIDER_FAMILY_TO_PRODUCT_KEY = {
    google: (0, $fR63l.ProductKeys3P).GoogleDrive
};
const $8e105220e5be9b9e$var$toProductKeyRates = (rates)=>{
    if (!rates) return undefined;
    const mapped = {};
    for (const [family, percent] of Object.entries(rates))mapped[$8e105220e5be9b9e$var$PROVIDER_FAMILY_TO_PRODUCT_KEY[family] ?? family] = percent;
    return mapped;
};
const $8e105220e5be9b9e$export$2fab414bcd04553f = ({ links: links })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const { cloudId: cloudId, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isPageFirstPartyOnly = links.length > 0 && links.every((l)=>(0, $cS4kb.isFirstPartyLink)(l.url));
    const { value: linkCounts, loading: isLinkCountLoading } = (0, $11c55f3cb3c29119$export$2bd9a43397bfe114)({
        skip: !isPageFirstPartyOnly
    });
    const hasSiteWideDriveLinks = (linkCounts?.[0, $11c55f3cb3c29119$export$3d6612235992a7fe] ?? 0) >= 1;
    const { isAuthenticated: isGdriveConnected, isLoading: isGdriveAuthLoading } = (0, $ce8c0a0fac7ee6d6$export$f4c25aea7c19a132)();
    const unconnectedThirdPartyLinks = (0, $cozmU.useMemo)(()=>links.filter((0, $e34182895af441bd$export$76cb2c3a079a73ad)), [
        links
    ]);
    const hasUnconnectedThirdParty = unconnectedThirdPartyLinks.length > 0;
    const { value: orgRates, loading: isRatesLoading } = (0, $f1588a16e52e7972$export$5d94aa936f525952)({
        skip: !hasUnconnectedThirdParty
    });
    const topApp = (0, $cozmU.useMemo)(()=>(0, $e34182895af441bd$export$41c181e9c9608a62)(orgRates, (0, $e34182895af441bd$export$8a9749363d54b4fa)(unconnectedThirdPartyLinks)), [
        orgRates,
        unconnectedThirdPartyLinks
    ]);
    // The trait hooks share one store with a global `loading` flag, so each is only
    // honoured when its branch is in play.
    const isLoading = isPageFirstPartyOnly && (isLinkCountLoading || isGdriveAuthLoading) || hasUnconnectedThirdParty && isRatesLoading;
    // First failing check, in order. `undefined` means the variant qualified — so these
    // double as the variant decision below, and cannot drift from it.
    const gdriveIneligibleReason = (0, $cozmU.useMemo)(()=>{
        if (!isPageFirstPartyOnly) return 'notFirstPartyOnly';
        if (!hasSiteWideDriveLinks) return 'noSiteWideDriveLinks';
        if (isGdriveConnected) return 'alreadyAuthenticated';
        return undefined;
    }, [
        isPageFirstPartyOnly,
        hasSiteWideDriveLinks,
        isGdriveConnected
    ]);
    const orgIneligibleReason = (0, $cozmU.useMemo)(()=>{
        if (!hasUnconnectedThirdParty) return 'noUnconnectedThirdParty';
        if (!topApp) return 'noTopApp';
        return undefined;
    }, [
        hasUnconnectedThirdParty,
        topApp
    ]);
    const variant = gdriveIneligibleReason === undefined ? 'gdrive' : orgIneligibleReason === undefined ? 'orgConnectedApps' : 'generic';
    const { value: connectorAuthRates } = (0, $c16ea8b659632d91$export$4555bcf1892bfb4)();
    // The org variant ranks its icons by the same trait its copy quotes, so the two agree.
    // The other variants quote no adoption figure, so they fall back to the Rovo connector
    // trait — the same one the CWR ghost icons rank on.
    const iconRates = (0, $cozmU.useMemo)(()=>variant === 'orgConnectedApps' ? $8e105220e5be9b9e$var$toProductKeyRates(orgRates) : connectorAuthRates, [
        variant,
        orgRates,
        connectorAuthRates
    ]);
    // The Drive variant names Google Drive, so its icons lead with Drive.
    const { apps: apps } = (0, $adae1c9eea9b105b$export$33e731add22822fa)({
        pinnedProductKey: variant === 'gdrive' ? (0, $fR63l.ProductKeys3P).GoogleDrive : undefined,
        rates: iconRates
    });
    const shownAttributes = (0, $cozmU.useMemo)(()=>{
        if (variant === 'gdrive') return {
            bannerType: 'gdrive',
            connector: $8e105220e5be9b9e$var$GDRIVE_ANALYTICS_CONNECTOR,
            ghostIconCount: apps.length
        };
        if (variant === 'orgConnectedApps' && topApp) return {
            bannerType: 'orgConnectedApps',
            connector: topApp.traitKey,
            topAppPercent: topApp.percent,
            gdriveIneligibleReason: gdriveIneligibleReason,
            ghostIconCount: apps.length
        };
        return {
            bannerType: 'generic',
            gdriveIneligibleReason: gdriveIneligibleReason,
            orgIneligibleReason: orgIneligibleReason,
            ghostIconCount: apps.length
        };
    }, [
        variant,
        topApp,
        gdriveIneligibleReason,
        orgIneligibleReason,
        apps.length
    ]);
    // Once per mount, on the variant first seen. Exactly one of `viewed` and `notShown`
    // fires, so `clicked / viewed` stays a click-through rate.
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        if (!isRovoLLMEnabled) {
            hasFiredRef.current = true;
            createAnalyticsEvent((0, $e40f091c99315ed8$export$3155a85848c110b5)({
                reason: 'rovoDisabled'
            })).fire();
            return;
        }
        if (isLoading) return;
        hasFiredRef.current = true;
        createAnalyticsEvent((0, $e40f091c99315ed8$export$57e0ff4c2905037a)(shownAttributes)).fire();
    }, [
        isRovoLLMEnabled,
        isLoading,
        shownAttributes,
        createAnalyticsEvent
    ]);
    const fireClickedEvent = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent((0, $e40f091c99315ed8$export$1711eb8ab907f796)(shownAttributes)).fire();
    }, [
        createAnalyticsEvent,
        shownAttributes
    ]);
    // Pressing the banner opens `RovoSettingsModal`, which a site without Rovo has no use
    // for, so the surface goes rather than leading somewhere dead.
    if (!isRovoLLMEnabled || isLoading) return {
        element: null
    };
    return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ez9xU.RovoSettingsModal), {
            product: "confluence",
            cloudId: cloudId,
            surface: $8e105220e5be9b9e$var$TEAMWORK_GRAPH_MODAL_SURFACE
        }, ({ open: open })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $836e02dfba756f43$export$f1c78716874e7f8b), {
                variant: variant,
                topAppPercent: topApp?.percent,
                apps: apps,
                onClick: ()=>{
                    fireClickedEvent();
                    open({
                        defaultTab: $8e105220e5be9b9e$var$APPS_TAB_ID
                    });
                }
            }))
    };
};



var $45zaV = parcelRequire("45zaV");


var $bT2y0 = parcelRequire("bT2y0");








// Rendered only while open, so Rovodal and the Rovo chat config graph stay out of
// the byline's after-paint chunk on the view page until the user asks for them.
// Nothing is lost by unmounting: Rovodal has no exit transition — it returns
// `null` when closed and has no outer `ModalTransition`.
const $5453bab8747bee12$var$TeamworkGraphModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "aKQO1",
    name: "TeamworkGraphModalLoadable",
    loader: async ()=>(await (parcelRequire("1TLbr"))).TeamworkGraphModal
});
function $5453bab8747bee12$export$95c2e1a0aa71e8e6({ isOpen: isOpen, onClose: onClose, contentId: contentId, contentType: contentType, connections: connections, atAGlance: atAGlance, promoBanner: promoBanner }) {
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5453bab8747bee12$var$TeamworkGraphModalLoadable, {
        isOpen: true,
        onClose: onClose,
        contentId: contentId,
        contentType: contentType,
        connections: connections,
        atAGlance: atAGlance,
        promoBanner: promoBanner
    });
}


function $f4e49e5d05ed910d$export$99325b1bd5089116({ contentId: contentId, contentType: contentType, connections: connections, isRovoEnabled: isRovoEnabled, onAskRovo: onAskRovo, isModalOpen: isModalOpen, onCloseModal: onCloseModal }) {
    const { atAGlance: atAGlance } = (0, $e881057e0de27ea9$export$850ea50adc381c)(contentId);
    const { element: promoBanner } = (0, $8e105220e5be9b9e$export$2fab414bcd04553f)({
        links: connections.linksTo.links
    });
    // Bound here rather than at the row, so the switch/close analytics can name the control
    // without every row action carrying the trigger. Wrapped rather than passed straight through,
    // or React would forward the click event as the prompt.
    const onAskRovoFromRow = (0, $cozmU.useCallback)((prompt)=>onAskRovo('rowAction', prompt), [
        onAskRovo
    ]);
    // The panel's "At a glance" entry, seeded with every connection url — the same prompt the
    // modal's "Add links to Rovo context" button carries — so the chat opens with the links as
    // context. Null when there are no links to send, in which case it opens unseeded.
    // Wrapped so the click event never becomes the prompt.
    const atAGlanceLinksPrompt = (0, $bT2y0.useLinksContextPrompt)(connections);
    const onAskRovoFromAtAGlance = (0, $cozmU.useCallback)(()=>onAskRovo('atAGlance', atAGlanceLinksPrompt ?? undefined), [
        onAskRovo,
        atAGlanceLinksPrompt
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5453bab8747bee12$export$95c2e1a0aa71e8e6), {
        isOpen: isModalOpen,
        onClose: onCloseModal,
        contentId: contentId,
        contentType: contentType,
        connections: connections,
        atAGlance: atAGlance,
        promoBanner: promoBanner
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $45zaV.ConnectionSections), {
        connections: connections,
        atAGlance: atAGlance,
        onAskRovo: isRovoEnabled ? onAskRovoFromRow : undefined,
        onAtAGlanceAskRovo: isRovoEnabled ? onAskRovoFromAtAGlance : undefined
    }), promoBanner));
}


/* TeamworkGraphPreviewPanelFooter.tsx generated by @compiled/babel-plugin v3.0.2 */ 





/* TeamworkGraphPreviewPanelOpenGraphButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 

















const $9456b78cdf0a1620$var$styles = {
    footerButton: "_0bjKvDKTcp _2sNsIgmnOE _23rrnHyKLB _4c065UPgdg _2Y7lL48HPE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _39xV02N91d _0jFU0VUofl _37wbyuDIqT _0hPCNLDIqT _4xdlr0FlnN _0KLXru66of _1UtDYzZpcK _1eOmH6o126 _3sFUREiSCN _3gzVzLN4oS"
};
const $9456b78cdf0a1620$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "byline-connections.preview-panel.open-graph-button.view-teamwork-graph",
        defaultMessage: "View Teamwork Graph"
    }
});
const $9456b78cdf0a1620$export$ee2b640a4973c09 = ({ onClick: onClick, testId: testId = 'teamwork-graph-preview-panel.open-graph-button' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.OPEN_GRAPH_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE)
            }
        }).fire();
        onClick();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $9456b78cdf0a1620$var$styles.footerButton,
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "medium",
        weight: "medium",
        maxLines: 1
    }, formatMessage($9456b78cdf0a1620$var$i18n.label)));
};


const $d72cc0f2de9fb89d$var$styles = {
    footer: "_4c065U5zaO _2Y7lL4NHnM _3YEZNOdnbC _24h04i2Njc _3iDTPbQ4SZ _0hPCNLDIqT _2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67 _0KLXrulfZc"
};
function $d72cc0f2de9fb89d$export$265b9faed850f344({ onOpenGraph: onOpenGraph, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "footer",
        testId: testId,
        xcss: $d72cc0f2de9fb89d$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9456b78cdf0a1620$export$ee2b640a4973c09), {
        onClick: onOpenGraph,
        testId: testId && `${testId}-open-graph`
    }));
}












var $a1ZzW = parcelRequire("a1ZzW");

const $1b4f773989b98515$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "byline-connections.preview-panel.info-button.label",
        defaultMessage: "About related context"
    },
    tooltip: {
        id: "byline-connections.preview-panel.info-button.tooltip",
        defaultMessage: "Links and references are automatically updated here as this page gets used across your team's work."
    }
});
const $1b4f773989b98515$export$bf99789ea211097a = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))),
        label: formatMessage($1b4f773989b98515$var$i18n.label),
        appearance: "subtle",
        isTooltipDisabled: false,
        tooltip: {
            content: formatMessage($1b4f773989b98515$var$i18n.tooltip)
        },
        testId: "teamwork-graph-preview-panel.info-button"
    });
};












var $bRCqW = parcelRequire("bRCqW");

const $6c5d7a56221ed430$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "byline-connections.preview-panel.title-context",
        defaultMessage: "Context"
    }
});
// `label=""` because the title text beside it already names the panel.
const $6c5d7a56221ed430$var$titleIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))), {
    label: "",
    testId: "teamwork-graph-preview-panel-title-icon"
});
const $6c5d7a56221ed430$export$d9fc4cda757f6729 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bRCqW.PreviewPanelTitle), {
        title: formatMessage($6c5d7a56221ed430$var$i18n.title),
        icon: $6c5d7a56221ed430$var$titleIcon
    });
};






var $4agZx = parcelRequire("4agZx");




const $9c84783b364c71ba$export$5c8bfb5aab8fac9b = ({ isRovoEnabled: isRovoEnabled })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [mode, setMode] = (0, $cozmU.useState)('connections');
    const [prefilledPrompt, setPrefilledPrompt] = (0, $cozmU.useState)(undefined);
    // The control that opened the chat, remembered so the close event can report it too.
    const [openTrigger, setOpenTrigger] = (0, $cozmU.useState)(undefined);
    const showRovo = (0, $cozmU.useCallback)((trigger, prompt)=>{
        createAnalyticsEvent((0, $4agZx.getRovoChatSwitchedEvent)({
            surface: 'panel',
            trigger: trigger
        })).fire();
        setOpenTrigger(trigger);
        setPrefilledPrompt(prompt);
        setMode('rovo');
    }, [
        createAnalyticsEvent
    ]);
    // Only the Rovo chat's back button calls this, so it always leaves the chat.
    const showConnections = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent((0, $4agZx.getRovoChatClosedEvent)({
            surface: 'panel',
            method: 'back',
            trigger: openTrigger
        })).fire();
        setOpenTrigger(undefined);
        // Cleared on the way out, or it would reappear the next time Rovo is opened — including
        // from an entry meant to open empty, like a row whose link has no url or "At a glance"
        // when there are no connection links to seed.
        setPrefilledPrompt(undefined);
        setMode('connections');
    }, [
        createAnalyticsEvent,
        openTrigger
    ]);
    const createAnalyticsEventRef = (0, $cozmU.useRef)(createAnalyticsEvent);
    createAnalyticsEventRef.current = createAnalyticsEvent;
    // Read through refs from the unmount cleanup so it fires with the mode (and opening trigger) at
    // dismissal without re-subscribing (and re-running the cleanup) on every mode change or update.
    const showingRovoRef = (0, $cozmU.useRef)(false);
    showingRovoRef.current = isRovoEnabled && mode === 'rovo';
    const openTriggerRef = (0, $cozmU.useRef)(openTrigger);
    openTriggerRef.current = openTrigger;
    (0, $cozmU.useEffect)(()=>()=>{
            if (showingRovoRef.current) createAnalyticsEventRef.current((0, $4agZx.getRovoChatClosedEvent)({
                surface: 'panel',
                method: 'panelClose',
                trigger: openTriggerRef.current
            })).fire();
        }, []);
    return {
        // Entitlement is checked alongside the mode, as the modal does, so losing Rovo falls back
        // to the connections rather than stranding the user on a chat they cannot use.
        isRovo: isRovoEnabled && mode === 'rovo',
        prefilledPrompt: prefilledPrompt,
        showRovo: showRovo,
        showConnections: showConnections
    };
};



var $5tMCB = parcelRequire("5tMCB");


var $6ckMU = parcelRequire("6ckMU");

const $d9e3ca7255f16432$var$styles = {
    scroll: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _4kiQYAdnbC _2WAcuGIZbP",
    body: "_4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _3YEZNOdnbC _0jFU0VIZbP",
    chatBody: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _4kiQYAdnbC"
};
function $d9e3ca7255f16432$export$f72b05b8836efb83({ contentId: contentId, contentType: contentType }) {
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)(); // The panel is only rendered while it is open, so its sections fetch as soon as it
    // mounts — no `enabled` gate, unlike the modal.
    const connections = (0, $13c0a60f8ad3bb4e$export$275ee434c520938c)(contentId, contentType);
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { isRovo: isRovo, prefilledPrompt: prefilledPrompt, showRovo: showRovo, showConnections: showConnections } = (0, $9c84783b364c71ba$export$5c8bfb5aab8fac9b)({
        isRovoEnabled: isRovoLLMEnabled
    });
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const openModal = (0, $cozmU.useCallback)(()=>setIsModalOpen(true), []);
    const closeModal = (0, $cozmU.useCallback)(()=>setIsModalOpen(false), []); // Close first: Rovo unmounts the column that mounts the modal, so an open flag left behind
    // would pop the modal back up on the way back to connections.
    const showRovoFromPanel = (0, $cozmU.useCallback)((...args)=>{
        setIsModalOpen(false);
        showRovo(...args);
    }, [
        showRovo
    ]); // Bound here, not in the header button, so the trigger stays a wiring-point concern like the others.
    const showRovoFromShareContext = (0, $cozmU.useCallback)((prompt)=>showRovoFromPanel('shareContext', prompt), [
        showRovoFromPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5WTxQ.PreviewPanel), {
        testId: "teamwork-graph-preview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fE1YT.PreviewPanelHeader), {
        onClose: ()=>close(),
        analyticsClient: null,
        parentProduct: (0, $5f7d816a14638938$export$f6fc4a5779d5dc2c),
        panelType: (0, $5f7d816a14638938$export$e8a5079e96625ede),
        moreActions: !isRovo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ckMU.TeamworkGraphShareContextButton), {
            contentId: contentId,
            testId: "teamwork-graph-preview-panel-share-context",
            onAskRovo: isRovoLLMEnabled ? showRovoFromShareContext : undefined
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c5d7a56221ed430$export$d9fc4cda757f6729), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1b4f773989b98515$export$bf99789ea211097a), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d9e3ca7255f16432$var$styles.scroll,
        testId: "teamwork-graph-preview-panel-scroll"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kMhHg.PreviewPanelBody), {
        analyticsClient: null,
        parentProduct: (0, $5f7d816a14638938$export$f6fc4a5779d5dc2c),
        panelType: (0, $5f7d816a14638938$export$e8a5079e96625ede),
        styles: isRovo ? $d9e3ca7255f16432$var$styles.chatBody : $d9e3ca7255f16432$var$styles.body
    }, isRovo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tMCB.TeamworkGraphChatColumn), {
        onBack: showConnections,
        prefilledPrompt: prefilledPrompt
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4e49e5d05ed910d$export$99325b1bd5089116), {
        contentId: contentId,
        contentType: contentType,
        connections: connections,
        isRovoEnabled: isRovoLLMEnabled,
        onAskRovo: showRovoFromPanel,
        isModalOpen: isModalOpen,
        onCloseModal: closeModal
    }))), !isRovo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d72cc0f2de9fb89d$export$265b9faed850f344), {
        onOpenGraph: openModal,
        testId: "teamwork-graph-preview-panel-footer"
    }));
}
const $d9e3ca7255f16432$export$74c6829b8c7e1a4 = (0, $3plmx.withSmartCardProviderContext)($d9e3ca7255f16432$export$f72b05b8836efb83);


const $9fc15bfa2158121b$var$getPanelId = (contentId)=>contentId ? `${0, $5f7d816a14638938$export$e043f5004f4e5a4}_${contentId}` : (0, $5f7d816a14638938$export$e043f5004f4e5a4);
const $9fc15bfa2158121b$export$240bf3f47c27458b = (contentId, contentType)=>{
    const { open: open } = (0, $lRhY3.usePreviewPanelsActions)();
    const panelId = $9fc15bfa2158121b$var$getPanelId(contentId);
    // Asked for by id, not bare: `useIsPreviewPanelOpen()` reports any open preview panel,
    // so a page preview panel would read as this one.
    const isTeamworkGraphPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)(panelId);
    const openTeamworkGraphPreviewPanel = (0, $cozmU.useCallback)(()=>{
        open({
            panel: {
                id: panelId,
                type: (0, $5f7d816a14638938$export$e8a5079e96625ede),
                product: (0, $5f7d816a14638938$export$ddbac920bdbdb256),
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d9e3ca7255f16432$export$74c6829b8c7e1a4), {
                        contentId: contentId,
                        contentType: contentType
                    })
            }
        });
    }, [
        open,
        panelId,
        contentId,
        contentType
    ]);
    return {
        isTeamworkGraphPreviewPanelOpen: isTeamworkGraphPreviewPanelOpen,
        openTeamworkGraphPreviewPanel: openTeamworkGraphPreviewPanel
    };
};


const $55b5fa95660732ad$var$BylineConnectionsInner = (props)=>{
    const { contentId: contentId, contentType: contentType } = props;
    const { title: title, error: pageTitleError } = (0, $ew8wg.usePageTitle)({
        contentId: contentId
    });
    const { isTeamworkGraphPreviewPanelOpen: isTeamworkGraphPreviewPanelOpen, openTeamworkGraphPreviewPanel: openTeamworkGraphPreviewPanel } = (0, $9fc15bfa2158121b$export$240bf3f47c27458b)(contentId, contentType);
    const { isOpen: isOpen, atAGlanceEnabled: atAGlanceEnabled, triggerRef: triggerRef, handleClose: closeMenu, handleNavigate: handleNavigate, handleOpenPreviewPanel: handleOpenPreviewPanel, handleToggle: handleToggle, handlePlaceholderOpenChange: handlePlaceholderOpenChange } = (0, $cd0c0d2e80124538$export$3969396859eef22e)({
        contentId: contentId,
        isTeamworkGraphPreviewPanelOpen: isTeamworkGraphPreviewPanelOpen,
        openTeamworkGraphPreviewPanel: openTeamworkGraphPreviewPanel
    });
    const data = (0, $14b4659b7aaed708$export$bb74724ea117ee6f)({
        ...props,
        pageTitle: pageTitleError ? null : title,
        atAGlanceEnabled: atAGlanceEnabled
    });
    const { outgoing: outgoing, incoming: incoming, relatedContent: relatedContent, devDocsConnection: devDocsConnection } = data;
    // Embedded Confluence has no preview panel. Keep gate evaluation short-circuited.
    const isEmbeddedMenu = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)() && ((0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment') || (0, $9wGTI.fg)('migrate_planner_to_docs_tab'));
    const handleClose = (0, $cozmU.useCallback)(()=>closeMenu(isEmbeddedMenu), [
        closeMenu,
        isEmbeddedMenu
    ]);
    const visibility = (0, $5e78f14186af6ae0$export$41ce1d5f545c25ec)({
        contentId: contentId,
        contentType: contentType,
        isEmbeddedMenu: isEmbeddedMenu,
        data: data
    });
    const hasOutboundConnection = outgoing.links.length > 0 || devDocsConnection !== null;
    (0, $460c5801038ac219$export$7705042750e63836)(contentId, visibility.isResolving, visibility.hasConnection, outgoing.error || (!hasOutboundConnection ? incoming.error : null));
    (0, $7263096a4038dcc7$export$568fc844f3097c27)(visibility);
    const { links: outgoingLinks, refreshLinkUrl: refreshLinkUrl } = outgoing;
    const { links: incomingLinks, twgLinks: incomingTwgLinks, hasNextPage: incomingLinksHaveMore, settled: incomingLinksSettled } = incoming;
    const { links: relatedContentLinks, loading: relatedContentLoading } = relatedContent;
    const { devDocsIcons: devDocsIcons } = visibility;
    const menuProps = (0, $cozmU.useMemo)(()=>({
            isEmbeddedMenu: isEmbeddedMenu,
            links: outgoingLinks,
            incomingLinks: incomingLinks,
            incomingLinksHaveMore: incomingLinksHaveMore,
            incomingLinksSettled: incomingLinksSettled,
            additionalIcons: devDocsIcons,
            relatedContentLinks: relatedContentLinks,
            relatedContentLoading: relatedContentLoading,
            devDocsConnection: devDocsConnection,
            contentId: contentId,
            refreshLinkUrl: refreshLinkUrl,
            onNavigate: handleNavigate,
            onOpenPreviewPanel: handleOpenPreviewPanel
        }), [
        isEmbeddedMenu,
        outgoingLinks,
        incomingLinks,
        incomingLinksHaveMore,
        incomingLinksSettled,
        devDocsIcons,
        relatedContentLinks,
        relatedContentLoading,
        devDocsConnection,
        contentId,
        refreshLinkUrl,
        handleNavigate,
        handleOpenPreviewPanel
    ]);
    const triggerProps = (0, $cozmU.useMemo)(()=>({
            links: outgoingLinks,
            incomingLinks: incomingTwgLinks,
            additionalIcons: devDocsIcons,
            minIcons: (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS),
            triggerRef: triggerRef,
            onToggle: handleToggle
        }), [
        outgoingLinks,
        incomingTwgLinks,
        devDocsIcons,
        triggerRef,
        handleToggle
    ]);
    if (visibility.hiddenBySsr) return null;
    // Loaded visibility is provisional while queries resolve; the placeholder checks SSR eligibility.
    if (visibility.isResolving) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d13ffa3aaf9dd66c$export$f8ba3742be6a3e0d), {
        contentId: contentId,
        contentType: contentType,
        connectionAncestors: props.connectionAncestors,
        isOpen: isOpen,
        onOpenChange: handlePlaceholderOpenChange
    });
    if (!visibility.shouldRenderByline) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d9aa28ddd15f0f51$export$bec8506dda89613f), {
        isOpen: isOpen,
        onClose: handleClose,
        menuProps: menuProps,
        triggerProps: triggerProps
    });
};
const $55b5fa95660732ad$var$BylineConnectionsWithSuspense = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        key: props.contentId,
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hvS6g.RelaySuspense), {
        interactionName: "BylinePageAdfQuery",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d13ffa3aaf9dd66c$export$f8ba3742be6a3e0d), {
            contentId: props.contentId,
            contentType: props.contentType,
            connectionAncestors: props.connectionAncestors
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($55b5fa95660732ad$var$BylineConnectionsInner, props)));
const $55b5fa95660732ad$export$867b5e5ad0743f37 = (0, $3plmx.withSmartCardProviderContext)($55b5fa95660732ad$var$BylineConnectionsWithSuspense);
module.exports["BylineConnections"] = $55b5fa95660732ad$export$867b5e5ad0743f37;

});

parcelRegister("hje3t", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bUd6P = parcelRequire("bUd6P");


var $iMnC5 = parcelRequire("iMnC5");


var $9NPFC = parcelRequire("9NPFC");

function $fc837618e233a230$export$92d8fa668dcc84de({ size: size }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- `white` is a member of Tile's `backgroundColor` union, which the rule cannot see; `logo-third-party` suppresses this for the same reason.
        backgroundColor: "white",
        hasBorder: true,
        label: "",
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        style: {
            lineHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bUd6P.RovoHexIcon), {
        label: "",
        size: size
    })));
}
module.exports["RovoTileIcon"] = $fc837618e233a230$export$92d8fa668dcc84de;

});

parcelRegister("6F7l4", function(module, exports) {
/* ConnectionsByLineMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $9NPFC = parcelRequire("9NPFC");


var $3jwuS = parcelRequire("3jwuS");


var $jmjWc = parcelRequire("jmjWc");


var $fURMF = parcelRequire("fURMF");


var $I7TEB = parcelRequire("I7TEB");

/* ConnectionsByLineRowActions.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $1sCHt = parcelRequire("1sCHt");




const $ad20e203017545fb$var$styles = {
    cluster: "_2mHwu81Y8M _3iDTPbccYA _0hPCNLDIqT _4xdlr0chRC _3YEZNOdnbC"
};
const $ad20e203017545fb$var$ConnectionsByLineRowActionButton = ({ action: action, item: item })=>{
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        // The row itself is clickable — it scrolls to the rendered link or opens
        // it in a new tab — so an action click must not bubble into that handler.
        event.stopPropagation();
        action.onClick(item);
    }, [
        action,
        item
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: action.icon,
        label: action.label,
        isTooltipDisabled: false,
        onClick: handleClick,
        testId: `connections-byline-row-action-${action.id}`
    });
};
const $ad20e203017545fb$export$316485efcf724587 = ({ actions: actions, item: item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ad20e203017545fb$var$styles.cluster
    }, actions.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad20e203017545fb$var$ConnectionsByLineRowActionButton, {
            key: action.id,
            action: action,
            item: item
        })));












var $bLfHG = parcelRequire("bLfHG");


var $4agZx = parcelRequire("4agZx");


var $bEvUu = parcelRequire("bEvUu");

/**
 * Derives the "Ask Rovo" row action for a connections row: an icon button that opens
 * the modal's Rovo chat seeded with this row's page as context.
 *
 * Returns null unless the caller passes an `onAskRovo` handler. The modal and the preview panel
 * both thread one, so the action is absent only in the byline popup, which has no Rovo at all.
 * Threaded as a prop alongside `onPreviewOpen` (rather than via context) so both callbacks reach
 * the row-action hooks the same way. Called by `ConnectionsByLineMenuItem` for every row,
 * alongside `useSmartLinkPreviewAction`.
 */ const $ab2f7621a35e6725$var$i18n = (0, $kSwu1.defineMessages)({
    askRovo: {
        id: "byline-connections.menu.item.ask-rovo",
        defaultMessage: "Ask Rovo"
    },
    contextPrompt: {
        id: "byline-connections.menu.item.ask-rovo-context-prompt",
        defaultMessage: "Fetch the content behind this link and use it as context for subsequent tasks:"
    }
});
const $ab2f7621a35e6725$var$ASK_ROVO_ACTION_ID = 'ask-rovo';
const $ab2f7621a35e6725$export$38f8161160ea9803 = (item, onAskRovo)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (!onAskRovo) return;
        createAnalyticsEvent((0, $4agZx.getAskRovoClickedEvent)({
            trigger: 'rowAction',
            product: item.product,
            resourceType: item.resourceType
        })).fire();
        // Prefill (not auto-send) a prompt pointing Rovo at this row's page, so the chat's
        // context is the connected page rather than the page the byline is on. The url is
        // joined on in code (not via the message) because the i18n extractor collapses a
        // newline inside a message to a space. Unseeded when the row has no url.
        onAskRovo(item.url ? [
            formatMessage($ab2f7621a35e6725$var$i18n.contextPrompt),
            item.url
        ].join('\n') : undefined);
    }, [
        createAnalyticsEvent,
        formatMessage,
        item.product,
        item.resourceType,
        item.url,
        onAskRovo
    ]);
    return (0, $cozmU.useMemo)(()=>onAskRovo ? {
            id: $ab2f7621a35e6725$var$ASK_ROVO_ACTION_ID,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
            label: formatMessage($ab2f7621a35e6725$var$i18n.askRovo),
            onClick: handleClick
        } : null, [
        onAskRovo,
        formatMessage,
        handleClick
    ]);
};









var $8VfSP = parcelRequire("8VfSP");


var $gybyF = parcelRequire("gybyF");


var $faU9A = parcelRequire("faU9A");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");







/**
 * Derives the "Open preview" row action for a connections row from the link's
 * SmartCard state.
 *
 * Called by `ConnectionsByLineMenuItem` for every row, which appends the result
 * to the actions its section supplied. Returns null unless the link is granted
 * and its SmartCard entry yields a `preview-content` action, so rows that can't
 * be previewed show no affordance. Requires a SmartCard provider in scope.
 */ const $ba21ca9b5c973fa0$var$i18n = (0, $kSwu1.defineMessages)({
    openPreview: {
        id: "byline-connections.menu.item.open-preview",
        defaultMessage: "Open preview"
    }
});
const $ba21ca9b5c973fa0$var$PREVIEW_ACTION_ID = 'preview-content';
const $ba21ca9b5c973fa0$var$reportPreviewActionError = (err)=>{
    const errorObj = err instanceof Error ? err : new Error(String(err));
    (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
};
const $ba21ca9b5c973fa0$export$e1a8e9c541506962 = (item, onPreviewOpen)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const hasPreviewAccess = item.access === 'granted';
    const actions = (0, $gybyF.useSmartLinkActions)({
        url: item.url,
        appearance: 'inline',
        prefetch: hasPreviewAccess
    });
    const previewAction = actions.find((action)=>action.id === $ba21ca9b5c973fa0$var$PREVIEW_ACTION_ID);
    // The platform only derives `preview-content` when the SmartCard entry carries
    // an embed `data.preview`. Same-site Confluence pages often resolve without
    // one — unlike Jira/3P links — leaving the row with no preview affordance. A
    // full reload makes ORS return the embed, after which the action appears.
    const reloadLink = (0, $faU9A.useSmartLinkReload)({
        url: item.url
    });
    const hasRequestedPreviewResolveRef = (0, $cozmU.useRef)(false);
    // Reload on mount rather than on hover, so the icon is ready before the user
    // reaches the row, and at most once to avoid resolve loops. Deliberately not
    // gated on `actions.length`: a metadata-only entry yields zero actions, so
    // gating on it would block exactly the rows that need the reload.
    (0, $cozmU.useEffect)(()=>{
        if (hasPreviewAccess && !previewAction && !hasRequestedPreviewResolveRef.current) {
            hasRequestedPreviewResolveRef.current = true;
            reloadLink();
        }
    }, [
        hasPreviewAccess,
        previewAction,
        reloadLink
    ]);
    const handlePreviewInvoke = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.CONNECTION_ROW_PREVIEW_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE),
                attributes: {
                    product: item.product,
                    resourceType: item.resourceType
                }
            }
        }).fire();
        onPreviewOpen?.();
        previewAction?.invoke().catch($ba21ca9b5c973fa0$var$reportPreviewActionError);
    }, [
        createAnalyticsEvent,
        item.product,
        item.resourceType,
        onPreviewOpen,
        previewAction
    ]);
    const showPreviewAction = hasPreviewAccess && Boolean(previewAction);
    return (0, $cozmU.useMemo)(()=>showPreviewAction ? {
            id: $ba21ca9b5c973fa0$var$PREVIEW_ACTION_ID,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
            label: formatMessage($ba21ca9b5c973fa0$var$i18n.openPreview),
            onClick: handlePreviewInvoke
        } : null, [
        showPreviewAction,
        formatMessage,
        handlePreviewInvoke
    ]);
};


const $27e32f8ec84143be$export$e5922176f457b015 = (item, onPreviewOpen, onAskRovo)=>{
    const previewAction = (0, $ba21ca9b5c973fa0$export$e1a8e9c541506962)(item, onPreviewOpen);
    const askRovoAction = (0, $ab2f7621a35e6725$export$38f8161160ea9803)(item, onAskRovo);
    return (0, $cozmU.useMemo)(()=>[
            previewAction,
            askRovoAction
        ].filter((action)=>action !== null), [
        previewAction,
        askRovoAction
    ]);
};






var $eEPSE = parcelRequire("eEPSE");


var $7zxJs = parcelRequire("7zxJs");










const $ee74b2779b35b5c3$var$ANALYTICS_SOURCE = 'connectionsBylineMenu';
const $ee74b2779b35b5c3$var$getAnalyticsAttributes = (item, status, reason)=>({
        product: item.product,
        resourceType: item.resourceType,
        authProviderKey: item.authProviders[0]?.key ?? null,
        access: item.access,
        occurrenceIndex: item.occurrenceIndex,
        ...status ? {
            status: status
        } : {},
        ...reason !== undefined ? {
            reason: reason
        } : {}
    });
const $ee74b2779b35b5c3$var$reportConnectError = (err)=>{
    const errorObj = err instanceof Error ? err : new Error(String(err));
    (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
};
const $ee74b2779b35b5c3$export$d93037bf2dc1b1f0 = ({ item: item, refreshLinkUrl: refreshLinkUrl, onConnectSuccess: onConnectSuccess })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [isConnecting, setIsConnecting] = (0, $cozmU.useState)(false);
    const connect = (0, $cozmU.useCallback)((event)=>{
        event.stopPropagation();
        if (isConnecting) return;
        const authProvider = item.authProviders[0];
        if (!authProvider) return;
        setIsConnecting(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'connectionsBylineConnectButton',
                source: $ee74b2779b35b5c3$var$ANALYTICS_SOURCE,
                attributes: $ee74b2779b35b5c3$var$getAnalyticsAttributes(item)
            }
        }).fire();
        (async ()=>{
            try {
                await (0, $eEPSE.auth)(authProvider.url);
            } catch (err) {
                const reason = err instanceof (0, $7zxJs.AuthError) ? err.type ?? null : null;
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'auth',
                        actionSubjectId: 'connectionsBylineConnectAuth',
                        source: $ee74b2779b35b5c3$var$ANALYTICS_SOURCE,
                        attributes: $ee74b2779b35b5c3$var$getAnalyticsAttributes(item, 'failed', reason)
                    }
                }).fire();
                $ee74b2779b35b5c3$var$reportConnectError(err);
                setIsConnecting(false);
                return;
            }
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'auth',
                    actionSubjectId: 'connectionsBylineConnectAuth',
                    source: $ee74b2779b35b5c3$var$ANALYTICS_SOURCE,
                    attributes: $ee74b2779b35b5c3$var$getAnalyticsAttributes(item, 'success')
                }
            }).fire();
            try {
                await refreshLinkUrl(item);
                onConnectSuccess?.();
            } catch (err) {
                $ee74b2779b35b5c3$var$reportConnectError(err);
                setIsConnecting(false);
            }
        })();
    }, [
        createAnalyticsEvent,
        isConnecting,
        item,
        onConnectSuccess,
        refreshLinkUrl
    ]);
    return {
        connect: connect,
        isConnecting: isConnecting
    };
};


const $a0b23ddb5269aeb3$var$LIVE_PAGE_SCROLL_ROOT_SELECTOR = '.fabric-editor-popup-scroll-parent';
const $a0b23ddb5269aeb3$var$MAIN_CONTENT_ID = 'AkMainContent';
const $a0b23ddb5269aeb3$export$6980ce4ab4fcefe5 = (isLivePage)=>{
    const currentDocument = typeof document === 'undefined' ? undefined : document;
    if (!currentDocument) return undefined;
    if (isLivePage) return currentDocument.querySelector($a0b23ddb5269aeb3$var$LIVE_PAGE_SCROLL_ROOT_SELECTOR) ?? undefined;
    return currentDocument.getElementById($a0b23ddb5269aeb3$var$MAIN_CONTENT_ID) ?? currentDocument;
};
const $a0b23ddb5269aeb3$export$e8a1a083f5b3b175 = ({ root: root, url: url })=>{
    const element = Array.from(root.querySelectorAll('a[href]')).find((anchor)=>anchor.getAttribute('href') === url);
    return element ? {
        status: 'found',
        element: element
    } : {
        status: 'not_found'
    };
};



var $38aC9 = parcelRequire("38aC9");


var $eyzEJ = parcelRequire("eyzEJ");


var $hDf5o = parcelRequire("hDf5o");




function $4a8664392fb76f90$export$a8859a12c9f593b4(dateString, locale) {
    if (!dateString) return undefined;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return undefined;
    const diffDays = Math.floor((Date.now() - date.getTime()) / 86400000);
    if (diffDays < 0) return undefined;
    // oxlint-disable-next-line compat/compat
    const rtf = new Intl.RelativeTimeFormat(locale, {
        numeric: 'always'
    });
    if (diffDays < 7) return rtf.format(-diffDays, 'day');
    return rtf.format(-Math.floor(diffDays / 7), 'week');
}
const $4a8664392fb76f90$export$67580b1c13935958 = (item, locale)=>{
    // Slot 1 — classification: "{Product} {resourceType}". Product uses the
    // customer-facing label (never the `townsquare` codename); resourceType is
    // lowercased. Either part is omitted when its source field is absent.
    const productLabel = (0, $eyzEJ.formatProduct)(item.product);
    const resourceTypeLabel = (0, $hDf5o.formatLabel)(item.resourceType)?.toLowerCase();
    const parts = [
        productLabel,
        resourceTypeLabel
    ].filter((part)=>Boolean(part));
    // Guard against duplicate words (e.g. townsquare "Goals" app → "Goals goals").
    const slot1 = parts.length === 2 && parts[0].toLowerCase() === parts[1].toLowerCase() ? parts[0] : parts.join(' ') || undefined;
    // Slot 2 — person: who created, updated, or owns it.
    const slot2 = item.owner || item.createdBy || item.updatedBy || item.assignedTo;
    // Slot 3 — date: when it was last touched.
    const slot3 = $4a8664392fb76f90$export$a8859a12c9f593b4(item.updatedAt, locale) || $4a8664392fb76f90$export$a8859a12c9f593b4(item.createdAt, locale) || null;
    return [
        slot1,
        slot2,
        slot3
    ];
};



var $5b9Ab = parcelRequire("5b9Ab");





const $db3ade85489bc276$var$UnconnectedConnectorHoverCardLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZM6iy",
    name: "UnconnectedConnectorHoverCardLoadable",
    loader: async ()=>(await (parcelRequire("7su1d"))).UnconnectedConnectorHoverCard
});
const $db3ade85489bc276$var$i18n = (0, $kSwu1.defineMessages)({
    connect: {
        id: "byline-connections.menu.item.connect",
        defaultMessage: "Connect"
    },
    connecting: {
        id: "byline-connections.menu.item.connecting",
        defaultMessage: "Connecting..."
    },
    descriptionSeparator: {
        id: "byline-connections.menu.item.description-separator",
        defaultMessage: "{left} \u2022 {right}"
    },
    productLink: {
        id: "byline-connections.menu.item.product-link",
        defaultMessage: "{product} link"
    }
});
const $db3ade85489bc276$var$styles = {
    row: "_2mHwu82ADO _0bjKvDOLYo _23rrnHo10F _4c065U2ADO _2Y7lL45zaO _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _4kiQYAUF4f _24h04i2Njc _1eOmH6o126",
    rowBody: "_2mHwu88HPE _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _0bjKvDKxmn _4c065UPgdg _2Y7lL4Pgdg _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _0KLXrujOvk _2fwxA5ecOK",
    textColumn: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    title: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1kk5Tku7m9 _1UtDYzy7kJ _1ANEUSLRg7 _39HuIbz8Lp",
    description: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1kk5Tku7m9 _1UtDYzKGUX _1ANEUSLRg7 _39HuIbz8Lp",
    aiSummary: "_1ANEUSzUZr",
    trailing: "_3YEZNOdnbC _3iDTPbccYA _0hPCNLDIqT"
};
const $db3ade85489bc276$var$pressableStyles = {
    connect: "_2sNsIgmnOE _0bjKvDKxmn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _2Y7lL41Y8M _1UtDYzM7Tp _0KLXrujOvk _0wOv4Q7zJH _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
    connecting: "_2sNsIgmnOE _0bjKvDKxmn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _2Y7lL41Y8M _1UtDYzot27 _0KLXrujOvk _0wOv4Q18ZR"
};
const $db3ade85489bc276$var$getNonGrantedRowContent = (rawUrl)=>{
    let parsed;
    try {
        parsed = new URL(rawUrl);
    } catch  {
        // URL was unparseable — fall back to showing the raw URL.
        return {
            titleContent: rawUrl,
            descriptionContent: null
        };
    }
    const hostname = parsed.hostname.replace(/^www\./i, ''); // Only trim slashes from the pathname itself — slashes inside the query
    // or fragment are meaningful and must be preserved.
    const trimmedPath = parsed.pathname.replace(/^\/+|\/+$/g, '');
    const pathDisplay = `${trimmedPath}${parsed.search}${parsed.hash}` || hostname;
    return {
        titleContent: pathDisplay,
        descriptionContent: hostname
    };
}; /**
    * Builds the title/description for a granted byline row from the data the
    * link resolver returned (title, plus 1–2 description slots).
    */ 
const $db3ade85489bc276$var$getGrantedRowContent = (item, locale, formatMessage)=>{
    const parts = (0, $4a8664392fb76f90$export$67580b1c13935958)(item, locale).filter((slot)=>Boolean(slot));
    const descriptionContent = parts.length === 0 ? null : parts.reduce((left, right)=>formatMessage($db3ade85489bc276$var$i18n.descriptionSeparator, {
            left: left,
            right: right
        }));
    return {
        titleContent: item.title,
        descriptionContent: descriptionContent
    };
}; /**
    * Builds the title/description for a non-granted incoming byline row —
    * typically a third-party Teamwork Graph link created with `access: undefined`.
    * These often carry no resolver title, which would otherwise leave the row
    * showing a raw URL, so we prefer a human-readable title when the graph gave us
    * one, else a "{Product} link" label (e.g. "Slack link"), and only keep the
    * URL-derived fallback when neither a title nor a product is available. The
    * description stays the hostname in those fallback cases.
    */ 
const $db3ade85489bc276$var$getIncomingRowContent = (item, formatMessage)=>{
    const { descriptionContent: descriptionContent } = $db3ade85489bc276$var$getNonGrantedRowContent(item.url);
    if (item.title) return {
        titleContent: item.title,
        descriptionContent: descriptionContent
    };
    const product = (0, $eyzEJ.formatProduct)(item.product);
    if (product) return {
        titleContent: formatMessage($db3ade85489bc276$var$i18n.productLink, {
            product: product
        }),
        descriptionContent: descriptionContent
    };
    return $db3ade85489bc276$var$getNonGrantedRowContent(item.url);
}; /**
    * Selects and builds the row content for a byline row: granted rows use the
    * resolver data, non-granted incoming rows get the incoming-specific title
    * handling, and everything else falls back to the URL.
    */ 
const $db3ade85489bc276$var$getRowContent = (item, linkDirection, locale, formatMessage)=>{
    if (item.access === 'granted') return $db3ade85489bc276$var$getGrantedRowContent(item, locale, formatMessage);
    if (linkDirection === 'incoming') return $db3ade85489bc276$var$getIncomingRowContent(item, formatMessage);
    return $db3ade85489bc276$var$getNonGrantedRowContent(item.url);
};
const $db3ade85489bc276$var$ConnectButton = ({ item: item, refreshLinkUrl: refreshLinkUrl, onConnectSuccess: onConnectSuccess })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { connect: connect, isConnecting: isConnecting } = (0, $ee74b2779b35b5c3$export$d93037bf2dc1b1f0)({
        item: item,
        refreshLinkUrl: refreshLinkUrl,
        onConnectSuccess: onConnectSuccess
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $db3ade85489bc276$var$styles.trailing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: isConnecting ? $db3ade85489bc276$var$pressableStyles.connecting : $db3ade85489bc276$var$pressableStyles.connect,
        onClick: connect,
        isDisabled: isConnecting
    }, formatMessage(isConnecting ? $db3ade85489bc276$var$i18n.connecting : $db3ade85489bc276$var$i18n.connect)));
};
const $db3ade85489bc276$var$ConnectionsByLineMenuItemInner = ({ item: item, refreshLinkUrl: refreshLinkUrl, linkDirection: linkDirection, aiSummary: aiSummary, onConnectSuccess: onConnectSuccess, onHover: onHover, onNavigate: onNavigate, onPreviewOpen: onPreviewOpen, onAskRovo: onAskRovo, compact: compact, disableHover: disableHover, analyticsSource: analyticsSource = (0, $I7TEB.ANALYTICS_SOURCE) })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [isRowHovered, setIsRowHovered] = (0, $cozmU.useState)(false);
    const [isRowFocused, setIsRowFocused] = (0, $cozmU.useState)(false);
    const isGranted = item.access === 'granted';
    const rowActions = (0, $27e32f8ec84143be$export$e5922176f457b015)(item, onPreviewOpen, onAskRovo);
    const fireItemClickAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'connectionRow',
                actionSubjectId: (0, $I7TEB.CONNECTION_ROW_ACTION_SUBJECT_ID),
                source: analyticsSource,
                attributes: {
                    product: item.product,
                    resourceType: item.resourceType,
                    access: item.access,
                    occurrenceIndex: item.occurrenceIndex,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        analyticsSource,
        createAnalyticsEvent,
        isLivePage,
        item
    ]);
    const fireScrollResultAnalytics = (0, $cozmU.useCallback)((result)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: result === 'success' ? 'succeeded' : 'failed',
                actionSubject: 'smartLinkScroll',
                actionSubjectId: (0, $I7TEB.SCROLL_RESULT_ACTION_SUBJECT_ID),
                source: analyticsSource,
                attributes: {
                    result: result,
                    reason: result === 'success' ? undefined : result,
                    product: item.product,
                    resourceType: item.resourceType,
                    occurrenceIndex: item.occurrenceIndex,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        analyticsSource,
        createAnalyticsEvent,
        isLivePage,
        item
    ]);
    const handleRowClick = (0, $cozmU.useCallback)(()=>{
        fireItemClickAnalytics();
        if (linkDirection === 'incoming') {
            window.open(item.url, '_blank', 'noopener,noreferrer');
            onNavigate?.();
            return;
        }
        const root = (0, $a0b23ddb5269aeb3$export$6980ce4ab4fcefe5)(isLivePage);
        if (!root) {
            fireScrollResultAnalytics('not_found');
            return;
        }
        const result = (0, $a0b23ddb5269aeb3$export$e8a1a083f5b3b175)({
            root: root,
            url: item.url
        });
        if (result.status !== 'found') {
            fireScrollResultAnalytics(result.status);
            return;
        }
        try {
            (0, $fURMF.scrollToElement)(result.element, undefined, 'smooth', isLivePage);
            fireScrollResultAnalytics('success');
            onNavigate?.();
        } catch  {
            fireScrollResultAnalytics('scroll_error');
        }
    }, [
        fireItemClickAnalytics,
        fireScrollResultAnalytics,
        isLivePage,
        item,
        linkDirection,
        onNavigate
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (disableHover) return;
        setIsRowHovered(true);
        onHover?.(item);
    }, [
        disableHover,
        onHover,
        item
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsRowHovered(false);
    }, []);
    const handleFocus = (0, $cozmU.useCallback)(()=>{
        if (disableHover) return;
        setIsRowFocused(true);
    }, [
        disableHover
    ]);
    const handleBlur = (0, $cozmU.useCallback)((event)=>{
        // Tabbing from the body to a trailing button must not hide it.
        if (!event.currentTarget.contains(event.relatedTarget)) setIsRowFocused(false);
    }, []);
    const showAffordances = !disableHover && (isRowHovered || isRowFocused); // `forbidden` means the user is authenticated to the provider but lacks
    // permission to this specific resource (e.g. a private Google Drive doc) —
    // connecting an account can't grant access, so don't offer Connect. (Note:
    // `meta.visibility` is unreliable here: accessible docs report 'restricted'
    // while the private one reports 'not_found', so we key on `access`.)
    const showConnectAction = !isGranted && item.access !== 'forbidden' && item.authProviders?.length > 0 && // Without a refresher there is nothing to update the row after a successful
    // auth, so the Connect flow would dead-end — don't offer it at all.
    Boolean(refreshLinkUrl);
    const { titleContent: titleContent, descriptionContent: descriptionContent } = $db3ade85489bc276$var$getRowContent(item, linkDirection, locale, formatMessage);
    const icon = (0, $5b9Ab.getSmartLinkIcon)(item);
    const row = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: ref,
            xcss: $db3ade85489bc276$var$styles.row,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleFocus,
            onBlur: handleBlur
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $db3ade85489bc276$var$styles.rowBody,
            onClick: handleRowClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: "",
            size: "small",
            backgroundColor: "transparent",
            hasBorder: true
        }, icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
            icon: icon,
            size: "menu"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $db3ade85489bc276$var$styles.textColumn
        }, compact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $db3ade85489bc276$var$styles.title
        }, titleContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $db3ade85489bc276$var$styles.title
        }, titleContent), aiSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $db3ade85489bc276$var$styles.aiSummary
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            size: "small",
            weight: "regular",
            color: "color.text.subtlest",
            maxLines: 2
        }, aiSummary)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $db3ade85489bc276$var$styles.description
        }, descriptionContent)))), showConnectAction && refreshLinkUrl && showAffordances ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db3ade85489bc276$var$ConnectButton, {
            item: item,
            refreshLinkUrl: refreshLinkUrl,
            onConnectSuccess: onConnectSuccess
        }) : null, showAffordances && rowActions.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad20e203017545fb$export$316485efcf724587), {
            item: item,
            actions: rowActions
        }) : null); // `disableHover` rows never open the hover card, so skip the lazy wrapper entirely
    // rather than mount it with a permanently-closed `isOpen`.
    if (showConnectAction && !disableHover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db3ade85489bc276$var$UnconnectedConnectorHoverCardLoadable, {
        item: item,
        isOpen: isRowHovered
    }, (triggerProps)=>row(triggerProps.ref));
    return row();
};
const $db3ade85489bc276$export$26a6dbb0548cf180 = /*#__PURE__*/ (0, $cozmU.memo)($db3ade85489bc276$var$ConnectionsByLineMenuItemInner);
module.exports["ConnectionsByLineMenuItem"] = $db3ade85489bc276$export$26a6dbb0548cf180;

});

parcelRegister("I7TEB", function(module, exports) {
const $87dcbdc0d0f33628$export$f7109619a5e9e0d6 = 'byline-connections';
const $87dcbdc0d0f33628$export$101fcd7717c218c = 'teamworkGraphAskRovo';
const $87dcbdc0d0f33628$export$b27e11d1203504c6 = 'teamworkGraphAtAGlance';
const $87dcbdc0d0f33628$export$44da7239490811f0 = 'teamworkGraphByline';
const $87dcbdc0d0f33628$export$934aa167151db3b1 = 'teamworkGraphConnectionRow';
const $87dcbdc0d0f33628$export$44cb3909ff4c43b4 = 'teamworkGraphConnectionRowPreview';
const $87dcbdc0d0f33628$export$9f421e6b009b0c46 = 'embeddedConnectionsBylineMenu';
const $87dcbdc0d0f33628$export$cf7911cc0496896d = 'incomingLinks';
const $87dcbdc0d0f33628$export$55cebf666ed7ac96 = 'incomingLinksLoadMore';
const $87dcbdc0d0f33628$export$330408bc2ba1ae11 = 'incomingLinksRemoteLinks';
const $87dcbdc0d0f33628$export$464cb4cd27148792 = 'connectionsBylineMenuClose';
const $87dcbdc0d0f33628$export$acc71150ed5ad64c = 'connectionsBylineMenuFooter';
const $87dcbdc0d0f33628$export$5ba4366f11f23c55 = 'connectionsBylineMenuShowMore';
const $87dcbdc0d0f33628$export$bba211f21228be2c = 'connectionsBylineMenu';
const $87dcbdc0d0f33628$export$40345c2a055906c6 = 'teamworkGraphModal';
const $87dcbdc0d0f33628$export$6d9fd39253136607 = 'teamworkGraphModalClose';
const $87dcbdc0d0f33628$export$a622ec92a443b64b = 'teamworkGraphModal';
const $87dcbdc0d0f33628$export$be7c2fb105208df8 = 'teamworkGraphOpenGraph';
const $87dcbdc0d0f33628$export$1b17b0123cd467d7 = 'pagePeople';
const $87dcbdc0d0f33628$export$1e3d227809c0b3f7 = 'teamworkGraphPreviewPanel';
const $87dcbdc0d0f33628$export$759cbc1c81b47827 = 'teamworkGraphPeopleAndAgentsRow';
const $87dcbdc0d0f33628$export$ebf3ac68dcdd04f3 = 'teamworkGraphPeopleAndAgentsShowMore';
const $87dcbdc0d0f33628$export$9de0d39be33ad03f = 'relatedContent';
const $87dcbdc0d0f33628$export$42ea7a21a01a98f7 = 'connectionsBylineMenuItemScroll';
const $87dcbdc0d0f33628$export$d4c2e3fd0fe0ee3e = 'teamworkGraphShareContext';
const $87dcbdc0d0f33628$export$9c4db6e16d3288ef = 'teamworkGraphShareContextClose';
const $87dcbdc0d0f33628$export$50e1feeed3c175fe = 'teamworkGraphShareContextCopyPrompt';
const $87dcbdc0d0f33628$export$547360dc458798ec = 'teamworkGraphShareContextModal';
const $87dcbdc0d0f33628$export$c5d0213fdeb686c8 = 'teamworkGraphShareContextTool';
module.exports["ANALYTICS_SOURCE"] = $87dcbdc0d0f33628$export$f7109619a5e9e0d6;
module.exports["ASK_ROVO_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$101fcd7717c218c;
module.exports["AT_A_GLANCE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$b27e11d1203504c6;
module.exports["BYLINE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$44da7239490811f0;
module.exports["CONNECTION_ROW_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$934aa167151db3b1;
module.exports["CONNECTION_ROW_PREVIEW_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$44cb3909ff4c43b4;
module.exports["EMBEDDED_MENU_SOURCE"] = $87dcbdc0d0f33628$export$9f421e6b009b0c46;
module.exports["INCOMING_LINKS_ACTION_SUBJECT"] = $87dcbdc0d0f33628$export$cf7911cc0496896d;
module.exports["INCOMING_LINKS_LOAD_MORE_ACTION_SUBJECT"] = $87dcbdc0d0f33628$export$55cebf666ed7ac96;
module.exports["INCOMING_LINKS_REMOTE_LINKS_ACTION_SUBJECT"] = $87dcbdc0d0f33628$export$330408bc2ba1ae11;
module.exports["MENU_CLOSE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$464cb4cd27148792;
module.exports["MENU_FOOTER_SOURCE"] = $87dcbdc0d0f33628$export$acc71150ed5ad64c;
module.exports["MENU_SHOW_MORE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$5ba4366f11f23c55;
module.exports["MENU_SOURCE"] = $87dcbdc0d0f33628$export$bba211f21228be2c;
module.exports["MODAL_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$40345c2a055906c6;
module.exports["MODAL_CLOSE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$6d9fd39253136607;
module.exports["MODAL_SOURCE"] = $87dcbdc0d0f33628$export$a622ec92a443b64b;
module.exports["OPEN_GRAPH_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$be7c2fb105208df8;
module.exports["PAGE_PEOPLE_ACTION_SUBJECT"] = $87dcbdc0d0f33628$export$1b17b0123cd467d7;
module.exports["PANEL_SOURCE"] = $87dcbdc0d0f33628$export$1e3d227809c0b3f7;
module.exports["PEOPLE_AND_AGENTS_ROW_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$759cbc1c81b47827;
module.exports["PEOPLE_AND_AGENTS_SHOW_MORE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$ebf3ac68dcdd04f3;
module.exports["RELATED_CONTENT_ACTION_SUBJECT"] = $87dcbdc0d0f33628$export$9de0d39be33ad03f;
module.exports["SCROLL_RESULT_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$42ea7a21a01a98f7;
module.exports["SHARE_CONTEXT_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$d4c2e3fd0fe0ee3e;
module.exports["SHARE_CONTEXT_CLOSE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$9c4db6e16d3288ef;
module.exports["SHARE_CONTEXT_COPY_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$50e1feeed3c175fe;
module.exports["SHARE_CONTEXT_MODAL_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$547360dc458798ec;
module.exports["SHARE_CONTEXT_TOOL_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$c5d0213fdeb686c8;

});

parcelRegister("4agZx", function(module, exports) {

var $I7TEB = parcelRequire("I7TEB");

const $d3ef9f581c529bcb$export$12b889841e4c036 = 'teamworkGraphRovoChat';
const $d3ef9f581c529bcb$export$6f13d53292529b34 = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $I7TEB.ASK_ROVO_ACTION_SUBJECT_ID),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $d3ef9f581c529bcb$export$82f52ee21bdab663 = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'switched',
            actionSubject: 'rovoChat',
            actionSubjectId: $d3ef9f581c529bcb$export$12b889841e4c036,
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $d3ef9f581c529bcb$export$13200ced42a5781f = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'closed',
            actionSubject: 'rovoChat',
            actionSubjectId: $d3ef9f581c529bcb$export$12b889841e4c036,
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
module.exports["getAskRovoClickedEvent"] = $d3ef9f581c529bcb$export$6f13d53292529b34;
module.exports["getRovoChatSwitchedEvent"] = $d3ef9f581c529bcb$export$82f52ee21bdab663;
module.exports["getRovoChatClosedEvent"] = $d3ef9f581c529bcb$export$13200ced42a5781f;

});

parcelRegister("bEvUu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $dcSzx = parcelRequire("dcSzx");

const $90058fc8c3407f36$export$3f5d7a61053aa3cd = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const createTwgAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        // Confluence events are `{ type, data }`. Anything else is passed straight through.
        if (!payload.data) return createAnalyticsEvent(payload);
        return createAnalyticsEvent({
            ...payload,
            data: {
                ...payload.data,
                attributes: {
                    ...payload.data.attributes,
                    twgTraceId: (0, $dcSzx.getTwgTraceId)()
                }
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            createAnalyticsEvent: createTwgAnalyticsEvent
        }), [
        createTwgAnalyticsEvent
    ]);
};
module.exports["useTwgAnalyticsEvents"] = $90058fc8c3407f36$export$3f5d7a61053aa3cd;

});

parcelRegister("7su1d", function(module, exports) {

let $56e26efeea10e5c8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56e26efeea10e5c8$var$load("hAcjP").then(()=>parcelRequire('kcVdk'));

});

parcelRegister("kC09O", function(module, exports) {
/* ShowMoreRow.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hBYtq = parcelRequire("hBYtq");

const $6484606ef90b2a01$var$styles = {
    row: "_0bjKvDOLYo _2sNsIg7NXe _23rrnHo10F _4c065U8HPE _2Y7lL45zaO _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0KLXrujOvk _2fwxA5ecOK _1kk5Tkf7mX _1UtDYzZpcK _1eOmH6o126"
};
const $6484606ef90b2a01$var$i18n = (0, $kSwu1.defineMessages)({
    showMore: {
        id: "byline-connections.preview-panel.show-more",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "byline-connections.preview-panel.show-less",
        defaultMessage: "Show less"
    }
}); /** Shared with the embedded connections byline menu, whose sections toggle the same way. */ 
const $6484606ef90b2a01$export$f82de8cbca70dfcb = $6484606ef90b2a01$var$i18n.showMore;
const $6484606ef90b2a01$export$6f96196723302358 = $6484606ef90b2a01$var$i18n.showLess;
const $6484606ef90b2a01$export$3590e0bf4f6b2ca2 = ({ isExpanded: isExpanded, onClick: onClick, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $6484606ef90b2a01$var$styles.row,
        "aria-expanded": isExpanded,
        onClick: onClick,
        testId: testId
    }, formatMessage(isExpanded ? $6484606ef90b2a01$var$i18n.showLess : $6484606ef90b2a01$var$i18n.showMore));
};
module.exports["showMoreMessage"] = $6484606ef90b2a01$export$f82de8cbca70dfcb;
module.exports["showLessMessage"] = $6484606ef90b2a01$export$6f96196723302358;
module.exports["ShowMoreRow"] = $6484606ef90b2a01$export$3590e0bf4f6b2ca2;

});

parcelRegister("21leH", function(module, exports) {

var $jDHty = parcelRequire("jDHty");

const $4adaf34aeab2c91c$export$c7b414e180315a71 = {
    contentId: undefined,
    incomingLinks: {
        links: [],
        loading: true,
        loadingMore: false,
        hasNextPage: false,
        endCursor: null,
        loadMore: ()=>{},
        error: undefined
    }
};
// BylineConnections is the sole producer. Readers never fetch or hydrate this stream.
const $4adaf34aeab2c91c$var$bridge = (0, $jDHty.createPanelDataBridge)($4adaf34aeab2c91c$export$c7b414e180315a71);
const $4adaf34aeab2c91c$export$838755d6e4074a19 = $4adaf34aeab2c91c$var$bridge.publish;
const $4adaf34aeab2c91c$export$82d95e6c3ee2cb53 = $4adaf34aeab2c91c$var$bridge.clear;
const $4adaf34aeab2c91c$export$a56df9ee573d1160 = $4adaf34aeab2c91c$var$bridge.useValue;
const $4adaf34aeab2c91c$export$5e509302065e8e8 = $4adaf34aeab2c91c$var$bridge.clearForTesting;
module.exports["publishIncomingLinks"] = $4adaf34aeab2c91c$export$838755d6e4074a19;
module.exports["clearIncomingLinks"] = $4adaf34aeab2c91c$export$82d95e6c3ee2cb53;
module.exports["useIncomingLinksData"] = $4adaf34aeab2c91c$export$a56df9ee573d1160;

});

parcelRegister("Hnn0l", function(module, exports) {

var $jDHty = parcelRequire("jDHty");

const $80a543aab06a3853$export$3410a3ccc4d8e4fb = {
    contentId: undefined,
    outgoingLinks: []
};
/**
 * Carries the content-scoped outgoing links collected by the byline to the panel.
 *
 * Only ever written from an effect, so nothing publishes during SSR and this
 * module-level state cannot leak between server requests.
 */ const $80a543aab06a3853$var$outgoingLinksBridge = (0, $jDHty.createPanelDataBridge)($80a543aab06a3853$export$3410a3ccc4d8e4fb);
const $80a543aab06a3853$export$397dc7f3cc2bb433 = $80a543aab06a3853$var$outgoingLinksBridge.publish;
const $80a543aab06a3853$export$8d2fbd86048952e1 = $80a543aab06a3853$var$outgoingLinksBridge.clear;
const $80a543aab06a3853$export$832705d949dd0d41 = $80a543aab06a3853$var$outgoingLinksBridge.subscribe;
const $80a543aab06a3853$export$3ec0983b8b493d18 = $80a543aab06a3853$var$outgoingLinksBridge.useValue;
const $80a543aab06a3853$export$506c885e440aa8aa = $80a543aab06a3853$var$outgoingLinksBridge.clearForTesting;
module.exports["publishOutgoingLinks"] = $80a543aab06a3853$export$397dc7f3cc2bb433;
module.exports["clearOutgoingLinks"] = $80a543aab06a3853$export$8d2fbd86048952e1;
module.exports["useOutgoingLinks"] = $80a543aab06a3853$export$3ec0983b8b493d18;

});

parcelRegister("4ao9J", function(module, exports) {

var $jDHty = parcelRequire("jDHty");

const $32154ea67d922195$export$f870547225cbe74b = {
    contentId: undefined,
    relatedContent: {
        enabled: false,
        links: [],
        loading: false,
        error: undefined
    }
};
// BylineConnections is the sole producer. Readers never fetch or hydrate this stream.
const $32154ea67d922195$var$bridge = (0, $jDHty.createPanelDataBridge)($32154ea67d922195$export$f870547225cbe74b);
const $32154ea67d922195$export$20ab1e77e1cd3cc2 = $32154ea67d922195$var$bridge.publish;
const $32154ea67d922195$export$ddbfb8004207fe5d = $32154ea67d922195$var$bridge.clear;
const $32154ea67d922195$export$e0a1f4af2d095c13 = $32154ea67d922195$var$bridge.useValue;
const $32154ea67d922195$export$cdaad0e5602ad257 = $32154ea67d922195$var$bridge.clearForTesting;
module.exports["publishRelatedContent"] = $32154ea67d922195$export$20ab1e77e1cd3cc2;
module.exports["clearRelatedContent"] = $32154ea67d922195$export$ddbfb8004207fe5d;
module.exports["useRelatedContentData"] = $32154ea67d922195$export$e0a1f4af2d095c13;

});

parcelRegister("4500S", function(module, exports) {
const $86a72eb2521887f6$export$fa2412b03251b330 = 4;
const $86a72eb2521887f6$export$d2840e53de4c9ae1 = 10;
module.exports["MAX_PAGE_PEOPLE"] = $86a72eb2521887f6$export$fa2412b03251b330;
module.exports["MAX_LISTED_PAGE_PEOPLE"] = $86a72eb2521887f6$export$d2840e53de4c9ae1;

});

parcelRegister("45zaV", function(module, exports) {
/* ConnectionSections.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $jmjWc = parcelRequire("jmjWc");

const $fc4cd27910e257d3$export$101b131926441521 = new Map();
const $fc4cd27910e257d3$export$4f955c0b5efa5938 = (output)=>{
    if (output?.status !== 'GENERATED' || !output.summaries.length) return $fc4cd27910e257d3$export$101b131926441521;
    const byAri = new Map();
    for (const { ari: ari, oneLiner: oneLiner } of output.summaries)if (!byAri.has(ari)) byAri.set(ari, oneLiner);
    return byAri;
};









var $g9HBv = parcelRequire("g9HBv");

/* ConnectionsByLineSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $lfoFx = parcelRequire("lfoFx");


var $4B2M3 = parcelRequire("4B2M3");


var $hTfX9 = parcelRequire("hTfX9");


var $6F7l4 = parcelRequire("6F7l4");


var $bG6aJ = parcelRequire("bG6aJ");

// same 12px radius as the section card. Overflow-hidden confines whatever
// paint the row's internals apply.
const $bba263788d7ab919$var$roundedRowStyles = null;
const $bba263788d7ab919$var$styles = {
    loadingMore: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VUF4f",
    emptyMessage: "_2sNsIgmnOE _1UtDYzot27 _2fwxA5DIqT"
};
const $bba263788d7ab919$export$deadd1488868c3d4 = ({ title: title, iconBefore: iconBefore, items: items, linkDirection: linkDirection, aiSummaries: aiSummaries, onPreviewOpen: onPreviewOpen, onAskRovo: onAskRovo, emptyMessage: emptyMessage, count: count = items.length, hasMore: hasMore, pagination: pagination, isExpanded: isExpanded, onToggleExpanded: onToggleExpanded, testId: testId })=>{
    // The body only exists while expanded, so the scroll root is held in state to
    // re-run the observer once the body mounts.
    const [scrollRoot, setScrollRoot] = (0, $cozmU.useState)(null); // `InfiniteScroll` rebuilds its observer whenever these options change identity.
    const observerOptions = (0, $cozmU.useMemo)(()=>({
            root: scrollRoot,
            rootMargin: '0px',
            threshold: 0.05
        }), [
        scrollRoot
    ]);
    const loadingMoreTestId = testId ? `${testId}--loading-more` : undefined;
    const isEmpty = items.length === 0 && !pagination?.isLoading && !pagination?.hasNextPage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bG6aJ.ConnectionsByLineSectionShell), {
        title: title,
        count: count ?? undefined,
        hasMore: hasMore,
        iconBefore: iconBefore,
        trailing: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTfX9.BylineConnectionIconStack), {
            links: items
        }),
        bodyRef: setScrollRoot,
        isExpanded: isExpanded,
        onToggleExpanded: onToggleExpanded,
        testId: testId
    }, isEmpty && emptyMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bba263788d7ab919$var$styles.emptyMessage,
        testId: testId ? `${testId}--empty` : undefined
    }, emptyMessage) : null, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: `${item.url}-${item.occurrenceIndex}`,
            className: (0, $hekY6.default)([
                "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6F7l4.ConnectionsByLineMenuItem), {
            item: item,
            linkDirection: linkDirection,
            aiSummary: item.ari ? aiSummaries?.get(item.ari) : undefined,
            onPreviewOpen: onPreviewOpen,
            onAskRovo: onAskRovo
        }))), pagination?.hasNextPage ? // Mounted only while `onLoadMore` can act on it: `InfiniteScroll` marks a cursor
    // as used before calling back and ignores that the call was rejected, so a
    // sentinel left mounted during a fetch burns the next cursor and pagination
    // stops. Remounting resets that state.
    pagination.isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bba263788d7ab919$var$styles.loadingMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        testId: loadingMoreTestId
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4B2M3.ObservableSpinner), {
        cursor: pagination.endCursor,
        onScrollTo: pagination.onLoadMore,
        observerOptions: observerOptions,
        spinnerSize: "small",
        testId: loadingMoreTestId ?? 'connections-by-line-section-loading-more'
    }) : null);
};


const $7ed3b9e6215820af$var$i18n = (0, $kSwu1.defineMessages)({
    appearsIn: {
        id: "byline-connections.preview-panel.section.appears-in",
        defaultMessage: "Appears in"
    },
    empty: {
        id: "byline-connections.preview-panel.section.appears-in.empty",
        defaultMessage: "This content is not referenced anywhere."
    }
});
const $7ed3b9e6215820af$export$696cfca056e338c6 = ({ links: links, loading: loading, loadingMore: loadingMore, hasNextPage: hasNextPage, endCursor: endCursor, loadMore: loadMore, error: error, aiSummaries: aiSummaries, onPreviewOpen: onPreviewOpen, onAskRovo: onAskRovo, isExpanded: isExpanded, onToggleExpanded: onToggleExpanded })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // The header count is pinned to the first page: the query returns no total, and even a
    // `count()` would not say how many of those rows ORS can resolve into rendered links.
    // `hasNextPage` adds the "+" instead.
    const initialCountRef = (0, $cozmU.useRef)(undefined);
    const hasFailedWithoutLinks = Boolean(error) && links.length === 0;
    if (initialCountRef.current === undefined && !loading && !hasFailedWithoutLinks) initialCountRef.current = links.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bba263788d7ab919$export$deadd1488868c3d4), {
        title: formatMessage($7ed3b9e6215820af$var$i18n.appearsIn),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9HBv))), {
            label: "",
            spacing: "none"
        }),
        items: links,
        linkDirection: "incoming",
        aiSummaries: aiSummaries,
        onPreviewOpen: onPreviewOpen,
        onAskRovo: onAskRovo,
        isExpanded: isExpanded,
        onToggleExpanded: onToggleExpanded,
        // A failed query is not an empty graph, so it does not earn the explanation.
        emptyMessage: error ? undefined : formatMessage($7ed3b9e6215820af$var$i18n.empty),
        count: initialCountRef.current ?? 0,
        hasMore: hasNextPage,
        pagination: {
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            // `loading` also covers the initial catch-up paging, which `loadMore` refuses to interrupt.
            isLoading: loading || loadingMore,
            onLoadMore: loadMore
        },
        testId: "teamwork-graph-preview-panel-appears-in-section"
    });
};


/* AtAGlanceSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $I7hWB = parcelRequire("I7hWB");








var $a9aSv = parcelRequire("a9aSv");


var $8wK2O = parcelRequire("8wK2O");





var $I7TEB = parcelRequire("I7TEB");


var $dcSzx = parcelRequire("dcSzx");


var $bEvUu = parcelRequire("bEvUu");

const $d99cd0c67750d40f$export$702afd7e17b0f89d = 'twgResult';
const $d99cd0c67750d40f$export$afa99ea9d7b3b0 = (surface, action, twgResultCount, attributes)=>{
    if (twgResultCount <= 0) return null;
    return {
        type: 'sendUIEvent',
        data: {
            action: action,
            actionSubject: $d99cd0c67750d40f$export$702afd7e17b0f89d,
            actionSubjectId: surface.actionSubjectId,
            source: surface.source,
            attributes: {
                ...attributes,
                product: 'confluence',
                subproduct: (0, $I7TEB.ANALYTICS_SOURCE),
                platform: 'web',
                eventname: `${$d99cd0c67750d40f$export$702afd7e17b0f89d} ${action}`,
                twgFeatureName: surface.twgFeatureName,
                twgInteractionId: (0, $dcSzx.getTwgTraceId)(),
                source: surface.twgSource,
                query_method: surface.queryMethod,
                twgResultCount: twgResultCount
            }
        }
    };
};
const $d99cd0c67750d40f$export$67fd8ea9f37a7a0b = (surface, twgResultCount, attributes)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        const event = $d99cd0c67750d40f$export$afa99ea9d7b3b0(surface, 'viewed', twgResultCount, attributes);
        if (event) {
            hasFiredRef.current = true;
            createAnalyticsEvent(event).fire();
        }
    }, [
        attributes,
        createAnalyticsEvent,
        surface,
        twgResultCount
    ]);
};
const $d99cd0c67750d40f$export$759f6ba0b6c7f1fc = (surface)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    return (0, $cozmU.useCallback)((twgResultCount, attributes)=>{
        const event = $d99cd0c67750d40f$export$afa99ea9d7b3b0(surface, 'actioned', twgResultCount, attributes);
        if (event) createAnalyticsEvent(event).fire();
    }, [
        createAnalyticsEvent,
        surface
    ]);
};


/* TeamworkGraphAskRovoButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $bUd6P = parcelRequire("bUd6P");


var $hBYtq = parcelRequire("hBYtq");





var $4agZx = parcelRequire("4agZx");




// entries in the panel read as one family.
// Button has fixed vertical padding, so Pressable.
const $4fc369165e330a2e$var$styles = {
    button: "_2mHwu8gVvo _0bjKvDKTcp _2sNsIgmnOE _23rrnHyKLB _4c065UPgdg _2Y7lL48HPE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _39xV02N91d _0jFU0VUofl _37wbyuDIqT _0hPCNLDIqT _0KLXru66of _1UtDYzZpcK _1eOmH6o126 _3sFUREiSCN _3gzVzLN4oS"
};
const $4fc369165e330a2e$var$i18n = (0, $kSwu1.defineMessages)({
    chatWithRovo: {
        id: "byline-connections.preview-panel.at-a-glance.chat-with-rovo-button",
        defaultMessage: "Chat with Rovo"
    }
});
function $4fc369165e330a2e$export$b29a191a5c5e9({ onClick: onClick, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent((0, $4agZx.getAskRovoClickedEvent)({
            trigger: 'atAGlance'
        })).fire();
        onClick();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $4fc369165e330a2e$var$styles.button,
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bUd6P.RovoHexIcon), {
        label: "",
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "medium",
        weight: "medium",
        maxLines: 1
    }, formatMessage($4fc369165e330a2e$var$i18n.chatWithRovo)));
}


const $91ded8c84d6983c5$var$LOADING_BAR_WIDTHS = [
    '100%',
    '85%',
    '70%'
];
const $91ded8c84d6983c5$var$styles = {
    card: "_2mHwu88HPE _0bjKvDyzSk _4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrunmFW",
    body: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w",
    loading: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $91ded8c84d6983c5$var$i18n = (0, $kSwu1.defineMessages)({
    contextFromYourWork: {
        id: "byline-connections.preview-panel.section.context-from-your-work",
        defaultMessage: "Context from your work"
    },
    loading: {
        id: "byline-connections.preview-panel.section.context-from-your-work.loading",
        defaultMessage: "Loading context from your work"
    },
    error: {
        id: "byline-connections.preview-panel.section.at-a-glance.error",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We couldn't generate this summary"
    },
    retryWaiting: {
        id: "byline-connections.preview-panel.section.at-a-glance.retry-waiting",
        defaultMessage: "The summary service is busy. We\u2019ll try again shortly."
    },
    insufficientEvidence: {
        id: "byline-connections.preview-panel.section.at-a-glance.insufficient-evidence.ai-non-final",
        defaultMessage: "We couldn\u2019t generate summaries because there isn\u2019t enough information in this page and its connections."
    }
});
const $91ded8c84d6983c5$var$Loading = ({ waitingForQuota: waitingForQuota })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $91ded8c84d6983c5$var$styles.loading,
        role: "status",
        "aria-label": formatMessage($91ded8c84d6983c5$var$i18n.loading),
        testId: "teamwork-graph-preview-panel-at-a-glance-section--loading"
    }, $91ded8c84d6983c5$var$LOADING_BAR_WIDTHS.map((width)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            key: width,
            width: width,
            height: "var(--ds-space-200, 16px)",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        })), waitingForQuota ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, formatMessage($91ded8c84d6983c5$var$i18n.retryWaiting)) : null);
}; /** Older responses may contain multiple items, so the whole overview joins into one paragraph. */ 
const $91ded8c84d6983c5$var$Summary = ({ overview: overview })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, overview.map((item)=>item.text).join(' '));
const $91ded8c84d6983c5$var$Failed = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "alert",
        testId: "teamwork-graph-preview-panel-at-a-glance-section--error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, formatMessage($91ded8c84d6983c5$var$i18n.error)));
};
const $91ded8c84d6983c5$var$InsufficientEvidence = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "teamwork-graph-preview-panel-at-a-glance-section--insufficient-evidence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, formatMessage($91ded8c84d6983c5$var$i18n.insufficientEvidence)));
};
const $91ded8c84d6983c5$export$d7d0920f7a8ebe0d = ({ output: output, loading: loading, error: error, retryPending: retryPending, retryReason: retryReason, onAskRovo: onAskRovo })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const headingId = (0, $cozmU.useId)();
    const overview = output?.overview;
    const summariesCount = output?.summaries.length ?? 0;
    const twgResultAttributes = (0, $cozmU.useMemo)(()=>({
            summariesCount: summariesCount
        }), [
        summariesCount
    ]);
    (0, $d99cd0c67750d40f$export$67fd8ea9f37a7a0b)((0, $8wK2O.AT_A_GLANCE_TWG_RESULT_SURFACE), overview?.length ?? 0, twgResultAttributes); // An unavailable response is a generation failure, so it shares the failure copy. Every
    // other summary-less state — no request made, insufficient evidence, or an empty
    // generated overview — is a lack of material to summarise rather than an error.
    const failed = Boolean(error) || output?.status === 'UNAVAILABLE';
    let body;
    if ((loading || retryPending) && !overview?.length) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($91ded8c84d6983c5$var$Loading, {
        waitingForQuota: Boolean(retryPending && retryReason === 'rateLimited')
    });
    else if (overview?.length) // Keep the summary if a later refetch fails.
    body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($91ded8c84d6983c5$var$Summary, {
        overview: overview
    });
    else if (failed) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($91ded8c84d6983c5$var$Failed, null);
    else body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($91ded8c84d6983c5$var$InsufficientEvidence, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $91ded8c84d6983c5$var$styles.card,
        role: "region",
        "aria-labelledby": headingId,
        testId: "teamwork-graph-preview-panel-at-a-glance-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h3",
        id: headingId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        weight: "bold"
    }, formatMessage($91ded8c84d6983c5$var$i18n.contextFromYourWork))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $91ded8c84d6983c5$var$styles.body,
        testId: "teamwork-graph-preview-panel-at-a-glance-section--body"
    }, body, onAskRovo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "teamwork-graph-preview-panel-at-a-glance-section--ask-rovo-slot"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fc369165e330a2e$export$b29a191a5c5e9), {
        onClick: onAskRovo,
        testId: "teamwork-graph-preview-panel-at-a-glance-section--ask-rovo"
    })) : null));
};









var $4bg4c = parcelRequire("4bg4c");


var $86sr7 = parcelRequire("86sr7");


const $e66409e8a5c11d6d$var$i18n = (0, $kSwu1.defineMessages)({
    linksTo: {
        id: "byline-connections.preview-panel.section.links-to",
        defaultMessage: "Links to"
    },
    empty: {
        id: "byline-connections.preview-panel.section.links-to.empty",
        defaultMessage: "This content does not link to anything."
    }
});
const $e66409e8a5c11d6d$export$f7d0d6af791d1bb = ({ links: links, aiSummaries: aiSummaries, onPreviewOpen: onPreviewOpen, onAskRovo: onAskRovo, isExpanded: isExpanded, onToggleExpanded: onToggleExpanded })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Reorders unconnected links first; the full length means no truncation.
    const items = (0, $cozmU.useMemo)(()=>(0, $86sr7.getTopConnectionLinks)(links, links.length), [
        links
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bba263788d7ab919$export$deadd1488868c3d4), {
        title: formatMessage($e66409e8a5c11d6d$var$i18n.linksTo),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4bg4c))), {
            label: "",
            spacing: "none"
        }),
        items: items,
        linkDirection: "outgoing",
        aiSummaries: aiSummaries,
        onPreviewOpen: onPreviewOpen,
        onAskRovo: onAskRovo,
        isExpanded: isExpanded,
        onToggleExpanded: onToggleExpanded,
        emptyMessage: formatMessage($e66409e8a5c11d6d$var$i18n.empty),
        testId: "teamwork-graph-preview-panel-links-to-section"
    });
};









var $arQY7 = parcelRequire("arQY7");


var $fBqzD = parcelRequire("fBqzD");


var $dinVW = parcelRequire("dinVW");


var $d6Ahp = parcelRequire("d6Ahp");


var $fnCzB = parcelRequire("fnCzB");


var $3EM6l = parcelRequire("3EM6l");


var $a6t12 = parcelRequire("a6t12");







/* PersonRow.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $w6R6I = parcelRequire("w6R6I");







const $f4d154f3da73b0ad$var$styles = {
    row: "_2mHwu88HPE _0bjKvDOLYo _4c065U8HPE _2Y7lL48HPE _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0KLXrujOvk _2fwxA5ecOK",
    interactive: "_23rrnHo10F _1eOmH6o126",
    content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu8Pgdg _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC",
    name: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1kk5Tk7GSX _1UtDYzy7kJ _1ANEUSLRg7 _39HuIbz8Lp",
    role: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _1ANEUSLRg7 _39HuIbz8Lp"
};
const $f4d154f3da73b0ad$export$2360cd0b07b95057 = ({ avatar: avatar, name: name, role: role, onClick: onClick, testId: testId })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, avatar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f4d154f3da73b0ad$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f4d154f3da73b0ad$var$styles.name
    }, name), role ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f4d154f3da73b0ad$var$styles.role
    }, role) : null));
    return onClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($f4d154f3da73b0ad$var$styles.row, $f4d154f3da73b0ad$var$styles.interactive),
        onClick: onClick,
        testId: testId
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f4d154f3da73b0ad$var$styles.row,
        testId: testId
    }, content);
};



var $lkmGM = parcelRequire("lkmGM");


var $3Jm25 = parcelRequire("3Jm25");


var $kC09O = parcelRequire("kC09O");

/* SectionEmptyState.tsx generated by @compiled/babel-plugin v3.0.2 */ 





const $8ba00a728dc0b537$var$styles = {
    container: "_0bjKvD8fU6 _4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _4kiQYAaXQy _37wbyuDIqT _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc",
    message: "_2sNsIgmnOE _3C14nsjBF4 _1UtDYzot27 _2fwxA5DIqT"
};
const $8ba00a728dc0b537$export$24bce80953fa3740 = ({ message: message, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8ba00a728dc0b537$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $8ba00a728dc0b537$var$styles.message
    }, message));





const $fc61a0da1ca0778a$export$ea801fe748451cc = 3;
const $fc61a0da1ca0778a$var$i18n = (0, $kSwu1.defineMessages)({
    agentAttribution: {
        id: "byline-connections.preview-panel.agent.attribution",
        defaultMessage: "with {name}"
    },
    heading: {
        id: "byline-connections.preview-panel.section.people-and-agents",
        defaultMessage: "People & Agents"
    },
    empty: {
        id: "byline-connections.preview-panel.section.people-and-agents.empty",
        defaultMessage: "There are no contributors yet. Relationships are mapped automatically as your team works together on this page. Start a conversation or share this page to strengthen your team\u2019s graph."
    }
});
const $fc61a0da1ca0778a$var$relationshipMessages = (0, $kSwu1.defineMessages)({
    created: {
        id: "byline-connections.preview-panel.person.relationship.created",
        defaultMessage: "Creator of this page"
    },
    contributed: {
        id: "byline-connections.preview-panel.person.relationship.contributed",
        defaultMessage: "Contributor of this page"
    },
    owns: {
        id: "byline-connections.preview-panel.person.relationship.owns",
        defaultMessage: "Owner of this page"
    },
    updated: {
        id: "byline-connections.preview-panel.person.relationship.updated",
        defaultMessage: "Editor of this page"
    },
    viewed: {
        id: "byline-connections.preview-panel.person.relationship.viewed",
        defaultMessage: "Viewer of this page"
    },
    favorited: {
        id: "byline-connections.preview-panel.person.relationship.favorited",
        defaultMessage: "Favoriter of this page"
    },
    liked: {
        id: "byline-connections.preview-panel.person.relationship.liked",
        defaultMessage: "Liker of this page"
    },
    'mentioned-in': {
        id: "byline-connections.preview-panel.person.relationship.mentioned-in",
        defaultMessage: "Mentionee of this page"
    },
    snapshotted: {
        id: "byline-connections.preview-panel.person.relationship.snapshotted",
        defaultMessage: "Snapshot creator of this page"
    },
    watches: {
        id: "byline-connections.preview-panel.person.relationship.watches",
        defaultMessage: "Watcher of this page"
    },
    'shared-with': {
        id: "byline-connections.preview-panel.person.relationship.shared-with",
        defaultMessage: "Recipient of this page"
    }
});
const $fc61a0da1ca0778a$var$messageForRelationship = (relationship)=>$fc61a0da1ca0778a$var$relationshipMessages[relationship];
/**
 * The person's profile in the people directory. Never `encodeURIComponent` the account id — the
 * colon in `70121:ed05…` is legal in a path, and `%3A` gives a URL the route cannot resolve.
 */ const $fc61a0da1ca0778a$var$profileUrl = (accountId)=>`/wiki/people/${accountId}?ref=confluence`;
/** Human rows open a profile; agent data does not supply a profile destination. */ const $fc61a0da1ca0778a$var$PersonListRow = ({ personOrAgent: personOrAgent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const colorMode = (0, $3EM6l.useAgentAvatarColorMode)();
    const attributedUser = personOrAgent.agent?.attributedUser;
    const onClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.PEOPLE_AND_AGENTS_ROW_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE),
                // The relationship tells us whether readers open authors or mere viewers.
                // Deliberately no name or account id — this payload carries no personal data.
                attributes: {
                    relationship: personOrAgent.primaryRelationship
                }
            }
        }).fire();
        // Graph Store can return a person with no account id. Record the press, but skip
        // navigation rather than send the reader to a dead `/wiki/people/`.
        if (!personOrAgent.accountId) return;
        window.open($fc61a0da1ca0778a$var$profileUrl(personOrAgent.accountId), '_blank', 'noopener,noreferrer');
    }, [
        createAnalyticsEvent,
        personOrAgent
    ]);
    const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4d154f3da73b0ad$export$2360cd0b07b95057), {
        // Hidden: `Avatar` labels itself with `name`, which the row already shows as text, so
        // without this the button announces the person twice. `name` stays for the initials.
        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true"
        }, personOrAgent.agent && attributedUser?.name.trim() ? // Omit identity IDs so these decorative avatars do not create profile-card actions.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fnCzB.AgentUserDualAvatar), {
            agentName: personOrAgent.name,
            agentAvatarUrl: personOrAgent.picture ?? undefined,
            agentIcon: personOrAgent.agent.agentIcon,
            userName: attributedUser.name,
            userAvatarUrl: attributedUser.avatarURL || undefined,
            size: "large",
            colorMode: colorMode
        }) : personOrAgent.agent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
            name: personOrAgent.name,
            avatarUrl: personOrAgent.picture ?? undefined,
            agentIcon: personOrAgent.agent.agentIcon,
            avatarSize: "medium",
            hasInlineSpacing: false,
            colorMode: colorMode
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: personOrAgent.picture ?? undefined,
            name: personOrAgent.name,
            size: "medium"
        })),
        name: personOrAgent.name,
        role: attributedUser?.name.trim() ? formatMessage($fc61a0da1ca0778a$var$i18n.agentAttribution, {
            name: attributedUser.name
        }) : formatMessage($fc61a0da1ca0778a$var$messageForRelationship(personOrAgent.primaryRelationship)),
        onClick: personOrAgent.agent ? undefined : onClick,
        // Keyed on the ARI, the only id `parsePagePeople` guarantees is present.
        testId: `teamwork-graph-person-row-${personOrAgent.ari}`
    });
    if (personOrAgent.agent) return row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: personOrAgent.accountId,
        fullName: personOrAgent.name,
        trigger: "hover",
        position: "left-start",
        fullWidthTrigger: true,
        // The row button owns focus and its accessible name; the card handles bubbled keys.
        disabledAriaAttributes: true
    }, row);
};
const $fc61a0da1ca0778a$export$89a2053dc433659f = ({ people: people, loading: loading, hasError: hasError, isExpanded: controlledExpanded, onToggleExpanded: onToggleExpanded })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [isExpanded, toggleExpanded] = (0, $bG6aJ.useExpandedState)(controlledExpanded, onToggleExpanded);
    const onToggle = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.PEOPLE_AND_AGENTS_SHOW_MORE_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE),
                // The direction of this press, not the state it was in — `true` is an expand.
                attributes: {
                    isExpanding: !isExpanded
                }
            }
        }).fire();
        toggleExpanded();
    }, [
        createAnalyticsEvent,
        isExpanded,
        toggleExpanded
    ]);
    // Nothing to show while discovery is in flight, and nothing to explain when it failed: an
    // error is not an empty graph, so the section stays out rather than claiming no one is here.
    if (people.length === 0 && (loading || hasError)) return null;
    const hasHiddenPeople = people.length > $fc61a0da1ca0778a$export$ea801fe748451cc;
    const listedPeople = isExpanded ? people : people.slice(0, $fc61a0da1ca0778a$export$ea801fe748451cc);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        testId: "teamwork-graph-people-and-agents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Jm25.SectionHeader), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
            label: "",
            color: "currentColor"
        }),
        label: formatMessage($fc61a0da1ca0778a$var$i18n.heading),
        count: people.length
    }), people.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ba00a728dc0b537$export$24bce80953fa3740), {
        message: formatMessage($fc61a0da1ca0778a$var$i18n.empty),
        testId: "teamwork-graph-people-and-agents-empty"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lkmGM.PressableGroup), {
        testId: "teamwork-graph-people-and-agents-group"
    }, listedPeople.map((personOrAgent)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fc61a0da1ca0778a$var$PersonListRow, {
            key: personOrAgent.ari,
            personOrAgent: personOrAgent
        })), hasHiddenPeople ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kC09O.ShowMoreRow), {
        isExpanded: isExpanded,
        onClick: onToggle,
        testId: "teamwork-graph-people-and-agents-show-more"
    }) : null));
};



/* SyncedFromSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $iMZH0 = parcelRequire("iMZH0");





var $e9QBI = parcelRequire("e9QBI");


var $idfQJ = parcelRequire("idfQJ");




const $bc447dd95fa0dc07$var$styles = {
    row: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn",
    headerIcon: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC"
};
const $bc447dd95fa0dc07$var$i18n = (0, $kSwu1.defineMessages)({
    syncedFrom: {
        id: "byline-connections.preview-panel.section.synced-from",
        defaultMessage: "Synced from"
    }
});
const $bc447dd95fa0dc07$export$ef217adc8b500549 = ({ connection: connection, isExpanded: isExpanded, onToggleExpanded: onToggleExpanded })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!connection) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bG6aJ.ConnectionsByLineSectionShell), {
        title: formatMessage($bc447dd95fa0dc07$var$i18n.syncedFrom),
        count: 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iMZH0))), {
            label: "",
            spacing: "none"
        }),
        trailing: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $bc447dd95fa0dc07$var$styles.headerIcon,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idfQJ.DevDocsScmProviderIcon), {
            provider: connection.provider
        })),
        isExpanded: isExpanded,
        onToggleExpanded: onToggleExpanded,
        testId: "teamwork-graph-preview-panel-synced-from-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bc447dd95fa0dc07$var$styles.row
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e9QBI.DevDocsConnectionRow), {
        connection: connection
    })));
};


const $79ecff49a6b66de2$var$styles = {
    connectionsColumn: "_2mHwu8NHnM _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc",
    card: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc _24h04i2Njc",
    linksGroup: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w",
    linksHeader: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    countBadge: "_0bjKvDcjp5 _2sNsIg7NXe _4c065UPgdg _2Y7lL41Y8M _3iDTPbQ4SZ _0jFU0Vey7F _4ouGXIoWWg _4kiQYAey7F _37wbyuDIqT _0hPCNLDIqT _3YEZNOdnbC _0KLXruG6qS _1UtDYzUktF _24h04i2Njc"
};
const $79ecff49a6b66de2$var$i18n = (0, $kSwu1.defineMessages)({
    links: {
        id: "byline-connections.preview-panel.links-header",
        defaultMessage: "Links"
    },
    linksEmpty: {
        id: "byline-connections.preview-panel.links-empty",
        defaultMessage: "This content isn\u2019t linked with anything yet."
    }
});

// view and the AI summary blocks with it. This component ships in the byline's after-paint chunk
// on every view page, so that section is a lazy boundary and loads once the panel or the modal
// mounts it. Nothing stands in while its chunk loads: the section is absent while its graph
// query is in flight anyway.
const $79ecff49a6b66de2$var$RelatedContentSection = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Rmsyo",
    name: "RelatedContentSection",
    loader: async ()=>(await (parcelRequire("iXlbG"))).RelatedContentSection
});
const $79ecff49a6b66de2$export$214f8ada772c6956 = ({ connections: connections, atAGlance: atAGlance, onPreviewOpen: onPreviewOpen, onAskRovo: onAskRovo, onAtAGlanceAskRovo: onAtAGlanceAskRovo, sectionExpansion: sectionExpansion })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const aiSummaries = (0, $cozmU.useMemo)(()=>(0, $fc4cd27910e257d3$export$4f955c0b5efa5938)(atAGlance.output), [
        atAGlance.output
    ]);
    const peopleAndAgentsLoading = connections.people.loading || connections.agentViewers.loading || connections.agentContributors.loading;
    const peopleAndAgentsHasError = Boolean(connections.people.error || connections.agentViewers.error || connections.agentContributors.error || connections.agentContributors.availability === 'unavailable'); // Resolves the controller to the controlled props a section forwards to its shell.
    // Returns nothing when uncontrolled, so the shell keeps owning the state.
    const expansionOf = (section)=>sectionExpansion ? {
            isExpanded: sectionExpansion.isExpanded(section),
            onToggleExpanded: ()=>sectionExpansion.toggle(section)
        } : {};
    const totalLinks = (connections.syncedFrom.connection ? 1 : 0) + connections.appearsIn.links.length + connections.linksTo.links.length;
    const hasMore = connections.appearsIn.hasNextPage; // The card is replaced by the empty state only once the one slice that could still fill it
    // has settled; "Links to" and "Synced from" are read synchronously, so they never wait. A
    // failed incoming query is not an empty graph, so the card stays for that too.
    const hasNoLinks = totalLinks === 0 && !connections.appearsIn.loading && !connections.appearsIn.error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $79ecff49a6b66de2$var$styles.connectionsColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ded8c84d6983c5$export$d7d0920f7a8ebe0d), {
        ...atAGlance,
        onAskRovo: onAtAGlanceAskRovo
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($79ecff49a6b66de2$var$RelatedContentSection, {
        ...connections.relatedContent,
        aiSummaries: aiSummaries,
        onPreviewOpen: onPreviewOpen,
        onAskRovo: onAskRovo,
        ...expansionOf('relatedContent')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $79ecff49a6b66de2$var$styles.linksGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $79ecff49a6b66de2$var$styles.linksHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold",
        color: "color.text"
    }, formatMessage($79ecff49a6b66de2$var$i18n.links)), totalLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $79ecff49a6b66de2$var$styles.countBadge
        ])
    }, totalLinks, hasMore ? '+' : null) : null), hasNoLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ba00a728dc0b537$export$24bce80953fa3740), {
        message: formatMessage($79ecff49a6b66de2$var$i18n.linksEmpty),
        testId: "teamwork-graph-preview-panel-links-empty"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $79ecff49a6b66de2$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc447dd95fa0dc07$export$ef217adc8b500549), {
        ...connections.syncedFrom,
        ...expansionOf('syncedFrom')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ed3b9e6215820af$export$696cfca056e338c6), {
        ...connections.appearsIn,
        onPreviewOpen: onPreviewOpen,
        onAskRovo: onAskRovo,
        ...expansionOf('appearsIn')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e66409e8a5c11d6d$export$f7d0d6af791d1bb), {
        ...connections.linksTo,
        onPreviewOpen: onPreviewOpen,
        onAskRovo: onAskRovo,
        ...expansionOf('linksTo')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fc61a0da1ca0778a$export$89a2053dc433659f), {
        people: connections.people.peopleAndAgents,
        loading: peopleAndAgentsLoading,
        hasError: peopleAndAgentsHasError,
        ...expansionOf('people')
    }));
};
module.exports["ConnectionSections"] = $79ecff49a6b66de2$export$214f8ada772c6956;

});

parcelRegister("bG6aJ", function(module, exports) {
/* ConnectionsByLineSectionShell.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");


var $xICd5 = parcelRequire("xICd5");

const $b63cd2ec09ae1c0c$var$MAX_BODY_HEIGHT = '306px';
const $b63cd2ec09ae1c0c$var$wrapperStyles = null;
const $b63cd2ec09ae1c0c$var$styles = {
    header: "_2mHwu81Y8M _2sNsIgmnOE _0bjKvDKxmn _4c065UPgdg _2Y7lL4Pgdg _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _0jFU0VUofl _0KLXrujOvk _0wOv4Q7zJH _1UtDYzy7kJ _2fwxA5ecOK",
    iconBefore: "_4c065U1Y8M _2Y7lL41Y8M _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _24h04i2Njc _3YEZNOdnbC",
    titleGroup: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu82ADO _3iDTPbQ4SZ _4ouGXIdnbC _0hPCNLDIqT",
    titleText: "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1UtDYzy7kJ _1ANEUSLRg7 _39HuIbz8Lp",
    trailing: "_2mHwu82ADO _3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC",
    chevron: "_4c065U1Y8M _2Y7lL41Y8M _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _24h04i2Njc _3YEZNOdnbC",
    body: "_2mHwu81Y8M _3iDTPbgBM8 _21ioM3W9qI _0NUa3rc7VA _2WAcuGIZbP"
};
const $b63cd2ec09ae1c0c$var$ChevronIcon = ({ isExpanded: isExpanded })=>isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        spacing: "none"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        spacing: "none"
    }); /**
                                                                                                                                                                                                                     * The section's expanded state and the handler that flips it, in one of two modes — the
                                                                                                                                                                                                                     * same controlled/uncontrolled split as a React `<input>`:
                                                                                                                                                                                                                     *
                                                                                                                                                                                                                     * - Controlled: `controlledExpanded` is passed, so the caller owns the state and the
                                                                                                                                                                                                                     *   handler defers to `onToggle`. The modal uses this to hold the state above the swap to
                                                                                                                                                                                                                     *   Rovo, so a section stays expanded across it.
                                                                                                                                                                                                                     * - Uncontrolled: neither is passed, so the hook owns the state (starting from
                                                                                                                                                                                                                     *   `defaultExpanded`, collapsed unless a section opts in) and the handler flips it.
                                                                                                                                                                                                                     *   The panel and popup use this; "At a glance" is the opt-in.
                                                                                                                                                                                                                     *
                                                                                                                                                                                                                     * Exported because `PeopleAndAgentsSection` needs the same split without the rest of the shell:
                                                                                                                                                                                                                     * it is a `PressableGroup`, not a collapsible body, so it discloses extra rows rather than
                                                                                                                                                                                                                     * hiding all of them. Keep one implementation of the split rather than two.
                                                                                                                                                                                                                     */ 
const $b63cd2ec09ae1c0c$export$47360455f9bb4561 = (controlledExpanded, onToggle, defaultExpanded = false)=>{
    const [uncontrolledExpanded, setUncontrolledExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const isControlled = controlledExpanded !== undefined;
    const toggle = (0, $cozmU.useCallback)(()=>{
        if (isControlled) onToggle?.();
        else setUncontrolledExpanded((prev)=>!prev);
    }, [
        isControlled,
        onToggle
    ]);
    return [
        isControlled ? controlledExpanded : uncontrolledExpanded,
        toggle
    ];
}; /**
    * Chrome for an expandable preview-panel section, with no opinion on what the body
    * contains: `ConnectionsByLineSection` wraps this to render smart-link rows, other
    * callers supply their own.
    *
    * The body is capped and scrolls, so a long section cannot push the ones below it
    * out of view.
    */ 
const $b63cd2ec09ae1c0c$export$8bedf248b7e9989d = ({ title: title, count: count, hasMore: hasMore = false, iconBefore: iconBefore, trailing: trailing, children: children, bodyRef: bodyRef, defaultExpanded: defaultExpanded = false, isExpanded: controlledExpanded, onToggleExpanded: onToggleExpanded, testId: testId })=>{
    const [isExpanded, handleClick] = $b63cd2ec09ae1c0c$export$47360455f9bb4561(controlledExpanded, onToggleExpanded, defaultExpanded);
    const id = (0, $cozmU.useId)();
    const headerId = `${id}-header`;
    const bodyId = `${id}-body`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _3mHaMX9r67 _2yjt2x6wH8 _4auqkJNvrM _0KLXrulfZc _24h04i2Njc _1JRIqYdnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        id: headerId,
        "aria-expanded": isExpanded,
        "aria-controls": bodyId,
        onClick: handleClick,
        xcss: $b63cd2ec09ae1c0c$var$styles.header,
        testId: testId ? `${testId}--header` : undefined
    }, iconBefore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $b63cd2ec09ae1c0c$var$styles.iconBefore
        ])
    }, iconBefore) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $b63cd2ec09ae1c0c$var$styles.titleGroup
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $b63cd2ec09ae1c0c$var$styles.titleText
        ])
    }, title), count !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $xICd5.SectionCountBadge), {
        count: count,
        hasMore: hasMore && count > 0
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $b63cd2ec09ae1c0c$var$styles.trailing
        ])
    }, trailing, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $b63cd2ec09ae1c0c$var$styles.chevron
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b63cd2ec09ae1c0c$var$ChevronIcon, {
        isExpanded: isExpanded
    })))), isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: bodyRef,
        id: bodyId,
        role: "region",
        "aria-labelledby": headerId,
        tabIndex: 0,
        xcss: $b63cd2ec09ae1c0c$var$styles.body,
        testId: testId ? `${testId}--body` : undefined
    }, children) : null);
};
module.exports["useExpandedState"] = $b63cd2ec09ae1c0c$export$47360455f9bb4561;
module.exports["ConnectionsByLineSectionShell"] = $b63cd2ec09ae1c0c$export$8bedf248b7e9989d;

});

parcelRegister("lkmGM", function(module, exports) {
/* PressableGroup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $c4a4c0e327cf4b83$var$styles = {
    container: "_0bjKvD8fU6 _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _0KLXrulfZc _24h04i2Njc",
    row: "_4ouGXIdnbC",
    firstRow: "_2C2kUQ8fU6 _1Lz9lo8fU6",
    lastRow: "_1v9SsV8fU6 _3XDz3B8fU6",
    divider: "_3zygPU9r67 _2IVJ4M6wH8 _22sfPnNvrM"
};
const $c4a4c0e327cf4b83$export$25678a1bf665462c = ({ children: children, testId: testId })=>{
    const rows = (0, $cozmU.Children).toArray(children);
    const lastIndex = rows.length - 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c4a4c0e327cf4b83$var$styles.container,
        testId: testId
    }, rows.map((row, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line react/no-array-index-key -- `Children.toArray` keys every element it returns, so element rows reuse that key; index is only the fallback for the strings and numbers it passes through unkeyed.
        , {
            key: /*#__PURE__*/ (0, $cozmU.isValidElement)(row) ? row.key ?? index : index,
            // asserting the group's shape needs to reach.
            "data-testid": testId ? `${testId}--row-${index}` : undefined,
            className: (0, $hekY6.default)([
                $c4a4c0e327cf4b83$var$styles.row,
                index === 0 && $c4a4c0e327cf4b83$var$styles.firstRow,
                index === lastIndex && $c4a4c0e327cf4b83$var$styles.lastRow,
                index > 0 && $c4a4c0e327cf4b83$var$styles.divider
            ])
        }, row)));
};
module.exports["PressableGroup"] = $c4a4c0e327cf4b83$export$25678a1bf665462c;

});

parcelRegister("3Jm25", function(module, exports) {
/* SectionHeader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $xICd5 = parcelRequire("xICd5");

const $87914a6ea05af414$var$styles = {
    header: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    label: "_2sNsIgmnOE _1kk5Tk7GSX _1UtDYzy7kJ"
};
const $87914a6ea05af414$export$8adb256d999cd5a0 = ({ icon: icon, label: label, count: count })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $87914a6ea05af414$var$styles.header
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $87914a6ea05af414$var$styles.label
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $xICd5.SectionCountBadge), {
        count: count
    }));
module.exports["SectionHeader"] = $87914a6ea05af414$export$8adb256d999cd5a0;

});

parcelRegister("iXlbG", function(module, exports) {

let $dcce2c1593c59c48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dcce2c1593c59c48$var$load("abBST"),
    $dcce2c1593c59c48$var$load("6wr18"),
    $dcce2c1593c59c48$var$load("kfGHh"),
    $dcce2c1593c59c48$var$load("lIiD7"),
    $dcce2c1593c59c48$var$load("ffEVr"),
    $dcce2c1593c59c48$var$load("4qYqO")
]).then(()=>parcelRequire('fBexU'));

});

parcelRegister("bT2y0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $6683769cb9483b95$var$i18n = (0, $kSwu1.defineMessages)({
    promptHeading: {
        id: "byline-connections.preview-panel.modal.ask-rovo-links-prompt-heading",
        defaultMessage: "Fetch the content behind each of these links and use it as context for subsequent tasks:"
    }
});
const $6683769cb9483b95$export$62c77a9657de28e5 = (connections)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>{
        const links = [
            ...connections.appearsIn.links,
            ...connections.linksTo.links,
            ...connections.relatedContent.links
        ];
        const urls = new Set();
        for (const { url: url } of links)if (url) urls.add(url);
        return urls.size ? [
            formatMessage($6683769cb9483b95$var$i18n.promptHeading),
            ...[
                ...urls
            ].map((url, index)=>`${index + 1}. ${url}`)
        ].join('\n') : null;
    }, [
        connections,
        formatMessage
    ]);
};
module.exports["useLinksContextPrompt"] = $6683769cb9483b95$export$62c77a9657de28e5;

});

parcelRegister("1TLbr", function(module, exports) {

let $161f872732118225$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $161f872732118225$var$load("9CFD7"),
    $161f872732118225$var$load("2beqm"),
    $161f872732118225$var$load("6THhx"),
    $161f872732118225$var$load("k0Z8C"),
    $161f872732118225$var$load("60PUI"),
    $161f872732118225$var$load("1xeJ3"),
    $161f872732118225$var$load("abBST"),
    $161f872732118225$var$load("bx9z9")
]).then(()=>parcelRequire('hECmq'));

});

parcelRegister("5tMCB", function(module, exports) {
/* TeamworkGraphChatColumn.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $kdlgT = parcelRequire("kdlgT");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $fGDv8 = parcelRequire("fGDv8");


var $zCcSI = parcelRequire("zCcSI");

const $2471d2fa1075b3d2$var$BASE_UI_CONFIG = {
    externalEmbed: true,
    fullScreen: false,
    // Open on a fresh backend-backed conversation (created inside the chat's own store
    // container) instead of the shared EMPTY_CONVERSATION_ID, so the first send performs no
    // EMPTY→real transition that rebuilds the chat and re-seeds the prompt, and each open gets a
    // unique draft slot. The behaviour is experiment-gated inside conversation-assistant.
    createConversationOnMount: {
        followUpSource: 'teamworkGraphByline'
    },
    elements: {
        mainChatHeader: false,
        navbar: false,
        closeButton: false,
        fullscreenButton: false,
        newChatButton: false,
        createAgentButton: false,
        browseAgentsButton: false,
        agentsMenu: false,
        stagingAreaEnabled: false
    }
};
const $2471d2fa1075b3d2$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _4kiQYAdnbC",
    header: "_4c065U5zaO _2Y7lL4kG2W _3YEZNOdnbC _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT",
    chat: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4kiQYAdnbC"
};
const $2471d2fa1075b3d2$var$i18n = (0, $kSwu1.defineMessages)({
    heading: {
        id: "byline-connections.preview-panel.modal.rovo-column.heading",
        defaultMessage: "Rovo"
    },
    backLabel: {
        id: "byline-connections.preview-panel.modal.rovo-column.back-label",
        defaultMessage: "Back to connections"
    }
});
function $2471d2fa1075b3d2$export$8fbab62a7f19201d({ onBack: onBack, prefilledPrompt: prefilledPrompt }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const config = (0, $zCcSI.useConversationAssistantConfig)({
        preventAbortRequestsOnStandaloneChatClose: true
    });
    const uiConfig = (0, $cozmU.useMemo)(()=>prefilledPrompt ? {
            ...$2471d2fa1075b3d2$var$BASE_UI_CONFIG,
            initialPromptText: prefilledPrompt,
            // Without this, `initialPromptText` is only applied for users in the
            // `cc_ai_growth_welcome_from_rovo` experiment.
            shouldSeedInitialPromptText: true
        } : $2471d2fa1075b3d2$var$BASE_UI_CONFIG, [
        prefilledPrompt
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2471d2fa1075b3d2$var$styles.root,
        testId: "teamwork-graph-modal-rovo-column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2471d2fa1075b3d2$var$styles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: formatMessage($2471d2fa1075b3d2$var$i18n.backLabel),
        appearance: "subtle",
        spacing: "compact",
        shape: "circle",
        onClick: onBack,
        testId: "teamwork-graph-modal-rovo-back"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage($2471d2fa1075b3d2$var$i18n.heading)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2471d2fa1075b3d2$var$styles.chat
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fGDv8.default), {
        testId: "teamwork-graph-modal-chat",
        config: config,
        uiConfig: uiConfig
    })));
}
module.exports["TeamworkGraphChatColumn"] = $2471d2fa1075b3d2$export$8fbab62a7f19201d;

});

parcelRegister("6ckMU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $jC4nA = parcelRequire("jC4nA");


var $I7TEB = parcelRequire("I7TEB");


var $jmjWc = parcelRequire("jmjWc");


const $9b0607d973efc2a0$export$b7ebe10419fd4a15 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "m-mIv",
    name: "ShareContextModalLoadable",
    loader: async ()=>(await (parcelRequire("fSH0R"))).ShareContextModal
});



var $bEvUu = parcelRequire("bEvUu");

const $475879d9027932e9$var$i18n = (0, $kSwu1.defineMessages)({
    shareWithAgent: {
        id: "byline-connections.preview-panel.header.share-with-agent",
        defaultMessage: "Share with agent"
    }
});
function $475879d9027932e9$export$b674a24ba120da05({ contentId: contentId, testId: testId = 'teamwork-graph-modal-share-context', onOpen: onOpen, source: source = (0, $I7TEB.ANALYTICS_SOURCE), onAskRovo: onAskRovo }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [hasOpenedModal, setHasOpenedModal] = (0, $cozmU.useState)(false);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.SHARE_CONTEXT_ACTION_SUBJECT_ID),
                source: source
            }
        }).fire();
        if (onOpen) {
            onOpen();
            return;
        }
        setHasOpenedModal(true);
        setIsModalOpen(true);
    }, [
        createAnalyticsEvent,
        onOpen,
        source
    ]);
    const closeModal = (0, $cozmU.useCallback)(()=>setIsModalOpen(false), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
        onClick: handleClick,
        testId: testId
    }, formatMessage($475879d9027932e9$var$i18n.shareWithAgent)), hasOpenedModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9b0607d973efc2a0$export$b7ebe10419fd4a15), {
        isOpen: isModalOpen,
        onClose: closeModal,
        contentId: contentId,
        onAskRovo: onAskRovo
    }));
}
module.exports["TeamworkGraphShareContextButton"] = $475879d9027932e9$export$b674a24ba120da05;

});

parcelRegister("fSH0R", function(module, exports) {

let $b8fd43a47c568c13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b8fd43a47c568c13$var$load("2hPbk"),
    $b8fd43a47c568c13$var$load("icYyL"),
    $b8fd43a47c568c13$var$load("abBST"),
    $b8fd43a47c568c13$var$load("fKQ9j"),
    $b8fd43a47c568c13$var$load("hhss7"),
    $b8fd43a47c568c13$var$load("Nr0vr")
]).then(()=>parcelRequire('casUE'));

});

parcelRegister("aKxcs", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<b75dcd816ce4b8bd73313cd50a946812>>
 * @relayHash 5d29dbb06afa46621e34f49131b3f839
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f47dc690f4d212f9c3ec615c12da22fb42b20f4278924ecd25cbbba4d12671c
const $64132a3f8ab78d31$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BylineClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BylineClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "5d29dbb06afa46621e34f49131b3f839",
            "id": "1f47dc690f4d212f9c3ec615c12da22fb42b20f4278924ecd25cbbba4d12671c",
            "metadata": {},
            "name": "BylineClassificationQuery",
            "operationKind": "query",
            "text": "query BylineClassificationQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,title,operations{operation,targetType},space{id,name,key,alias},type,status}}}"
        }
    };
}();
$64132a3f8ab78d31$var$node.hash = "e42e71a5c3870b4bc1b88d032b366270";
var $64132a3f8ab78d31$export$2e2bcd8739ae039 = $64132a3f8ab78d31$var$node;


/**
 * @generated SignedSource<<cec9d6bf228902cf556f738cdfea5739>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87d62e4cd7f32dc5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useClassificationLevelV2"
            }
        ],
        "kind": "Fragment",
        "name": "BylineClassification_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "alias"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "useClassificationLevelV2",
                        "variableName": "useClassificationLevelV2"
                    }
                ],
                "kind": "FragmentSpread",
                "name": "useContentClassification_content"
            }
        ],
        "type": "Content"
    };
}();
$87d62e4cd7f32dc5$var$node.hash = "4d2a0647887ac7997f379b0d32c129ab";
var $87d62e4cd7f32dc5$export$2e2bcd8739ae039 = $87d62e4cd7f32dc5$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jMyy4 = parcelRequire("jMyy4");


var $cuWTe = parcelRequire("cuWTe");


var $1ggpj = parcelRequire("1ggpj");


var $3u0dr = parcelRequire("3u0dr");








var $hekY6 = parcelRequire("hekY6");


var $jmjWc = parcelRequire("jmjWc");


const $200528ba24c995ad$export$b3d0b57fae17761b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fcpuS",
    name: "ContentTypeClassificationLoader",
    loader: async ()=>(await (parcelRequire("8bE4L"))).ContentTypeClassification,
    loading: (props)=>{
        const { contentClassificationMetadata: contentClassificationMetadata } = props;
        const { hasNoClassification: hasNoClassification } = contentClassificationMetadata;
        const shouldNotRenderLoader = hasNoClassification;
        if (shouldNotRenderLoader) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
            const $ = (0, $bDgLe.c)(13);
            let T0;
            let t1;
            let t2;
            let t3;
            let t4;
            if ($[0] !== __cmplr || $[1] !== t0) {
                const { as: t5, style: __cmpls, ...__cmplp } = t0;
                const C = t5 === undefined ? "div" : t5;
                T0 = C;
                t1 = __cmplp;
                t2 = __cmpls;
                t3 = __cmplr;
                t4 = (0, $hekY6.default)([
                    "_0jFU0VoWWg",
                    __cmplp.className
                ]);
                $[0] = __cmplr;
                $[1] = t0;
                $[2] = T0;
                $[3] = t1;
                $[4] = t2;
                $[5] = t3;
                $[6] = t4;
            } else {
                T0 = $[2];
                t1 = $[3];
                t2 = $[4];
                t3 = $[5];
                t4 = $[6];
            }
            let t5;
            if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
                    ...t1,
                    style: t2,
                    ref: t3,
                    className: t4
                });
                $[7] = T0;
                $[8] = t1;
                $[9] = t2;
                $[10] = t3;
                $[11] = t4;
                $[12] = t5;
            } else t5 = $[12];
            return t5;
        } : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $hekY6.default)([
                    "_0jFU0VoWWg",
                    __cmplp.className
                ])
            });
        }), {}, '');
    }
});



var $knzfV = parcelRequire("knzfV");


var $1u6lx = parcelRequire("1u6lx");


var $bFMG7 = parcelRequire("bFMG7");





var $b3j2Y = parcelRequire("b3j2Y");


var $jjv3l = parcelRequire("jjv3l");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $5278cea226e8a354$export$84b0a317f0d2e2ff = (0, $87d62e4cd7f32dc5$export$2e2bcd8739ae039);
const $5278cea226e8a354$export$5dc05a3e9ee4399c = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { contentId: contentId, classificationContextFragmentRef: classificationContextFragmentRef, contentFragmentRef: contentFragmentRef } = t0;
    if (classificationContextFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_classification_context_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t1;
        if ($[0] !== classificationContextFragmentRef || $[1] !== contentId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContextFragmentReader, {
                contentId: contentId,
                contentFragmentRef: classificationContextFragmentRef
            });
            $[0] = classificationContextFragmentRef;
            $[1] = contentId;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== contentFragmentRef || $[4] !== contentId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationLegacyQueryReader, {
            contentId: contentId,
            contentFragmentRef: contentFragmentRef
        });
        $[3] = contentFragmentRef;
        $[4] = contentId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $5278cea226e8a354$var$BylineClassificationContextFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { contentId: contentId, contentFragmentRef: contentFragmentRef } = t0;
    const contentData = (0, $6SsN4.useFragment)($5278cea226e8a354$export$84b0a317f0d2e2ff, contentFragmentRef);
    const readerProps = $5278cea226e8a354$var$useBylineClassificationReaderProps(contentId, contentData);
    let t1;
    if ($[0] !== contentData || $[1] !== contentId || $[2] !== readerProps.contentStatusContext) {
        t1 = {
            contentId: contentId,
            contentFragmentRef: contentData,
            contentStatusContext: readerProps.contentStatusContext,
            shouldReadFromQueries: true
        };
        $[0] = contentData;
        $[1] = contentId;
        $[2] = readerProps.contentStatusContext;
        $[3] = t1;
    } else t1 = $[3];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassificationFromFragment)(t1);
    let t2;
    if ($[4] !== contentClassificationMetadata || $[5] !== readerProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContent, {
            ...readerProps,
            contentClassificationMetadata: contentClassificationMetadata
        });
        $[4] = contentClassificationMetadata;
        $[5] = readerProps;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $5278cea226e8a354$var$BylineClassificationLegacyQueryReader = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { contentId: contentId, contentFragmentRef: contentFragmentRef } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: bylineClassificationQueryError } = (0, $jMyy4.useQueryInterop)((0, $64132a3f8ab78d31$export$2e2bcd8739ae039), {
        ...t1,
        __callerPackage__: "content-header"
    });
    const contentData = data?.content?.nodes?.[0];
    const readerProps = $5278cea226e8a354$var$useBylineClassificationReaderProps(contentId, contentData);
    if (bylineClassificationQueryError) {
        let t2;
        if ($[2] !== bylineClassificationQueryError) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: bylineClassificationQueryError
            });
            $[2] = bylineClassificationQueryError;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    if (contentFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_meta_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t2;
        if ($[4] !== contentFragmentRef || $[5] !== readerProps) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationMetadataFragmentReader, {
                ...readerProps,
                contentFragmentRef: contentFragmentRef
            });
            $[4] = contentFragmentRef;
            $[5] = readerProps;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    let t2;
    if ($[7] !== readerProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationMetadataQueryReader, readerProps);
        $[7] = readerProps;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
const $5278cea226e8a354$var$useBylineClassificationReaderProps = (contentId, contentData)=>{
    const $ = (0, $bDgLe.c)(19);
    const isExternal = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const rawContentType = contentData?.type ?? undefined;
    const isArchived = contentData?.status === "archived";
    const isDraft = contentData?.status === "draft";
    const isViewEditOrLive = (0, $aSsfA.useGetPageMode)();
    let t0;
    if ($[0] !== isArchived || $[1] !== isDraft || $[2] !== isViewEditOrLive || $[3] !== rawContentType) {
        t0 = (0, $cuWTe.getContentMode)(rawContentType, isArchived, isDraft, isViewEditOrLive) || isViewEditOrLive || (0, $cD1qu.PageMode).VIEW;
        $[0] = isArchived;
        $[1] = isDraft;
        $[2] = isViewEditOrLive;
        $[3] = rawContentType;
        $[4] = t0;
    } else t0 = $[4];
    const contentMode = t0;
    let t1;
    if ($[5] !== contentMode || $[6] !== rawContentType) {
        t1 = {
            type: rawContentType,
            mode: contentMode
        };
        $[5] = contentMode;
        $[6] = rawContentType;
        $[7] = t1;
    } else t1 = $[7];
    const contentType = t1;
    let contentStatusContext;
    if (contentType.mode === "live" || contentType.mode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false)) contentStatusContext = "current-and-draft";
    else if (contentType.mode === "edit" || contentType.mode === "draft") contentStatusContext = "draft-only";
    else contentStatusContext = "current-only";
    const t2 = contentData?.space?.key || "";
    const t3 = contentData?.space?.key;
    let t4;
    if ($[8] !== contentType.mode) {
        t4 = contentType.mode === (0, $cD1qu.PageMode).VIEW && !(0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
        $[8] = contentType.mode;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== contentData || $[11] !== contentId || $[12] !== contentStatusContext || $[13] !== contentType || $[14] !== isExternal || $[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
        t5 = {
            contentId: contentId,
            spaceKey: t2,
            spaceKeyOverride: t3,
            contentData: contentData,
            contentType: contentType,
            contentStatusContext: contentStatusContext,
            isExternal: isExternal,
            isViewModeReadOnly: t4
        };
        $[10] = contentData;
        $[11] = contentId;
        $[12] = contentStatusContext;
        $[13] = contentType;
        $[14] = isExternal;
        $[15] = t2;
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
};
const $5278cea226e8a354$var$BylineClassificationMetadataQueryReader = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let contentId;
    let props;
    let spaceKeyOverride;
    if ($[0] !== t0) {
        ({ contentId: contentId, spaceKeyOverride: spaceKeyOverride, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = props;
        $[3] = spaceKeyOverride;
    } else {
        contentId = $[1];
        props = $[2];
        spaceKeyOverride = $[3];
    }
    let t1;
    if ($[4] !== contentId || $[5] !== props.contentStatusContext || $[6] !== spaceKeyOverride) {
        t1 = {
            contentId: contentId,
            spaceKeyOverride: spaceKeyOverride,
            contentStatusContext: props.contentStatusContext,
            shouldReadFromQueries: true
        };
        $[4] = contentId;
        $[5] = props.contentStatusContext;
        $[6] = spaceKeyOverride;
        $[7] = t1;
    } else t1 = $[7];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)(t1);
    let t2;
    if ($[8] !== contentClassificationMetadata || $[9] !== contentId || $[10] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContent, {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata,
            ...props
        });
        $[8] = contentClassificationMetadata;
        $[9] = contentId;
        $[10] = props;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};
const $5278cea226e8a354$var$BylineClassificationMetadataFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let contentFragmentRef;
    let contentId;
    let props;
    if ($[0] !== t0) {
        ({ contentId: contentId, contentFragmentRef: contentFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = contentFragmentRef;
        $[2] = contentId;
        $[3] = props;
    } else {
        contentFragmentRef = $[1];
        contentId = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== contentFragmentRef || $[5] !== contentId || $[6] !== props.contentStatusContext) {
        t1 = {
            contentId: contentId,
            contentFragmentRef: contentFragmentRef,
            contentStatusContext: props.contentStatusContext,
            shouldReadFromQueries: true
        };
        $[4] = contentFragmentRef;
        $[5] = contentId;
        $[6] = props.contentStatusContext;
        $[7] = t1;
    } else t1 = $[7];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassificationFromFragment)(t1);
    let t2;
    if ($[8] !== contentClassificationMetadata || $[9] !== contentId || $[10] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContent, {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata,
            ...props
        });
        $[8] = contentClassificationMetadata;
        $[9] = contentId;
        $[10] = props;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};
const $5278cea226e8a354$var$BylineClassificationContent = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId, spaceKey: spaceKey, contentData: contentData, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, isExternal: isExternal, isViewModeReadOnly: isViewModeReadOnly } = t0;
    let t1;
    if ($[0] !== contentClassificationMetadata.isReclassificationPermitted || $[1] !== contentData?.operations) {
        t1 = (0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false) ? contentClassificationMetadata.isReclassificationPermitted ?? false : contentData?.operations?.some($5278cea226e8a354$var$_temp);
        $[0] = contentClassificationMetadata.isReclassificationPermitted;
        $[1] = contentData?.operations;
        $[2] = t1;
    } else t1 = $[2];
    const hasUpdatePermission = t1;
    const readOnly = isExternal || !hasUpdatePermission || isViewModeReadOnly;
    const isClassificationEnabled = contentClassificationMetadata.featureEnabled ?? false;
    let t2;
    if ($[3] !== contentClassificationMetadata || $[4] !== contentId || $[5] !== contentType || $[6] !== isClassificationEnabled || $[7] !== readOnly || $[8] !== spaceKey) {
        t2 = isClassificationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $200528ba24c995ad$export$b3d0b57fae17761b), {
            variant: (0, $1u6lx.TagButtonUIVariant).default,
            spaceKey: spaceKey,
            contentId: contentId,
            contentType: contentType.type ?? "",
            contentClassificationMetadata: contentClassificationMetadata,
            readOnly: readOnly,
            spacing: "expanded"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knzfV.ClassificationEditModal), {
            contentId: contentId,
            spaceKey: spaceKey,
            contentClassificationMetadata: contentClassificationMetadata
        })) : null;
        $[3] = contentClassificationMetadata;
        $[4] = contentId;
        $[5] = contentType;
        $[6] = isClassificationEnabled;
        $[7] = readOnly;
        $[8] = spaceKey;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
};
function $5278cea226e8a354$var$_temp(operation) {
    return operation?.targetType && (0, $1ggpj.VALID_OPERATION_TARGETS).includes(operation.targetType) && operation.operation === "update";
}
module.exports["BylineClassification"] = $5278cea226e8a354$export$5dc05a3e9ee4399c;

});

parcelRegister("8bE4L", function(module, exports) {

let $5f5e7005a7b09987$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5f5e7005a7b09987$var$load("kT6dz"),
    $5f5e7005a7b09987$var$load("6wr18"),
    $5f5e7005a7b09987$var$load("ffEVr"),
    $5f5e7005a7b09987$var$load("hhss7"),
    $5f5e7005a7b09987$var$load("cGkFm"),
    $5f5e7005a7b09987$var$load("aqMLH"),
    $5f5e7005a7b09987$var$load("ctdyb"),
    $5f5e7005a7b09987$var$load("abBST"),
    $5f5e7005a7b09987$var$load("4Oj5y")
]).then(()=>parcelRequire('2JKSZ'));

});

parcelRegister("6iOCg", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kmQhR = parcelRequire("kmQhR");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $1LXnB = parcelRequire("1LXnB");


var $jVylI = parcelRequire("jVylI");


var $aV3a0 = parcelRequire("aV3a0");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $jjv3l = parcelRequire("jjv3l");


var $6mKj3 = parcelRequire("6mKj3");


var $gektR = parcelRequire("gektR");


var $1P7Cq = parcelRequire("1P7Cq");


var $1xpoY = parcelRequire("1xpoY");








var $8wW9d = parcelRequire("8wW9d");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");

const $e105dde0a43b3be2$export$b613c53a0aeac846 = (contentId)=>{
    const $ = (0, $bDgLe.c)(15);
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    const { webItems: connectItems, loading: loadingConnectItems, error: connectError } = (0, $6ld6a.useWebItemLocation)(t0);
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
        };
        $[2] = t1;
    } else t1 = $[2];
    const { extensions: forgeItems, loading: loadingForgeItems, error: forgeError } = (0, $3b6WO.useExtensionList)(t1);
    let t2;
    let t3;
    if ($[3] !== connectItems || $[4] !== forgeItems) {
        t2 = ()=>{
            (0, $8wW9d.recordNonContentAppKeys)("byline", [
                ...connectItems?.map($e105dde0a43b3be2$var$_temp) ?? [],
                ...forgeItems?.map($e105dde0a43b3be2$var$_temp2) ?? []
            ]);
        };
        t3 = [
            connectItems,
            forgeItems
        ];
        $[3] = connectItems;
        $[4] = forgeItems;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = connectItems?.length > 0 || forgeItems?.length > 0;
    let t5;
    if ($[7] !== connectError || $[8] !== connectItems || $[9] !== forgeError || $[10] !== forgeItems || $[11] !== loadingConnectItems || $[12] !== loadingForgeItems || $[13] !== t4) {
        t5 = {
            hasApps: t4,
            connectItems: connectItems,
            loadingConnectItems: loadingConnectItems,
            connectError: connectError,
            forgeItems: forgeItems,
            loadingForgeItems: loadingForgeItems,
            forgeError: forgeError
        };
        $[7] = connectError;
        $[8] = connectItems;
        $[9] = forgeError;
        $[10] = forgeItems;
        $[11] = loadingConnectItems;
        $[12] = loadingForgeItems;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
function $e105dde0a43b3be2$var$_temp(item) {
    return item.completeKey;
}
function $e105dde0a43b3be2$var$_temp2(item_0) {
    return item_0.id;
}



var $j2moL = parcelRequire("j2moL");


var $35Exc = parcelRequire("35Exc");








var $kSwu1 = parcelRequire("kSwu1");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $1sCHt = parcelRequire("1sCHt");


var $3izAL = parcelRequire("3izAL");


var $kh0hi = parcelRequire("kh0hi");




const $120e402a2d601a31$var$i18n = (0, $kSwu1.defineMessages)({
    showAllApps: {
        id: "content-header.livepages.by-line.showAllApps",
        defaultMessage: "Show all apps"
    },
    showLessApps: {
        id: "content-header.livepages.by-line.showLess",
        defaultMessage: "Show less"
    }
});
const $120e402a2d601a31$var$toggleButtonGradientStyles = (0, $buxP3.xcss)({
    height: '100%',
    position: 'relative',
    '::before': {
        content: '""',
        background: `linear-gradient(to right, transparent, ${"var(--ds-surface, #FFFFFF)"})`,
        height: '100%',
        left: 'space.negative.400',
        position: 'absolute',
        width: '32px'
    }
});
const $120e402a2d601a31$var$buttonStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: "var(--ds-radius-small, 4px)",
    color: 'color.text.subtle',
    display: 'flex',
    font: 'font.body.small',
    gap: 'space.075',
    padding: 'space.050',
    paddingInlineStart: 'space.075',
    paddingInlineEnd: 'space.075',
    whiteSpace: 'nowrap',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $120e402a2d601a31$export$a2051cde2c49a6fb = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isExpanded: isExpanded, handleToggle: handleToggle } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const t1 = !isExpanded && $120e402a2d601a31$var$toggleButtonGradientStyles;
    let t2;
    if ($[0] !== handleToggle || $[1] !== intl || $[2] !== isExpanded) {
        t2 = !isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: $120e402a2d601a31$var$_temp,
            label: intl.formatMessage($120e402a2d601a31$var$i18n.showAllApps),
            onClick: handleToggle,
            testId: "show-all-apps-button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: $120e402a2d601a31$var$buttonStyles,
            onClick: handleToggle,
            testId: "show-less-apps-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
            label: "",
            size: "small"
        }), intl.formatMessage($120e402a2d601a31$var$i18n.showLessApps));
        $[0] = handleToggle;
        $[1] = intl;
        $[2] = isExpanded;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t1,
            testId: "single-line-byline-toggle-wrapper"
        }, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
function $120e402a2d601a31$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps,
        size: "small"
    });
}



var $3aDMt = parcelRequire("3aDMt");


var $87We3 = parcelRequire("87We3");

const $202654fe0d7532c2$var$singleLineBaseStyles = (0, $buxP3.xcss)({
    whiteSpace: 'nowrap',
    width: '100%',
    overflowX: 'hidden'
});
const $202654fe0d7532c2$var$appsContainerStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    gap: 'space.050',
    overflow: 'hidden'
});
const $202654fe0d7532c2$var$bylineContentStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    gap: 'space.050'
});
const $202654fe0d7532c2$var$singleLineWrapStyles = (0, $buxP3.xcss)({
    flexWrap: 'wrap',
    overflowX: 'visible'
});
const $202654fe0d7532c2$var$centerAlignmentStyles = (0, $buxP3.xcss)({
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'initial'
});
const $202654fe0d7532c2$var$maxWidthStyles = (0, $buxP3.xcss)({
    maxWidth: '760px'
});
// when the last byline app is on the first row of the byline, its top position should be within this offset
// this is assuming no byline items are wrapping themselves (which they shouldn't be)
const $202654fe0d7532c2$var$BYLINE_SINGLE_ROW_TOP_OFFSET = 15;
const $202654fe0d7532c2$var$AppsContainer = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $202654fe0d7532c2$var$appsContainerStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $202654fe0d7532c2$export$cc95b64079434472 = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, children: children, contentType: contentType = 'page', isTitleCenterAlignedOverride: isTitleCenterAlignedOverride, showByLineExtensions: showByLineExtensions = true, bylineAppContentProperties: bylineAppContentProperties })=>{
    const bylineAppsDefaultCollapsed = (0, $1xpoY.default).getBoolean('confluence_byline_app_default_collapsed', false);
    const [shouldShowToggleButton, setShouldShowToggleButton] = (0, $cozmU.useState)(false);
    const [haveAppsLoaded, setHaveAppsLoaded] = (0, $cozmU.useState)(false);
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(!bylineAppsDefaultCollapsed);
    const [currentParentWidth, setCurrentParentWidth] = (0, $cozmU.useState)();
    const isRestrictedExternalShare = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const bylineRef = (0, $cozmU.useRef)(null);
    const { isTitleCenteredInitial: isTitleCenteredInitial } = (0, $aV3a0.useTitleContentPropertiesForEditor)({
        contentId: contentId,
        contentType: contentType
    });
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { hasApps: hasApps, connectItems: connectItems, connectError: connectError, forgeItems: forgeItems, forgeError: forgeError, loadingConnectItems: loadingConnectItems, loadingForgeItems: loadingForgeItems } = (0, $e105dde0a43b3be2$export$b613c53a0aeac846)(contentId);
    const [initialSnapshot] = (0, $cozmU.useState)(()=>{
        if (!renderServerPlaceholder || isRestrictedExternalShare || !showByLineExtensions || !(0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) return {
            contentId: contentId,
            snapshot: undefined
        };
        // Enrolled loads have already paid the preload cost, so they remain exposed even when
        // an incomplete result prevents the snapshot from being rendered.
        const snapshot = (0, $87We3.createByLineAppSnapshot)({
            connectError: connectError,
            connectItems: connectItems,
            forgeError: forgeError,
            forgeItems: forgeItems,
            loadingConnectItems: loadingConnectItems,
            loadingForgeItems: loadingForgeItems,
            bylineAppContentProperties: bylineAppContentProperties
        });
        // Keep the server/mount-time presentation immutable while the client queries refresh.
        const authoritative = (0, $87We3.isByLineAppSnapshotAuthoritative)(snapshot);
        return {
            contentId: contentId,
            snapshot: authoritative ? snapshot : undefined
        };
    });
    const isInitialSnapshotRetired = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        // This snapshot belongs only to the initial hydration. Once another page commits,
        // never make it eligible again if SPA navigation later returns to the initial page.
        if (initialSnapshot.snapshot && contentId !== initialSnapshot.contentId) isInitialSnapshotRetired.current = true;
    }, [
        contentId,
        initialSnapshot
    ]);
    const authoritativeSnapshot = !isInitialSnapshotRetired.current && initialSnapshot.contentId === contentId ? initialSnapshot.snapshot : undefined;
    (0, $cozmU.useEffect)(()=>{
        if (!bylineRef.current || !haveAppsLoaded) return;
        const bylineAppsRoot = authoritativeSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? bylineRef.current.querySelector('[data-byline-app-runtime]') : bylineRef.current;
        if (!bylineAppsRoot) return;
        const forgeApps = Array.from(bylineAppsRoot.querySelectorAll('[data-testid="forge-byline-header-wrapper"]'));
        const webItemApps = Array.from(bylineAppsRoot.querySelectorAll('[data-testid="web-item-link"]'));
        // forge items are rendered after web items so theyd be last if rendered
        const appsList = [
            ...webItemApps,
            ...forgeApps
        ];
        const lastAppElement = appsList[appsList.length - 1];
        if (!lastAppElement) return;
        const bylineRefRect = bylineRef.current?.getBoundingClientRect();
        const lastAppRect = lastAppElement.getBoundingClientRect();
        const areOnSameLine = Math.abs(bylineRefRect.top - lastAppRect.top) < $202654fe0d7532c2$var$BYLINE_SINGLE_ROW_TOP_OFFSET;
        if (isExpanded) {
            // theres no need to calculate overflow below if the apps are already expanded
            // we just need to check if all apps fit in the first row so we can hide the toggle button
            setShouldShowToggleButton(!areOnSameLine);
            return;
        }
        // Check if elements are on the same line by comparing their top positions
        setShouldShowToggleButton(lastAppRect.right > bylineRefRect.right);
    }, [
        authoritativeSnapshot,
        currentParentWidth,
        haveAppsLoaded,
        isExpanded
    ]);
    const toggleShowAllApps = ()=>{
        setIsExpanded((currentState)=>!currentState);
    };
    const handleBylineAppsLoaded = (0, $cozmU.useCallback)(()=>{
        setHaveAppsLoaded(true);
    }, []);
    const updateContentAreaWidth = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))((width)=>{
        setCurrentParentWidth(width);
    }, 100);
    // this container is necessary to prevent the byline overflow from pushing the show more button out of view
    const RestrictAppsInOverflowContainer = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment : $202654fe0d7532c2$var$AppsContainer;
    const shouldShowApps = !isRestrictedExternalShare && (hasApps || Boolean(authoritativeSnapshot?.apps.length)) && showByLineExtensions;
    const bylineApps = renderServerPlaceholder && window.__SSR_REACT_STREAMING__ ? authoritativeSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aDMt.AuthoritativeByLineApps), {
        snapshot: authoritativeSnapshot
    }) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j2moL.LazyLivePagesByLineApps), {
        contentId: contentId,
        connectItems: connectItems,
        forgeItems: forgeItems,
        forgeError: forgeError,
        showLivePagesExtensionPoints: true,
        isSingleLineByline: true,
        onBylineAppsLoaded: handleBylineAppsLoaded,
        loadingConnectItems: loadingConnectItems,
        loadingForgeItems: loadingForgeItems,
        authoritativeSnapshot: authoritativeSnapshot
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gektR.AlignmentButtonContainer)
        ]
    }, (alignmentButtonContainer)=>{
        const isTitleCenterAligned = isTitleCenterAlignedOverride || (!alignmentButtonContainer.state.isLoadingComplete ? isTitleCenteredInitial : alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).CENTER);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35Exc.BylineStyledMainDivSingleLine), {
            isExpanded: isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            testId: "byline-single-line",
            ref: bylineRef,
            xcss: [
                $202654fe0d7532c2$var$singleLineBaseStyles,
                // show more toggles to enable wrap are dependent on having apps present
                // this would prevent an edge case of a very long byline (or tiny viewport) with no apps being cut off
                (isExpanded || !shouldShowApps) && $202654fe0d7532c2$var$singleLineWrapStyles,
                isTitleCenterAligned && $202654fe0d7532c2$var$centerAlignmentStyles,
                isTitleCenterAligned && !isExpanded && $202654fe0d7532c2$var$maxWidthStyles
            ],
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $202654fe0d7532c2$var$bylineContentStyles
        }, children), shouldShowApps && bylineApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RestrictAppsInOverflowContainer, null, bylineApps)) : null), renderServerPlaceholder && window.__SSR_REACT_STREAMING__ ? null : shouldShowApps && shouldShowToggleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $120e402a2d601a31$export$a2051cde2c49a6fb), {
            isExpanded: isExpanded,
            handleToggle: toggleShowAllApps
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
            setWidth: updateContentAreaWidth
        }));
    });
});
module.exports["SingleLineByLine"] = $202654fe0d7532c2$export$cc95b64079434472;

});

parcelRegister("j2moL", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $6mKj3 = parcelRequire("6mKj3");


var $80koo = parcelRequire("80koo");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");


var $jmjWc = parcelRequire("jmjWc");











var $ah4BL = parcelRequire("ah4BL");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");


var $asQED = parcelRequire("asQED");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $euq7N = parcelRequire("euq7N");







/**
 * @generated SignedSource<<146f014633927f394ddf960a506da573>>
 * @relayHash 7c8317bb717346ea2ddd7f2fdb49f2d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c54ae82f4f2aaf407e36724c9a56ad7521ffa4ac52a827b9d418240e4a5d4b7
const $25c03fd7fde92d1a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "InvokeExtensionResponse",
            "kind": "LinkedField",
            "name": "invokeExtension",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "InvocationResponsePayload",
                    "kind": "LinkedField",
                    "name": "response",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "body"
                        }
                    ]
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCode"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "BulkMutationErrorExtension"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ByLineForgeAppinvokeExtensionMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ByLineForgeAppinvokeExtensionMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7c8317bb717346ea2ddd7f2fdb49f2d0",
            "id": "4c54ae82f4f2aaf407e36724c9a56ad7521ffa4ac52a827b9d418240e4a5d4b7",
            "metadata": {},
            "name": "ByLineForgeAppinvokeExtensionMutation",
            "operationKind": "mutation",
            "text": "mutation ByLineForgeAppinvokeExtensionMutation($input:InvokeExtensionInput!){invokeExtension(input:$input){success,response{body},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$25c03fd7fde92d1a$var$node.hash = "00321bd07f93db1aae1039ee5a2af686";
var $25c03fd7fde92d1a$export$2e2bcd8739ae039 = $25c03fd7fde92d1a$var$node;








var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $4n1IT = parcelRequire("4n1IT");


var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $lfoFx = parcelRequire("lfoFx");








var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $aF5bm = parcelRequire("aF5bm");


var $4vC63 = parcelRequire("4vC63");


var $7QUD1 = parcelRequire("7QUD1");


var $lOI2p = parcelRequire("lOI2p");


var $jYZsR = parcelRequire("jYZsR");


var $hIaUw = parcelRequire("hIaUw");


var $grspz = parcelRequire("grspz");


var $8a9Dm = parcelRequire("8a9Dm");


var $9fBoq = parcelRequire("9fBoq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7W8i8 = parcelRequire("7W8i8");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $jMyy4 = parcelRequire("jMyy4");


var $1JyKZ = parcelRequire("1JyKZ");


var $308Wd = parcelRequire("308Wd");


var $e5xte = parcelRequire("e5xte");







var $46f2a733fab59ac5$exports = {};
$46f2a733fab59ac5$exports = new URL("AK_AddonIcon.7997ef8d.svg", import.meta.url).toString();



var $83fWZ = parcelRequire("83fWZ");


var $5vpeX = parcelRequire("5vpeX");


var $7sf7C = parcelRequire("7sf7C");
















const $92aefd48974e22dc$export$9bfd6c1ca71ef80d = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { appId: appId, contentId: contentId, hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportedTitleAlignmentRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== appId || $[1] !== contentId || $[2] !== createAnalyticsEvent || $[3] !== hasAuthoritativeBylineAppSnapshot) {
        t1 = (titleChanged, resolutionOutcome)=>{
            if (!hasAuthoritativeBylineAppSnapshot || !(0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true)) return;
            const reported = reportedTitleAlignmentRef.current;
            if (reported?.appId === appId && reported.contentId === contentId) return;
            reportedTitleAlignmentRef.current = {
                appId: appId,
                contentId: contentId
            };
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "resolved",
                    actionSubject: "forgeExtension",
                    actionSubjectId: "dynamicProperties",
                    source: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                    attributes: {
                        resolutionOutcome: resolutionOutcome,
                        titleChanged: titleChanged
                    }
                }
            }).fire();
        };
        $[0] = appId;
        $[1] = contentId;
        $[2] = createAnalyticsEvent;
        $[3] = hasAuthoritativeBylineAppSnapshot;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};


const $1cb9b1bda2de2c04$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_BYLINE_FORGE_EXPERIENCE); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cb9b1bda2de2c04$var$ContentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEkG2W _1EqgXl4DOi _0NUa3r4DOi _2WAcuGIZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1cb9b1bda2de2c04$var$i18n = (0, $kSwu1.defineMessages)({
    appIcon: {
        id: "content-header.forge.byline-app.app-icon-alt",
        defaultMessage: "App Icon"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cb9b1bda2de2c04$var$ByLineForgeAppHeaderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "span" : t2;
        const { isHidden: isHidden, ...__cmpldp } = __cmplp;
        const t3 = __cmplp.isHidden ? "none" : "inline-block";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_z2o4qt": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_3iDTPb3qsO _0adFHsPgdg _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0z71MC98eZ _4tUF3yYbGa _0a2Gmi6wH8 _0ReiIH7zJH",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $1cb9b1bda2de2c04$var$Image = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEn1Zi _0jFU0VEbN9 _39xV02EbN9 _3iDTPbvbI6 _1RrJLiYXK7 _1UtDYz8ujp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1cb9b1bda2de2c04$var$forgeAppButtonStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.small',
    display: 'inline-flex',
    font: 'font.body.small',
    color: 'color.text.subtle',
    gap: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    marginRight: 'space.0',
    padding: 'space.050',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $1cb9b1bda2de2c04$var$forgeAppButtonDotStyles = (0, $buxP3.xcss)({
    '::before': {
        content: '"\u2022"',
        display: 'inline-block',
        paddingRight: 'space.050',
        alignSelf: 'center',
        textDecoration: 'none'
    }
});
const $1cb9b1bda2de2c04$var$sharedForgeAppButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    display: 'inline-flex',
    padding: 'space.0'
});
const $1cb9b1bda2de2c04$var$ByLineForgeAppTrigger = ({ app: app, reference: reference, defineTriggerRef: defineTriggerRef, toggleClose: toggleClose, isOpen: isOpen, extensionData: extensionData, isHidden: isHidden, hideDot: hideDot, appTitle: appTitle, setAppTitle: setAppTitle, hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot, authoritativePresentation: authoritativePresentation, contentPropertyKeys: contentPropertyKeys })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const appHasDynamicProperties = !!app.properties.dynamicProperties;
    const [contentPropertyKey, setContentPropertyKey] = (0, $cozmU.useState)(app.properties.contentPropertyKey || '');
    const initialAppTitleRef = (0, $cozmU.useRef)(appTitle);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const workspaceARI = (0, $aF5bm.useWorkspaceARI)();
    const [appIcon, setAppIcon] = (0, $cozmU.useState)(()=>app.properties.contentPropertyKey && authoritativePresentation && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? authoritativePresentation?.icon?.src || null : app.properties.icon || null);
    const [appTooltip, setAppTooltip] = (0, $cozmU.useState)(()=>app.properties.contentPropertyKey && authoritativePresentation && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? authoritativePresentation?.tooltip || null : app.properties.tooltip || null);
    const reportTitleAlignment = (0, $92aefd48974e22dc$export$9bfd6c1ca71ef80d)({
        appId: app.id,
        contentId: extensionData.content?.id,
        hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot
    });
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(appHasDynamicProperties && (!app.properties.contentPropertyKey && !hasAuthoritativeBylineAppSnapshot || !(0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)));
    const localId = (0, $cozmU.useMemo)(()=>(0, $grspz.getLocalId)(app.id), [
        app.id
    ]);
    const getContextToken = (0, $1JyKZ.useGetContextToken)({
        extension: app,
        extensionData: extensionData,
        localId: localId,
        contextIds: [
            workspaceARI
        ]
    });
    const getContextTokenRef = (0, $cozmU.useRef)(getContextToken);
    (0, $cozmU.useEffect)(()=>{
        getContextTokenRef.current = getContextToken;
    }, [
        getContextToken
    ]);
    const [bylineDynamicPropertiesMutation] = (0, $308Wd.useMutationInterop)((0, $25c03fd7fde92d1a$export$2e2bcd8739ae039), {
        interopApolloAggClient: true,
        __callerPackage__: "content-header"
    });
    const fetchDynamicProperties = (0, $cozmU.useCallback)(async ()=>{
        const extensionId = app.id;
        const contextPayload = {
            cloudId: cloudId,
            localId: localId,
            extension: extensionData
        };
        let contextToken;
        try {
            contextToken = await getContextTokenRef.current();
        } catch (e) {
            reportTitleAlignment(false, 'failed');
            throw new Error(`Failed to get context token: ${e}`);
        }
        const result = await bylineDynamicPropertiesMutation({
            variables: {
                input: {
                    entryPoint: 'dynamicProperties',
                    contextIds: [
                        workspaceARI
                    ],
                    extensionId: extensionId,
                    payload: {
                        context: contextPayload,
                        ...contextPayload,
                        // TODO: This is temporary for Forge apps' backward compatibility
                        ...contextToken ? {
                            contextToken: contextToken
                        } : {}
                    }
                }
            }
        }).catch((e)=>{
            return {
                data: {
                    invokeExtension: {
                        success: false,
                        errors: [
                            {
                                message: e
                            }
                        ]
                    }
                }
            };
        });
        setIsLoading(false); // @ts-expect-error The types here are a bit messy. Typegen for AGG should help solve that
        const { response: response, success: success } = result.data?.invokeExtension; // @ts-expect-error The types here are a bit messy. Typegen for AGG should help solve that
        const errors = result.data?.invokeExtension.errors;
        if (!success) {
            const logger = (0, $7W8i8.getLogger)('by-line-apps');
            const errorMessages = errors.map((error)=>error.message).join(' ');
            reportTitleAlignment(false, 'failed'); // prints error to aid forge developer && allow Ecosystem to track these errors
            logger.error`Failed to fetch dynamic properties for ByLine Forge app: ${app.id} with error: ${errorMessages}`;
            if (errorMessages !== 'User consent required') (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Failed to fetch dynamic properties for ByLine Forge app: ${app.id} with error: ${errorMessages}`), {
                attribution: (0, $3IBnw.Attribution).ECOSYSTEM
            });
            return;
        }
        if (!response && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) {
            reportTitleAlignment(false, 'succeeded');
            return;
        }
        if (response.body) {
            const { body: { title: dynamicPropsTitle, tooltip: dynamicPropsTooltip, icon: dynamicPropsIcon } } = response;
            reportTitleAlignment(Boolean(dynamicPropsTitle && (0, $9fBoq.extensionTitle)(app, dynamicPropsTitle) !== (0, $9fBoq.extensionTitle)(app)), 'succeeded');
            dynamicPropsTitle && setAppTitle((0, $9fBoq.extensionTitle)(app, dynamicPropsTitle));
            dynamicPropsTooltip && setAppTooltip(dynamicPropsTooltip);
            dynamicPropsIcon && setAppIcon(dynamicPropsIcon);
        } else reportTitleAlignment(false, 'succeeded');
    }, [
        app,
        cloudId,
        extensionData,
        bylineDynamicPropertiesMutation,
        workspaceARI,
        setAppTitle,
        localId,
        reportTitleAlignment
    ]);
    // Validation function for content property data
    const validateContentPropertyDataCallback = (0, $cozmU.useCallback)((data)=>{
        const defaultValues = {
            title: initialAppTitleRef.current,
            icon: app.properties.icon || '',
            tooltip: app.properties.tooltip || '',
            contentPropertyKey: app.properties.contentPropertyKey || ''
        };
        if ((0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) return (0, $5vpeX.validateContentPropertyData)(data, {
            ...defaultValues,
            // The manifest title is undecorated; the client adds the environment suffix once.
            title: app.properties.contentPropertyKey ? app.properties.title || '' : defaultValues.title
        }, (0, $euq7N.getBylineAppContentPropertyKeys)([
            app
        ]));
        return (0, $5vpeX.validateContentPropertyData)(data, defaultValues);
    }, [
        app
    ]); // Validation function specifically for FORGE_CONTENT_PROPERTY_UPDATED event data
    const validateEventDataCallback = (0, $cozmU.useCallback)((eventData)=>{
        const defaultValues = {
            title: appTitle,
            icon: app.properties.icon || '',
            tooltip: app.properties.tooltip || ''
        };
        return (0, $5vpeX.validateEventData)(eventData, defaultValues);
    }, [
        appTitle,
        app.properties.icon,
        app.properties.tooltip
    ]);
    const runGeneralContentPropertyQuery = (0, $cozmU.useCallback)(()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: generalContentPropertyData, refetch: refetchQueryContentProperties } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jMyy4.useQueryInterop)((0, $7sf7C.default), {
            variables: {
                contentId: extensionData.content?.id,
                ...(0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? {
                    keys: contentPropertyKeys ?? (0, $euq7N.getBylineAppContentPropertyKeys)([
                        app
                    ])
                } : {}
            },
            __callerPackage__: "content-header"
        });
        return {
            data: generalContentPropertyData,
            refetch: refetchQueryContentProperties
        };
    }, [
        app,
        contentPropertyKeys,
        extensionData
    ]); // Run general content property query to get all properties (including IDs), if the app has a contentPropertyKey
    const queryResult = app.properties.contentPropertyKey ? runGeneralContentPropertyQuery() : null;
    const generalData = queryResult?.data || null;
    const refetchContentProperties = queryResult?.refetch; // Validate content property data and get clean values
    const validatedProperties = !generalData && app.properties.contentPropertyKey && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? null : validateContentPropertyDataCallback(generalData);
    (0, $cozmU.useEffect)(()=>{
        // refetch for updates on popup.content close
        // Only run if app has defined contentPropertyKey
        if (contentPropertyKey && !!validatedProperties?.contentPropertyKey && validatedProperties.contentPropertyKey !== '') {
            setContentPropertyKey(validatedProperties.contentPropertyKey);
            setIsLoading(false); // Update app properties with validated values
            if (validatedProperties.title && validatedProperties.title !== '') setAppTitle((0, $9fBoq.extensionTitle)(app, validatedProperties.title));
            if (validatedProperties.icon && validatedProperties.icon !== '') setAppIcon(validatedProperties.icon);
            if (validatedProperties.tooltip && validatedProperties.tooltip !== '') setAppTooltip(validatedProperties.tooltip);
        } else if (!isOpen && appHasDynamicProperties && (!contentPropertyKey || !(0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true))) fetchDynamicProperties();
    }, [
        isOpen,
        appHasDynamicProperties,
        fetchDynamicProperties,
        validatedProperties?.title,
        validatedProperties?.icon,
        validatedProperties?.tooltip,
        validatedProperties?.contentPropertyKey,
        setAppTitle,
        setAppIcon,
        setAppTooltip,
        setContentPropertyKey,
        contentPropertyKey,
        app
    ]); // Event listener for FORGE_CONTENT_PROPERTY_UPDATED events
    (0, $cozmU.useEffect)(()=>{
        const handleContentPropertyUpdate = async (event)=>{
            const customEvent = event;
            if (customEvent.detail?.payload?.propertyKey !== app.properties.contentPropertyKey) return;
             // Refetch content properties to get the latest data and ensure proper validation
            // This is important when multiple apps use the same contentPropertyKey
            if (refetchContentProperties) try {
                await refetchContentProperties();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn('Failed to refetch content properties on event update:', error);
            }
             // Validate the event data using the specific event validation method
            const validatedData = validateEventDataCallback(customEvent.detail?.payload); // Update app properties with validated values
            if (validatedData.title && validatedData.title !== '') {
                if ((0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) setAppTitle((currentTitle)=>validatedData.title === currentTitle ? validatedData.title : (0, $9fBoq.extensionTitle)(app, validatedData.title));
                else setAppTitle((0, $9fBoq.extensionTitle)(app, validatedData.title));
            }
            if (validatedData.icon && validatedData.icon !== '') setAppIcon(validatedData.icon);
            if (validatedData.tooltip && validatedData.tooltip !== '') setAppTooltip(validatedData.tooltip);
        }; // Only process if this event is for our content property key
        if (!contentPropertyKey || contentPropertyKey === '') return ()=>{}; // Return empty cleanup function to maintain React lifecycle consistency
        document.addEventListener('forge.bridge.FORGE_CONTENT_PROPERTY_UPDATED', handleContentPropertyUpdate); // Cleanup function to remove event listener
        return ()=>{
            document.removeEventListener('forge.bridge.FORGE_CONTENT_PROPERTY_UPDATED', handleContentPropertyUpdate);
        };
    }, [
        validateEventDataCallback,
        contentPropertyKey,
        setAppTitle,
        setAppIcon,
        setAppTooltip,
        app,
        refetchContentProperties
    ]);
    const appImageAlt = formatMessage($1cb9b1bda2de2c04$var$i18n.appIcon);
    const handleAppImageError = (event)=>{
        event.currentTarget.src = (0, (/*@__PURE__*/$parcel$interopDefault($46f2a733fab59ac5$exports)));
    };
    const ForgeAppButton = hasAuthoritativeBylineAppSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        testId: "byline-forge-app-button",
        xcss: $1cb9b1bda2de2c04$var$sharedForgeAppButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5xte.BylineAppTriggerVisual), {
        isInteractive: true,
        showDot: !(isHidden || hideDot)
    }, appIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: appImageAlt,
        "data-testid": "byline-forge-app-image",
        height: 14,
        onError: handleAppImageError,
        src: appIcon,
        width: 14
    }) : null, appTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        testId: "byline-forge-app-button",
        xcss: [
            $1cb9b1bda2de2c04$var$forgeAppButtonStyles,
            !(isHidden || hideDot) && $1cb9b1bda2de2c04$var$forgeAppButtonDotStyles
        ]
    }, appIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$Image, {
        alt: appImageAlt,
        "data-testid": "byline-forge-app-image",
        onError: handleAppImageError,
        src: appIcon
    }) : null, appTitle);
    const bylineForgeAppHeaderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppHeaderWrapper, {
        ref: defineTriggerRef && reference ? defineTriggerRef(reference) : null,
        onClick: toggleClose,
        isHidden: isHidden,
        "data-testid": "forge-byline-header-wrapper"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        testId: "byline-forge-app-trigger-loading-spinner"
    }) : ForgeAppButton);
    return app.properties?.keyboardShortcut?.accelerator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
        module: app,
        tooltip: appTooltip ?? ''
    }, bylineForgeAppHeaderWrapper) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        content: appTooltip
    }, bylineForgeAppHeaderWrapper);
};
const $1cb9b1bda2de2c04$export$d2159b9f3f077903 = (t0)=>{
    const $ = (0, $bDgLe.c)(85);
    const { app: app, contentId: contentId, isHidden: t1, setShowAll: t2, hideDot: t3, hasAuthoritativeBylineAppSnapshot: t4, authoritativePresentation: authoritativePresentation, contentPropertyKeys: contentPropertyKeys } = t0;
    const isHidden = t1 === undefined ? false : t1;
    const setShowAll = t2 === undefined ? $1cb9b1bda2de2c04$var$_temp : t2;
    const hideDot = t3 === undefined ? false : t3;
    const hasAuthoritativeBylineAppSnapshot = t4 === undefined ? false : t4;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isEditing = isLivePage || isOnEditRoute;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [popupRef, setPopupRef] = (0, $cozmU.useState)(null);
    const [triggerRef, setTriggerRef] = (0, $cozmU.useState)(null);
    let t5;
    if ($[0] !== app || $[1] !== authoritativePresentation) {
        t5 = ()=>app.properties.contentPropertyKey && authoritativePresentation && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true) ? authoritativePresentation.label : (0, $9fBoq.extensionTitle)(app);
        $[0] = app;
        $[1] = authoritativePresentation;
        $[2] = t5;
    } else t5 = $[2];
    const [appTitle, setAppTitle] = (0, $cozmU.useState)(t5);
    const [t6] = (0, $ep3mz.usePageState)();
    const { routeName: routeName, spaceKey: spaceAlias } = t6;
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t7;
    if ($[3] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[3] = routeName;
        $[4] = t7;
    } else t7 = $[4];
    const t8 = isLivePage ? "live" : null;
    let t9;
    if ($[5] !== contentId || $[6] !== t7 || $[7] !== t8) {
        t9 = {
            id: contentId,
            type: t7,
            subtype: t8
        };
        $[5] = contentId;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = spaceKey || spaceAlias;
    let t11;
    if ($[9] !== spaceId || $[10] !== t10) {
        t11 = {
            id: spaceId,
            key: t10
        };
        $[9] = spaceId;
        $[10] = t10;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== t11 || $[13] !== t9) {
        t12 = {
            type: (0, $7Ndnw.FORGE_MODULE_BYLINE),
            content: t9,
            space: t11
        };
        $[12] = t11;
        $[13] = t9;
        $[14] = t12;
    } else t12 = $[14];
    const extensionData = (0, $83fWZ.useMemoizedObj)(t12);
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (node)=>{
            setPopupRef(node);
        };
        $[15] = t13;
    } else t13 = $[15];
    const defineContentRef = t13;
    let t14;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (ref)=>(node_0)=>{
                setTriggerRef(node_0);
                ref(node_0);
            };
        $[16] = t14;
    } else t14 = $[16];
    const defineTriggerRef = t14;
    let t15;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>{
            setIsOpen(false);
        };
        $[17] = t15;
    } else t15 = $[17];
    const onClose = t15;
    let t16;
    if ($[18] !== contentId || $[19] !== experienceTracker || $[20] !== isOpen) {
        t16 = ()=>{
            !isOpen && experienceTracker.start({
                name: $1cb9b1bda2de2c04$var$EXPERIENCE_NAME,
                id: contentId,
                timeout: 10000
            });
            setIsOpen(!isOpen);
        };
        $[18] = contentId;
        $[19] = experienceTracker;
        $[20] = isOpen;
        $[21] = t16;
    } else t16 = $[21];
    const toggleClose = t16;
    let t17;
    if ($[22] !== activationId || $[23] !== app || $[24] !== contentId || $[25] !== createAnalyticsEvent || $[26] !== experienceTracker || $[27] !== routeName || $[28] !== spaceAlias || $[29] !== spaceId) {
        t17 = ()=>{
            experienceTracker.succeed({
                name: $1cb9b1bda2de2c04$var$EXPERIENCE_NAME
            });
            const appId = (0, $8a9Dm.getAppId)(app);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                        moduleKey: (0, $8a9Dm.getModuleKey)(app),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            }).fire();
        };
        $[22] = activationId;
        $[23] = app;
        $[24] = contentId;
        $[25] = createAnalyticsEvent;
        $[26] = experienceTracker;
        $[27] = routeName;
        $[28] = spaceAlias;
        $[29] = spaceId;
        $[30] = t17;
    } else t17 = $[30];
    const onInitialRender = t17;
    let t18;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = {
            close: onClose
        };
        $[31] = t18;
    } else t18 = $[31];
    const bridge = t18;
    let t19;
    if ($[32] !== popupRef || $[33] !== triggerRef) {
        t19 = {
            onClose: onClose,
            popupRef: popupRef,
            triggerRef: triggerRef
        };
        $[32] = popupRef;
        $[33] = triggerRef;
        $[34] = t19;
    } else t19 = $[34];
    (0, $lOI2p.useInlineDialogCloseManager)(t19);
    if (!spaceKey) return null;
    let InvisibleDiv;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        InvisibleDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)($1cb9b1bda2de2c04$var$_temp2);
        $[35] = InvisibleDiv;
    } else InvisibleDiv = $[35];
    if (app.properties.viewportContainer === "modal") {
        let t20;
        if ($[36] !== app || $[37] !== appTitle || $[38] !== authoritativePresentation || $[39] !== contentPropertyKeys || $[40] !== extensionData || $[41] !== hasAuthoritativeBylineAppSnapshot || $[42] !== hideDot || $[43] !== isHidden || $[44] !== isOpen || $[45] !== toggleClose) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppTrigger, {
                app: app,
                appTitle: appTitle,
                setAppTitle: setAppTitle,
                isOpen: isOpen,
                toggleClose: toggleClose,
                extensionData: extensionData,
                isHidden: isHidden,
                hideDot: hideDot,
                hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot,
                authoritativePresentation: authoritativePresentation,
                contentPropertyKeys: contentPropertyKeys
            });
            $[36] = app;
            $[37] = appTitle;
            $[38] = authoritativePresentation;
            $[39] = contentPropertyKeys;
            $[40] = extensionData;
            $[41] = hasAuthoritativeBylineAppSnapshot;
            $[42] = hideDot;
            $[43] = isHidden;
            $[44] = isOpen;
            $[45] = toggleClose;
            $[46] = t20;
        } else t20 = $[46];
        let t21;
        if ($[47] !== InvisibleDiv || $[48] !== app || $[49] !== extensionData || $[50] !== isOpen || $[51] !== onInitialRender) {
            t21 = isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ByLineForgeApp), {
                app: app,
                extensionData: extensionData,
                onInitialRender: onInitialRender,
                onTearDown: onClose,
                bridge: bridge
            })) : null;
            $[47] = InvisibleDiv;
            $[48] = app;
            $[49] = extensionData;
            $[50] = isOpen;
            $[51] = onInitialRender;
            $[52] = t21;
        } else t21 = $[52];
        let t22;
        if ($[53] !== t20 || $[54] !== t21) {
            t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t20, t21);
            $[53] = t20;
            $[54] = t21;
            $[55] = t22;
        } else t22 = $[55];
        return t22;
    }
    const t20 = !isEditing;
    let t21;
    if ($[56] !== app || $[57] !== extensionData || $[58] !== onInitialRender || $[59] !== popupRef) {
        t21 = (t22)=>{
            const { update: scheduleUpdate } = t22;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ContentWrapper, {
                ref: defineContentRef,
                "data-testid": "forge-popup-content-wrapper"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYZsR.ResizeChangeListener), {
                onUpdate: scheduleUpdate,
                popupRef: popupRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ByLineForgeApp), {
                app: app,
                extensionData: extensionData,
                onInitialRender: onInitialRender,
                onTearDown: onClose,
                bridge: bridge
            })));
        };
        $[56] = app;
        $[57] = extensionData;
        $[58] = onInitialRender;
        $[59] = popupRef;
        $[60] = t21;
    } else t21 = $[60];
    let t22;
    if ($[61] !== app || $[62] !== appTitle || $[63] !== authoritativePresentation || $[64] !== contentPropertyKeys || $[65] !== extensionData || $[66] !== hasAuthoritativeBylineAppSnapshot || $[67] !== hideDot || $[68] !== isHidden || $[69] !== isOpen || $[70] !== toggleClose) {
        t22 = (t23)=>{
            const { ref: ref_0 } = t23;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppTrigger, {
                app: app,
                appTitle: appTitle,
                setAppTitle: setAppTitle,
                reference: ref_0,
                isOpen: isOpen,
                defineTriggerRef: defineTriggerRef,
                toggleClose: toggleClose,
                extensionData: extensionData,
                isHidden: isHidden,
                hideDot: hideDot,
                hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot,
                authoritativePresentation: authoritativePresentation,
                contentPropertyKeys: contentPropertyKeys
            });
        };
        $[61] = app;
        $[62] = appTitle;
        $[63] = authoritativePresentation;
        $[64] = contentPropertyKeys;
        $[65] = extensionData;
        $[66] = hasAuthoritativeBylineAppSnapshot;
        $[67] = hideDot;
        $[68] = isHidden;
        $[69] = isOpen;
        $[70] = toggleClose;
        $[71] = t22;
    } else t22 = $[71];
    let t23;
    if ($[72] !== appTitle || $[73] !== isOpen || $[74] !== t20 || $[75] !== t21 || $[76] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            shouldRenderToParent: t20,
            testId: "forge-action-popup",
            role: "dialog",
            content: t21,
            label: appTitle,
            isOpen: isOpen,
            placement: "bottom-start",
            trigger: t22
        });
        $[72] = appTitle;
        $[73] = isOpen;
        $[74] = t20;
        $[75] = t21;
        $[76] = t22;
        $[77] = t23;
    } else t23 = $[77];
    let t24;
    if ($[78] !== app || $[79] !== isEditing || $[80] !== setShowAll) {
        t24 = !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
            module: app,
            action: ()=>{
                setShowAll(true);
                setIsOpen(true);
            }
        });
        $[78] = app;
        $[79] = isEditing;
        $[80] = setShowAll;
        $[81] = t24;
    } else t24 = $[81];
    let t25;
    if ($[82] !== t23 || $[83] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t23, t24);
        $[82] = t23;
        $[83] = t24;
        $[84] = t25;
    } else t25 = $[84];
    return t25;
};
function $1cb9b1bda2de2c04$var$_temp() {}
function $1cb9b1bda2de2c04$var$_temp2(t0, __cmplr) {
    const { as: t1, style: __cmpls, ...__cmplp } = t0;
    const C = t1 === undefined ? "div" : t1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbYbGa",
            __cmplp.className
        ])
    });
}















var $5SGpQ = parcelRequire("5SGpQ");


var $jmUhx = parcelRequire("jmUhx");

const $8a60fc49afcf0f5b$var$i18n = (0, $kSwu1.defineMessages)({
    showMore: {
        id: "content-header.by-line.apps-show-more",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "content-header.by-line.apps.show-less",
        defaultMessage: "Show less"
    }
});
const $8a60fc49afcf0f5b$export$94132a0e348806d4 = null; // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $8a60fc49afcf0f5b$var$ShowMoreLess = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _1UtDYzZpcK _0wOv4Q7zJH _3UcnShqogv _1Yjlt598eZ _2AckfdYbGa _42hYr56wH8 _3Ku51IbQDk _0OU75rvbI6 _1eQ8NNZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
const $8a60fc49afcf0f5b$var$StyledButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $5SGpQ.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4vhRtvue9s _2yzFFQSqN7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-enable @atlaskit/ui-styling-standard/no-important-styles */ 
const $8a60fc49afcf0f5b$export$e5bc424bebb08325 = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { showMore: t1, showButtonDesign: t2, setShowAll: setShowAll } = t0;
    const showMore = t1 === undefined ? false : t1;
    const showButtonDesign = t2 === undefined ? false : t2;
    const intl = (0, $kSwu1.useIntl)();
    const textKey = showMore ? $8a60fc49afcf0f5b$var$i18n.showMore : $8a60fc49afcf0f5b$var$i18n.showLess;
    const testIdText = showMore ? "more" : "less";
    let t3;
    if ($[0] !== setShowAll || $[1] !== showMore) {
        t3 = (event)=>{
            if (event.key === "Enter") {
                setShowAll(showMore);
                setTimeout($8a60fc49afcf0f5b$var$_temp, 0);
            }
        };
        $[0] = setShowAll;
        $[1] = showMore;
        $[2] = t3;
    } else t3 = $[2];
    const handleKeyDown = t3;
    let t4;
    if ($[3] !== handleKeyDown || $[4] !== intl || $[5] !== setShowAll || $[6] !== showButtonDesign || $[7] !== showMore || $[8] !== testIdText || $[9] !== textKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, showButtonDesign ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a60fc49afcf0f5b$var$StyledButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
                label: ""
            }),
            appearance: "subtle",
            testId: `live-pages-byline-show-${testIdText}`,
            onClick: ()=>setShowAll(showMore)
        }, intl.formatMessage(textKey)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a60fc49afcf0f5b$var$ShowMoreLess, {
            role: "button",
            onClick: ()=>setShowAll(showMore),
            "data-testid": `byline-show-${testIdText}`,
            tabIndex: 0,
            onKeyDown: handleKeyDown,
            id: "byline-apps-show-more-less-toggle"
        }, intl.formatMessage(textKey)));
        $[3] = handleKeyDown;
        $[4] = intl;
        $[5] = setShowAll;
        $[6] = showButtonDesign;
        $[7] = showMore;
        $[8] = testIdText;
        $[9] = textKey;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
function $8a60fc49afcf0f5b$var$_temp() {
    document.getElementById("byline-apps-show-more-less-toggle")?.focus();
}


const $cd6af931b4e9ea04$var$NUMBER_OF_VISIBLE_APPS = 3;
const $cd6af931b4e9ea04$var$LIVE_PAGES_NUMBER_OF_VISIBLE_APPS = 4; // eslint-disable-next-line @compiled/no-exported-css, @compiled/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $cd6af931b4e9ea04$export$94132a0e348806d4 = null; // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $cd6af931b4e9ea04$var$StyledWebItemList = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $asQED.WebItemList) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2XghbEn1Zi _2qu77JdnbC _1vTVu6dnbC _1NtoLtdnbC _0HXiU0dnbC _27y5OMdnbC _2Cd6PSdnbC _1jHGkcdnbC _2oVaLednbC _0dSRFrvbI6 _29szWcvbI6 _2IjzHGZpcK _13g1dfZpcK _20I9K8qogv _2nx5EY98eZ _1JfYJOYbGa _1blFbC6wH8 _45DIsCbQDk _3Za31wvbI6 _1SZqtMZpcK _2tv9TP98eZ _0WrLWkYbGa _46xcRf6wH8 _2HYQVbKGUX _27sYQ7YXK7 _1UihsyKGUX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, name: name, isEmpty: isEmpty } = t0;
    if (isEmpty) return children;
    let t1;
    if ($[0] !== children || $[1] !== name) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: name
        }, children);
        $[0] = children;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $cd6af931b4e9ea04$export$127ace2288e0ed63 = ({ contentId: contentId, connectItems: connectItems, forgeItems: forgeItems, onLoad: onLoad, showLivePagesExtensionPoints: showLivePagesExtensionPoints, showLoader: showLoader, isSingleLineByline: isSingleLineByline = false, hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot = false, authoritativeForgeAppIds: authoritativeForgeAppIds = [], authoritativeForgeAppPresentations: authoritativeForgeAppPresentations = [] })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const contentPropertyKeys = (0, $cozmU.useMemo)(()=>(0, $euq7N.getBylineAppContentPropertyKeys)(forgeItems), [
        forgeItems
    ]);
    const numberOfVisibleApps = showLivePagesExtensionPoints ? $cd6af931b4e9ea04$var$LIVE_PAGES_NUMBER_OF_VISIBLE_APPS : $cd6af931b4e9ea04$var$NUMBER_OF_VISIBLE_APPS;
    const [isShowAll, setShowAll] = (0, $cozmU.useState)((0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).BYLINE_APPS_SHOW_ALL));
    (0, $cozmU.useEffect)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).BYLINE_APPS_SHOW_ALL, isShowAll);
    }, [
        isShowAll
    ]);
    (0, $cozmU.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'bylineApps',
                source: 'ByLineAppsComponent',
                attributes: {
                    numberOfApps: connectItems?.length + forgeItems?.length
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        connectItems?.length,
        forgeItems?.length
    ]);
    if (showLoader) // Doing this to prevent flash during live pages SSR hydration step.
    // At this point, the data has been loaded but showLoader is still true since the onLoad is asynchronously setting the showLoader
    // state to false. It will briefly render both the placeholder and the actual content at the same time.
    // Returning null here ensures we only show actual content when the loader is not showing and prevents the flash.
    return null;
    connectItems = connectItems || [];
    forgeItems = forgeItems || [];
    const renderPart = (cApps, fApps, numberOfForgeAppsToShow)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, cApps.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper, {
            name: "byline-apps-connect-items",
            isEmpty: cApps.length === 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd6af931b4e9ea04$var$StyledWebItemList, {
            pageId: contentId,
            webItems: cApps,
            ContainerTagName: "span",
            webItemClassName: "bylineWebItem",
            hideDot: showLivePagesExtensionPoints || isSingleLineByline,
            noContainer: isSingleLineByline,
            useBadgeStyles: true,
            hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot,
            isLegacyConnectApp: (0, $9wGTI.fg)('customer-messaging-iframe-banner-enabled')
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper, {
            name: "byline-apps-forge-items",
            isEmpty: fApps.length === 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, fApps.map((app, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1cb9b1bda2de2c04$export$d2159b9f3f077903), {
                key: app.id,
                app: app,
                contentId: contentId,
                isHidden: isShowAll ? false : idx >= numberOfForgeAppsToShow,
                setShowAll: setShowAll,
                hideDot: showLivePagesExtensionPoints || isSingleLineByline,
                hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot && ((0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? authoritativeForgeAppIds.includes(app.id) : true),
                contentPropertyKeys: contentPropertyKeys,
                authoritativePresentation: authoritativeForgeAppPresentations.find(({ id: id })=>id === app.id)?.presentation
            }))))); // single line byline renders all apps initially, hiding them in overflow until user clicks show more button
    // when user clicks show more, they are shown and wrapped to next line
    if (isSingleLineByline) return renderPart(connectItems, forgeItems, connectItems.length + forgeItems.length);
    if (connectItems.length + forgeItems.length <= numberOfVisibleApps) return renderPart(connectItems, forgeItems, forgeItems.length);
    else {
        // We should show the first numberOfVisibleApps apps including Connect and Forge app;
        // however, all Forge apps need to be RENDERED in order for the Forge Keyboard Shortcut listener
        // to be rendered and active. If (Connect app + Forge apps) is greater than numberOfVisibleApps,
        // then we will show the first numberOfVisibleApps Connect and Forge apps, render all the
        // Forge apps, but visually hide the Forge apps that go beyond numberOfVisibleApps.
        const numberOfConnectAppsToRender = Math.min(connectItems.length, numberOfVisibleApps);
        const numberOfForgeAppsToShow_0 = numberOfVisibleApps - numberOfConnectAppsToRender;
        const firstConnectApps = connectItems.slice(0, numberOfConnectAppsToRender);
        const remainingConnectApps = connectItems.slice(numberOfConnectAppsToRender);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, renderPart(firstConnectApps, forgeItems, numberOfForgeAppsToShow_0), isShowAll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, renderPart(remainingConnectApps, [], 0), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a60fc49afcf0f5b$export$e5bc424bebb08325), {
            showMore: false,
            showButtonDesign: !!showLivePagesExtensionPoints,
            setShowAll: setShowAll
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a60fc49afcf0f5b$export$e5bc424bebb08325), {
            showMore: true,
            showButtonDesign: !!showLivePagesExtensionPoints,
            setShowAll: setShowAll
        }));
    }
};



var $3aDMt = parcelRequire("3aDMt");

const $dc19d0558ac0af95$var$ByLineAppRuntimeHandoff = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbcK7c _2Sx1tOYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $dc19d0558ac0af95$var$ByLineAppRuntime = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbcK7c",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $dc19d0558ac0af95$var$ByLineAppSnapshotFallback = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbcK7c",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $dc19d0558ac0af95$export$da423a9f3d95b9b8 = (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { contentId: contentId, connectItems: connectItems, forgeItems: forgeItems, forgeError: forgeError, isSingleLineByline: isSingleLineByline, onBylineAppsLoaded: onBylineAppsLoaded, showLivePagesExtensionPoints: showLivePagesExtensionPoints, loadingConnectItems: t1, loadingForgeItems: t2, authoritativeSnapshot: authoritativeSnapshot } = t0;
    const loadingConnectItems = t1 === undefined ? false : t1;
    const loadingForgeItems = t2 === undefined ? false : t2;
    const isLoading = loadingConnectItems || loadingForgeItems;
    let t3;
    if ($[0] !== onBylineAppsLoaded) {
        t3 = ()=>{
            onBylineAppsLoaded?.();
        };
        $[0] = onBylineAppsLoaded;
        $[1] = t3;
    } else t3 = $[1];
    const handleLoad = t3;
    const shouldRenderBylineApps = !isLoading;
    let t4;
    if ($[2] !== authoritativeSnapshot?.apps) {
        t4 = authoritativeSnapshot?.apps ?? [];
        $[2] = authoritativeSnapshot?.apps;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t4) {
        t5 = t4.filter($dc19d0558ac0af95$var$_temp);
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const authoritativeForgeAppPresentations = t5;
    let t6;
    if ($[6] !== authoritativeForgeAppPresentations) {
        t6 = authoritativeForgeAppPresentations.map($dc19d0558ac0af95$var$_temp2);
        $[6] = authoritativeForgeAppPresentations;
        $[7] = t6;
    } else t6 = $[7];
    const authoritativeForgeAppIds = t6;
    let t7;
    if ($[8] !== authoritativeForgeAppIds || $[9] !== authoritativeForgeAppPresentations || $[10] !== authoritativeSnapshot || $[11] !== connectItems || $[12] !== contentId || $[13] !== forgeError || $[14] !== forgeItems || $[15] !== handleLoad || $[16] !== isSingleLineByline || $[17] !== showLivePagesExtensionPoints) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80koo.RequireLegacyWRM), {
            key: "byline-app-wrm",
            wrm: "wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-content-byline-resources-v5"
        }, ()=>{
            if (forgeError && (!authoritativeSnapshot || !(0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true))) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(forgeError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: forgeError
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                    name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
                });
            }
            const unhandledForgeError = forgeError && !(0, $7Sm4c.isErrorMarkedAsHandled)(forgeError) ? forgeError : undefined;
            const apps = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, unhandledForgeError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: unhandledForgeError
            }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cd6af931b4e9ea04$export$127ace2288e0ed63), {
                key: contentId,
                contentId: contentId,
                forgeItems: forgeError ? [] : forgeItems,
                connectItems: connectItems,
                showLivePagesExtensionPoints: showLivePagesExtensionPoints,
                onLoad: handleLoad,
                isSingleLineByline: isSingleLineByline,
                hasAuthoritativeBylineAppSnapshot: Boolean(authoritativeSnapshot),
                authoritativeForgeAppIds: authoritativeForgeAppIds,
                authoritativeForgeAppPresentations: authoritativeForgeAppPresentations
            }), unhandledForgeError ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
            }));
            return authoritativeSnapshot && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc19d0558ac0af95$var$ByLineAppRuntime, {
                "data-byline-app-runtime": true
            }, apps) : apps;
        });
        $[8] = authoritativeForgeAppIds;
        $[9] = authoritativeForgeAppPresentations;
        $[10] = authoritativeSnapshot;
        $[11] = connectItems;
        $[12] = contentId;
        $[13] = forgeError;
        $[14] = forgeItems;
        $[15] = handleLoad;
        $[16] = isSingleLineByline;
        $[17] = showLivePagesExtensionPoints;
        $[18] = t7;
    } else t7 = $[18];
    const runtimeApps = t7;
    let t8;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
        });
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== authoritativeSnapshot || $[21] !== runtimeApps || $[22] !== shouldRenderBylineApps) {
        t9 = shouldRenderBylineApps && (authoritativeSnapshot && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc19d0558ac0af95$var$ByLineAppRuntimeHandoff, null, runtimeApps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc19d0558ac0af95$var$ByLineAppSnapshotFallback, {
            "data-byline-app-snapshot": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aDMt.AuthoritativeByLineApps), {
            snapshot: authoritativeSnapshot
        }))) : runtimeApps);
        $[20] = authoritativeSnapshot;
        $[21] = runtimeApps;
        $[22] = shouldRenderBylineApps;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t8, t9);
        $[24] = t9;
        $[25] = t10;
    } else t10 = $[25];
    return t10;
};

const $dc19d0558ac0af95$export$573ad1d5e82d9d7e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9W4UB",
    name: "LazyLivePagesByLineApps",
    loader: async ()=>{
        return (await Promise.resolve(module.exports)).LivePagesByLineApps;
    },
    loading: (props)=>props.authoritativeSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aDMt.AuthoritativeByLineApps), {
            snapshot: props.authoritativeSnapshot
        }) : null
});
function $dc19d0558ac0af95$var$_temp(app) {
    return app.producer === "forge" && app.presentation.resolution === "resolved";
}
function $dc19d0558ac0af95$var$_temp2(t0) {
    const { id: id } = t0;
    return id;
}
module.exports["LivePagesByLineApps"] = $dc19d0558ac0af95$export$da423a9f3d95b9b8;
module.exports["LazyLivePagesByLineApps"] = $dc19d0558ac0af95$export$573ad1d5e82d9d7e;

});

parcelRegister("83fWZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

const $7a82ae306aa8d2fb$export$656295fdbe704c1d = (obj)=>{
    const ref = (0, $cozmU.useRef)(obj);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(ref.current, obj)) ref.current = obj;
    return ref.current;
};
const $7a82ae306aa8d2fb$export$3b131fc84567c0ad = (data)=>{
    if (!data) return false;
    if ('singleContent' in data) return false;
    if ('content' in data) {
        const properties = data?.content?.nodes?.[0]?.properties?.nodes || [];
        const editorVersion = properties.find((p)=>p?.key === 'editor');
        return editorVersion?.value?.includes('v2') || false;
    }
    return false;
};
const $7a82ae306aa8d2fb$export$44be1e207a638653 = (graphqlUser)=>({
        isAnonymous: !graphqlUser?.accountId,
        userId: graphqlUser?.accountId ?? undefined,
        fullName: graphqlUser?.displayName,
        avatarUrl: graphqlUser?.profilePicture?.path
    });
module.exports["useMemoizedObj"] = $7a82ae306aa8d2fb$export$656295fdbe704c1d;
module.exports["isFabricEditor"] = $7a82ae306aa8d2fb$export$3b131fc84567c0ad;
module.exports["toUserProps"] = $7a82ae306aa8d2fb$export$44be1e207a638653;

});

parcelRegister("35Exc", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $0adb659d8e3039a1$export$c008670b78f0cf4f = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _2XghbEQU1O _1UtDYzZpcK _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.isTitleCenterAligned ? "_2fwxA5DIqT" : "_2fwxA5OLYo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$8360598613515efc = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$c008670b78f0cf4f : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4kiQYAS40j",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0adb659d8e3039a1$export$3ed1f5d7ee09c27 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$c008670b78f0cf4f : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEPgdg _0hPCNLDIqT _2O5Vij7dHp _42Yu6BgtVO _1ANEUSLRg7",
            !!__cmplp.hasFixedHeight ? "_0jFU0VUofl" : "_0jFU0VIZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$var$BylineStyledMainDivSingleLineWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let children;
    let props;
    if ($[0] !== t0) {
        const { isExpanded: isExpanded, children: t1, ...t2 } = t0;
        children = t1;
        props = t2;
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0adb659d8e3039a1$export$3ed1f5d7ee09c27, props, children);
        $[3] = children;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
}; /* eslint-enable @typescript-eslint/no-unused-vars */ 
const $0adb659d8e3039a1$export$b95808ab42b44324 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$var$BylineStyledMainDivSingleLineWrapper : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02N91d _1mT5xdRAKS _42Yu6BIZbP",
            __cmplp.isExpanded ? "_00U5WxHZdu" : "_00U5WxdnbC",
            __cmplp.isExpanded ? "_4afKC8A17z" : "_4afKC8dnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$6a3337cf751e21ac = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { hasBadgeStylePageOwnerBylineItem: hasBadgeStylePageOwnerBylineItem, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02N91d _0luBOg98eZ _2h5UOzYbGa _3W2WEt6wH8 _0gKGieM7Tp _0uGipI98eZ _0DlTgX98eZ _1Oh6lc98eZ _1KbF3r98eZ _2LQVB40Rl6 _27PHXJ0Rl6 _38ddKy0Rl6 _1R2oCZ0Rl6 _4BW6TR6wH8 _2IWu1s6wH8 _4i4dA66wH8 _06nYrP6wH8 _1EjoPeAwSC _1BrKNsAwSC _1E1xWzAwSC _3bFj0TAwSC",
            !!__cmplp.hasBadgeStylePageOwnerBylineItem ? "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC" : "_2XghbE8UTm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0adb659d8e3039a1$export$5237d2d172029aad = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$6a3337cf751e21ac : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _313842FQfX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["StyledMainDiv"] = $0adb659d8e3039a1$export$c008670b78f0cf4f;
module.exports["StandardPageBylineStyledMainDiv"] = $0adb659d8e3039a1$export$8360598613515efc;
module.exports["BylineStyledMainDivSingleLine"] = $0adb659d8e3039a1$export$b95808ab42b44324;
module.exports["StyledTextDiv"] = $0adb659d8e3039a1$export$6a3337cf751e21ac;

});

parcelRegister("5YSiR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5cc6a47526452ac3$export$a07022482001031b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R7O8o",
    name: "LazyAIPlannerSyncByline",
    loader: async ()=>(await (parcelRequire("k21gb"))).AIPlannerSyncByline,
    loading: ()=>null
});
module.exports["LazyAIPlannerSyncByline"] = $5cc6a47526452ac3$export$a07022482001031b;

});

parcelRegister("k21gb", function(module, exports) {

let $e954f8bdb80bbf40$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e954f8bdb80bbf40$var$load("abBST"),
    $e954f8bdb80bbf40$var$load("kfGHh"),
    $e954f8bdb80bbf40$var$load("lIiD7"),
    $e954f8bdb80bbf40$var$load("i1I18"),
    $e954f8bdb80bbf40$var$load("3w65n")
]).then(()=>parcelRequire('9gzhk'));

});

parcelRegister("3TrzI", function(module, exports) {
const $b443a1044784ca20$export$847f5bb75f781390 = 'AI_PLANNER';
const $b443a1044784ca20$export$593a849e6e9b7c73 = 'artifact.resolveByConfluenceContentAri';
module.exports["AI_PLANNER_GENERATED_BY"] = $b443a1044784ca20$export$847f5bb75f781390;
module.exports["AI_PLANNER_SYNC_BYLINE_RESOLVER_PROCEDURE"] = $b443a1044784ca20$export$593a849e6e9b7c73;

});

parcelRegister("cI2rq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $6mKj3 = parcelRequire("6mKj3");


var $euq7N = parcelRequire("euq7N");


var $7sf7C = parcelRequire("7sf7C");

const $f5477882acb5003c$export$1ea55ec97ca20a67 = (contentId, t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const enabled = t0 === undefined ? true : t0;
    const relayContext = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    if (!enabled || !contentId || !relayContext || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_ssr_byline", "isEnabled", true)) return;
    let t1;
    let t2;
    if ($[0] !== contentId || $[1] !== relayContext) {
        t2 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const keys = (0, $euq7N.getBylineAppContentPropertyKeys)();
            if (keys.length === 0) {
                t2 = undefined;
                break bb0;
            }
            const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)((0, $7sf7C.default)), {
                contentId: contentId,
                keys: keys
            });
            t1 = relayContext.environment.lookup(operation.fragment);
        }
        $[0] = contentId;
        $[1] = relayContext;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    const snapshot = t1;
    const data = snapshot.data;
    return snapshot.isMissingData ? undefined : data?.content?.nodes?.[0]?.properties ?? undefined;
};
module.exports["useBylineAppContentProperties"] = $f5477882acb5003c$export$1ea55ec97ca20a67;

});

parcelRegister("38aC9", function(module, exports) {
/* SmartLinkIconRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kTb7m = parcelRequire("kTb7m");

const $034a9b0def7554d2$var$baseStyles = null; // Image icons fill their wrapper; the wrapper carries the desired pixel size.
const $034a9b0def7554d2$var$imgStyles = null; // Stack chips keep third-party product images at 10px inside the 16px glyph tile, matching
// the pre-app-icon byline. Menu rows keep the 16px face.
const $034a9b0def7554d2$var$imageStyles = {
    stack: "_39xV02uFDC _0jFU0VuFDC",
    menu: "_39xV02ey7F _0jFU0Vey7F"
}; // AtlasKit React-element icons (@atlaskit/icon, @atlaskit/object) render an <svg> at a fixed
// intrinsic 16px that ignores the wrapper size, so we render at that natural size and scale the
// whole composed icon down with a centred transform — this shrinks any element icon uniformly
// without distorting or clipping it. 16px -> 10px in the stack; the menu keeps the natural size.
const $034a9b0def7554d2$var$elementStyles = {
    stack: "_39xV02ey7F _0jFU0Vey7F _46hvQmFQfX _1VJPcaGquZ _0yKXXaDIqT",
    menu: "_39xV02ey7F _0jFU0Vey7F"
}; // Product logos already include a branded tile. AtlasKit IconWrapper is `inline-block`, so the
// SVG sits on a line box and looks high in the chip. The slot is a flex container and the
// wrapper span is also flex so the logo centres on both axes.
const $034a9b0def7554d2$var$logoStyles = {
    stack: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02N91d _0jFU0VN91d _4ouGXIdnbC _4kiQYAdnbC _4ya3eEdnbC _4v6ugQQ4SZ _1XJ99dDIqT _3NACppDIqT",
    menu: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _39xV02oWWg _0jFU0VoWWg _4ouGXIdnbC _4kiQYAdnbC _3YEZNOdnbC _4ya3eEdnbC _4v6ugQQ4SZ _1XJ99dDIqT _3NACppDIqT"
};
// surfaces as the browser's "broken image" glyph. <img> load failures aren't caught by React error
// boundaries — they only surface through the DOM `onError` event — so we attach `onError` to the
// <img> at the point it's created here and swap in a neutral link icon on failure.
const $034a9b0def7554d2$var$ImageIcon = ({ src: src, size: size })=>{
    const [hasErrored, setHasErrored] = (0, $cozmU.useState)(false); // Reset when the source changes — the menu reuses one renderer instance across rows.
    (0, $cozmU.useEffect)(()=>{
        setHasErrored(false);
    }, [
        src
    ]);
    if (hasErrored) // The fallback is an <svg> element icon, so it uses the element wrapper (which applies the
    // stack scale-down / menu natural-size logic) rather than the image wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
            $034a9b0def7554d2$var$elementStyles[size]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
            $034a9b0def7554d2$var$imageStyles[size]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: "",
        src: src,
        onError: ()=>setHasErrored(true),
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _00EA0egIor"
        ])
    }));
};
const $034a9b0def7554d2$export$24f3a21bb86b5d0c = ({ icon: icon, size: size })=>{
    if (icon.kind === 'image') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($034a9b0def7554d2$var$ImageIcon, {
        src: icon.src,
        size: size
    });
    if (icon.kind === 'logo') {
        const logoNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(icon.node, {
            size: size === 'stack' ? 'xxsmall' : 'small'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": "smart-link-logo",
            className: (0, $hekY6.default)([
                $034a9b0def7554d2$var$logoStyles[size]
            ])
        }, logoNode);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
            $034a9b0def7554d2$var$elementStyles[size]
        ])
    }, icon.node);
};
module.exports["SmartLinkIconRenderer"] = $034a9b0def7554d2$export$24f3a21bb86b5d0c;

});

parcelRegister("jDHty", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $7c8469b2a0f7d0de$export$d77e972d07b86701 = (initialData)=>{
    let current = initialData;
    const subscribers = new Set();
    const notify = ()=>{
        subscribers.forEach((callback)=>{
            callback();
        });
    };
    const publish = (data)=>{
        current = data;
        notify();
    };
    const clear = ()=>{
        current = initialData;
        notify();
    };
    const subscribe = (callback)=>{
        subscribers.add(callback);
        return ()=>{
            subscribers.delete(callback);
        };
    };
    // Returns the stored object rather than building a new one, so
    // `useSyncExternalStore` sees a stable snapshot between publishes.
    const getSnapshot = ()=>current;
    const getServerSnapshot = ()=>initialData;
    /**
	 * Reads the published data, but only when it belongs to `contentId`. The filter
	 * lives here rather than in each consumer so a new section cannot forget it and
	 * silently render the previous page's data after an SPA transition.
	 */ const useValue = (contentId)=>{
        const data = (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, getServerSnapshot);
        return data.contentId === contentId ? data : initialData;
    };
    const clearForTesting = ()=>{
        current = initialData;
        subscribers.clear();
    };
    return {
        publish: publish,
        clear: clear,
        subscribe: subscribe,
        useValue: useValue,
        clearForTesting: clearForTesting
    };
};
module.exports["createPanelDataBridge"] = $7c8469b2a0f7d0de$export$d77e972d07b86701;

});

parcelRegister("hTfX9", function(module, exports) {
/* BylineConnectionIconStack.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $38aC9 = parcelRequire("38aC9");


var $jJhQa = parcelRequire("jJhQa");


var $f0mzK = parcelRequire("f0mzK");


var $8tDDs = parcelRequire("8tDDs");

const $a9443aed03d2e255$var$styles = {
    stack: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _2YgrGrP0S5",
    spacingBefore: "_0GTcwR1Y8M",
    spacingAfter: "_2xTnZx1Y8M"
};
const $a9443aed03d2e255$var$appIconTileStyles = null;
const $a9443aed03d2e255$var$glyphTileStyles = null;
const $a9443aed03d2e255$var$firstIconTileStyles = null;
const $a9443aed03d2e255$var$secondIconTileStyles = null;
const $a9443aed03d2e255$var$thirdIconTileStyles = null;
const $a9443aed03d2e255$var$isAtlasKitAppLogo = (icon)=>icon.icon.kind === 'logo';
const $a9443aed03d2e255$export$de98155121ad78a4 = ({ links: links, incomingLinks: incomingLinks, additionalIcons: additionalIcons, appearance: appearance = 'default', minIcons: minIcons, spacing: spacing = 'after' })=>{
    const realIcons = (0, $cozmU.useMemo)(()=>(0, $jJhQa.getBylineConnectionIcons)(links, additionalIcons, incomingLinks), [
        links,
        additionalIcons,
        incomingLinks
    ]);
    const icons = (0, $cozmU.useMemo)(()=>{
        const target = Math.min(minIcons ?? 0, (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS));
        if (realIcons.length >= target) return realIcons;
        const padding = appearance === 'placeholder' ? Array.from({
            length: target - realIcons.length
        }, (_, index)=>(0, $f0mzK.createPlaceholderConnectionIcon)(realIcons.length + index)) : (0, $8tDDs.getFallbackConnectionIcons)(realIcons, target - realIcons.length);
        return [
            ...realIcons,
            ...padding
        ];
    }, [
        realIcons,
        minIcons,
        appearance
    ]);
    if (icons.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": "byline-connections-icon-stack",
        className: (0, $hekY6.default)([
            $a9443aed03d2e255$var$styles.stack,
            spacing === 'before' && $a9443aed03d2e255$var$styles.spacingBefore,
            spacing === 'after' && $a9443aed03d2e255$var$styles.spacingAfter
        ])
    }, icons.map((icon, index)=>{
        const useAppChrome = $a9443aed03d2e255$var$isAtlasKitAppLogo(icon);
        const chip = useAppChrome ? 'app' : 'glyph';
        switch(index){
            case 0:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    key: icon.key,
                    "data-chip": chip,
                    className: (0, $hekY6.default)([
                        useAppChrome ? "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc" : "_0bjKvDKxmn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc",
                        "_42Yu6BPvK5"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
                    icon: icon.icon,
                    size: "stack"
                }));
            case 1:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    key: icon.key,
                    "data-chip": chip,
                    "data-rotation-enabled": true,
                    className: (0, $hekY6.default)([
                        useAppChrome ? "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc" : "_0bjKvDKxmn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc",
                        "_0GTcwR5UaJ _42Yu6Bbhqd _2AERac9ub0"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
                    icon: icon.icon,
                    size: "stack"
                }));
            case 2:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    key: icon.key,
                    "data-chip": chip,
                    className: (0, $hekY6.default)([
                        useAppChrome ? "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc" : "_0bjKvDKxmn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc",
                        "_0GTcwR5UaJ _42Yu6BgtVO"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
                    icon: icon.icon,
                    size: "stack"
                }));
            default:
                return null;
        }
    }));
};
module.exports["BylineConnectionIconStack"] = $a9443aed03d2e255$export$de98155121ad78a4;

});

parcelRegister("8wK2O", function(module, exports) {

var $I7TEB = parcelRequire("I7TEB");

const $c484d458bde3f527$var$SERVICE_ERROR_CODES = new Set([
    'AI_FEATURE_RATE_LIMITED',
    'AI_FEATURE_TIMEOUT',
    'AI_FEATURE_UNAUTHORIZED',
    'AI_FEATURE_FORBIDDEN',
    'AI_FEATURE_EMPTY_RESPONSE',
    'AI_FEATURE_INVALID_RESPONSE',
    'AI_FEATURE_DEPENDENCY_FAILURE',
    'AI_FEATURE_CLIENT_ERROR',
    'AI_FEATURE_INVALID_INPUT',
    'AI_FEATURE_INTERNAL_ERROR'
]);
const $c484d458bde3f527$export$596ac2202cd95511 = (code)=>code === undefined ? undefined : $c484d458bde3f527$var$SERVICE_ERROR_CODES.has(code) ? code : 'UNKNOWN';
const $c484d458bde3f527$export$1c32d73668cee9f0 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: 'atAGlanceSummary',
            actionSubjectId: (0, $I7TEB.AT_A_GLANCE_ACTION_SUBJECT_ID),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $c484d458bde3f527$export$c94aa1bf4dcf738d = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: 'atAGlanceSummary',
            actionSubjectId: (0, $I7TEB.AT_A_GLANCE_ACTION_SUBJECT_ID),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $c484d458bde3f527$export$7688f758e142df9b = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'aborted',
            actionSubject: 'atAGlanceSummary',
            actionSubjectId: (0, $I7TEB.AT_A_GLANCE_ACTION_SUBJECT_ID),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $c484d458bde3f527$export$49035d4f326a99cc = {
    actionSubjectId: (0, $I7TEB.AT_A_GLANCE_ACTION_SUBJECT_ID),
    source: (0, $I7TEB.ANALYTICS_SOURCE),
    twgFeatureName: 'confluenceConnectionsAtAGlance',
    twgSource: 'Cypher',
    queryMethod: 'REST'
};
module.exports["getServiceErrorCodeForAnalytics"] = $c484d458bde3f527$export$596ac2202cd95511;
module.exports["getAtAGlanceSucceededEvent"] = $c484d458bde3f527$export$1c32d73668cee9f0;
module.exports["getAtAGlanceFailedEvent"] = $c484d458bde3f527$export$c94aa1bf4dcf738d;
module.exports["getAtAGlanceAbortedEvent"] = $c484d458bde3f527$export$7688f758e142df9b;
module.exports["AT_A_GLANCE_TWG_RESULT_SURFACE"] = $c484d458bde3f527$export$49035d4f326a99cc;

});

parcelRegister("dcSzx", function(module, exports) {
// Minted on first use rather than at module load: the SSR process keeps modules between requests,
// so a load-time id would be one id shared by every reader of every page. No event fires during
// SSR, so the server never mints one.
let $457579216673ba99$var$twgTraceId;
const $457579216673ba99$export$fe6d17ef66ee2fa4 = ()=>{
    if ($457579216673ba99$var$twgTraceId === undefined) $457579216673ba99$var$twgTraceId = crypto.randomUUID();
    return $457579216673ba99$var$twgTraceId;
};
const $457579216673ba99$export$cde77d3ccbf7ce14 = ()=>{
    $457579216673ba99$var$twgTraceId = undefined;
};
module.exports["getTwgTraceId"] = $457579216673ba99$export$fe6d17ef66ee2fa4;

});

parcelRegister("86sr7", function(module, exports) {
const $b7da36d1b8481eed$export$97a0c2716ca9f0c9 = 3;
const $b7da36d1b8481eed$var$isUnconnected = (link)=>link.access === 'unauthorized';
function $b7da36d1b8481eed$export$8c96aced19644e7c(links, limit = $b7da36d1b8481eed$export$97a0c2716ca9f0c9) {
    return [
        ...links
    ].sort((a, b)=>{
        const rankDiff = Number($b7da36d1b8481eed$var$isUnconnected(b)) - Number($b7da36d1b8481eed$var$isUnconnected(a));
        return rankDiff !== 0 ? rankDiff : a.occurrenceIndex - b.occurrenceIndex;
    }).slice(0, limit);
}
module.exports["DEFAULT_VISIBLE_LINK_COUNT"] = $b7da36d1b8481eed$export$97a0c2716ca9f0c9;
module.exports["getTopConnectionLinks"] = $b7da36d1b8481eed$export$8c96aced19644e7c;

});

parcelRegister("e9QBI", function(module, exports) {
/* DevDocsConnectionRow.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $8VfSP = parcelRequire("8VfSP");


var $8oBbn = parcelRequire("8oBbn");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $bQm3c = parcelRequire("bQm3c");


var $fONL3 = parcelRequire("fONL3");


var $4P3Ik = parcelRequire("4P3Ik");


var $idfQJ = parcelRequire("idfQJ");

const $bd9b9a29e384189b$var$i18n = (0, $kSwu1.defineMessages)({
    // Message id retained from the byline menu section so existing translations
    // carry over now that the row is shared with the preview panel.
    providerRepo: {
        id: "dev-docs.byline-connection.menu.section.provider-repo.ai-non-final",
        defaultMessage: "{provider} repo"
    }
});
const $bd9b9a29e384189b$var$styles = {
    rowWrapper: "_4c065U2ADO _2Y7lL48HPE",
    textColumn: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    title: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1kk5Tku7m9 _1UtDYzy7kJ _1ANEUSLRg7 _39HuIbz8Lp",
    metadata: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1kk5Tku7m9 _1UtDYzKGUX _1ANEUSLRg7 _39HuIbz8Lp",
    metadataPart: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1ANEUSLRg7 _39HuIbz8Lp",
    metadataSeparator: "_0bjKvDS5Zs _2YLqiK1Y8M _3iDTPbvbI6 _3YEZNOdnbC _39xV024Y4b _0jFU0V4Y4b _0KLXrugozt"
};
const $bd9b9a29e384189b$var$LinkItemWithInteraction = (0, $8oBbn.default); /**
                                                                                                  * A single Dev Docs source row. Falls back to a non-interactive row when the
                                                                                                  * repository URL cannot be resolved.
                                                                                                  *
                                                                                                  * Shared by the Teamwork Graph byline menu and the preview panel, so it renders no
                                                                                                  * section heading of its own.
                                                                                                  */ 
const $bd9b9a29e384189b$export$bc1a2b85ad79f624 = ({ connection: connection, onNavigate: onNavigate })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    const [isRepositoryLinkIconVisible, setIsRepositoryLinkIconVisible] = (0, $cozmU.useState)(false);
    const lastSynced = (0, $4P3Ik.formatDevDocsRelativeSyncTime)(connection.lastSynced, intl);
    const providerConfig = (0, $fONL3.getDevDocsSourceProviderConfigFromValue)(connection.provider);
    const providerDisplayName = providerConfig?.displayName ?? (0, $fONL3.getDevDocsSourceProviderDisplayName)(connection.provider);
    const repositoryUrl = (0, $fONL3.getDevDocsRepositoryUrl)({
        environment: environment,
        provider: connection.provider,
        repoName: connection.repoName
    });
    const providerTypeLabel = providerDisplayName ? formatMessage($bd9b9a29e384189b$var$i18n.providerRepo, {
        provider: providerDisplayName
    }) : null;
    const metadataParts = [
        providerTypeLabel,
        connection.owner,
        lastSynced
    ].filter((metadataPart)=>Boolean(metadataPart));
    const metadata = metadataParts.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        alignBlock: "center",
        xcss: $bd9b9a29e384189b$var$styles.metadata
    }, metadataParts.map((metadataPart, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: `${metadataPart}-${index}`
        }, index > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $bd9b9a29e384189b$var$styles.metadataSeparator,
            "aria-hidden": "true"
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $bd9b9a29e384189b$var$styles.metadataPart
        }, metadataPart)))) : null;
    const rowText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $bd9b9a29e384189b$var$styles.textColumn,
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bd9b9a29e384189b$var$styles.title
    }, connection.repoName), metadata);
    const showRepositoryLinkIcon = (0, $cozmU.useCallback)(()=>{
        setIsRepositoryLinkIconVisible(true);
    }, []);
    const hideRepositoryLinkIcon = (0, $cozmU.useCallback)(()=>{
        setIsRepositoryLinkIconVisible(false);
    }, []);
    if (!repositoryUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bd9b9a29e384189b$var$styles.rowWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idfQJ.DevDocsScmProviderLogo), {
        provider: connection.provider
    }), rowText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd9b9a29e384189b$var$LinkItemWithInteraction, {
        href: repositoryUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: onNavigate,
        onMouseEnter: showRepositoryLinkIcon,
        onMouseLeave: hideRepositoryLinkIcon,
        onFocus: showRepositoryLinkIcon,
        onBlur: hideRepositoryLinkIcon,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idfQJ.DevDocsScmProviderLogo), {
            provider: connection.provider
        }),
        iconAfter: isRepositoryLinkIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            testId: "dev-docs-byline-repository-link-icon"
        }) : null
    }, rowText);
};
module.exports["DevDocsConnectionRow"] = $bd9b9a29e384189b$export$bc1a2b85ad79f624;

});

parcelRegister("xICd5", function(module, exports) {
/* SectionCountBadge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $5accbe136c7255ea$var$styles = {
    badge: "_0bjKvDcjp5 _2sNsIg7NXe _4c065UPgdg _2Y7lL41Y8M _3iDTPbQ4SZ _0jFU0Vey7F _4ouGXIoWWg _4kiQYAey7F _37wbyuDIqT _0hPCNLDIqT _3YEZNOdnbC _0KLXruG6qS _1UtDYzUktF _24h04i2Njc"
};
const $5accbe136c7255ea$export$2211d1b0625dcf47 = ({ count: count, hasMore: hasMore = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $5accbe136c7255ea$var$styles.badge
        ])
    }, count, hasMore ? '+' : null);
module.exports["SectionCountBadge"] = $5accbe136c7255ea$export$2211d1b0625dcf47;

});

parcelRegister("5vpeX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

// Utility function to check if a value is a non-empty string
const $3b594b06ac9b7376$var$isNonEmptyString = (value)=>{
    return typeof value === 'string' && value.trim() !== '';
};
// Utility function to validate and set a byline content property value
const $3b594b06ac9b7376$var$validatePropertyValue = (key, value, validatedProperties)=>{
    if (value !== undefined) {
        if ($3b594b06ac9b7376$var$isNonEmptyString(value)) validatedProperties[key] = value;
        else // eslint-disable-next-line no-console
        console.warn(`Byline content property ${key} must be a non-empty string, got:`, typeof value);
    }
};
// Validation function for extracting property node from GraphQL query data
const $3b594b06ac9b7376$var$validateContentPropertyQuery = (data, contentPropertyKey, exactKeys)=>{
    // Check if data exists and has the expected structure
    if (!data || !data.content || !data.content.nodes || data.content.nodes.length === 0 || !data.content.nodes[0].properties || !data.content.nodes[0].properties.nodes || data.content.nodes[0].properties.nodes.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('Invalid byline content property query data');
        return null;
    }
    // Get all objects that match the contentPropertyKey
    const properties = data.content.nodes[0].properties.nodes;
    let matchingObjects;
    if (exactKeys && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) matchingObjects = properties.filter((property)=>property !== null && exactKeys.includes(property.key ?? ''));
    else {
        const contentKeyPattern = new RegExp(contentPropertyKey);
        matchingObjects = properties.filter((property)=>{
            // Preserve the legacy error and fallback for malformed property lists.
            if (property === null) throw new TypeError('Invalid byline content property node');
            return contentKeyPattern.test(property.key ?? '');
        });
    }
    if (matchingObjects.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('No property nodes matching content property key pattern found');
        return null;
    }
    if (matchingObjects.length > 1) {
        // eslint-disable-next-line no-console
        console.warn('Multiple property nodes matching content property key pattern found. Please make sure your contentPropertyKey is unique, like a UUID.');
        return null;
    }
    const propertyNode = matchingObjects[0];
    const validContentPropertyKey = propertyNode.key ?? undefined;
    if (!propertyNode.value) {
        // eslint-disable-next-line no-console
        console.warn('Byline content property data has no value');
        return null;
    }
    return {
        propertyNode: propertyNode,
        validContentPropertyKey: validContentPropertyKey
    };
};
// Common function to validate title, icon, and tooltip properties
const $3b594b06ac9b7376$var$validateProperties = (propertyValue, validatedProperties)=>{
    // validate each property
    $3b594b06ac9b7376$var$validatePropertyValue('title', propertyValue.title, validatedProperties);
    $3b594b06ac9b7376$var$validatePropertyValue('icon', propertyValue.icon, validatedProperties);
    $3b594b06ac9b7376$var$validatePropertyValue('tooltip', propertyValue.tooltip, validatedProperties);
};
const $3b594b06ac9b7376$export$48cf1be175912dd = (data, defaultValues, exactKeys)=>{
    try {
        // Validate and extract the query data
        const queryResult = $3b594b06ac9b7376$var$validateContentPropertyQuery(data, defaultValues.contentPropertyKey, exactKeys);
        if (!queryResult) return defaultValues;
        const { propertyNode: propertyNode, validContentPropertyKey: validContentPropertyKey } = queryResult;
        // Parse JSON with error handling
        let propertyValue;
        try {
            propertyValue = JSON.parse(propertyNode.value ?? '');
        } catch (jsonError) {
            // eslint-disable-next-line no-console
            console.error('Failed to parse byline content property JSON:', jsonError);
            return defaultValues;
        }
        // Validate the structure of the parsed value
        if (typeof propertyValue !== 'object' || propertyValue === null) {
            // eslint-disable-next-line no-console
            console.error('Byline content property value is not an object:', propertyValue);
            return defaultValues;
        }
        const validatedProperties = {
            ...defaultValues
        };
        // Validate each property using the byline content property value utility function
        $3b594b06ac9b7376$var$validateProperties(propertyValue, validatedProperties);
        if (validContentPropertyKey && validContentPropertyKey !== '') validatedProperties.contentPropertyKey = validContentPropertyKey;
        return validatedProperties;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Unexpected error in content property validation:', error);
        return defaultValues;
    }
};
const $3b594b06ac9b7376$export$96933cae6933ce51 = (eventData, defaultValues)=>{
    try {
        // Check if eventData exists and has the expected structure
        if (!eventData || !eventData.propertyKey || !eventData.valueUpdate) {
            // eslint-disable-next-line no-console
            console.warn('Invalid FORGE_CONTENT_PROPERTY_UPDATED event data structure');
            return defaultValues;
        }
        const valueUpdate = eventData.valueUpdate;
        // Validate the structure of valueUpdate
        if (typeof valueUpdate !== 'object' || valueUpdate === null) {
            // eslint-disable-next-line no-console
            console.error('Event valueUpdate is not an object:', valueUpdate);
            return defaultValues;
        }
        const validatedProperties = {
            ...defaultValues
        };
        $3b594b06ac9b7376$var$validateProperties(valueUpdate, validatedProperties);
        return validatedProperties;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Unexpected error in event data validation:', error);
        return defaultValues;
    }
};
module.exports["validateContentPropertyData"] = $3b594b06ac9b7376$export$48cf1be175912dd;
module.exports["validateEventData"] = $3b594b06ac9b7376$export$96933cae6933ce51;

});

parcelRegister("3aDMt", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $e5xte = parcelRequire("e5xte");


var $87We3 = parcelRequire("87We3");

const $73425511e70f8b25$export$85c37fe80d19fd66 = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { snapshot: snapshot } = t0;
    let apps;
    if ($[0] !== snapshot.apps) {
        apps = [];
        for (const app of snapshot.apps)if (app.presentation.resolution === "resolved") apps.push(app);
        $[0] = snapshot.apps;
        $[1] = apps;
    } else apps = $[1];
    const resolvedApps = apps;
    if (!(0, $87We3.isByLineAppSnapshotAuthoritative)(snapshot)) return null;
    let t1;
    if ($[2] !== resolvedApps) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, resolvedApps.map($73425511e70f8b25$var$_temp));
        $[2] = resolvedApps;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
function $73425511e70f8b25$var$_temp(t0) {
    const { id: id, presentation: presentation, producer: producer } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5xte.BylineAppTriggerVisual), {
        "data-byline-app-producer": producer,
        "data-testid": producer === "connect" ? "web-item-link" : "forge-byline-header-wrapper",
        key: id,
        title: presentation.tooltip
    }, presentation.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: "",
        height: presentation.icon.height,
        src: presentation.icon.src,
        width: presentation.icon.width
    }) : null, producer === "connect" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: presentation.label
        }
    }) : presentation.label);
}
module.exports["AuthoritativeByLineApps"] = $73425511e70f8b25$export$85c37fe80d19fd66;

});

parcelRegister("f0mzK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kTb7m = parcelRequire("kTb7m");

const $3dd61ef4b34e980c$export$1516ba114d4009a6 = (index)=>({
        key: `placeholder-link-${index}`,
        label: '',
        icon: {
            kind: 'element',
            key: `placeholder-link-${index}`,
            label: '',
            node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)",
                testId: "byline-connections-ssr-placeholder-icon"
            })
        }
    });
module.exports["createPlaceholderConnectionIcon"] = $3dd61ef4b34e980c$export$1516ba114d4009a6;

});

parcelRegister("8tDDs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4H55s = parcelRequire("4H55s");


var $jh2Zn = parcelRequire("jh2Zn");


var $hje3t = parcelRequire("hje3t");

const $6c7256c3d4e0ce19$var$claude = {
    key: 'Claude',
    label: 'Claude',
    icon: {
        kind: 'logo',
        key: 'Claude',
        label: 'Claude',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H55s.ClaudeIcon), {
            label: "",
            size: "xxsmall",
            testId: "byline-connections-claude-icon"
        })
    }
};
const $6c7256c3d4e0ce19$var$cursor = {
    key: 'Cursor',
    label: 'Cursor',
    icon: {
        kind: 'logo',
        key: 'Cursor',
        label: 'Cursor',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jh2Zn.CursorIcon), {
            label: "",
            size: "xxsmall",
            testId: "byline-connections-cursor-icon"
        })
    }
};
const $6c7256c3d4e0ce19$var$rovo = {
    key: 'Rovo',
    label: 'Rovo',
    icon: {
        kind: 'logo',
        key: 'Rovo',
        label: 'Rovo',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hje3t.RovoTileIcon), {
            size: "xxsmall"
        })
    }
};
const $6c7256c3d4e0ce19$export$9191577ae9981ba3 = (icons, count)=>{
    // With no usable connection icons, match the existing Share context with AI entry.
    const fallbacks = icons.length === 0 ? [
        $6c7256c3d4e0ce19$var$rovo,
        $6c7256c3d4e0ce19$var$claude,
        $6c7256c3d4e0ce19$var$cursor
    ] : [
        $6c7256c3d4e0ce19$var$claude,
        $6c7256c3d4e0ce19$var$cursor,
        $6c7256c3d4e0ce19$var$rovo
    ];
    const existingProducts = new Set(icons.flatMap(({ key: key, label: label })=>[
            key.toLowerCase(),
            label.toLowerCase()
        ]));
    return fallbacks.filter(({ key: key })=>!existingProducts.has(key.toLowerCase())).slice(0, count);
};
module.exports["getFallbackConnectionIcons"] = $6c7256c3d4e0ce19$export$9191577ae9981ba3;

});

parcelRegister("87We3", function(module, exports) {

var $euq7N = parcelRequire("euq7N");


var $9fBoq = parcelRequire("9fBoq");


var $5vpeX = parcelRequire("5vpeX");

const $deb788b04f754a67$export$f3f60ff46f4bf02b = (snapshot)=>snapshot.completeness === 'complete' && snapshot.producers.connect === 'complete' && snapshot.producers.forge === 'complete';
const $deb788b04f754a67$var$getProducerStatus = ({ error: error, hasItems: hasItems, loading: loading })=>{
    if (error) return 'failed';
    if (loading && !hasItems) return 'pending';
    return 'complete';
};
const $deb788b04f754a67$var$getCompleteness = (connect, forge)=>{
    if (connect === 'complete' && forge === 'complete') return 'complete';
    if (connect === 'failed' && forge === 'failed') return 'failed';
    return 'partial';
};
const $deb788b04f754a67$export$d1d89135a42756e9 = ({ connectError: connectError, connectItems: connectItems, forgeError: forgeError, forgeItems: forgeItems, loadingConnectItems: loadingConnectItems, loadingForgeItems: loadingForgeItems, bylineAppContentProperties: bylineAppContentProperties })=>{
    const connectStatus = $deb788b04f754a67$var$getProducerStatus({
        error: connectError,
        hasItems: connectItems.length > 0,
        loading: loadingConnectItems
    });
    const forgeStatus = $deb788b04f754a67$var$getProducerStatus({
        error: forgeError,
        hasItems: forgeItems.length > 0,
        loading: loadingForgeItems
    });
    const connectApps = connectItems.map((item, order)=>({
            id: item.completeKey || item.id || `connect-${order}`,
            order: order,
            producer: 'connect',
            presentation: {
                ...item.icon?.path ? {
                    icon: {
                        height: item.icon.height ?? 14,
                        src: item.icon.path,
                        width: item.icon.width ?? 14
                    }
                } : {},
                label: item.label ?? '',
                resolution: 'resolved',
                source: 'connectWebItem',
                ...item.tooltip ? {
                    tooltip: item.tooltip
                } : {}
            }
        }));
    const forgeApps = forgeItems.map((app, index)=>{
        const contentPropertyKey = app.properties.contentPropertyKey;
        const hasDynamicProperties = Boolean(app.properties.dynamicProperties);
        const defaultPresentation = {
            contentPropertyKey: contentPropertyKey ?? '',
            icon: app.properties.icon ?? '',
            title: app.properties.title ?? '',
            tooltip: app.properties.tooltip ?? ''
        };
        const contentPropertyPresentation = contentPropertyKey && bylineAppContentProperties?.nodes?.length ? (0, $5vpeX.validateContentPropertyData)({
            content: {
                nodes: [
                    {
                        properties: bylineAppContentProperties
                    }
                ]
            }
        }, defaultPresentation, (0, $euq7N.getBylineAppContentPropertyKeys)([
            app
        ])) : defaultPresentation;
        const presentationIcon = contentPropertyPresentation?.icon || app.properties.icon;
        const presentationTitle = contentPropertyPresentation?.title || app.properties.title;
        const presentationTooltip = contentPropertyPresentation?.tooltip || app.properties.tooltip;
        // Validation returns the original defaults when stored data cannot be used.
        const source = contentPropertyKey ? contentPropertyPresentation !== defaultPresentation ? 'contentProperty' : 'manifest' : hasDynamicProperties ? 'dynamicProperties' : 'manifest';
        return {
            id: app.id,
            order: connectApps.length + index,
            producer: 'forge',
            presentation: {
                ...presentationIcon ? {
                    icon: {
                        height: 14,
                        src: presentationIcon,
                        width: 14
                    }
                } : {},
                label: presentationTitle ? (0, $9fBoq.extensionTitle)(app, presentationTitle) : '',
                resolution: presentationTitle ? 'resolved' : 'unresolved',
                source: source,
                ...presentationTooltip ? {
                    tooltip: presentationTooltip
                } : {}
            }
        };
    });
    return {
        apps: [
            ...connectApps,
            ...forgeApps
        ],
        completeness: $deb788b04f754a67$var$getCompleteness(connectStatus, forgeStatus),
        producers: {
            connect: connectStatus,
            forge: forgeStatus
        }
    };
};
module.exports["isByLineAppSnapshotAuthoritative"] = $deb788b04f754a67$export$f3f60ff46f4bf02b;
module.exports["createByLineAppSnapshot"] = $deb788b04f754a67$export$d1d89135a42756e9;

});


//# sourceMappingURL=EditorByLineArea.b07d7846.js.map
